// Generated by packages/assets/scripts/generate.ts. Do not edit; edit the sources and run pnpm generate.
import type { LanguageDef } from "../src/types.ts";

export const STRINGS = {
  de: {
    "a11y.bannerMode": "Bannermodus",
    "a11y.board.banner": "Banner",
    "a11y.board.bannerRemoved": "Banner entfernt.",
    "a11y.board.banners1": "1 Banner",
    "a11y.board.bannersN": "{n} Banner",
    "a11y.board.cabin": "Die Hütte",
    "a11y.board.cellBanner": "Banner",
    "a11y.board.cellCabin": "Hütte",
    "a11y.board.cellExplored": "erkundet",
    "a11y.board.cellMist": "Nebel",
    "a11y.board.cellWrongBanner": "falsches Banner",
    "a11y.board.chordWaits": "Die Banner ringsum passen nicht zur Zahl.",
    "a11y.board.chosen": "Gewählt: {name}.",
    "a11y.board.confirmed": "Bestätigt",
    "a11y.board.creature": "Ein Wesen",
    "a11y.board.deepMist": "Dichter Nebel",
    "a11y.board.describe": "Umgebung beschreiben",
    "a11y.board.dirEast": "Osten",
    "a11y.board.dirNorth": "Norden",
    "a11y.board.dirSouth": "Süden",
    "a11y.board.dirWest": "Westen",
    "a11y.board.east": "{n} östlich",
    "a11y.board.explore": "Ringsum erkunden",
    "a11y.board.explored": "Erkundet",
    "a11y.board.exploredOn": "Erkundet, {what}",
    "a11y.board.frontier0": "kein Nebel zum Erkunden",
    "a11y.board.frontier1": "1 Nebelfeld zum Erkunden",
    "a11y.board.frontierN": "{n} Nebelfelder zum Erkunden",
    "a11y.board.furthest": "Weitester Punkt: {distance}.",
    "a11y.board.hid": "Lag hier versteckt",
    "a11y.board.hintExplore": "Deckt die Felder ringsum auf.",
    "a11y.board.hintPlant": "Setzt ein Banner.",
    "a11y.board.hintReveal": "Deckt das Feld auf.",
    "a11y.board.hintTakeAway": "Entfernt das Banner.",
    "a11y.board.inMist": "{n} im Nebel",
    "a11y.board.inView": "Im Bild: {what}",
    "a11y.board.listAnd": "{list} und {last}",
    "a11y.board.mist": "Nebel",
    "a11y.board.nextTo": "Neben {numbers}",
    "a11y.board.north": "{n} nördlich",
    "a11y.board.place": "{where} der Hütte, {distance}",
    "a11y.board.plant": "Banner setzen",
    "a11y.board.revealed1": "1 Feld erkundet.",
    "a11y.board.revealedN": "{n} Felder erkundet.",
    "a11y.board.rotorBanners": "Banner",
    "a11y.board.rotorMist": "Nebel zum Erkunden",
    "a11y.board.rotorNorthSouth": "Norden und Süden",
    "a11y.board.rotorNumbers": "Offene Zahlen",
    "a11y.board.roundIt": "Ringsum {what}",
    "a11y.board.rowHere": "Hier: {tiles}.",
    "a11y.board.rowNorth": "Norden: {tiles}.",
    "a11y.board.rowSouth": "Süden: {tiles}.",
    "a11y.board.south": "{n} südlich",
    "a11y.board.takeAway": "Banner entfernen",
    "a11y.board.turned": "Gedreht.",
    "a11y.board.west": "{n} westlich",
    "a11y.board.woke": "Erwachte hier und beendete die Expedition",
    "a11y.board.wrongBanner": "Falsches Banner",
    "a11y.distance": "Weiteste Entfernung",
    "a11y.find": "Neuer Fund: {name}.",
    "a11y.findMore": "Neue Funde: {name} und noch {n}.",
    "a11y.map": "Expeditionskarte",
    "about.body1": "Hinter der Hütte beginnt der Nebel, und im Nebel wohnen die Alten: Trolle unter dem Moos, die Huldra zwischen den Bäumen, Näcken an stillem Wasser.",
    "about.body2": "Bei Mistsweeper geht es darum, das Gelände zu lesen, bevor du es betrittst. Die Zahlen sagen dir, wie viele Wesen in der Nähe schlafen. Wie weit du kommst, liegt bei dir.",
    "about.body3": "Mistsweeper ist eine Neuinterpretation des Rätselklassikers Minesweeper, inspiriert von nordischen Mythen und Sagen.",
    "about.made": "Gemacht von Great Scott! in Stockholm, Schweden.",
    "about.version": "Version {version}",
    "accessibility.contact": "Wenn dich etwas am Spielen hindert oder dir das Spiel leichter machen würde, schreib uns.",
    "accessibility.contactTitle": "Sag uns Bescheid",
    "accessibility.contrast": "Die Welt und die Menüs sind mit Tinte auf Papier gezeichnet, und ihr Kontrast liegt bei Tag wie bei Nacht weit über dem, was Text braucht. Rot markiert, was wichtig ist, aber nie allein: Ein Banner hat seine Form, ein falsches Banner bekommt nach einer Expedition ein Kreuz, und das Feld, auf dem sie endete, einen Rahmen.",
    "accessibility.contrastTitle": "Kontrast und Farbe",
    "accessibility.dark": "Das Spiel folgt dem Dunkelmodus deines Systems: Nacht ist die Welt im Mondlicht. Du kannst Tag oder Nacht auch in den Einstellungen unter Design wählen.",
    "accessibility.darkTitle": "Dunkel und hell",
    "accessibility.intro": "Mistsweeper soll für möglichst viele Menschen spielbar sein. Hier steht, was das Spiel heute unterstützt, im Web und in der iOS-App, und woran wir arbeiten.",
    "accessibility.keys": "Im Web lässt sich das ganze Spiel mit der Tastatur spielen: Die Pfeiltasten oder WASD bewegen den Cursor, die Eingabe- oder Leertaste deckt ein Feld auf, F setzt oder entfernt ein Banner, Q und E drehen die Kamera, T und G neigen sie, Plus und Minus zoomen, H führt zurück zur Hütte und Esc schließt, was offen ist.",
    "accessibility.keysTitle": "Tastatur im Web",
    "accessibility.motion": "Wenn „Bewegung reduzieren“ in deinem System oder in den Einstellungen des Spiels aktiviert ist, bewegt sich nichts von selbst. Der Nebel, der Wind, die Tiere und die Kamera stehen still, neues Gelände erscheint sofort und die Ränder der Welt bleiben scharf.",
    "accessibility.motionTitle": "Bewegung reduzieren",
    "accessibility.sound": "Ton und Musik verraten dir nie etwas, das du nicht auch sehen kannst. Das Spiel kommt ohne gesprochenes Wort und ohne Video aus. In der iOS-App begleitet die Haptik das Aufdecken von Feldern und das Setzen von Bannern. Musik, Töne und Haptik lassen sich in den Einstellungen einzeln ausschalten.",
    "accessibility.soundTitle": "Ton",
    "accessibility.title": "Barrierefreiheit",
    "accessibility.updated": "Stand: 25. Oktober 2026",
    "accessibility.work": "In der iOS-App lässt sich die Karte mit VoiceOver und Sprachsteuerung lesen und spielen, und der Text passt sich deiner Textgröße an. Im Web haben Menüs und Schaltflächen Beschriftungen für Screenreader, aber die Karte lässt sich damit noch nicht lesen oder spielen. Wir arbeiten daran.",
    "accessibility.workTitle": "Woran wir arbeiten",
    "app.tagline": "Eine endlose Expedition",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "Ein Malbuch in Pixel-Art, ohne Werbung und Tracking.",
    "apps.intro": "Kleine Spiele und Apps aus demselben Studio.",
    "apps.krono": "Bring Geschichte, Popkultur und Musik auf einer Zeitleiste in die richtige Reihenfolge.",
    "apps.ordna": "Ein ruhiges Sortierrätsel. Tausend davon, und keine Unterbrechungen.",
    "apps.tapotron": "Tippspiele und Beats auf einem Raster eifriger Knöpfe.",
    "archive.appNoteCloud": "In iCloud gespeichert, auf all deinen Geräten.",
    "archive.appNoteDevice": "Auf diesem Gerät gespeichert. Schalte iCloud für Mistsweeper ein, damit sie auf all deinen Geräten sind.",
    "archive.best": "dein Rekord",
    "archive.daily": "Tägliche Expeditionen",
    "archive.dayStreak": "Tage in Folge",
    "archive.endlessBest": "Rekord",
    "archive.endlessLast": "Zuletzt",
    "archive.endlessRuns": "Runden",
    "archive.expeditions": "Expeditionen",
    "archive.gameCenter": "Im Game Center mit Freunden vergleichen",
    "archive.notPlayed": "nicht gespielt",
    "archive.sealed": "versiegelt",
    "archive.today": "heute, begonnen",
    "archive.todayWord": "heute",
    "archive.webNote": "In diesem Browser gespeichert. Die iOS-App hat ihre eigenen Expeditionen in iCloud.",
    "archive.webNoteShort": "In diesem Browser gespeichert.",
    "banner.1": "Drei Spitzen",
    "banner.a1": "Schwalben­schwanz",
    "banner.a3": "Speerspitze",
    "banner.b1": "Viertel­kreis",
    "banner.b2": "Rabenbanner",
    "banner.b3": "Halbrund",
    "banner.c2": "T-Stab",
    "banner.c3": "Wegzeichen",
    "banner.c4": "Gedreht",
    "beta.bugs": "Funktioniert etwas nicht oder sieht seltsam aus? Schreib uns, was du getan hast, was passiert ist und auf welchem Gerät. Ein Screenshot hilft.",
    "beta.bugsTitle": "Fehler",
    "beta.changes": "Das Spiel ändert sich während der Beta. Zur Veröffentlichung beginnen die Expeditionen nicht wieder bei #1, sondern zählen einfach weiter.",
    "beta.changesTitle": "Was sich ändert",
    "beta.intro": "Mistsweeper lässt sich spielen, ist aber noch nicht fertig. Vor der Veröffentlichung brauchen wir deine Hilfe.",
    "beta.language": "Das Spiel gibt es in neun Sprachen, und die meisten Übersetzungen hat noch niemand gelesen, für den die Sprache Muttersprache ist. Klingt etwas falsch oder steif? Schreib uns, wo du es gesehen hast und wie du es sagen würdest.",
    "beta.languageTitle": "Text und Sprache",
    "beta.more": "Mehr",
    "beta.ticker1": "Mistsweeper ist in der Beta",
    "beta.ticker2": "Finde Fehler für uns",
    "beta.ticker3": "Hilf uns mit der Sprache",
    "beta.title": "Über die Beta",
    "button.banner": "Banner",
    "button.cancel": "Abbrechen",
    "button.close": "Schließen",
    "button.daily": "Heutige Expedition",
    "button.endless": "Endlos",
    "button.home": "Zurück zur Hütte",
    "button.practice": "Übungsrunde",
    "button.settings": "Einstellungen",
    "button.zoomIn": "Vergrößern",
    "button.zoomOut": "Verkleinern",
    "clearing.arrange": "Anordnen",
    "clearing.cabin": "Die Hütte bleibt, wo sie ist.",
    "clearing.cabinChosen": "Deine Hütte: {name}.",
    "clearing.cabinHint": "Deine Hütte kann jedes Haus sein, das du gefunden hast. Halte sie gedrückt, um zu wählen.",
    "clearing.cat.creatures": "Wesen",
    "clearing.cat.ground": "Gelände",
    "clearing.cat.houses": "Häuser",
    "clearing.cat.plants": "Pflanzen",
    "clearing.cat.stones": "Steine",
    "clearing.changeCabin": "Hütte wechseln",
    "clearing.chooseCabin": "Wähle deine Hütte",
    "clearing.clear": "Räumen",
    "clearing.delete": "Löschen",
    "clearing.deleteBody": "Was dort aufgestellt ist, wird mitgelöscht. Deine Funde bleiben.",
    "clearing.deleteTitle": "{name} löschen?",
    "clearing.deleted": "{name} ist gelöscht.",
    "clearing.discovered": "{n} von {total} gefunden",
    "clearing.done": "Fertig",
    "clearing.edit": "Ändern",
    "clearing.editing": "{name} ändern",
    "clearing.family.barley": "Gerste",
    "clearing.family.barn": "Scheune",
    "clearing.family.beacon": "Signalfeuer",
    "clearing.family.beehive": "Bienenkörbe",
    "clearing.family.bergstroll": "Bergtroll",
    "clearing.family.birch": "Birke",
    "clearing.family.boat": "Boot",
    "clearing.family.boathouse": "Bootshaus",
    "clearing.family.boulder": "Findling",
    "clearing.family.bush": "Strauch",
    "clearing.family.cairn": "Steinhaufen",
    "clearing.family.campfire": "Lagerfeuer",
    "clearing.family.cart": "Karren",
    "clearing.family.cave": "Höhle",
    "clearing.family.church": "Stabkirche",
    "clearing.family.cottage": "Kate",
    "clearing.family.driftwood": "Treibholz",
    "clearing.family.fabod": "Alm",
    "clearing.family.faering": "Färing",
    "clearing.family.fence": "Zaun",
    "clearing.family.fern": "Farn",
    "clearing.family.fishhut": "Fischerhütte",
    "clearing.family.flottning": "Flößerei",
    "clearing.family.fornborg": "Ringwall",
    "clearing.family.goahti": "Torfhütte",
    "clearing.family.gravhog": "Grabhügel",
    "clearing.family.harbre": "Stelzenspeicher",
    "clearing.family.hassja": "Heureiter",
    "clearing.family.hides": "Felle und Fleisch",
    "clearing.family.hjell": "Fischgestell",
    "clearing.family.house": "Hütte",
    "clearing.family.huldra": "Huldra",
    "clearing.family.huntingtower": "Hochsitz",
    "clearing.family.jatte": "Riese",
    "clearing.family.jetty": "Bootssteg",
    "clearing.family.juniper": "Wacholder",
    "clearing.family.kastal": "Steinturm",
    "clearing.family.kolmila": "Kohlenmeiler",
    "clearing.family.kummel": "Steinbake",
    "clearing.family.laundry": "Wäsche",
    "clearing.family.lavvu": "Lavvu",
    "clearing.family.lilypads": "Seerosen",
    "clearing.family.log": "Baumstamm",
    "clearing.family.longhouse": "Langhaus",
    "clearing.family.massif": "Bergmassiv",
    "clearing.family.mushroom": "Pilze",
    "clearing.family.nacken": "Näcken",
    "clearing.family.njalla": "Njalla",
    "clearing.family.oak": "Eiche",
    "clearing.family.oats": "Hafer",
    "clearing.family.outcrop": "Felsplatte",
    "clearing.family.peak": "Gipfel",
    "clearing.family.pebbles": "Kiesel",
    "clearing.family.pine": "Kiefer",
    "clearing.family.reeds": "Schilf",
    "clearing.family.rengarde": "Rentiergehege",
    "clearing.family.rock": "Stein",
    "clearing.family.rockcarving": "Felsritzung",
    "clearing.family.rootcellar": "Erdkeller",
    "clearing.family.rowan": "Eberesche",
    "clearing.family.ruin": "Ruine",
    "clearing.family.runestone": "Runenstein",
    "clearing.family.rye": "Roggen",
    "clearing.family.sauna": "Sauna",
    "clearing.family.seamark": "Seezeichen",
    "clearing.family.shed": "Schuppen",
    "clearing.family.shipsetting": "Schiffssetzung",
    "clearing.family.shorestones": "Ufersteine",
    "clearing.family.sjotroll": "Seetroll",
    "clearing.family.skogstroll": "Waldtroll",
    "clearing.family.smithy": "Schmiede",
    "clearing.family.snag": "Toter Baum",
    "clearing.family.spruce": "Fichte",
    "clearing.family.stonecircle": "Steinkreis",
    "clearing.family.stones": "Menhire",
    "clearing.family.stooks": "Stoppelfeld",
    "clearing.family.stormannagard": "Herrenhof",
    "clearing.family.stump": "Baumstumpf",
    "clearing.family.tent": "Zelt",
    "clearing.family.tjardal": "Teergrube",
    "clearing.family.tuft": "Gras",
    "clearing.family.watermill": "Wassermühle",
    "clearing.family.well": "Brunnen",
    "clearing.family.wellsweep": "Ziehbrunnen",
    "clearing.family.windmill": "Windmühle",
    "clearing.family.windthrow": "Windwurf",
    "clearing.family.woodpile": "Holzstapel",
    "clearing.fold": "Einklappen",
    "clearing.ground.forest": "Wald",
    "clearing.ground.meadow": "Wiese",
    "clearing.ground.mountain": "Berg",
    "clearing.ground.water": "Wasser",
    "clearing.grown": "Der Nebel weicht zurück.",
    "clearing.hint": "Wähle unten etwas aus und tippe dann auf ein Feld. Tippe noch einmal, um es zu drehen. Halte ein Feld gedrückt, um es zu ändern.",
    "clearing.hintVoiceOver": "Wähle unten etwas aus und doppeltippe dann auf ein Feld. Mit den Aktionen eines Felds kannst du es ändern, drehen oder räumen.",
    "clearing.large": "Groß",
    "clearing.locked": "Noch nicht gefunden. Es wartet draußen im Nebel.",
    "clearing.lockedName": "{name}, noch nicht gefunden",
    "clearing.made": "Eine neue Lichtung: {name}.",
    "clearing.mist": "Das liegt im Nebel.",
    "clearing.needsLand": "Das braucht Land.",
    "clearing.needsWater": "Das braucht Wasser.",
    "clearing.new": "Neue Lichtung",
    "clearing.photo": "Foto",
    "clearing.photo.back": "Zurück",
    "clearing.photo.failed": "Das Bild ließ sich hier nicht erstellen.",
    "clearing.photo.file": "lichtung",
    "clearing.photo.formats": "Format",
    "clearing.photo.notSaved": "Das Bild konnte nicht gespeichert werden. In den Einstellungen kannst du Mistsweeper erlauben, Fotos hinzuzufügen.",
    "clearing.photo.picture": "Dein Bild",
    "clearing.photo.save": "Speichern",
    "clearing.photo.saved": "In deinen Fotos gespeichert.",
    "clearing.photo.share": "Teilen",
    "clearing.photo.shutter": "Foto aufnehmen",
    "clearing.photo.usage": "Mistsweeper speichert die Bilder deiner Lichtung in deinen Fotos, wenn du darum bittest.",
    "clearing.rename": "Umbenennen",
    "clearing.renameSave": "Speichern",
    "clearing.renameTitle": "Lichtung benennen",
    "clearing.size": "Größe der Lichtung",
    "clearing.small": "Klein",
    "clearing.supporter": "Supporter",
    "clearing.turn": "Drehen",
    "clearing.undo": "Rückgängig",
    "clearing.yours": "Deine Lichtungen",
    "controls.banner": "Banner setzen",
    "controls.click": "Klicken",
    "controls.drag": "Ziehen",
    "controls.pan": "Verschieben",
    "controls.pinch": "Auf- und zuziehen",
    "controls.qe": "Q und E",
    "controls.reveal": "Aufdecken",
    "controls.rightClick": "Rechtsklick",
    "controls.rightDrag": "Rechtsklick und ziehen",
    "controls.scroll": "Scrollen",
    "controls.tg": "T und G",
    "controls.tilt": "Neigen",
    "controls.title": "Steuerung",
    "controls.turn": "Drehen",
    "controls.turnTilt": "Drehen und neigen",
    "controls.twist": "Zwei Finger drehen",
    "controls.twoFingers": "Zwei Finger nach oben oder unten",
    "controls.voActions": "Nach oben oder unten streichen",
    "controls.voFind": "Nebel zum Erkunden, offene Zahlen, Banner, Norden und Süden",
    "controls.voMagicTap": "Mit zwei Fingern doppeltippen",
    "controls.voMove": "Die Karte um vier Felder verschieben",
    "controls.voRotor": "Rotor drehen",
    "controls.voScroll": "Mit drei Fingern streichen",
    "controls.voSummary": "Wo du bist und wie weit du gekommen bist",
    "controls.voSwipe": "Nach links oder rechts streichen",
    "controls.voTileActions": "Die Aktionen eines Felds: Banner, ringsum erkunden, Umgebung beschreiben",
    "controls.voTiles": "Die Felder im Bild, Reihe für Reihe von Norden",
    "controls.zoom": "Zoomen",
    "daily.next": "Nächste Expedition in {time}",
    "feedback.subject": "Feedback zu Mistsweeper, Version {version}",
    "find.new": "Neuer Fund",
    "getApp.beta": "Die App ist in der Beta. Installiert wird sie mit TestFlight, Apples App zum Testen von Apps vor ihrer Veröffentlichung.",
    "getApp.haptics": "Haptik unter deinen Fingern.",
    "getApp.intro": "Jeden Tag dieselbe Expedition, mit ein paar Dingen, die nur eine App kann.",
    "getApp.join": "Der Beta auf TestFlight beitreten",
    "getApp.note": "Deine Expeditionen in diesem Browser bleiben hier. Die App hat ihre eigenen.",
    "getApp.offline": "Auch ohne Internet spielbar.",
    "getApp.qr": "Richte die Kamera deines iPhone auf diesen Code, um der Beta beizutreten.",
    "getApp.qrLabel": "QR-Code für die Beta auf TestFlight",
    "getApp.reminder": "Eine tägliche Erinnerung zu einer Uhrzeit deiner Wahl.",
    "getApp.widget": "Ein Widget mit der heutigen Expedition und deiner Serie.",
    "hint.clearingDesktop": "Wähle etwas aus und stelle es auf der Lichtung auf. Rechtsklick auf ein Feld ändert es.",
    "hint.photoDesktop": "Richte die Lichtung im Fenster aus und mach dann das Foto.",
    "hint.reveal": "Tippe neben erkundetes Gelände, um ein Feld aufzudecken.",
    "hint.revealDesktop": "Klicke neben erkundetes Gelände, um ein Feld aufzudecken. Rechtsklick setzt ein Banner.",
    "hint.revealVoiceOver": "Streiche zu einem Nebelfeld neben erkundetem Gelände oder finde es mit dem Rotor. Doppeltippe dann, um es aufzudecken.",
    "howto.1": "Du beginnst bei der Hütte. Alles andere ist Nebel.",
    "howto.2": "Decke ein Feld auf, das an erkundetes Gelände grenzt. Du gehst von dort weiter, wo du schon warst, ein Feld nach dem anderen.",
    "howto.3": "Eine Zahl sagt, wie viele Wesen sich in den acht Feldern um sie herum verstecken.",
    "howto.3example": "Hier verstecken sich Wesen in zwei der drei Felder, die noch im Nebel liegen.",
    "howto.4mouse": "Setze ein Banner, wo du ein Wesen vermutest: Klicke mit der rechten Maustaste auf das Feld.",
    "howto.4touch": "Setze ein Banner, wo du ein Wesen vermutest: Schalte den Bannermodus ein und tippe auf das Feld.",
    "howto.4voiceOver": "Setze ein Banner, wo du ein Wesen vermutest: Streiche auf dem Feld nach oben oder unten zu seinen Aktionen und wähle „Banner setzen“.",
    "howto.5": "Weckst du ein Wesen, endet die Expedition. Dein Ergebnis ist der weiteste Punkt, den du von der Hütte aus erreicht hast.",
    "howto.6": "Jeden Tag kommt eine neue Expedition: dasselbe Gelände für alle und nur ein Versuch. Für die ruhigen Stunden gibt es Endlos.",
    "howto.tryLesson": "In der Welt ausprobieren",
    "hud.best": "Rekord {distance}",
    "hud.clearing": "Lichtung",
    "hud.menu": "Menü",
    "hud.north": "Norden nach oben drehen",
    "hud.practice": "Übungsrunde, #{n}",
    "hud.today": "Heute",
    "hud.turnLeft": "Nach links drehen, Q",
    "hud.turnLeftKey": "Q",
    "hud.turnRight": "Nach rechts drehen, E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "Das ist Gerste.",
    "inspect.barley.2": "Bald Brot oder etwas Besseres.",
    "inspect.barn.1": "Das ist eine Scheune.",
    "inspect.barn.2": "Voller Heu und Katzen.",
    "inspect.barn.3": "Heu bis unters Dach. Das reicht bis zum Frühjahr.",
    "inspect.beacon.1": "Ein Signalfeuer. Bei Feindsichtung entzünden.",
    "inspect.beacon.2": "Ein Feuer, dann das nächste, und das ganze Land weiß es.",
    "inspect.beacon.3": "Trocken und bereit. Noch hat es niemand entzündet.",
    "inspect.beehive.1": "Bienenkörbe. Besser nicht anklopfen.",
    "inspect.beehive.2": "Wir haben zu tun.",
    "inspect.birch.1": "Das ist eine Birke.",
    "inspect.birch.2": "Weiße Rinde, schwarze Striche. Jemand hat gezählt.",
    "inspect.birch.3": "Birkenrinde brennt auch nass. Gut zu wissen.",
    "inspect.birch.4": "Die Birke ist als Erste grün, als Erste gelb.",
    "inspect.boat.1": "Ein Ruderboot. Jemand will es sicher zurück.",
    "inspect.boat.2": "Ruder eingezogen. Niemand an Bord.",
    "inspect.boathouse.1": "Es riecht nach Teer und nassem Tauwerk.",
    "inspect.boathouse.2": "Das Boot ist draußen. Wann es zurück ist, hat niemand gesagt.",
    "inspect.boulder.1": "Ein Findling. Er zog einmal um, mit dem Eis.",
    "inspect.boulder.2": "Ich kam mit dem Eis. Ich bleibe.",
    "inspect.boulder.3": "Das Eis ließ ihn hier liegen und ging nach Hause.",
    "inspect.bush.1": "Das ist ein Strauch.",
    "inspect.bush.2": "Im Strauch versteckt sich nichts. Vermutlich.",
    "inspect.bush.3": "Etwas raschelte. Es war nur der Strauch.",
    "inspect.cabin": "Deine Hütte. Der Ofen ist noch warm.",
    "inspect.cairn.1": "Das ist ein Steinhaufen.",
    "inspect.cairn.2": "Wer vorbeikommt, legt einen Stein dazu.",
    "inspect.cairn.3": "Jemand hat den Weg markiert. Oder ein Grab.",
    "inspect.campfire.1": "Das ist ein Lagerfeuer.",
    "inspect.campfire.2": "Ein Feuer, und niemand dabei.",
    "inspect.campfire.3": "Jemand ist in aller Eile aufgebrochen.",
    "inspect.cart.1": "Das ist ein Karren.",
    "inspect.cart.2": "Zurückgelassen, wo das Pferd stehen blieb.",
    "inspect.cave.1": "Das ist eine Höhle. Sie führt hinein.",
    "inspect.cave.2": "Komm herein.",
    "inspect.cave.3": "Etwas atmet darin. Oder es ist der Wind.",
    "inspect.church.1": "Eine Stabkirche. Jahrhunderte voller Teer.",
    "inspect.church.2": "Kein einziger Stein. Nur Holz und Geduld.",
    "inspect.church.3": "Drinnen ist es still. Das war es schon immer.",
    "inspect.creature.bergstroll": "Hier wohnte ein Bergtroll.",
    "inspect.creature.huldra": "Hier wohnte eine Huldra.",
    "inspect.creature.jatte": "Hier wohnte ein Riese.",
    "inspect.creature.nacken": "Hier wohnte Näcken.",
    "inspect.creature.sjotroll": "Hier wohnte ein Seetroll.",
    "inspect.creature.skogstroll": "Hier wohnte ein Waldtroll.",
    "inspect.deer.1": "Ein Reh. Es hat dich längst gesehen.",
    "inspect.deer.2": "Es hebt den Kopf und frisst dann weiter.",
    "inspect.driftwood.1": "Treibholz. Niemand weiß, woher.",
    "inspect.driftwood.2": "Es hat mehr vom Meer gesehen als jeder hier.",
    "inspect.duck.1": "Eine Stockente. Sie kümmert sich um ihren Kram.",
    "inspect.duck.2": "Sie hat dazu eine Meinung.",
    "inspect.elk.1": "Ein Elch. Es ist ihm egal.",
    "inspect.elk.2": "Das Größte im Wald und das Leiseste.",
    "inspect.faering.1": "Ein Färing. Vier Ruder und ein Segel.",
    "inspect.faering.2": "Gezimmert wie einst die Langschiffe.",
    "inspect.fence.1": "Ein Zaun. Kein einziger Nagel.",
    "inspect.fence.2": "Was er drinnen halten sollte, ist davongezogen.",
    "inspect.fern.1": "Das ist ein Farn.",
    "inspect.fern.2": "Farne waren vor den Bäumen da.",
    "inspect.fern.3": "In der Mittsommernacht soll der Farn blühen. Gesehen hat es niemand.",
    "inspect.fishhut.1": "Netze, Bojen und alter Hering.",
    "inspect.fishhut.2": "Fischerhütte. Der Geruch ist zuerst da.",
    "inspect.flottning.1": "Stämme auf dem Weg zur Küste.",
    "inspect.flottning.2": "Flößerei. Das Tragen übernimmt der Fluss.",
    "inspect.fornborg.1": "Ein Ringwall. Hierher lief man, wenn die Signalfeuer brannten.",
    "inspect.fornborg.2": "Der Wall ist zerfallen. Wen er aufhielt, der ist auch fort.",
    "inspect.fornborg.3": "Wer diese Steine aufschichtete, weiß niemand.",
    "inspect.goahti.1": "Eine Torfhütte. Außen Torf, innen warm.",
    "inspect.goahti.2": "Der Rauch zieht oben ab. Das tut er seit jeher.",
    "inspect.gravhog.1": "Ein Grabhügel. Jemand Wichtiges.",
    "inspect.gravhog.2": "Hier liegt jemand. Geh leise.",
    "inspect.gravhog.3": "Ein Grab. Tausend Jahre Gras darüber.",
    "inspect.harbre.1": "Ein Stelzenspeicher. Auf Pfosten, für Mäuse zu hoch.",
    "inspect.harbre.2": "Darin liegt das Korn vom letzten Jahr.",
    "inspect.hassja.1": "Ein Heureiter. Das Heu trocknet im Wind.",
    "inspect.hassja.2": "Heu auf den Stangen. Jetzt darf es nicht regnen.",
    "inspect.hides.1": "Rentierfelle auf Rahmen. Nichts geht verloren.",
    "inspect.hides.2": "Fleisch trocknet im Wind. Wintervorrat.",
    "inspect.hjell.1": "Stockfisch beim Trocknen. Das Kochen übernimmt der Wind.",
    "inspect.hjell.2": "Das riecht bis hierher.",
    "inspect.home": "Hier wohnt {name}.",
    "inspect.huntingtower.1": "Da oben sitzt jemand und wartet.",
    "inspect.huntingtower.2": "Die Elche wissen Bescheid.",
    "inspect.jetty.1": "Das ist ein Bootssteg.",
    "inspect.jetty.2": "Er geht ein Stück hinaus und gibt auf.",
    "inspect.jetty.3": "Ein guter Ort für nackte Füße.",
    "inspect.juniper.1": "Das ist ein Wacholder.",
    "inspect.juniper.2": "Ein Wacholder. Er sticht zurück.",
    "inspect.juniper.3": "Ein Wacholder. Von Weitem sieht er aus wie jemand, der still dasteht.",
    "inspect.kastal.1": "Dicke Mauern, kleine Fenster.",
    "inspect.kastal.2": "Jemand erwartete Besuch, und zwar keinen netten.",
    "inspect.kolmila.1": "Das ist ein Kohlenmeiler.",
    "inspect.kolmila.2": "Er schwelt wochenlang. Jemand muss wach bleiben.",
    "inspect.kolmila.3": "Hinein geht Holz. Heraus kommt Kohle.",
    "inspect.kummel.1": "Eine Steinbake. Sie zeigt Seeleuten, wo sie sind.",
    "inspect.kummel.2": "Vom Meer aus sieht man sie. Mehr soll sie auch nicht.",
    "inspect.laundry.1": "Die Wäsche von jemandem.",
    "inspect.laundry.2": "Bis zum Abend trocken, wenn der Nebel wegbleibt.",
    "inspect.laundry.3": "Eine Socke fehlt.",
    "inspect.lavvu.1": "Ein Lavvu. Morgen früh kann es weg sein.",
    "inspect.lavvu.2": "Stangen und Tuch. Mehr braucht es nicht.",
    "inspect.lilypads.1": "Seerosen.",
    "inspect.lilypads.2": "Seerosen. Nicht pflücken. Jemand hängt an ihnen.",
    "inspect.lilypads.3": "Seerosen an langen Stängeln, hinab ins Dunkel.",
    "inspect.log.1": "Das ist ein Baumstamm.",
    "inspect.log.2": "Längst gefallen. Das Moos ist eingezogen.",
    "inspect.massif.1": "Das ist ein Bergmassiv.",
    "inspect.massif.2": "Der Berg nimmt Besucher nicht zur Kenntnis.",
    "inspect.massif.3": "Schnee in den Spalten, selbst im August.",
    "inspect.mushroom.1": "Pilze. Besser stehen lassen.",
    "inspect.mushroom.2": "Alle Pilze sind essbar. Manche nur einmal.",
    "inspect.mushroom.3": "Für die kommt noch jemand mit einem Korb.",
    "inspect.njalla.1": "Eine Njalla. Ein Pfahl, und die Bären können nur zusehen.",
    "inspect.njalla.2": "Vorräte, hoch oben, wo nur Menschen hinkommen.",
    "inspect.oak.1": "Das ist eine Eiche.",
    "inspect.oak.2": "Eine Eiche. Älter als die älteste Geschichte über sie.",
    "inspect.oak.3": "Die Eiche hat Könige kommen und gehen sehen.",
    "inspect.oak.4": "Einst gehörte jede Eiche der Krone.",
    "inspect.oats.1": "Das ist Hafer.",
    "inspect.oats.2": "Hafer für die Pferde und fürs Frühstück.",
    "inspect.outcrop.1": "Nackter Fels. Das Land ohne Mantel.",
    "inspect.outcrop.2": "Warm in der Sonne, kalt in der Nacht.",
    "inspect.outcrop.3": "Das hat das Eis geschliffen.",
    "inspect.peak.1": "Gipfel. Schnee das ganze Jahr.",
    "inspect.peak.2": "Hier oben wächst nichts.",
    "inspect.peak.3": "Die Aussicht soll gut sein. Der Nebel sieht das anders.",
    "inspect.pebbles.1": "Kiesel.",
    "inspect.pebbles.2": "Jeder einzelne war einmal ein Berg.",
    "inspect.pine.1": "Das ist eine Kiefer.",
    "inspect.pine.2": "Die Kiefer war zuerst da.",
    "inspect.pine.3": "Kiefern mögen es trocken und karg. Diese hier ist zufrieden.",
    "inspect.pine.4": "Die Kiefer neigt sich, wie der Wind es ihr gesagt hat.",
    "inspect.reeds.1": "Schilf.",
    "inspect.reeds.2": "Das Schilf flüstert. Es ist nur der Wind.",
    "inspect.reeds.3": "Etwas regte sich darin. Vermutlich ein Vogel.",
    "inspect.reindeer.1": "Jedes Rentier hier gehört jemandem.",
    "inspect.reindeer.2": "Es ist unterwegs. Es weiß, wohin.",
    "inspect.rengarde.1": "Im Herbst sammelt sich hier die Herde.",
    "inspect.rengarde.2": "Jetzt leer. Die Rentiere wissen, wohin sie ziehen.",
    "inspect.rock.1": "Das ist ein Stein.",
    "inspect.rock.2": "Ja? Ein Stein.",
    "inspect.rock.3": "Ein Stein. Er hat dazu keine Meinung.",
    "inspect.rock.4": "Nichts passiert. Das ist ein Stein.",
    "inspect.rockcarving.1": "In den Fels geritzt, lange vor den Runen.",
    "inspect.rockcarving.2": "Wir waren hier.",
    "inspect.rockcarving.3": "Niemand kann das lesen. Es sagt trotzdem etwas.",
    "inspect.rootcellar.1": "Kartoffeln im Dunkeln.",
    "inspect.rootcellar.2": "Da drin friert es nie.",
    "inspect.rowan.1": "Das ist eine Eberesche.",
    "inspect.rowan.2": "Eine Eberesche. Viele Beeren, viel Schnee, sagt man.",
    "inspect.rowan.3": "Trolle meiden Ebereschen, heißt es.",
    "inspect.ruin.1": "Das ist eine Ruine.",
    "inspect.ruin.2": "Darauf war einmal jemand stolz.",
    "inspect.ruin.3": "Was hier stand, ist fort. Die Steine blieben.",
    "inspect.runestone.1": "Das ist ein Runenstein.",
    "inspect.runestone.2": "Jemand ließ ihn errichten, für ein Kind.",
    "inspect.runestone.3": "Runenstein. Zog nach Osten, steht da. Kam nicht heim.",
    "inspect.runestone.4": "Runenstein. Deute dies, wer kann.",
    "inspect.rye.1": "Das ist Roggen.",
    "inspect.rye.2": "Roggen steht den Winter durch und verlangt nichts.",
    "inspect.sauna.1": "Das ist eine Sauna.",
    "inspect.sauna.2": "Eine Sauna. Noch warm.",
    "inspect.sauna.3": "Birkenzweige an der Tür. Jemand kommt wieder.",
    "inspect.seamark.1": "Ein Seezeichen. Seeleute steuern danach.",
    "inspect.seamark.2": "Hier.",
    "inspect.shed.1": "Ein Schuppen. Werkzeug, Seile und Teergeruch.",
    "inspect.shed.2": "Abgeschlossen, und der Schlüssel ist woanders.",
    "inspect.shipsetting.1": "Ein Schiff aus Stein, für die letzte Reise.",
    "inspect.shipsetting.2": "Mit diesem Schiff wurde jemand verabschiedet.",
    "inspect.shipsetting.3": "Steinschiff. Es hat sich nicht bewegt, seit der Eisenzeit.",
    "inspect.shorestones.1": "Flache Steine hüpfen am besten.",
    "inspect.shorestones.2": "Das Wasser arbeitet schon lange an ihnen.",
    "inspect.smithy.1": "Das ist eine Schmiede.",
    "inspect.smithy.2": "Es riecht nach Kohle und Eisen.",
    "inspect.smithy.3": "Trolle mögen kein Eisen, heißt es.",
    "inspect.snag.1": "Der Baum ist tot. Er steht trotzdem.",
    "inspect.snag.2": "Ein toter Baum. Trocken bis ins Mark und gut fürs Feuer.",
    "inspect.snag.3": "Die Spechte sind weiterhin interessiert.",
    "inspect.spruce.1": "Das ist eine Fichte.",
    "inspect.spruce.2": "Unter einer Fichte ist immer ein wenig Abend.",
    "inspect.spruce.3": "Nadeln unter den Füßen. Sonst wächst hier nichts.",
    "inspect.spruce.4": "Das ganze Jahr dunkel und nie in Eile.",
    "inspect.stonecircle.1": "Ein Steinkreis. Hier saßen Richter, sagt man.",
    "inspect.stonecircle.2": "Eigentlich ein Grab. Die Richter sind nur eine Sage.",
    "inspect.stonecircle.3": "Tritt ein. Oder lass es.",
    "inspect.stones.1": "Von Hand aufgerichtet. Niemand weiß mehr, warum.",
    "inspect.stones.2": "Menhire. Sie stehen da, als hätten sie eben aufgehört zu reden.",
    "inspect.stones.3": "Die Menhire warten noch immer.",
    "inspect.stooks.1": "Die Ernte ist eingebracht.",
    "inspect.stooks.2": "Die Garben trocknen. Jemand kommt sie noch holen.",
    "inspect.stump.1": "Das ist ein Baumstumpf.",
    "inspect.stump.2": "Hier war jemand mit der Axt.",
    "inspect.stump.3": "Zähl die Ringe, falls Zeit bleibt.",
    "inspect.tent.1": "Ein Zelt von einer früheren Expedition.",
    "inspect.tent.2": "Die Expedition kam nie zurück, um es zu holen.",
    "inspect.tent.3": "Die letzte Seite im Notizbuch ist leer.",
    "inspect.tjardal.1": "Eine Teergrube. Kiefernholz hinein, Teer heraus.",
    "inspect.tjardal.2": "Damit wurden Schiffe geteert.",
    "inspect.tuft.1": "Gras.",
    "inspect.tuft.2": "Keine besonderen Vorkommnisse. Gras.",
    "inspect.tuft.3": "Das Gras beugt sich und steht wieder auf.",
    "inspect.tuft.4": "Nur Gras.",
    "inspect.watermill.1": "Das ist eine Wassermühle.",
    "inspect.watermill.2": "Das Mahlen übernimmt das Wasser, Tag und Nacht.",
    "inspect.well.1": "Das ist ein Brunnen.",
    "inspect.well.2": "Lass einen Stein fallen und zähl. Es geht tief hinab.",
    "inspect.well.3": "Kaltes Wasser, das ganze Jahr.",
    "inspect.wellsweep.1": "Ein Ziehbrunnen. Das Heben übernimmt die lange Stange.",
    "inspect.wellsweep.2": "Herauf kommt der Eimer, wenn jemand zieht.",
    "inspect.windmill.1": "Das ist eine Windmühle.",
    "inspect.windmill.2": "Die ganze Mühle dreht sich in den Wind.",
    "inspect.windmill.3": "Hier mahlt der Wind das Mehl.",
    "inspect.windthrow.1": "Das ist ein Windwurf.",
    "inspect.windthrow.2": "Vom Wind ausgerissen, mit Stumpf und Stiel.",
    "inspect.windthrow.3": "Windwurf. Frag nicht, was passiert ist.",
    "inspect.woodpile.1": "Der nächste Winter, gestapelt.",
    "inspect.woodpile.2": "Sorgfältig gestapelt. Nimm nicht das unterste.",
    "lang.mist": "Nebel",
    "lang.name": "Deutsch",
    "lesson.cabinText": "Du beginnst bei der Hütte. Tippe auf ein Feld neben erkundetem Gelände, und der Nebel lichtet sich. Versuch es mit dem eingekreisten Feld.",
    "lesson.cabinTextMouse": "Du beginnst bei der Hütte. Klicke auf ein Feld neben erkundetem Gelände, und der Nebel lichtet sich. Versuch es mit dem eingekreisten Feld.",
    "lesson.cabinTitle": "Die Hütte",
    "lesson.done": "Fertig",
    "lesson.endDistance": "Du hast dich {distance} von der Hütte entfernt. Das ist dein Ergebnis. Je weiter, desto besser.",
    "lesson.endText": "Die Zahlen verschwinden, sobald über ihren Wesen Banner stehen. Weckst du ein Wesen, endet die Expedition.",
    "lesson.endTitle": "Bereit",
    "lesson.invite": "Lerne zuerst das Spiel kennen. Es dauert eine Minute, und deine Freunde warten.",
    "lesson.noCreature": "Dort schläft kein Wesen.",
    "lesson.numberHold": "Halte den Finger auf dem Feld, um ein Banner zu setzen.",
    "lesson.numberMode": "Oder schalte den Bannermodus ein und tippe auf das Feld.",
    "lesson.numberMouse": "Klicke mit der rechten Maustaste auf das Feld, um ein Banner zu setzen.",
    "lesson.numberText": "Eine Zahl zählt die Wesen in den acht Feldern um sie herum. Diese 1 hat nur noch ein Feld im Nebel, also schläft dort eines.",
    "lesson.numberTitle": "Eine Zahl",
    "lesson.ownText": "Die 2, die du gefunden hast, hat noch zwei Felder im Nebel. Setze auf beide ein Banner.",
    "lesson.ownTitle": "Jetzt du",
    "lesson.safeText": "Diese 1 hat ihr Wesen schon gefunden. Also ist das andere Feld um sie herum sicher. Decke es auf.",
    "lesson.safeTitle": "Sicheres Gelände",
    "lesson.woke": "Dort schlief ein Wesen. Versuch es noch einmal.",
    "list.add": "Hinzufügen",
    "list.addBody": "Dein Name und deine Expedition sind für alle auf mistsweeper.com und in der App zu sehen. Künftig wird deine Expedition jeden Tag hinzugefügt, sobald sie endet, bis du das in den Einstellungen ausschaltest.",
    "list.addTitle": "Deinen Namen hinzufügen",
    "list.as": "als {name}",
    "list.countSoFar": "Bisher {count} Entdecker",
    "list.countSoFarOne": "Bisher {count} Entdecker",
    "list.empty": "Heute ist noch niemand auf der Liste. Du könntest den Anfang machen.",
    "list.errorAlready": "Von hier aus wurde schon eine Expedition zur heutigen Liste hinzugefügt.",
    "list.errorBlocked": "Von hier aus können keine Expeditionen mehr hinzugefügt werden.",
    "list.errorBusy": "Von hier aus kamen zu viele Anfragen in kurzer Zeit. Versuch es in ein paar Minuten noch einmal.",
    "list.errorClosed": "Die Liste für diese Expedition ist geschlossen.",
    "list.errorName": "Verwende 2 bis 20 Buchstaben, Ziffern oder Leerzeichen.",
    "list.errorOther": "Die Liste ist nicht erreichbar. Versuch es noch einmal.",
    "list.errorRefused": "Dieser Name kann nicht verwendet werden. Versuch einen anderen.",
    "list.hiddenName": "Name ausgeblendet",
    "list.loading": "Auf der Suche nach den heutigen Top-Entdeckern.",
    "list.nameLabel": "Dein Name",
    "list.notAdded": "Nicht auf der Liste",
    "list.placeSoFar": "#{place} von bisher {count}",
    "list.remove": "Entfernen",
    "list.removeBody": "Alle Expeditionen, die von hier aus hinzugefügt wurden, verschwinden von den Listen. Unter deinen eigenen Expeditionen bleiben sie erhalten.",
    "list.removeTitle": "Deine Expeditionen entfernen?",
    "list.renameBody": "Er ändert sich bei jeder Expedition, die du hinzugefügt hast.",
    "list.renameTitle": "Dein Name auf der Liste",
    "list.report": "Melden",
    "list.reportBody": "Ein Name, den mehrere Spieler melden, wird ausgeblendet, bis wir ihn uns angesehen haben.",
    "list.reportTitle": "Diesen Namen melden?",
    "list.tiles": "{tiles} Felder",
    "list.unreachable": "Die Liste ist gerade nicht erreichbar. Versuch es gleich noch einmal.",
    "list.waiting": "Wartet darauf, hinzugefügt zu werden",
    "list.you": "Du",
    "list.yours": "Deine Expedition",
    "menu.about": "Über Mistsweeper",
    "menu.apps": "Mehr von Great Scott!",
    "menu.appsLine": "Ordna, Krono, Tapotron, Color Tap",
    "menu.back": "Zurück zum Menü",
    "menu.close": "Menü schließen",
    "menu.expeditions": "Deine Expeditionen",
    "menu.expeditionsLine": "Serie {streak}, Rekord {distance}",
    "menu.feedback": "Feedback senden",
    "menu.getApp": "iOS-App laden",
    "menu.getAppLine": "Erinnerungen und Haptik, in der Beta",
    "menu.howto": "So spielst du",
    "menu.howtoLine": "Die Regeln und die Steuerung",
    "menu.list": "Top-Entdecker",
    "menu.listLine": "Wer heute am weitesten kam",
    "menu.privacy": "Datenschutzerklärung",
    "menu.settingsLine": "Design {theme}, {language}",
    "menu.version": "Version {version} · Great Scott! AB",
    "mode.daily": "Expedition #{n}",
    "mode.endless": "Endlos",
    "mode.endlessBest": "Endlos, Rekord {distance}",
    "note.banner": "Banner gesetzt.",
    "note.bannerOff": "Bannermodus aus.",
    "note.bannerOn": "Bannermodus an.",
    "note.cabin": "Zurück zur Hütte.",
    "note.clearing": "Deine Lichtung. Stell deine Funde auf.",
    "note.copied": "In die Zwischenablage kopiert.",
    "note.endless": "Endlos. Jedes Mal eine neue Welt.",
    "note.listRemoved": "Von den Listen entfernt.",
    "note.listReported": "Name gemeldet.",
    "note.north": "Norden ist wieder oben.",
    "note.today": "Die heutige Expedition.",
    "note.todayPractice": "Die heutige Expedition, als Übung.",
    "over.bergstroll": "Du hast einen Bergtroll geweckt.",
    "over.bergstrollLine": "Bergtrolle sitzen so still zwischen den Steinen, dass man sie für Steine hält.",
    "over.copied": "Kopiert",
    "over.endlessRuns": "Endlos-Runden",
    "over.furthestLabel": "Weitester Punkt",
    "over.huldra": "Die Huldra wartete zwischen den Bäumen.",
    "over.huldraLine": "Sie sieht aus wie eine junge Frau, bis sie sich umdreht. Wer ihr in den Wald folgt, bleibt dort.",
    "over.jatte": "Ein Riese erhob sich aus dem Berg.",
    "over.jatteLine": "Riesen schlafen in den Bergen, die Schultern über der Erde. Du hast auf einem gestanden.",
    "over.jatteMeadow": "Ein Riese trat aus dem Nebel.",
    "over.jatteMeadowLine": "Riesen wandern über offenes Land, weit weg von jeder Hütte. Niemand hört sie kommen.",
    "over.kickerDaily": "Expedition #{n}, {dateShort}",
    "over.kickerEndless": "Endlos",
    "over.kickerPractice": "Übungsrunde zu Expedition #{n}",
    "over.kickerTogether": "Endlos, gemeinsam",
    "over.memberLine": "{tiles}, {distance}",
    "over.nacken": "Näcken wartete am Wasser.",
    "over.nackenLine": "Näcken spielt an stillem Wasser. Wer stehen bleibt, um zu lauschen, geht nicht weiter.",
    "over.newWorld": "Neue Welt erkunden",
    "over.practiceBoard": "Auf dem heutigen Gelände üben",
    "over.setOutAgain": "Erneut aufbrechen",
    "over.share": "Teilen",
    "over.shared": "Geteilt",
    "over.sjotroll": "Du hast einen Seetroll geweckt.",
    "over.sjotrollLine": "Was wie eine kleine Insel aussah, hatte Augen.",
    "over.skogstroll": "Du hast einen Waldtroll geweckt.",
    "over.skogstrollLine": "Waldtrolle schlafen unter dem Moos, wo die Fichten am dichtesten stehen. Sie hassen es, geweckt zu werden.",
    "over.streak": "Serie",
    "over.streakDay": "{days} Tag",
    "over.streakDays": "{days} Tage",
    "over.title": "Etwas regte sich im Nebel.",
    "over.todayResult": "Heutiges Ergebnis",
    "over.todayWaiting": "Die heutige Expedition wartet noch",
    "over.togetherBest": "Rekord gemeinsam",
    "over.togetherMembers": "Entdecker",
    "over.yourBest": "Dein Rekord",
    "party.away": "Weg",
    "party.back": "Wieder zusammen.",
    "party.cardLine": "{status}, {tiles}, {distance}",
    "party.copied": "Link kopiert.",
    "party.fell": "Schaut zu",
    "party.follow": "Folgen",
    "party.following": "Du folgst {name}",
    "party.full": "Diese Expedition ist voll.",
    "party.guest": "Entdecker {n}",
    "party.invite": "Freunde einladen",
    "party.inviteBody": "Schick den Link oder zeig den QR-Code. Wer mitkommt, steigt hier ein, bei deiner Hütte, auf dieser Expedition. Bis zu {n} zusammen.",
    "party.inviteTitle": "Gemeinsam erkunden",
    "party.join": "Mitkommen",
    "party.joinBody": "Eine Expedition, {distance} tief im Nebel. Wer einem Wesen begegnet, schaut den anderen zu.",
    "party.joinTitle": "{name} lädt dich ein",
    "party.joinTitleAnon": "Du bist eingeladen",
    "party.joined": "{name} ist dabei.",
    "party.leave": "Expedition verlassen",
    "party.lock": "Für Neue schließen",
    "party.locked": "Diese Expedition ist für Neue geschlossen.",
    "party.lockedNote": "Für Neue geschlossen.",
    "party.lost": "Verbindung verloren. Die anderen werden gesucht.",
    "party.memberFell": "{name} ist gefallen.",
    "party.memberRemoved": "{name} ist nicht mehr auf der Expedition.",
    "party.members": "Mitglieder der Expedition",
    "party.notNow": "Nicht jetzt",
    "party.openNote": "Für Neue geöffnet.",
    "party.out": "Im Nebel",
    "party.over": "Diese Expedition ist vorbei.",
    "party.qrLabel": "QR-Code mit dem Link zu dieser Expedition",
    "party.remove": "Aus der Expedition nehmen",
    "party.removeAsk": "{name} aus der Expedition nehmen? Mit dem Link geht es dann nicht mehr zurück.",
    "party.removed": "Du bist nicht mehr auf dieser Expedition.",
    "party.share": "Link teilen",
    "party.shareText": "Komm mit auf meine Expedition im Nebel.",
    "party.tiles": "{n} Felder",
    "party.tiles1": "1 Feld",
    "party.unavailable": "Das ging nicht. Versuch es gleich noch einmal.",
    "party.unfollow": "Nicht mehr folgen",
    "party.unlock": "Für Neue öffnen",
    "party.you": "Du",
    "party.youFell": "Du bist gefallen. Jetzt schaust du den anderen zu.",
    "party.youNamed": "{name} (du)",
    "party.yourName": "Dein Name",
    "placeholder.store": "[Link zum App Store]",
    "privacy.cloudApp": "Wenn iCloud für Mistsweeper an ist, werden deine Einstellungen, Expeditionen und Lichtungen und die Stelle, an der die Kamera an jedem Ort stand, auch in deiner eigenen iCloud gespeichert, damit sie dir auf dein iPhone und iPad folgen. Nur dein Apple Account kann sie lesen. Wir können es nicht. Löschst du die App, bleiben sie in iCloud. Du kannst sie in der App „Einstellungen“ unter iCloud löschen.",
    "privacy.cloudTitleApp": "In deiner iCloud",
    "privacy.contact": "Mistsweeper wird von Great Scott! AB in Stockholm, Schweden, entwickelt. Schreib uns bei allen Fragen zum Datenschutz.",
    "privacy.contactTitle": "Kontakt",
    "privacy.gameCenterApp": "Wenn du auf deinem Gerät bei Game Center angemeldet bist, sendet die App an Apple, wie weit du bei jeder Tagesexpedition gekommen bist, und deine weiteste Endlos-Runde. Beides erscheint in den Game-Center-Bestenlisten des Spiels unter deinem Game-Center-Namen, für alle, die deine Game-Center-Einstellungen zulassen. Das Spiel liest weder deinen Namen noch deine Freunde und speichert nichts aus Game Center. Bist du nicht angemeldet, wird nichts gesendet. Abmelden kannst du dich unter Game Center in der App Einstellungen.",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "Die Website wird über Cloudflare ausgeliefert. Wie jeder Webhoster sieht Cloudflare deine IP-Adresse, um dir die Website zu senden, und kann sie für kurze Zeit in eigenen Protokollen speichern, um den Dienst sicher zu halten. Wir selbst führen keine Protokolle.",
    "privacy.hostTitle": "Hosting",
    "privacy.intro": "Mistsweeper ist zum Spielen gemacht, nicht zum Sammeln von Daten. Hier ist alles, was es speichert.",
    "privacy.list": "Über dich wird nichts gesendet, bis du eine Expedition unter einem Namen hinzufügst oder einen Namen meldest. Deinen Platz auf der Liste berechnet dein Gerät, aus derselben Antwort, die alle bekommen. Sobald du eine hinzugefügt hast, speichern wir den Namen, die Expedition mit ihren Spielzügen und ihrem Ergebnis, wann sie hinzugefügt wurde, ob sie aus dem Web oder der App kam, und eine verfremdete Form eines Codes, den dein Gerät erstellt. All das liegt bei Cloudflare, und der Name und die Expedition werden allen auf mistsweeper.com und in der App gezeigt. Danach wird die Expedition jedes Tages von selbst hinzugefügt, bis du das in den Einstellungen ausschaltest. Damit die Liste fair und freundlich bleibt, können wir lesen, was hinzugefügt wurde, einen Namen oder eine Expedition ausblenden oder löschen und ein Gerät davon abhalten, weitere hinzuzufügen. Alle können einen Namen melden, und eine Meldung speichert dieselbe verfremdete Form des Codes des Geräts, das sie gesendet hat. Um Missbrauch zu verhindern, werden Anfragen von einer Adresse zehn Minuten lang in verfremdeter Form gezählt, die nie aufgeschrieben wird.",
    "privacy.listRemove": "Was du hinzugefügt hast, bleibt, bis du es entfernst. „Meine Expeditionen entfernen“ in den Einstellungen löscht es von allen Listen, für das, was von dort hinzugefügt wurde: Browser und App entfernen jeweils ihr Eigenes. Der verfremdete Code bleibt noch einige Tage, damit ein anderes deiner Geräte die Expedition nicht von selbst wieder hinzufügen kann, und auf Meldungen, die du gemacht hast. Hast du das Gerät nicht mehr, schreib uns, dann löschen wir, was du hinzugefügt hast. Du kannst uns jederzeit fragen, was wir über dich speichern.",
    "privacy.listRemoveTitle": "Die Liste verlassen",
    "privacy.none": "Keine Konten, keine Werbung, kein Tracking und keine Cookies. Wir verkaufen keine personenbezogenen Daten, geben sie nicht weiter und erheben keine außer dem, was du zu den Top-Entdeckern hinzufügst oder beim gemeinsamen Erkunden sendest.",
    "privacy.noneTitle": "Was wir nicht tun",
    "privacy.share": "Wenn du ein Ergebnis teilst, entscheidest du selbst, wohin der Text geht. Links zum App Store und E-Mail-Links öffnen sich außerhalb des Spiels.",
    "privacy.shareTitle": "Teilen und Links",
    "privacy.stored": "Deine Einstellungen, Expeditionen und Ergebnisse werden im lokalen Speicher dieses Browsers abgelegt, damit du dort weitermachen kannst, wo du aufgehört hast. Sie bleiben auf deinem Gerät und werden nur an uns gesendet, wenn du eine Expedition zu den Top-Entdeckern hinzufügst. Löschst du die Daten der Website in deinem Browser, werden sie hier entfernt.",
    "privacy.storedApp": "Deine Einstellungen, Expeditionen und Ergebnisse werden in der App auf diesem Gerät gespeichert, damit du dort weitermachen kannst, wo du aufgehört hast. Sie werden nur an uns gesendet, wenn du eine Expedition zu den Top-Entdeckern hinzufügst. Löschst du die App, werden sie von diesem Gerät gelöscht.",
    "privacy.storedTitle": "In deinem Browser",
    "privacy.storedTitleApp": "Auf deinem Gerät",
    "privacy.title": "Datenschutz",
    "privacy.together": "Wenn du andere einlädst oder über einen Link bei einer Expedition mitkommst, wird die Expedition bei Cloudflare gespeichert, solange ihr spielt: ihre Tipps, der Name und das Banner, die jedes Mitglied gewählt hat, und ein Code, den jeder Browser behält, um seinen Platz wieder einzunehmen. Wohin die Kamera jedes Mitglieds schaut, wird während des Spiels an die anderen weitergegeben und nie gespeichert. Wir können die gemeinsamen Expeditionen sehen, einer zuschauen, während sie läuft, und sie erneut abspielen, damit das Spiel funktioniert und fair bleibt. Alles zu einer Expedition wird eine Woche nach dem letzten Spiel gelöscht.",
    "privacy.togetherTitle": "Gemeinsam erkunden",
    "privacy.updated": "Stand: 1. November 2026",
    "privacy.updatedApp": "Stand: 1. November 2026",
    "privacy.usageApp": "Die iOS-App zählt mit TelemetryDeck, wie sie genutzt wird. TelemetryDeck ist ein datenschutzfreundlicher Analysedienst aus Deutschland mit Servern in der EU. Gezählt wird, wenn eine Sitzung beginnt, eine Expedition startet oder endet, ein Ergebnis geteilt wird und sich die Lichtung öffnet. Jede Zählung enthält die Version der App, die Sprache des Spiels, Angaben zum Gerät wie Modell, System, Bildschirm und Einstellungen sowie einen Code für die App auf diesem Gerät, der vor dem Senden unkenntlich gemacht wird, sodass er nicht auf dich zurückgeführt werden kann. Deine IP-Adresse wird nicht gespeichert, und nichts über deine Ergebnisse oder deine Person wird gesendet.",
    "privacy.usageTitleApp": "Nutzungsstatistik in der App",
    "privacy.visits": "Um zu sehen, wie viele Menschen die Website besuchen, nutzen wir Plausible, einen datenschutzfreundlichen Analysedienst, der in der EU gehostet wird. Er verwendet keine Cookies und speichert keine personenbezogenen Daten, nur Gesamtzahlen wie Besuche, Länder, Browser und die Website, über die du hergekommen bist. Deine IP-Adresse wird nicht gespeichert.",
    "privacy.visitsTitle": "Besucherzählung",
    "punct.comma": ", ",
    "punct.join": "{first} {next}",
    "punct.period": ".",
    "reminder.body": "Expedition #{n} wartet im Nebel.",
    "sealed.body": "Ein neuer Tag hat begonnen, während du unterwegs warst. Dein Ergebnis, {distance}, ist gespeichert. Du kannst als Übung weiter erkunden.",
    "sealed.next": "Zur Expedition #{n}",
    "sealed.title": "Expedition #{n} ist zu Ende.",
    "settings.appPromo": "Erinnerungen und Haptik gibt es mit der iOS-App, jetzt in der Beta.",
    "settings.debug": "Frame-Zeiten anzeigen",
    "settings.developer": "Entwickler",
    "settings.feel": "Spielgefühl",
    "settings.haptics": "Haptik",
    "settings.hapticsLine": "Ein leichtes Tippen, wenn du ein Feld aufdeckst oder ein Banner setzt.",
    "settings.language": "Sprache",
    "settings.languageAuto": "Automatisch",
    "settings.languageAutoLine": "Folgt der Systemeinstellung: {language}",
    "settings.languageDraft": "Entwurf",
    "settings.listAuto": "Meine Expeditionen hinzufügen",
    "settings.listAutoLine": "Jeden Tag kommt deine Expedition auf die Liste, sobald sie endet.",
    "settings.listName": "Name auf der Liste",
    "settings.listNote": "Füge deine Expedition zur heutigen Liste hinzu, wenn sie endet.",
    "settings.listRemove": "Meine Expeditionen entfernen",
    "settings.motion": "Bewegung reduzieren",
    "settings.motionLine": "Der Nebel steht still, neues Gelände erscheint sofort und die Ränder der Welt bleiben scharf. Folgt der Systemeinstellung, bis du es hier änderst.",
    "settings.music": "Musik",
    "settings.musicLine": "Eine leise Melodie aus dem Wald, während du erkundest.",
    "settings.remind": "Tägliche Erinnerung",
    "settings.remindDay": "Tag",
    "settings.remindDenied": "Mitteilungen für Mistsweeper sind aus. Tippe, um sie in den Einstellungen zu erlauben.",
    "settings.remindEarlier": "{n} Minuten früher",
    "settings.remindEvening": "Abend",
    "settings.remindLater": "{n} Minuten später",
    "settings.remindLine": "Um {time}, wenn die heutige Expedition noch wartet.",
    "settings.remindNext": "Neue Expedition {time}",
    "settings.remindNight": "Nacht",
    "settings.remindTime": "Uhrzeit der Erinnerung",
    "settings.reminders": "Erinnerungen",
    "settings.sounds": "Töne",
    "settings.soundsLine": "Ein Ton für jedes aufgedeckte Feld, jedes Banner und jedes Wesen.",
    "settings.theme": "Design",
    "settings.themeAuto": "Automatisch",
    "settings.themeAutoLine": "Folgt der Systemeinstellung: Nacht im Dunkelmodus, sonst Tag.",
    "settings.themeSupporter": "In Supporter gewählt",
    "settings.tilt": "Tilt-Shift",
    "settings.title": "Einstellungen",
    "settings.zoom": "Zoom",
    "start.continue": "Fortsetzen, {distance}",
    "start.endlessLine": "Jedes Mal eine neue Welt, so oft du willst.",
    "start.setOut": "Aufbrechen",
    "start.tagDistance": "#{n}, {distance}",
    "start.tagDone": "#{n}, erledigt, {distance}",
    "start.tagNew": "#{n}, neu",
    "start.tagNewDate": "#{n}, {dateShort}, neu",
    "start.tagProgress": "#{n}, begonnen, {distance}",
    "start.todayDone": "Für heute erledigt. Nächste Expedition in {time}.",
    "start.todayDoneShort": "Nächste Expedition in {time}.",
    "start.todayInProgress": "Begonnen. Mach dort weiter, wo du aufgehört hast.",
    "start.todayInProgressShort": "Mach dort weiter, wo du aufgehört hast.",
    "start.todayNew": "{dateLong}. Ein Versuch, dasselbe Gelände für alle.",
    "start.todayNewShort": "Ein Versuch, dasselbe Gelände für alle.",
    "support.devices": "Mit iCloud bringt die App deine Expeditionen und Lichtungen auf deine anderen Geräte. Im Browser bleiben sie in diesem Browser.",
    "support.devicesTitle": "Ein neues Gerät",
    "support.intro": "Mistsweeper entsteht in einem kleinen Studio in Stockholm. Wenn etwas nicht funktioniert oder du eine Frage hast, schreib uns.",
    "support.list": "„{remove}“ unter {settings} nimmt deine Expeditionen von allen Listen. Um einen Namen zu melden, halte seine Zeile gedrückt oder klicke am Computer mit der rechten Maustaste darauf.",
    "support.listTitle": "Dein Name auf der Liste {list}",
    "support.purchase": "Dein Kauf ist an deinen Apple Account gebunden. Öffne {supporter} im Menü der App und wähle {restore}.",
    "support.purchaseTitle": "Ein Kauf ist verschwunden",
    "support.title": "Support",
    "supporter.accent": "Akzentfarbe",
    "supporter.accentLine": "Die Farbe deiner Banner.",
    "supporter.accentNumber": "Farbe {n}",
    "supporter.banner": "Banner",
    "supporter.banners": "Banner",
    "supporter.bannersLine": "Setze auf jeder Expedition ein anderes Banner.",
    "supporter.buy": "Supporter werden, {price}",
    "supporter.buyLine": "Ein einmaliger Kauf, kein Abo. Mit der Familienfreigabe gilt er für deine ganze Familie.",
    "supporter.buyNoPrice": "Supporter werden",
    "supporter.cabin": "Deine Hütte",
    "supporter.cabinLine": "Lass ein Haus, das du gefunden hast, dort stehen, wo die Hütte steht, auf jeder Expedition und auf jeder Lichtung.",
    "supporter.chooseCabin": "Auf der Lichtung wählen",
    "supporter.clearingLocked": "Nur ein Supporter kann diese Lichtung ändern.",
    "supporter.clearings": "Lichtungen",
    "supporter.clearingsLine": "Eine größere Lichtung, 15 mal 15 Felder, und so viele Lichtungen, wie du möchtest.",
    "supporter.failed": "Der Kauf hat nicht geklappt. Versuch es gleich noch einmal.",
    "supporter.free": "Alles, was du spielst, ist kostenlos und bleibt es.",
    "supporter.icon": "App-Symbol",
    "supporter.icons": "App-Symbole",
    "supporter.iconsLine": "Wähle das Symbol auf deinem Home-Bildschirm. Jedes hat ein helles und ein dunkles Aussehen.",
    "supporter.lead": "Als Supporter wählst du, wie das Spiel auf deinem Bildschirm aussieht, und du hilfst uns, weiter an Mistsweeper zu arbeiten.",
    "supporter.line": "Designs, App-Symbole, Banner, deine Hütte",
    "supporter.nothingToRestore": "Für diesen Apple Account wurde kein Kauf von Supporter gefunden.",
    "supporter.pending": "Warten auf Genehmigung. Supporter kommt, sobald der Kauf genehmigt ist.",
    "supporter.restore": "Kauf wiederherstellen",
    "supporter.since": "Supporter seit {date}",
    "supporter.thanks": "Danke, dass du Mistsweeper unterstützt. Hier wählst du, wie das Spiel auf deinem Bildschirm aussieht.",
    "supporter.theme": "Design",
    "supporter.themeLine": "Tag, Nacht und Automatisch findest du in den Einstellungen.",
    "supporter.themes": "Designs",
    "supporter.themesLine": "Spiel das ganze Spiel in anderen Farben. Bei manchen wählst du auch die Farbe deiner Banner.",
    "supporter.unreachable": "Der App Store ist gerade nicht erreichbar. Versuch es gleich noch einmal.",
    "theme.day": "Tag",
    "theme.fjord": "Fjord",
    "theme.mossa": "Moos",
    "theme.night": "Nacht",
    "theme.pergament": "Pergament",
    "theme.rosa": "Rosa",
    "theme.skymning": "Dämmerung",
    "time.hoursMinutes": "{h} h {m} min",
    "time.minutes": "{m} min",
    "webgl.missing": "Mistsweeper braucht WebGL 2, das dieser Browser nicht unterstützt.",
    "welcome.mistDaily": "Jeden Tag kommt eine neue Expedition: dasselbe Gelände für alle und nur ein Versuch. Für die ruhigen Stunden gibt es Endlos.",
    "welcome.mistNumbers": "Eine Zahl sagt, wie viele Wesen sich in den acht Feldern um sie herum verstecken. Setze ein Banner, wo du glaubst, dass eines schläft, und geh weiter.",
    "welcome.mistText": "Du beginnst bei einer Hütte auf einer Waldlichtung, und alles andere ist Nebel. Decke Feld für Feld auf, immer vom erkundeten Gelände aus.",
    "welcome.mistTitle": "In den Nebel",
    "welcome.next": "Weiter",
    "welcome.remindNo": "Jetzt nicht",
    "welcome.remindText": "Jeden Tag kommt eine neue Expedition. Wähle eine Uhrzeit, dann sagen wir dir Bescheid, wenn die heutige noch wartet. Du kannst das in den Einstellungen ändern.",
    "welcome.remindTitle": "Eine tägliche Erinnerung",
    "welcome.remindYes": "Erinnere mich",
    "welcome.skip": "Überspringen",
    "welcome.starsLater": "Etwas später fragen wir dich, wie es dir gefällt. Ein Moment deiner Zeit hilft uns dann sehr.",
    "welcome.starsText": "Mistsweeper kommt von Great Scott!, einem kleinen Studio in Stockholm. Für ein kleines Spiel sind Bewertungen im App Store der beste Weg, von anderen gefunden zu werden.",
    "welcome.starsTitle": "Aus einem kleinen Studio",
    "welcome.step": "Schritt {n} von {total}",
    "widget.bestDay": "Bester Tag {distance}",
    "widget.clearingDescription": "Deine Lichtung, mit dem, was du gefunden hast, und deinen besten Strecken.",
    "widget.clearingName": "Deine Lichtung",
    "widget.description": "Die heutige Expedition, wie du sie verlassen hast, und deine Serie.",
    "widget.next": "Nächste in {time}",
    "widget.streak": "Serie {days}",
    "widget.waiting": "Wartet",
  },
  en: {
    "a11y.bannerMode": "Banner mode",
    "a11y.board.banner": "Banner",
    "a11y.board.bannerRemoved": "Banner taken away.",
    "a11y.board.banners1": "1 banner",
    "a11y.board.bannersN": "{n} banners",
    "a11y.board.cabin": "The cabin",
    "a11y.board.cellBanner": "banner",
    "a11y.board.cellCabin": "cabin",
    "a11y.board.cellExplored": "explored",
    "a11y.board.cellMist": "mist",
    "a11y.board.cellWrongBanner": "wrong banner",
    "a11y.board.chordWaits": "The banners round it do not match its number.",
    "a11y.board.chosen": "Chosen: {name}.",
    "a11y.board.confirmed": "Confirmed",
    "a11y.board.creature": "A creature",
    "a11y.board.deepMist": "Deep mist",
    "a11y.board.describe": "Describe surroundings",
    "a11y.board.dirEast": "East",
    "a11y.board.dirNorth": "North",
    "a11y.board.dirSouth": "South",
    "a11y.board.dirWest": "West",
    "a11y.board.east": "{n} east",
    "a11y.board.explore": "Explore round it",
    "a11y.board.explored": "Explored",
    "a11y.board.exploredOn": "Explored, {what}",
    "a11y.board.frontier0": "No mist to explore",
    "a11y.board.frontier1": "1 tile of mist to explore",
    "a11y.board.frontierN": "{n} tiles of mist to explore",
    "a11y.board.furthest": "Furthest point {distance}.",
    "a11y.board.hid": "Hid here",
    "a11y.board.hintExplore": "Reveals the tiles round it.",
    "a11y.board.hintPlant": "Plants a banner.",
    "a11y.board.hintReveal": "Reveals the tile.",
    "a11y.board.hintTakeAway": "Takes the banner away.",
    "a11y.board.inMist": "{n} in mist",
    "a11y.board.inView": "{what} in view",
    "a11y.board.listAnd": "{list} and {last}",
    "a11y.board.mist": "Mist",
    "a11y.board.nextTo": "Next to {numbers}",
    "a11y.board.north": "{n} north",
    "a11y.board.place": "{where} of the cabin, {distance}",
    "a11y.board.plant": "Plant a banner",
    "a11y.board.revealed1": "Explored 1 tile.",
    "a11y.board.revealedN": "Explored {n} tiles.",
    "a11y.board.rotorBanners": "Banners",
    "a11y.board.rotorMist": "Mist to explore",
    "a11y.board.rotorNorthSouth": "North and south",
    "a11y.board.rotorNumbers": "Open numbers",
    "a11y.board.roundIt": "{what} round it",
    "a11y.board.rowHere": "Here: {tiles}.",
    "a11y.board.rowNorth": "North: {tiles}.",
    "a11y.board.rowSouth": "South: {tiles}.",
    "a11y.board.south": "{n} south",
    "a11y.board.takeAway": "Take the banner away",
    "a11y.board.turned": "Turned.",
    "a11y.board.west": "{n} west",
    "a11y.board.woke": "Woke here and ended the expedition",
    "a11y.board.wrongBanner": "Wrong banner",
    "a11y.distance": "Furthest distance",
    "a11y.find": "New find: {name}.",
    "a11y.findMore": "New finds: {name} and {n} more.",
    "a11y.map": "Expedition map",
    "about.body1": "Beyond the cabin the mist begins, and in the mist live the old ones: trolls under the moss, the huldra among the trees, Näcken by still water.",
    "about.body2": "Mistsweeper is about reading the ground before you step on it. The numbers tell you how many creatures sleep nearby. How far you get is up to you.",
    "about.body3": "Mistsweeper is a new take on Minesweeper, the classic puzzle game, inspired by Nordic myths and folk tales.",
    "about.made": "Made by Great Scott! in Stockholm, Sweden.",
    "about.version": "Version {version}",
    "accessibility.contact": "If something stops you from playing, or would make the game easier for you, write to us.",
    "accessibility.contactTitle": "Tell us",
    "accessibility.contrast": "The world and the menus are drawn in ink on paper, with a contrast well above what text needs, by day and by night. Red marks what matters but never alone: a banner has its shape, a wrong banner after an expedition gets a cross, and the tile where it ended gets a frame.",
    "accessibility.contrastTitle": "Contrast and colour",
    "accessibility.dark": "The game follows your system's dark mode: Night is the world by moonlight. You can also choose Day or Night under Settings, Theme.",
    "accessibility.darkTitle": "Dark and light",
    "accessibility.intro": "Mistsweeper should be playable by as many people as possible. This is what the game supports today, on the web and in the iOS app, and what we are working on.",
    "accessibility.keys": "On the web the whole game can be played from the keyboard: the arrow keys or WASD move the cursor, Enter or Space reveals a tile, F plants or takes away a banner, Q and E turn the camera, T and G tilt it, plus and minus zoom, H goes back to the cabin and Escape closes what is open.",
    "accessibility.keysTitle": "Keyboard on the web",
    "accessibility.motion": "With Reduce Motion on in your system, or the game's own switch under Settings, nothing moves by itself. The mist, the wind, the animals and the camera stand still, new ground appears at once and the world's edges stay sharp.",
    "accessibility.motionTitle": "Reduce motion",
    "accessibility.sound": "Sound and music never tell you anything you cannot also see. The game has no speech and no video. In the iOS app, haptics follow reveals and banners. Music, sounds and haptics can each be turned off under Settings.",
    "accessibility.soundTitle": "Sound",
    "accessibility.title": "Accessibility",
    "accessibility.updated": "Updated 25 October 2026",
    "accessibility.work": "In the iOS app the map can be read and played with VoiceOver and Voice Control, and the text follows your text size. On the web the menus and buttons have labels for screen readers, but the map cannot yet be read or played with one. We are working on that.",
    "accessibility.workTitle": "What we are working on",
    "app.tagline": "An endless expedition",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "A pixel art coloring book, free of ads and tracking.",
    "apps.intro": "Small games and apps from the same studio.",
    "apps.krono": "Put history, pop culture and music in order on a timeline.",
    "apps.ordna": "A quiet sort puzzle. A thousand of them, and no interruptions.",
    "apps.tapotron": "Tap games and beats on a grid of eager buttons.",
    "archive.appNoteCloud": "Kept in iCloud, on all your devices.",
    "archive.appNoteDevice": "Kept on this device. Turn on iCloud for Mistsweeper to keep them on all your devices.",
    "archive.best": "your best",
    "archive.daily": "Daily expeditions",
    "archive.dayStreak": "Day streak",
    "archive.endlessBest": "Best",
    "archive.endlessLast": "Last",
    "archive.endlessRuns": "Runs",
    "archive.expeditions": "Expeditions",
    "archive.gameCenter": "Compare with friends in Game Center",
    "archive.notPlayed": "not played",
    "archive.sealed": "sealed",
    "archive.today": "today, in progress",
    "archive.todayWord": "today",
    "archive.webNote": "Saved in this browser. The iOS app keeps its own expeditions, in iCloud.",
    "archive.webNoteShort": "Saved in this browser.",
    "banner.1": "Three tails",
    "banner.a1": "Swallowtail",
    "banner.a3": "Spearpoint",
    "banner.b1": "Quarter round",
    "banner.b2": "Raven banner",
    "banner.b3": "Half round",
    "banner.c2": "T-staff",
    "banner.c3": "Waymark",
    "banner.c4": "Twisted",
    "beta.bugs": "Something not working, or looking odd? Write what you did, what happened and on which device. A screenshot helps.",
    "beta.bugsTitle": "Bugs",
    "beta.changes": "The game changes during the beta. When it comes out, the expeditions carry on where they are, without starting again from #1.",
    "beta.changesTitle": "What will change",
    "beta.intro": "Mistsweeper can be played, but it is not finished. Before it comes out, we need help from you who play it.",
    "beta.language": "The game speaks nine languages, and most of the translations have not yet been read by a native speaker. Does something sound wrong or stiff? Write where you saw it and how you would say it.",
    "beta.languageTitle": "Text and language",
    "beta.more": "More",
    "beta.ticker1": "Mistsweeper is in beta",
    "beta.ticker2": "Find bugs for us",
    "beta.ticker3": "Help us with the language",
    "beta.title": "About the beta",
    "button.banner": "Banner",
    "button.cancel": "Cancel",
    "button.close": "Close",
    "button.daily": "Today's expedition",
    "button.endless": "Endless",
    "button.home": "Back to the cabin",
    "button.practice": "Practice run",
    "button.settings": "Settings",
    "button.zoomIn": "Zoom in",
    "button.zoomOut": "Zoom out",
    "clearing.arrange": "Arrange",
    "clearing.cabin": "The cabin stays where it is.",
    "clearing.cabinChosen": "Your cabin: {name}.",
    "clearing.cabinHint": "Your cabin can be any house you have found. Hold it to choose.",
    "clearing.cat.creatures": "Creatures",
    "clearing.cat.ground": "Ground",
    "clearing.cat.houses": "Houses",
    "clearing.cat.plants": "Plants",
    "clearing.cat.stones": "Stones",
    "clearing.changeCabin": "Change cabin",
    "clearing.chooseCabin": "Choose your cabin",
    "clearing.clear": "Clear",
    "clearing.delete": "Delete",
    "clearing.deleteBody": "What is set out there goes with it. Your finds stay.",
    "clearing.deleteTitle": "Delete {name}?",
    "clearing.deleted": "{name} is deleted.",
    "clearing.discovered": "{n} of {total} found",
    "clearing.done": "Done",
    "clearing.edit": "Edit",
    "clearing.editing": "Editing {name}",
    "clearing.family.barley": "Barley",
    "clearing.family.barn": "Barn",
    "clearing.family.beacon": "Beacon",
    "clearing.family.beehive": "Beehives",
    "clearing.family.bergstroll": "Mountain troll",
    "clearing.family.birch": "Birch",
    "clearing.family.boat": "Boat",
    "clearing.family.boathouse": "Boathouse",
    "clearing.family.boulder": "Boulder",
    "clearing.family.bush": "Bush",
    "clearing.family.cairn": "Cairn",
    "clearing.family.campfire": "Campfire",
    "clearing.family.cart": "Cart",
    "clearing.family.cave": "Cave",
    "clearing.family.church": "Stave church",
    "clearing.family.cottage": "Cottage",
    "clearing.family.driftwood": "Driftwood",
    "clearing.family.fabod": "Summer farm",
    "clearing.family.faering": "Faering",
    "clearing.family.fence": "Fence",
    "clearing.family.fern": "Fern",
    "clearing.family.fishhut": "Fishing hut",
    "clearing.family.flottning": "Log driving",
    "clearing.family.fornborg": "Hillfort",
    "clearing.family.goahti": "Turf hut",
    "clearing.family.gravhog": "Burial mound",
    "clearing.family.harbre": "Raised storehouse",
    "clearing.family.hassja": "Hay rack",
    "clearing.family.hides": "Hides and meat",
    "clearing.family.hjell": "Fish rack",
    "clearing.family.house": "Cabin",
    "clearing.family.huldra": "Huldra",
    "clearing.family.huntingtower": "Hunting tower",
    "clearing.family.jatte": "Giant",
    "clearing.family.jetty": "Jetty",
    "clearing.family.juniper": "Juniper",
    "clearing.family.kastal": "Stone tower",
    "clearing.family.kolmila": "Charcoal kiln",
    "clearing.family.kummel": "Sea cairn",
    "clearing.family.laundry": "Laundry",
    "clearing.family.lavvu": "Lavvu",
    "clearing.family.lilypads": "Water lilies",
    "clearing.family.log": "Log",
    "clearing.family.longhouse": "Longhouse",
    "clearing.family.massif": "Massif",
    "clearing.family.mushroom": "Mushrooms",
    "clearing.family.nacken": "Näcken",
    "clearing.family.njalla": "Njalla",
    "clearing.family.oak": "Oak",
    "clearing.family.oats": "Oats",
    "clearing.family.outcrop": "Outcrop",
    "clearing.family.peak": "Peak",
    "clearing.family.pebbles": "Pebbles",
    "clearing.family.pine": "Pine",
    "clearing.family.reeds": "Reeds",
    "clearing.family.rengarde": "Reindeer corral",
    "clearing.family.rock": "Rock",
    "clearing.family.rockcarving": "Rock carving",
    "clearing.family.rootcellar": "Root cellar",
    "clearing.family.rowan": "Rowan",
    "clearing.family.ruin": "Ruin",
    "clearing.family.runestone": "Runestone",
    "clearing.family.rye": "Rye",
    "clearing.family.sauna": "Sauna",
    "clearing.family.seamark": "Sea mark",
    "clearing.family.shed": "Storehouse",
    "clearing.family.shipsetting": "Ship setting",
    "clearing.family.shorestones": "Shore stones",
    "clearing.family.sjotroll": "Lake troll",
    "clearing.family.skogstroll": "Forest troll",
    "clearing.family.smithy": "Smithy",
    "clearing.family.snag": "Dead tree",
    "clearing.family.spruce": "Spruce",
    "clearing.family.stonecircle": "Stone circle",
    "clearing.family.stones": "Standing stones",
    "clearing.family.stooks": "Harvested field",
    "clearing.family.stormannagard": "Great hall",
    "clearing.family.stump": "Stump",
    "clearing.family.tent": "Tent",
    "clearing.family.tjardal": "Tar kiln",
    "clearing.family.tuft": "Grass",
    "clearing.family.watermill": "Water mill",
    "clearing.family.well": "Well",
    "clearing.family.wellsweep": "Well sweep",
    "clearing.family.windmill": "Windmill",
    "clearing.family.windthrow": "Windthrow",
    "clearing.family.woodpile": "Woodpile",
    "clearing.fold": "Fold away",
    "clearing.ground.forest": "Forest",
    "clearing.ground.meadow": "Meadow",
    "clearing.ground.mountain": "Mountain",
    "clearing.ground.water": "Water",
    "clearing.grown": "The mist draws back.",
    "clearing.hint": "Choose something below, then tap a tile. Tap it again to turn it. Hold a tile to change it.",
    "clearing.hintVoiceOver": "Choose something below, then double tap a tile. A tile's actions edit, turn or clear it.",
    "clearing.large": "Large",
    "clearing.locked": "Not found yet. It waits out in the mist.",
    "clearing.lockedName": "{name}, not found yet",
    "clearing.made": "A new clearing: {name}.",
    "clearing.mist": "That is in the mist.",
    "clearing.needsLand": "That needs land.",
    "clearing.needsWater": "That needs water.",
    "clearing.new": "New clearing",
    "clearing.photo": "Photo",
    "clearing.photo.back": "Back",
    "clearing.photo.failed": "The picture could not be made here.",
    "clearing.photo.file": "clearing",
    "clearing.photo.formats": "Format",
    "clearing.photo.notSaved": "The picture could not be saved. Settings can let Mistsweeper add to your photos.",
    "clearing.photo.picture": "Your picture",
    "clearing.photo.save": "Save",
    "clearing.photo.saved": "Saved to your photos.",
    "clearing.photo.share": "Share",
    "clearing.photo.shutter": "Take a picture",
    "clearing.photo.usage": "Mistsweeper saves the pictures of your clearing to your photos when you ask it to.",
    "clearing.rename": "Rename",
    "clearing.renameSave": "Save",
    "clearing.renameTitle": "Name the clearing",
    "clearing.size": "Size of the clearing",
    "clearing.small": "Small",
    "clearing.supporter": "Supporter",
    "clearing.turn": "Turn",
    "clearing.undo": "Undo",
    "clearing.yours": "Your clearings",
    "controls.banner": "Plant a banner",
    "controls.click": "Click",
    "controls.drag": "Drag",
    "controls.pan": "Pan",
    "controls.pinch": "Pinch",
    "controls.qe": "Q and E",
    "controls.reveal": "Reveal",
    "controls.rightClick": "Right-click",
    "controls.rightDrag": "Right-drag",
    "controls.scroll": "Scroll",
    "controls.tg": "T and G",
    "controls.tilt": "Tilt",
    "controls.title": "Moving around",
    "controls.turn": "Turn",
    "controls.turnTilt": "Turn and tilt",
    "controls.twist": "Twist two fingers",
    "controls.twoFingers": "Two fingers up or down",
    "controls.voActions": "Swipe up or down",
    "controls.voFind": "Mist to explore, open numbers, banners, north and south",
    "controls.voMagicTap": "Double tap with two fingers",
    "controls.voMove": "Move four tiles across the map",
    "controls.voRotor": "Turn the rotor",
    "controls.voScroll": "Swipe with three fingers",
    "controls.voSummary": "Where you are and how far you have come",
    "controls.voSwipe": "Swipe left or right",
    "controls.voTileActions": "A tile's actions: banners, explore round it, describe surroundings",
    "controls.voTiles": "The tiles in view, row by row from the north",
    "controls.zoom": "Zoom",
    "daily.next": "Next expedition in {time}",
    "feedback.subject": "Mistsweeper feedback, version {version}",
    "find.new": "New find",
    "getApp.beta": "The app is in beta. TestFlight, Apple's app for trying apps before they are out, installs it.",
    "getApp.haptics": "Haptics under your fingers.",
    "getApp.intro": "The same expedition every day, with a few things only an app can do.",
    "getApp.join": "Join the beta on TestFlight",
    "getApp.note": "Your expeditions in this browser stay here. The app keeps its own.",
    "getApp.offline": "Plays without a connection.",
    "getApp.qr": "Point your iPhone camera here to join the beta.",
    "getApp.qrLabel": "QR code for the beta on TestFlight",
    "getApp.reminder": "A daily reminder at a time you choose.",
    "getApp.widget": "A widget with today's expedition and your streak.",
    "hint.clearingDesktop": "Choose something and set it out in the clearing. Right-click a tile to change it.",
    "hint.photoDesktop": "Frame the clearing in the window, then take the picture.",
    "hint.reveal": "Tap next to explored ground to reveal it.",
    "hint.revealDesktop": "Click next to explored ground to reveal it. Right-click to plant a banner.",
    "hint.revealVoiceOver": "Swipe to mist next to explored ground, or find it with the rotor, then double tap to reveal it.",
    "howto.1": "You start at the cabin. Everything else is mist.",
    "howto.2": "Reveal a tile next to ground you have explored. You walk from where you have been, one tile at a time.",
    "howto.3": "A number counts the creatures hiding in the eight tiles around it.",
    "howto.3example": "Here, creatures hide in two of the three tiles still in mist.",
    "howto.4mouse": "Plant a banner where you think a creature hides: right-click the tile.",
    "howto.4touch": "Plant a banner where you think a creature hides: turn on banner mode and tap the tile.",
    "howto.4voiceOver": "Plant a banner where you think a creature hides: swipe up or down on the tile to its actions and choose Plant a banner.",
    "howto.5": "Wake a creature and the expedition ends. Your score is the furthest point you reached from the cabin.",
    "howto.6": "Each day brings a new expedition: the same ground for everyone, and one attempt. Endless is there for the quiet hours.",
    "howto.tryLesson": "Try it in the world",
    "hud.best": "Best {distance}",
    "hud.clearing": "Clearing",
    "hud.menu": "Menu",
    "hud.north": "Turn north up",
    "hud.practice": "Practice run, #{n}",
    "hud.today": "Today",
    "hud.turnLeft": "Turn left, Q",
    "hud.turnLeftKey": "Q",
    "hud.turnRight": "Turn right, E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "It's barley.",
    "inspect.barley.2": "Soon bread, or something better.",
    "inspect.barn.1": "It's a barn.",
    "inspect.barn.2": "Full of hay and cats.",
    "inspect.barn.3": "Hay to the roof. It will last until spring.",
    "inspect.beacon.1": "A vårdkase. Lit when enemies are sighted.",
    "inspect.beacon.2": "One fire, then the next, and the whole land knows.",
    "inspect.beacon.3": "Dry and ready. Nobody has lit it yet.",
    "inspect.beehive.1": "Beehives. Best not to knock.",
    "inspect.beehive.2": "We are busy.",
    "inspect.birch.1": "It's a birch.",
    "inspect.birch.2": "White bark, black marks. Someone has been counting.",
    "inspect.birch.3": "Birch bark burns even when wet. Good to know.",
    "inspect.birch.4": "The birch is first to leaf, first to turn yellow.",
    "inspect.boat.1": "A rowing boat. Someone will want it back.",
    "inspect.boat.2": "Oars in. Nobody aboard.",
    "inspect.boathouse.1": "It smells of tar and wet rope.",
    "inspect.boathouse.2": "The boat is out. Nobody has said when it is back.",
    "inspect.boulder.1": "A flyttblock. It moved once, with the ice.",
    "inspect.boulder.2": "I came with the ice. I am staying.",
    "inspect.boulder.3": "The ice left this here and went home.",
    "inspect.bush.1": "It's a bush.",
    "inspect.bush.2": "Nothing is hiding in the bush. Probably.",
    "inspect.bush.3": "Something rustled. It was only the bush.",
    "inspect.cabin": "Your cabin. The stove is still warm.",
    "inspect.cairn.1": "It's a cairn.",
    "inspect.cairn.2": "Everyone who passes adds a stone.",
    "inspect.cairn.3": "Someone marked the way. Or a grave.",
    "inspect.campfire.1": "It's a campfire.",
    "inspect.campfire.2": "A fire, and nobody by it.",
    "inspect.campfire.3": "Someone left in a hurry.",
    "inspect.cart.1": "It's a cart.",
    "inspect.cart.2": "Left where the horse stopped.",
    "inspect.cave.1": "It's a cave. It goes in.",
    "inspect.cave.2": "Come in.",
    "inspect.cave.3": "Something breathes in there. Or it's the wind.",
    "inspect.church.1": "A stave church. Centuries of tar.",
    "inspect.church.2": "Not one stone in it. Only wood and patience.",
    "inspect.church.3": "It is quiet in there. It always was.",
    "inspect.creature.bergstroll": "A mountain troll lived here.",
    "inspect.creature.huldra": "A huldra lived here.",
    "inspect.creature.jatte": "A giant lived here.",
    "inspect.creature.nacken": "Näcken lived here.",
    "inspect.creature.sjotroll": "A lake troll lived here.",
    "inspect.creature.skogstroll": "A forest troll lived here.",
    "inspect.deer.1": "A roe deer. It has already seen you.",
    "inspect.deer.2": "It lifts its head, then goes back to eating.",
    "inspect.driftwood.1": "Driftwood. Nobody knows from where.",
    "inspect.driftwood.2": "It has seen more of the sea than anyone here.",
    "inspect.duck.1": "A mallard. It minds its own business.",
    "inspect.duck.2": "It has views on this.",
    "inspect.elk.1": "An elk. It does not care.",
    "inspect.elk.2": "The largest thing in the forest, and the quietest.",
    "inspect.faering.1": "A faering. Four oars and a sail.",
    "inspect.faering.2": "Made the way the long ships were.",
    "inspect.fence.1": "A gärdesgård. Not a single nail in it.",
    "inspect.fence.2": "What it was meant to hold in has wandered off.",
    "inspect.fern.1": "It's a fern.",
    "inspect.fern.2": "Ferns were here before the trees.",
    "inspect.fern.3": "They say a fern flowers on Midsummer night. Nobody has seen it.",
    "inspect.fishhut.1": "Nets, floats and old herring.",
    "inspect.fishhut.2": "Fishing hut. The smell arrives first.",
    "inspect.flottning.1": "Logs on their way to the coast.",
    "inspect.flottning.2": "Log driving. The river does the carrying.",
    "inspect.fornborg.1": "A fornborg. People ran here when the beacons were lit.",
    "inspect.fornborg.2": "The wall has fallen. Whoever it stopped is gone too.",
    "inspect.fornborg.3": "Nobody knows who piled these stones.",
    "inspect.goahti.1": "A goahti. Turf outside, warm inside.",
    "inspect.goahti.2": "The smoke goes out at the top. It always has.",
    "inspect.gravhog.1": "A burial mound. Someone important.",
    "inspect.gravhog.2": "Someone lies here. Walk softly.",
    "inspect.gravhog.3": "A grave. A thousand years of grass on top.",
    "inspect.harbre.1": "A härbre. Up on posts, out of reach of mice.",
    "inspect.harbre.2": "Last year's grain is in there.",
    "inspect.hassja.1": "A hässja. The hay dries in the wind.",
    "inspect.hassja.2": "Hay on the rails. It must not rain now.",
    "inspect.hides.1": "Reindeer hides on frames. Nothing goes to waste.",
    "inspect.hides.2": "Meat drying in the wind. Winter food.",
    "inspect.hjell.1": "Stockfish, drying. The wind does the cooking.",
    "inspect.hjell.2": "It can be smelled from here.",
    "inspect.home": "Here lives {name}.",
    "inspect.huntingtower.1": "Someone sits up there and waits.",
    "inspect.huntingtower.2": "The elk know about it.",
    "inspect.jetty.1": "It's a jetty.",
    "inspect.jetty.2": "It goes out a little way and gives up.",
    "inspect.jetty.3": "A good place for bare feet.",
    "inspect.juniper.1": "It's a juniper.",
    "inspect.juniper.2": "A juniper. It pricks back.",
    "inspect.juniper.3": "A juniper. From afar it looks like someone standing still.",
    "inspect.kastal.1": "Thick walls, small windows.",
    "inspect.kastal.2": "Someone expected visitors, and not the friendly kind.",
    "inspect.kolmila.1": "It's a kolmila.",
    "inspect.kolmila.2": "It smoulders for weeks. Someone must stay awake.",
    "inspect.kolmila.3": "Wood goes in. Charcoal comes out.",
    "inspect.kummel.1": "A kummel. It tells sailors where they are.",
    "inspect.kummel.2": "It can be seen from the sea. That is all it is for.",
    "inspect.laundry.1": "Someone's laundry.",
    "inspect.laundry.2": "Dry by evening, if the mist stays away.",
    "inspect.laundry.3": "One sock short.",
    "inspect.lavvu.1": "A lavvu. It can be gone by morning.",
    "inspect.lavvu.2": "Poles and cloth. Nothing more is needed.",
    "inspect.lilypads.1": "Water lilies.",
    "inspect.lilypads.2": "Water lilies. Don't pick them. Someone is fond of them.",
    "inspect.lilypads.3": "Water lilies on long stems, down into the dark.",
    "inspect.log.1": "It's a log.",
    "inspect.log.2": "Fallen long ago. The moss has moved in.",
    "inspect.massif.1": "It's a massif.",
    "inspect.massif.2": "The mountain does not notice visitors.",
    "inspect.massif.3": "Snow in the clefts, even in August.",
    "inspect.mushroom.1": "Mushrooms. Best left alone.",
    "inspect.mushroom.2": "All mushrooms can be eaten. Some only once.",
    "inspect.mushroom.3": "Someone will want these in a basket.",
    "inspect.njalla.1": "A njalla. One post, and the bears can only look.",
    "inspect.njalla.2": "Food, up high, where only people reach.",
    "inspect.oak.1": "It's an oak.",
    "inspect.oak.2": "An oak. Older than the oldest story about it.",
    "inspect.oak.3": "The oak has seen kings come and go.",
    "inspect.oak.4": "Once, every oak belonged to the crown.",
    "inspect.oats.1": "It's oats.",
    "inspect.oats.2": "Oats for the horses, and for breakfast.",
    "inspect.outcrop.1": "Bare rock. The land without its coat.",
    "inspect.outcrop.2": "Warm in the sun, cold at night.",
    "inspect.outcrop.3": "The ice polished this.",
    "inspect.peak.1": "Peak. Snow all year.",
    "inspect.peak.2": "Nothing grows up here.",
    "inspect.peak.3": "The view is said to be good. The mist disagrees.",
    "inspect.pebbles.1": "Pebbles.",
    "inspect.pebbles.2": "Each one was a mountain once.",
    "inspect.pine.1": "It's a pine.",
    "inspect.pine.2": "The pine was here first.",
    "inspect.pine.3": "Pines like it dry and poor. This one is content.",
    "inspect.pine.4": "The pine leans the way the wind told it to.",
    "inspect.reeds.1": "Reeds.",
    "inspect.reeds.2": "The reeds whisper. It is only the wind.",
    "inspect.reeds.3": "Something moved in there. Probably a bird.",
    "inspect.reindeer.1": "Every reindeer here belongs to someone.",
    "inspect.reindeer.2": "It is on its way. It knows where.",
    "inspect.rengarde.1": "The herd gathers here in autumn.",
    "inspect.rengarde.2": "Empty now. The reindeer know where they are going.",
    "inspect.rock.1": "It's a rock.",
    "inspect.rock.2": "Yes? A rock.",
    "inspect.rock.3": "A rock. It has no opinion.",
    "inspect.rock.4": "Nothing happens. It's a rock.",
    "inspect.rockcarving.1": "Cut into the rock, long before the runes.",
    "inspect.rockcarving.2": "We were here.",
    "inspect.rockcarving.3": "Nobody can read it. It is still saying something.",
    "inspect.rootcellar.1": "Potatoes in the dark.",
    "inspect.rootcellar.2": "It never freezes in there.",
    "inspect.rowan.1": "It's a rowan.",
    "inspect.rowan.2": "A rowan. Many berries, much snow, they say.",
    "inspect.rowan.3": "Trolls are said to stay away from rowan.",
    "inspect.ruin.1": "It's a ruin.",
    "inspect.ruin.2": "Someone was proud of this once.",
    "inspect.ruin.3": "What stood here has gone. The stones stayed.",
    "inspect.runestone.1": "It's a runestone.",
    "inspect.runestone.2": "Someone had this raised for their child.",
    "inspect.runestone.3": "Runestone. Went east, it says. Did not come home.",
    "inspect.runestone.4": "Runestone. Read this, if you can.",
    "inspect.rye.1": "It's rye.",
    "inspect.rye.2": "Rye stands through the winter and asks for nothing.",
    "inspect.sauna.1": "It's a sauna.",
    "inspect.sauna.2": "A sauna. Still warm.",
    "inspect.sauna.3": "Birch twigs by the door. Someone will be back.",
    "inspect.seamark.1": "A sea mark. Sailors steer by it.",
    "inspect.seamark.2": "Here.",
    "inspect.shed.1": "A storehouse. Tools, rope and a smell of tar.",
    "inspect.shed.2": "Locked, and the key is somewhere else.",
    "inspect.shipsetting.1": "A ship of stone, for one last voyage.",
    "inspect.shipsetting.2": "Someone was sent off in this ship.",
    "inspect.shipsetting.3": "Stone ship. It has not moved since the Iron Age.",
    "inspect.shorestones.1": "Flat stones skip best.",
    "inspect.shorestones.2": "The water has been at these for a long time.",
    "inspect.smithy.1": "It's a smithy.",
    "inspect.smithy.2": "It smells of coal and iron.",
    "inspect.smithy.3": "Trolls dislike iron, they say.",
    "inspect.snag.1": "It's dead. It stands anyway.",
    "inspect.snag.2": "A torraka. Dry to the core, and good for a fire.",
    "inspect.snag.3": "The woodpeckers are still interested.",
    "inspect.spruce.1": "It's a spruce.",
    "inspect.spruce.2": "Under a spruce it is always a little evening.",
    "inspect.spruce.3": "Needles underfoot. Nothing else grows here.",
    "inspect.spruce.4": "Dark all year, and in no hurry.",
    "inspect.stonecircle.1": "A domarring. Judges sat here, they say.",
    "inspect.stonecircle.2": "Really a grave. The judges are only a story.",
    "inspect.stonecircle.3": "Step inside. Or don't.",
    "inspect.stones.1": "Raised by hand. Nobody remembers why.",
    "inspect.stones.2": "Standing stones. They look as if they just stopped talking.",
    "inspect.stones.3": "The standing stones are still waiting.",
    "inspect.stooks.1": "The harvest is in.",
    "inspect.stooks.2": "Sheaves drying. Someone will be back for them.",
    "inspect.stump.1": "It's a stump.",
    "inspect.stump.2": "Someone has been here with an axe.",
    "inspect.stump.3": "Count the rings, if there is time.",
    "inspect.tent.1": "A tent from an earlier expedition.",
    "inspect.tent.2": "This expedition never came back for it.",
    "inspect.tent.3": "The last page of the notebook is blank.",
    "inspect.tjardal.1": "A tjärdal. Pine goes in, tar runs out.",
    "inspect.tjardal.2": "Ships were tarred with this.",
    "inspect.tuft.1": "Grass.",
    "inspect.tuft.2": "Nothing to report. Grass.",
    "inspect.tuft.3": "The grass bends and stands up again.",
    "inspect.tuft.4": "Just grass.",
    "inspect.watermill.1": "It's a water mill.",
    "inspect.watermill.2": "The water does the grinding, day and night.",
    "inspect.well.1": "It's a well.",
    "inspect.well.2": "Drop a stone and count. It's deep.",
    "inspect.well.3": "Cold water, all year.",
    "inspect.wellsweep.1": "A well sweep. The long pole does the lifting.",
    "inspect.wellsweep.2": "Up comes the bucket, if someone pulls.",
    "inspect.windmill.1": "It's a windmill.",
    "inspect.windmill.2": "The whole mill turns to face the wind.",
    "inspect.windmill.3": "Here the wind grinds the flour.",
    "inspect.windthrow.1": "It's a rotvälta.",
    "inspect.windthrow.2": "The wind did this, roots and all.",
    "inspect.windthrow.3": "Windthrow. Don't ask what happened.",
    "inspect.woodpile.1": "Next winter, in stacks.",
    "inspect.woodpile.2": "Stacked with care. Don't take the bottom one.",
    "lang.mist": "mist",
    "lang.name": "English",
    "lesson.cabinText": "You start at the cabin. Tap a tile next to the ground you have explored, and the mist lifts. Try the one in the ring.",
    "lesson.cabinTextMouse": "You start at the cabin. Click a tile next to the ground you have explored, and the mist lifts. Try the one in the ring.",
    "lesson.cabinTitle": "The cabin",
    "lesson.done": "Done",
    "lesson.endDistance": "You came {distance} from the cabin. That is your result. The further, the better.",
    "lesson.endText": "The numbers go once their creatures have banners. Wake a creature, and the expedition ends.",
    "lesson.endTitle": "Ready",
    "lesson.invite": "Learn the game first. It takes a minute, and your friends are waiting.",
    "lesson.noCreature": "No creature sleeps there.",
    "lesson.numberHold": "Hold your finger on it to plant a banner.",
    "lesson.numberMode": "Or turn on banner mode and tap it.",
    "lesson.numberMouse": "Right-click it to plant a banner.",
    "lesson.numberText": "A number counts the creatures in the eight tiles around it. This 1 has one tile left in the mist, so one sleeps there.",
    "lesson.numberTitle": "A number",
    "lesson.ownText": "The 2 you found has two tiles left in the mist. Plant a banner on both.",
    "lesson.ownTitle": "On your own",
    "lesson.safeText": "This 1 has found its creature already. So the other tile around it is safe. Reveal it.",
    "lesson.safeTitle": "Safe ground",
    "lesson.woke": "A creature slept there. Try again.",
    "list.add": "Add",
    "list.addBody": "Your name and your expedition are shown to everyone at mistsweeper.com and in the app. Each day's expedition is then added as it ends, until you turn it off in Settings.",
    "list.addTitle": "Add your name",
    "list.as": "as {name}",
    "list.countSoFar": "{count} explorers so far",
    "list.countSoFarOne": "{count} explorer so far",
    "list.empty": "No explorers yet today. You could be the first.",
    "list.errorAlready": "An expedition from here is already on today's list.",
    "list.errorBlocked": "Expeditions from here can no longer be added.",
    "list.errorBusy": "Too many at once from here. Try again in a few minutes.",
    "list.errorClosed": "The list for this expedition has closed.",
    "list.errorName": "Use 2 to 20 letters, digits or spaces.",
    "list.errorOther": "The list can't be reached. Try again.",
    "list.errorRefused": "That name can't be used. Try another.",
    "list.hiddenName": "Name hidden",
    "list.loading": "Looking for today's top explorers.",
    "list.nameLabel": "Your name",
    "list.notAdded": "Not on the list",
    "list.placeSoFar": "#{place} of {count} so far",
    "list.remove": "Remove",
    "list.removeBody": "Every expedition added from here leaves the lists. They stay in your own expeditions.",
    "list.removeTitle": "Remove your expeditions?",
    "list.renameBody": "It changes on every expedition you have added.",
    "list.renameTitle": "Your name on the list",
    "list.report": "Report",
    "list.reportBody": "A name that several players report is hidden until we have looked at it.",
    "list.reportTitle": "Report this name?",
    "list.tiles": "{tiles} tiles",
    "list.unreachable": "The list can't be reached right now. Try again in a moment.",
    "list.waiting": "Waiting to be added",
    "list.you": "You",
    "list.yours": "Your expedition",
    "menu.about": "About Mistsweeper",
    "menu.apps": "More from Great Scott!",
    "menu.appsLine": "Ordna, Krono, Tapotron, Color Tap",
    "menu.back": "Back to the menu",
    "menu.close": "Close the menu",
    "menu.expeditions": "Your expeditions",
    "menu.expeditionsLine": "Streak {streak}, best {distance}",
    "menu.feedback": "Send feedback",
    "menu.getApp": "Get the iOS app",
    "menu.getAppLine": "Reminders and haptics, in beta",
    "menu.howto": "How to play",
    "menu.howtoLine": "The rules and the controls",
    "menu.list": "Top explorers",
    "menu.listLine": "Who went furthest today",
    "menu.privacy": "Privacy policy",
    "menu.settingsLine": "{theme} theme, {language}",
    "menu.version": "Version {version} · Great Scott! AB",
    "mode.daily": "Expedition #{n}",
    "mode.endless": "Endless",
    "mode.endlessBest": "Endless, best {distance}",
    "note.banner": "Banner planted.",
    "note.bannerOff": "Banner mode off.",
    "note.bannerOn": "Banner mode on.",
    "note.cabin": "Back to the cabin.",
    "note.clearing": "Your clearing. Set out your finds.",
    "note.copied": "Copied to clipboard.",
    "note.endless": "Endless. A new world every time.",
    "note.listRemoved": "Removed from the lists.",
    "note.listReported": "Name reported.",
    "note.north": "North is up again.",
    "note.today": "Today's expedition.",
    "note.todayPractice": "Today's expedition, as practice.",
    "over.bergstroll": "You woke a mountain troll.",
    "over.bergstrollLine": "Mountain trolls sit so still among the stones that you take them for stones.",
    "over.copied": "Copied to clipboard",
    "over.endlessRuns": "Endless runs",
    "over.furthestLabel": "Furthest point",
    "over.huldra": "The huldra was waiting in the trees.",
    "over.huldraLine": "She looks like a young woman until she turns around. Whoever follows her into the forest stays there.",
    "over.jatte": "A giant rose from the mountain.",
    "over.jatteLine": "Giants sleep in the mountains with their shoulders above the ground. You were standing on one.",
    "over.jatteMeadow": "A giant stepped out of the mist.",
    "over.jatteMeadowLine": "Giants walk the open ground far from any cabin. Nobody hears them coming.",
    "over.kickerDaily": "Expedition #{n}, {dateShort}",
    "over.kickerEndless": "Endless",
    "over.kickerPractice": "Practice run on expedition #{n}",
    "over.kickerTogether": "Endless, together",
    "over.memberLine": "{tiles}, {distance}",
    "over.nacken": "Näcken was waiting by the water.",
    "over.nackenLine": "Näcken plays by still water. Whoever stops to listen walks no further.",
    "over.newWorld": "Explore a new world",
    "over.practiceBoard": "Practice today's board",
    "over.setOutAgain": "Set out again",
    "over.share": "Share",
    "over.shared": "Shared",
    "over.sjotroll": "You woke a lake troll.",
    "over.sjotrollLine": "What looked like an islet had eyes.",
    "over.skogstroll": "You woke a forest troll.",
    "over.skogstrollLine": "Forest trolls sleep under the moss where the spruces stand thickest. They hate to be woken.",
    "over.streak": "Streak",
    "over.streakDay": "{days} day",
    "over.streakDays": "{days} days",
    "over.title": "Something stirred in the mist.",
    "over.todayResult": "Today's result",
    "over.todayWaiting": "Today's expedition is still waiting",
    "over.togetherBest": "Best together",
    "over.togetherMembers": "Explorers",
    "over.yourBest": "Your best",
    "party.away": "Away",
    "party.back": "Together again.",
    "party.cardLine": "{status}, {tiles}, {distance}",
    "party.copied": "Link copied.",
    "party.fell": "Watching",
    "party.follow": "Follow",
    "party.following": "Following {name}",
    "party.full": "That expedition is full.",
    "party.guest": "Explorer {n}",
    "party.invite": "Invite a friend",
    "party.inviteBody": "Send the link or show the QR code. Whoever joins steps in here, at your cabin, on this expedition. Up to {n} together.",
    "party.inviteTitle": "Explore together",
    "party.join": "Join",
    "party.joinBody": "An expedition {distance} into the mist. Whoever meets a creature watches the others go on.",
    "party.joinTitle": "{name} invites you",
    "party.joinTitleAnon": "You are invited",
    "party.joined": "{name} joined.",
    "party.leave": "Leave the expedition",
    "party.lock": "Close to new explorers",
    "party.locked": "That expedition is closed to new explorers.",
    "party.lockedNote": "Closed to new explorers.",
    "party.lost": "The line was lost. Finding the others again.",
    "party.memberFell": "{name} fell.",
    "party.memberRemoved": "{name} is no longer on the expedition.",
    "party.members": "Members of the expedition",
    "party.notNow": "Not now",
    "party.openNote": "Open to new explorers.",
    "party.out": "In the mist",
    "party.over": "That expedition is over.",
    "party.qrLabel": "QR code with the link to this expedition",
    "party.remove": "Remove from the expedition",
    "party.removeAsk": "Remove {name} from the expedition? They cannot come back with the link.",
    "party.removed": "You are no longer on that expedition.",
    "party.share": "Share the link",
    "party.shareText": "Join my expedition in the mist.",
    "party.tiles": "{n} tiles",
    "party.tiles1": "1 tile",
    "party.unavailable": "Could not start it. Try again in a moment.",
    "party.unfollow": "Stop following",
    "party.unlock": "Open to new explorers",
    "party.you": "You",
    "party.youFell": "You fell. Now you watch the others.",
    "party.youNamed": "{name} (you)",
    "party.yourName": "Your name",
    "placeholder.store": "[App Store link]",
    "privacy.cloudApp": "When iCloud is on for Mistsweeper, your settings, expeditions and clearings, and where the camera was left in each place, are also kept in your own iCloud, so they follow you to your iPhone and iPad. Only your Apple Account can read them. We cannot. Deleting the app does not remove them from iCloud. You can remove them under iCloud in the Settings app.",
    "privacy.cloudTitleApp": "In your iCloud",
    "privacy.contact": "Mistsweeper is made by Great Scott! AB in Stockholm, Sweden. Write to us with any question about privacy.",
    "privacy.contactTitle": "Contact",
    "privacy.gameCenterApp": "If you are signed in to Game Center on your device, the app sends Apple how far you reached on each day's expedition and your furthest endless run. They show on the game's Game Center leaderboards, under your Game Center name, to the players your Game Center settings allow. The game does not read your name or your friends, and keeps nothing from Game Center. If you are not signed in, nothing is sent. You can sign out under Game Center in the Settings app.",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "The site is served by Cloudflare. Like every web host, it sees your IP address so it can send you the site, and may keep it for a short time in its own logs to keep the service safe. We keep no logs of our own.",
    "privacy.hostTitle": "Hosting",
    "privacy.intro": "Mistsweeper is made to be played, not to collect data. This is everything it keeps.",
    "privacy.list": "Nothing about you is sent until you add an expedition under a name or report a name. Your place on the list is worked out on your device, from the same answer everyone gets. Once you add one, we keep the name, the expedition with its taps and result, when it was added, whether it came from the web or the app, and a scrambled form of a code your device makes. They are kept at Cloudflare, and the name and the expedition are shown to everyone at mistsweeper.com and in the app. From then on each day's expedition is added by itself, until you turn that off in Settings. To keep the list fair and friendly we can read what was added, hide or delete a name or an expedition, and stop a device from adding more. Anyone can report a name, and a report keeps the same scrambled form of the code of the device that sent it. To stop abuse, requests from one address are counted for ten minutes in a scrambled form that is never written down.",
    "privacy.listRemove": "What you added stays until you remove it. Remove my expeditions in Settings deletes it from every list, for what was added from there: a browser and the app each remove their own. The scrambled code stays for a few days, so that another of your devices cannot add the expedition again by itself, and on reports you made. If you no longer have the device, write to us and we will delete what you added. You can always ask us what we keep about you.",
    "privacy.listRemoveTitle": "Leaving the list",
    "privacy.none": "No accounts, no ads, no tracking and no cookies. We do not sell personal data or share it, and we collect none beyond what you add to Top explorers or send while exploring together.",
    "privacy.noneTitle": "What we do not do",
    "privacy.share": "When you share a result, you choose where the text goes. Links to the App Store and to email open outside the game.",
    "privacy.shareTitle": "Sharing and links",
    "privacy.stored": "Your settings, expeditions and results are saved in this browser's local storage, so you can pick up where you left off. They stay on your device, and are sent to us only if you add an expedition to Top explorers. Clearing the site's data in your browser removes them from here.",
    "privacy.storedApp": "Your settings, expeditions and results are saved in the app on this device, so you can pick up where you left off. They are sent to us only if you add an expedition to Top explorers. Deleting the app removes them from this device.",
    "privacy.storedTitle": "In your browser",
    "privacy.storedTitleApp": "On your device",
    "privacy.title": "Privacy",
    "privacy.together": "When you invite others or join an expedition by a link, the expedition is kept at Cloudflare while you play: its taps, the name and banner each member chose, and a code each browser keeps so it can take its place again. Where each member's camera looks is passed to the others as you play and never kept. We can see the expeditions played together, watch one as it goes and play it again, to keep the game working and fair. Everything about an expedition is deleted a week after it was last played.",
    "privacy.togetherTitle": "Exploring together",
    "privacy.updated": "Updated 1 November 2026",
    "privacy.updatedApp": "Updated 1 November 2026",
    "privacy.usageApp": "The iOS app counts how it is used with TelemetryDeck, a privacy-friendly analytics service from Germany with servers in the EU. It counts when a session begins, an expedition starts or ends, a result is shared and the clearing opens. Each count carries the app's version, the game's language, details of the device such as its model, system, screen and settings, and a code for the app on this device that is scrambled before it is sent, so it cannot be traced back to you. Your IP address is not stored, and nothing about your results or who you are is sent.",
    "privacy.usageTitleApp": "Counting use in the app",
    "privacy.visits": "To see how many people visit, we use Plausible, a privacy-friendly analytics service hosted in the EU. It uses no cookies and keeps no personal data, only totals such as visits, countries, browsers and the site that sent you here. Your IP address is not stored.",
    "privacy.visitsTitle": "Counting visits",
    "punct.comma": ", ",
    "punct.join": "{first} {next}",
    "punct.period": ".",
    "reminder.body": "Expedition #{n} is waiting in the mist.",
    "sealed.body": "The day changed while you were out. Your result, {distance}, is saved. You can keep exploring as practice.",
    "sealed.next": "Start expedition #{n}",
    "sealed.title": "Expedition #{n} has ended.",
    "settings.appPromo": "Reminders and haptics come with the iOS app, now in beta.",
    "settings.debug": "Show frame times",
    "settings.developer": "Developer",
    "settings.feel": "Feel",
    "settings.haptics": "Haptics",
    "settings.hapticsLine": "A small tap when you reveal a tile or plant a banner.",
    "settings.language": "Language",
    "settings.languageAuto": "Automatic",
    "settings.languageAutoLine": "Follows your system setting: {language}",
    "settings.languageDraft": "Draft",
    "settings.listAuto": "Add my expeditions",
    "settings.listAutoLine": "Each day's expedition joins the list as it ends.",
    "settings.listName": "Name on the list",
    "settings.listNote": "Add your expedition when it ends to join today's list.",
    "settings.listRemove": "Remove my expeditions",
    "settings.motion": "Reduce motion",
    "settings.motionLine": "The mist stands still, new ground appears at once and the world's edges stay sharp. Follows your system setting until you change it.",
    "settings.music": "Music",
    "settings.musicLine": "A quiet tune from the forest while you explore.",
    "settings.remind": "Daily reminder",
    "settings.remindDay": "Day",
    "settings.remindDenied": "Notifications are off for Mistsweeper. Tap to allow them in Settings.",
    "settings.remindEarlier": "{n} minutes earlier",
    "settings.remindEvening": "Evening",
    "settings.remindLater": "{n} minutes later",
    "settings.remindLine": "At {time}, while today's expedition is still waiting.",
    "settings.remindNext": "New expedition {time}",
    "settings.remindNight": "Night",
    "settings.remindTime": "Reminder time",
    "settings.reminders": "Reminders",
    "settings.sounds": "Sounds",
    "settings.soundsLine": "A sound for every reveal, banner and creature.",
    "settings.theme": "Theme",
    "settings.themeAuto": "Automatic",
    "settings.themeAutoLine": "Follows your system setting: Day in light mode, Night in dark mode.",
    "settings.themeSupporter": "Chosen in Supporter",
    "settings.tilt": "Tilt-shift",
    "settings.title": "Settings",
    "settings.zoom": "Zoom",
    "start.continue": "Continue, {distance}",
    "start.endlessLine": "A new world every time, as often as you like.",
    "start.setOut": "Set out",
    "start.tagDistance": "#{n}, {distance}",
    "start.tagDone": "#{n}, done, {distance}",
    "start.tagNew": "#{n}, new",
    "start.tagNewDate": "#{n}, {dateShort}, new",
    "start.tagProgress": "#{n}, in progress, {distance}",
    "start.todayDone": "Done for today. Next expedition in {time}.",
    "start.todayDoneShort": "Next expedition in {time}.",
    "start.todayInProgress": "In progress. Pick up where you left off.",
    "start.todayInProgressShort": "Pick up where you left off.",
    "start.todayNew": "{dateLong}. One attempt, the same ground for everyone.",
    "start.todayNewShort": "One attempt, the same ground for everyone.",
    "support.devices": "With iCloud on, the app brings your expeditions and clearings to your other devices. In a browser they stay in that browser.",
    "support.devicesTitle": "A new device",
    "support.intro": "Mistsweeper is made by a small studio in Stockholm. If something does not work, or you have a question, write to us.",
    "support.list": "“{remove}” in {settings} takes your expeditions off every list. To report a name, hold its row, or right-click it on a computer.",
    "support.listTitle": "Your name on {list}",
    "support.purchase": "Your purchase follows your Apple Account. Open {supporter} in the app's menu and choose {restore}.",
    "support.purchaseTitle": "A purchase that has gone missing",
    "support.title": "Support",
    "supporter.accent": "Accent colour",
    "supporter.accentLine": "The colour of your banners.",
    "supporter.accentNumber": "Colour {n}",
    "supporter.banner": "Banner",
    "supporter.banners": "Banners",
    "supporter.bannersLine": "Plant another banner on every expedition.",
    "supporter.buy": "Become a supporter, {price}",
    "supporter.buyLine": "One purchase, no subscription. With Family Sharing, your family has it too.",
    "supporter.buyNoPrice": "Become a supporter",
    "supporter.cabin": "Your cabin",
    "supporter.cabinLine": "Let a house you have found stand where the cabin stands, on every expedition and in every clearing.",
    "supporter.chooseCabin": "Choose in the clearing",
    "supporter.clearingLocked": "Only a supporter can change this clearing.",
    "supporter.clearings": "Clearings",
    "supporter.clearingsLine": "A larger clearing, 15 by 15 tiles, and as many clearings as you like.",
    "supporter.failed": "The purchase did not go through. Try again in a moment.",
    "supporter.free": "Everything you play is free, and stays free.",
    "supporter.icon": "App icon",
    "supporter.icons": "App icons",
    "supporter.iconsLine": "Choose the icon on your home screen. Each has a light and a dark look.",
    "supporter.lead": "As a supporter you choose how the game looks on your screen, and you help us keep making Mistsweeper.",
    "supporter.line": "Themes, app icons, banners, your cabin",
    "supporter.nothingToRestore": "No purchase of Supporter was found for this Apple Account.",
    "supporter.pending": "Waiting for approval. Supporter comes as soon as the purchase is approved.",
    "supporter.restore": "Restore purchase",
    "supporter.since": "Supporter since {date}",
    "supporter.thanks": "Thank you for supporting Mistsweeper. Here you choose how the game looks on your screen.",
    "supporter.theme": "Theme",
    "supporter.themeLine": "Day, Night and Automatic are in Settings.",
    "supporter.themes": "Themes",
    "supporter.themesLine": "Play the whole game in other colours. In some, you also choose the colour of your banners.",
    "supporter.unreachable": "The App Store could not be reached. Try again in a moment.",
    "theme.day": "Day",
    "theme.fjord": "Fjord",
    "theme.mossa": "Moss",
    "theme.night": "Night",
    "theme.pergament": "Parchment",
    "theme.rosa": "Pink",
    "theme.skymning": "Dusk",
    "time.hoursMinutes": "{h} h {m} min",
    "time.minutes": "{m} min",
    "webgl.missing": "Mistsweeper needs WebGL 2, which this browser does not provide.",
    "welcome.mistDaily": "Each day brings a new expedition, the same ground for everyone and one attempt. Endless is there for the quiet hours.",
    "welcome.mistNumbers": "A number counts the creatures hiding in the eight tiles around it. Plant a banner where you think one sleeps, and walk on.",
    "welcome.mistText": "You start at a cabin in a forest clearing, and everything else is mist. Reveal one tile at a time from the ground you have explored.",
    "welcome.mistTitle": "Into the mist",
    "welcome.next": "Next",
    "welcome.remindNo": "Not now",
    "welcome.remindText": "A new expedition comes every day. Choose a time, and we will tell you when today's is still waiting. You can change it in Settings.",
    "welcome.remindTitle": "A daily reminder",
    "welcome.remindYes": "Remind me",
    "welcome.skip": "Skip",
    "welcome.starsLater": "A little later we will ask what you think. A moment then helps us a great deal.",
    "welcome.starsText": "Mistsweeper is made by Great Scott!, a small studio in Stockholm. For a small game, ratings on the App Store are the best way to be found by others.",
    "welcome.starsTitle": "Made by a small studio",
    "welcome.step": "Step {n} of {total}",
    "widget.bestDay": "Best day {distance}",
    "widget.clearingDescription": "Your clearing, with how much you have found and your best distances.",
    "widget.clearingName": "Your clearing",
    "widget.description": "Today's expedition as you left it, and your streak.",
    "widget.next": "Next in {time}",
    "widget.streak": "Streak {days}",
    "widget.waiting": "Waiting",
  },
  es: {
    "a11y.bannerMode": "Modo bandera",
    "a11y.board.banner": "Bandera",
    "a11y.board.bannerRemoved": "Bandera retirada.",
    "a11y.board.banners1": "1 bandera",
    "a11y.board.bannersN": "{n} banderas",
    "a11y.board.cabin": "La cabaña",
    "a11y.board.cellBanner": "bandera",
    "a11y.board.cellCabin": "cabaña",
    "a11y.board.cellExplored": "explorada",
    "a11y.board.cellMist": "niebla",
    "a11y.board.cellWrongBanner": "bandera incorrecta",
    "a11y.board.chordWaits": "Las banderas de alrededor no coinciden con su número.",
    "a11y.board.chosen": "Selección: {name}.",
    "a11y.board.confirmed": "Confirmada",
    "a11y.board.creature": "Una criatura",
    "a11y.board.deepMist": "Niebla profunda",
    "a11y.board.describe": "Describir el entorno",
    "a11y.board.dirEast": "Este",
    "a11y.board.dirNorth": "Norte",
    "a11y.board.dirSouth": "Sur",
    "a11y.board.dirWest": "Oeste",
    "a11y.board.east": "{n} al este",
    "a11y.board.explore": "Explorar alrededor",
    "a11y.board.explored": "Explorada",
    "a11y.board.exploredOn": "Explorada, {what}",
    "a11y.board.frontier0": "Sin niebla por explorar",
    "a11y.board.frontier1": "1 casilla de niebla por explorar",
    "a11y.board.frontierN": "{n} casillas de niebla por explorar",
    "a11y.board.furthest": "Punto más lejano: {distance}.",
    "a11y.board.hid": "Se escondía aquí",
    "a11y.board.hintExplore": "Descubre las casillas de alrededor.",
    "a11y.board.hintPlant": "Planta una bandera.",
    "a11y.board.hintReveal": "Descubre la casilla.",
    "a11y.board.hintTakeAway": "Retira la bandera.",
    "a11y.board.inMist": "{n} en la niebla",
    "a11y.board.inView": "{what} a la vista",
    "a11y.board.listAnd": "{list} y {last}",
    "a11y.board.mist": "Niebla",
    "a11y.board.nextTo": "Junto a {numbers}",
    "a11y.board.north": "{n} al norte",
    "a11y.board.place": "{where} de la cabaña, {distance}",
    "a11y.board.plant": "Plantar una bandera",
    "a11y.board.revealed1": "1 casilla explorada.",
    "a11y.board.revealedN": "{n} casillas exploradas.",
    "a11y.board.rotorBanners": "Banderas",
    "a11y.board.rotorMist": "Niebla por explorar",
    "a11y.board.rotorNorthSouth": "Norte y sur",
    "a11y.board.rotorNumbers": "Números por resolver",
    "a11y.board.roundIt": "{what} a su alrededor",
    "a11y.board.rowHere": "Aquí: {tiles}.",
    "a11y.board.rowNorth": "Norte: {tiles}.",
    "a11y.board.rowSouth": "Sur: {tiles}.",
    "a11y.board.south": "{n} al sur",
    "a11y.board.takeAway": "Retirar la bandera",
    "a11y.board.turned": "Girado.",
    "a11y.board.west": "{n} al oeste",
    "a11y.board.woke": "Despertó aquí y puso fin a la expedición",
    "a11y.board.wrongBanner": "Bandera incorrecta",
    "a11y.distance": "Distancia máxima",
    "a11y.find": "Nuevo hallazgo: {name}.",
    "a11y.findMore": "Nuevos hallazgos: {name} y {n} más.",
    "a11y.map": "Mapa de la expedición",
    "about.body1": "Más allá de la cabaña empieza la niebla, y en la niebla viven los antiguos: troles bajo el musgo, la huldra entre los árboles, Näcken junto al agua quieta.",
    "about.body2": "Mistsweeper consiste en leer el terreno antes de pisarlo. Los números te dicen cuántas criaturas duermen cerca. Hasta dónde llegues depende de ti.",
    "about.body3": "Mistsweeper es una nueva mirada al Buscaminas, el clásico juego de lógica, inspirada en los mitos y cuentos populares nórdicos.",
    "about.made": "Hecho por Great Scott! en Estocolmo, Suecia.",
    "about.version": "Versión {version}",
    "accessibility.contact": "Si algo te impide jugar, o hay algo que te facilitaría el juego, escríbenos.",
    "accessibility.contactTitle": "Cuéntanos",
    "accessibility.contrast": "El mundo y los menús están dibujados con tinta sobre papel, con un contraste muy superior al que necesita el texto, de día y de noche. El rojo marca lo importante, pero nunca solo: una bandera tiene su forma, una bandera incorrecta lleva una cruz tras la expedición y la casilla donde terminó lleva un marco.",
    "accessibility.contrastTitle": "Contraste y color",
    "accessibility.dark": "El juego sigue el modo oscuro del sistema: Noche es el mundo a la luz de la luna. También puedes elegir Día o Noche en Ajustes, Tema.",
    "accessibility.darkTitle": "Oscuro y claro",
    "accessibility.intro": "Queremos que Mistsweeper esté al alcance de tanta gente como sea posible. Aquí te contamos lo que el juego ofrece hoy, en la web y en la app para iOS, y en qué estamos trabajando.",
    "accessibility.keys": "En la web, todo el juego funciona con el teclado: las flechas o WASD mueven el cursor, Enter o la barra espaciadora descubre una casilla, F planta o retira una bandera, Q y E giran la cámara, T y G la inclinan, las teclas más y menos acercan y alejan, H vuelve a la cabaña y Esc cierra lo que esté abierto.",
    "accessibility.keysTitle": "Teclado en la web",
    "accessibility.motion": "Con Reducir movimiento activado en el sistema, o con el interruptor propio del juego en Ajustes, nada se mueve solo. La niebla, el viento, los animales y la cámara se quedan quietos, el terreno nuevo aparece al instante y los bordes del mundo se mantienen nítidos.",
    "accessibility.motionTitle": "Reducir movimiento",
    "accessibility.sound": "El sonido y la música nunca te dicen nada que no puedas ver también. El juego no tiene voces ni video. En la app para iOS, la vibración acompaña a cada casilla descubierta y a cada bandera. La música, los sonidos y la vibración se pueden desactivar por separado en Ajustes.",
    "accessibility.soundTitle": "Sonido",
    "accessibility.title": "Accesibilidad",
    "accessibility.updated": "Última actualización: 25 de octubre de 2026",
    "accessibility.work": "En la app para iOS, el mapa se puede leer y jugar con VoiceOver y Control por voz, y el texto se adapta a tu tamaño de texto. En la web, los menús y los botones tienen etiquetas para lectores de pantalla, pero el mapa aún no se puede leer ni jugar con uno. Estamos en ello.",
    "accessibility.workTitle": "En lo que trabajamos",
    "app.tagline": "Una expedición sin fin",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "Un libro para colorear de pixel art, sin anuncios ni seguimiento.",
    "apps.intro": "Pequeños juegos y apps del mismo estudio.",
    "apps.krono": "Ordena historia, cultura pop y música en una línea de tiempo.",
    "apps.ordna": "Un tranquilo rompecabezas de ordenar. Mil niveles y ninguna interrupción.",
    "apps.tapotron": "Juegos de toques y ritmos en una cuadrícula de botones impacientes.",
    "archive.appNoteCloud": "Guardadas en iCloud, en todos tus dispositivos.",
    "archive.appNoteDevice": "Guardadas en este dispositivo. Activa iCloud para Mistsweeper y las tendrás en todos tus dispositivos.",
    "archive.best": "tu récord",
    "archive.daily": "Expediciones diarias",
    "archive.dayStreak": "Días seguidos",
    "archive.endlessBest": "Récord",
    "archive.endlessLast": "Última",
    "archive.endlessRuns": "Rondas",
    "archive.expeditions": "Expediciones",
    "archive.gameCenter": "Comparar con amigos en Game Center",
    "archive.notPlayed": "sin jugar",
    "archive.sealed": "sellada",
    "archive.today": "hoy, en curso",
    "archive.todayWord": "hoy",
    "archive.webNote": "Guardadas en este navegador. La app para iOS tiene las suyas, en iCloud.",
    "archive.webNoteShort": "Guardadas en este navegador.",
    "banner.1": "Tres puntas",
    "banner.a1": "Cola de golondrina",
    "banner.a3": "Punta de lanza",
    "banner.b1": "Cuarto de círculo",
    "banner.b2": "Estandarte del cuervo",
    "banner.b3": "Semicírculo",
    "banner.c2": "Asta en T",
    "banner.c3": "Hito",
    "banner.c4": "Retorcida",
    "beta.bugs": "¿Algo no funciona o se ve raro? Escríbenos qué hiciste, qué pasó y en qué dispositivo. Una captura de pantalla ayuda.",
    "beta.bugsTitle": "Errores",
    "beta.changes": "El juego cambia durante la beta. Cuando se lance, las expediciones seguirán donde estén, sin volver a empezar desde la #1.",
    "beta.changesTitle": "Qué va a cambiar",
    "beta.intro": "Mistsweeper ya se puede jugar, pero no está terminado. Antes de su lanzamiento, necesitamos tu ayuda.",
    "beta.language": "El juego está en nueve idiomas, y la mayoría de las traducciones aún no las ha leído ninguna persona nativa. ¿Algo suena mal o forzado? Escríbenos dónde lo viste y cómo lo dirías tú.",
    "beta.languageTitle": "Texto e idioma",
    "beta.more": "Más",
    "beta.ticker1": "Mistsweeper está en beta",
    "beta.ticker2": "Ayúdanos a encontrar errores",
    "beta.ticker3": "Ayúdanos con el idioma",
    "beta.title": "Sobre la beta",
    "button.banner": "Bandera",
    "button.cancel": "Cancelar",
    "button.close": "Cerrar",
    "button.daily": "Expedición de hoy",
    "button.endless": "Sin fin",
    "button.home": "Volver a la cabaña",
    "button.practice": "Ronda de práctica",
    "button.settings": "Ajustes",
    "button.zoomIn": "Acercar",
    "button.zoomOut": "Alejar",
    "clearing.arrange": "Colocar",
    "clearing.cabin": "La cabaña se queda donde está.",
    "clearing.cabinChosen": "Tu cabaña: {name}.",
    "clearing.cabinHint": "Tu cabaña puede ser cualquier casa que hayas encontrado. Mantén el dedo sobre ella para elegir.",
    "clearing.cat.creatures": "Criaturas",
    "clearing.cat.ground": "Terreno",
    "clearing.cat.houses": "Casas",
    "clearing.cat.plants": "Plantas",
    "clearing.cat.stones": "Piedras",
    "clearing.changeCabin": "Cambiar cabaña",
    "clearing.chooseCabin": "Elige tu cabaña",
    "clearing.clear": "Despejar",
    "clearing.delete": "Eliminar",
    "clearing.deleteBody": "Todo lo colocado allí desaparece con el claro. Tus hallazgos se conservan.",
    "clearing.deleteTitle": "¿Eliminar {name}?",
    "clearing.deleted": "Claro eliminado: {name}.",
    "clearing.discovered": "{n} de {total} hallazgos",
    "clearing.done": "Listo",
    "clearing.edit": "Editar",
    "clearing.editing": "Editando {name}",
    "clearing.family.barley": "Cebada",
    "clearing.family.barn": "Granero",
    "clearing.family.beacon": "Hoguera de aviso",
    "clearing.family.beehive": "Colmenas",
    "clearing.family.bergstroll": "Trol de montaña",
    "clearing.family.birch": "Abedul",
    "clearing.family.boat": "Barca",
    "clearing.family.boathouse": "Cobertizo de barcas",
    "clearing.family.boulder": "Peñasco",
    "clearing.family.bush": "Arbusto",
    "clearing.family.cairn": "Hito de piedras",
    "clearing.family.campfire": "Fogata",
    "clearing.family.cart": "Carreta",
    "clearing.family.cave": "Cueva",
    "clearing.family.church": "Iglesia de madera",
    "clearing.family.cottage": "Casita de campo",
    "clearing.family.driftwood": "Madera de deriva",
    "clearing.family.fabod": "Granja de verano",
    "clearing.family.faering": "Faering",
    "clearing.family.fence": "Valla de madera",
    "clearing.family.fern": "Helecho",
    "clearing.family.fishhut": "Caseta de pesca",
    "clearing.family.flottning": "Balsa de troncos",
    "clearing.family.fornborg": "Fuerte antiguo",
    "clearing.family.goahti": "Choza de turba",
    "clearing.family.gravhog": "Túmulo",
    "clearing.family.harbre": "Despensa elevada",
    "clearing.family.hassja": "Secadero de heno",
    "clearing.family.hides": "Pieles y carne",
    "clearing.family.hjell": "Secadero de pescado",
    "clearing.family.house": "Cabaña",
    "clearing.family.huldra": "Huldra",
    "clearing.family.huntingtower": "Torre de caza",
    "clearing.family.jatte": "Gigante",
    "clearing.family.jetty": "Embarcadero",
    "clearing.family.juniper": "Enebro",
    "clearing.family.kastal": "Torre de piedra",
    "clearing.family.kolmila": "Carbonera",
    "clearing.family.kummel": "Hito costero",
    "clearing.family.laundry": "Ropa tendida",
    "clearing.family.lavvu": "Lavvu",
    "clearing.family.lilypads": "Nenúfares",
    "clearing.family.log": "Tronco caído",
    "clearing.family.longhouse": "Casa larga",
    "clearing.family.massif": "Macizo",
    "clearing.family.mushroom": "Hongos",
    "clearing.family.nacken": "Näcken",
    "clearing.family.njalla": "Njalla",
    "clearing.family.oak": "Roble",
    "clearing.family.oats": "Avena",
    "clearing.family.outcrop": "Afloramiento rocoso",
    "clearing.family.peak": "Pico",
    "clearing.family.pebbles": "Guijarros",
    "clearing.family.pine": "Pino",
    "clearing.family.reeds": "Juncos",
    "clearing.family.rengarde": "Corral de renos",
    "clearing.family.rock": "Roca",
    "clearing.family.rockcarving": "Grabado rupestre",
    "clearing.family.rootcellar": "Despensa subterránea",
    "clearing.family.rowan": "Serbal",
    "clearing.family.ruin": "Ruina",
    "clearing.family.runestone": "Piedra rúnica",
    "clearing.family.rye": "Centeno",
    "clearing.family.sauna": "Sauna",
    "clearing.family.seamark": "Baliza",
    "clearing.family.shed": "Cobertizo",
    "clearing.family.shipsetting": "Barco de piedras",
    "clearing.family.shorestones": "Piedras de orilla",
    "clearing.family.sjotroll": "Trol del lago",
    "clearing.family.skogstroll": "Trol del bosque",
    "clearing.family.smithy": "Herrería",
    "clearing.family.snag": "Árbol seco",
    "clearing.family.spruce": "Abeto",
    "clearing.family.stonecircle": "Círculo de piedras",
    "clearing.family.stones": "Menhires",
    "clearing.family.stooks": "Campo cosechado",
    "clearing.family.stormannagard": "Gran salón",
    "clearing.family.stump": "Tocón",
    "clearing.family.tent": "Tienda de campaña",
    "clearing.family.tjardal": "Horno de brea",
    "clearing.family.tuft": "Hierba",
    "clearing.family.watermill": "Molino de agua",
    "clearing.family.well": "Pozo",
    "clearing.family.wellsweep": "Pozo con cigoñal",
    "clearing.family.windmill": "Molino de viento",
    "clearing.family.windthrow": "Árbol arrancado",
    "clearing.family.woodpile": "Pila de leña",
    "clearing.fold": "Plegar",
    "clearing.ground.forest": "Bosque",
    "clearing.ground.meadow": "Prado",
    "clearing.ground.mountain": "Montaña",
    "clearing.ground.water": "Agua",
    "clearing.grown": "La niebla retrocede.",
    "clearing.hint": "Elige algo aquí abajo y toca una casilla. Vuelve a tocarla para girarlo. Mantén el dedo sobre una casilla para cambiarla.",
    "clearing.hintVoiceOver": "Elige algo aquí abajo y toca dos veces una casilla. Las acciones de una casilla sirven para editarla, girarla o despejarla.",
    "clearing.large": "Grande",
    "clearing.locked": "Aún sin encontrar. Espera en algún lugar de la niebla.",
    "clearing.lockedName": "{name}, aún sin encontrar",
    "clearing.made": "Un claro nuevo: {name}.",
    "clearing.mist": "Eso está en la niebla.",
    "clearing.needsLand": "Eso va en tierra firme.",
    "clearing.needsWater": "Eso va en el agua.",
    "clearing.new": "Nuevo claro",
    "clearing.photo": "Foto",
    "clearing.photo.back": "Volver",
    "clearing.photo.failed": "Aquí no se pudo crear la foto.",
    "clearing.photo.file": "claro",
    "clearing.photo.formats": "Formato",
    "clearing.photo.notSaved": "No se pudo guardar la foto. En los ajustes del sistema puedes permitir que Mistsweeper guarde fotos.",
    "clearing.photo.picture": "Tu foto",
    "clearing.photo.save": "Guardar",
    "clearing.photo.saved": "Guardada en tus fotos.",
    "clearing.photo.share": "Compartir",
    "clearing.photo.shutter": "Tomar la foto",
    "clearing.photo.usage": "Mistsweeper guarda en Fotos las imágenes de tu claro cuando se lo pides.",
    "clearing.rename": "Renombrar",
    "clearing.renameSave": "Guardar",
    "clearing.renameTitle": "Ponle nombre al claro",
    "clearing.size": "Tamaño del claro",
    "clearing.small": "Pequeño",
    "clearing.supporter": "Supporter",
    "clearing.turn": "Girar",
    "clearing.undo": "Deshacer",
    "clearing.yours": "Tus claros",
    "controls.banner": "Plantar una bandera",
    "controls.click": "Clic",
    "controls.drag": "Arrastrar",
    "controls.pan": "Mover el mapa",
    "controls.pinch": "Pellizcar",
    "controls.qe": "Q y E",
    "controls.reveal": "Descubrir",
    "controls.rightClick": "Clic derecho",
    "controls.rightDrag": "Arrastrar con el botón derecho",
    "controls.scroll": "Desplazar",
    "controls.tg": "T y G",
    "controls.tilt": "Inclinar",
    "controls.title": "Cómo moverte",
    "controls.turn": "Girar",
    "controls.turnTilt": "Girar e inclinar",
    "controls.twist": "Girar dos dedos",
    "controls.twoFingers": "Dos dedos arriba o abajo",
    "controls.voActions": "Deslizar arriba o abajo",
    "controls.voFind": "Niebla por explorar, números por resolver, banderas, norte y sur",
    "controls.voMagicTap": "Tocar dos veces con dos dedos",
    "controls.voMove": "Mover el mapa cuatro casillas",
    "controls.voRotor": "Girar el rotor",
    "controls.voScroll": "Deslizar con tres dedos",
    "controls.voSummary": "Dónde estás y cuánto has avanzado",
    "controls.voSwipe": "Deslizar a izquierda o derecha",
    "controls.voTileActions": "Acciones de la casilla: banderas, explorar alrededor, describir el entorno",
    "controls.voTiles": "Las casillas a la vista, fila por fila desde el norte",
    "controls.zoom": "Acercar y alejar",
    "daily.next": "Próxima expedición en {time}",
    "feedback.subject": "Comentarios sobre Mistsweeper, versión {version}",
    "find.new": "Nuevo hallazgo",
    "getApp.beta": "La app está en beta. Se instala con TestFlight, la app de Apple para probar apps antes de su lanzamiento.",
    "getApp.haptics": "Vibración bajo tus dedos.",
    "getApp.intro": "La misma expedición cada día, con algunas cosas que solo una app puede hacer.",
    "getApp.join": "Unirse a la beta en TestFlight",
    "getApp.note": "Tus expediciones en este navegador se quedan aquí. La app tiene las suyas.",
    "getApp.offline": "Funciona sin conexión.",
    "getApp.qr": "Apunta aquí con la cámara del iPhone para unirte a la beta.",
    "getApp.qrLabel": "Código QR de la beta en TestFlight",
    "getApp.reminder": "Un recordatorio diario a la hora que elijas.",
    "getApp.widget": "Un widget con la expedición de hoy y tu racha.",
    "hint.clearingDesktop": "Elige algo y colócalo en el claro. Clic derecho en una casilla para cambiarla.",
    "hint.photoDesktop": "Encuadra el claro en la ventana y toma la foto.",
    "hint.reveal": "Toca una casilla junto al terreno explorado para descubrirla.",
    "hint.revealDesktop": "Clic junto a lo explorado para descubrir. Clic derecho para plantar una bandera.",
    "hint.revealVoiceOver": "Desliza hasta una casilla de niebla junto al terreno explorado, o búscala con el rotor, y tócala dos veces para descubrirla.",
    "howto.1": "Empiezas en la cabaña. Todo lo demás es niebla.",
    "howto.2": "Descubre una casilla junto al terreno que has explorado. Avanzas desde donde ya has estado, casilla a casilla.",
    "howto.3": "Un número indica cuántas criaturas se esconden en las ocho casillas que lo rodean.",
    "howto.3example": "Aquí hay criaturas escondidas en dos de las tres casillas que siguen en la niebla.",
    "howto.4mouse": "Planta una bandera donde creas que se esconde una criatura: haz clic derecho en la casilla.",
    "howto.4touch": "Planta una bandera donde creas que se esconde una criatura: activa el modo bandera y toca la casilla.",
    "howto.4voiceOver": "Planta una bandera donde creas que se esconde una criatura: desliza hacia arriba o hacia abajo sobre la casilla para recorrer sus acciones y elige Plantar una bandera.",
    "howto.5": "Si despiertas a una criatura, la expedición termina. Tu resultado es el punto más lejano de la cabaña al que llegues.",
    "howto.6": "Cada día trae una nueva expedición: el mismo terreno para todos y un solo intento. El modo Sin fin está ahí para los ratos tranquilos.",
    "howto.tryLesson": "Probar en el mundo",
    "hud.best": "Récord {distance}",
    "hud.clearing": "Claro",
    "hud.menu": "Menú",
    "hud.north": "Orientar al norte",
    "hud.practice": "Ronda de práctica, #{n}",
    "hud.today": "Hoy",
    "hud.turnLeft": "Girar a la izquierda, Q",
    "hud.turnLeftKey": "Q",
    "hud.turnRight": "Girar a la derecha, E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "Es cebada.",
    "inspect.barley.2": "Pronto será pan, o algo mejor.",
    "inspect.barn.1": "Es un granero.",
    "inspect.barn.2": "Lleno de heno y gatos.",
    "inspect.barn.3": "Heno hasta el techo. Durará hasta la primavera.",
    "inspect.beacon.1": "Una hoguera de aviso. Se enciende al avistar enemigos.",
    "inspect.beacon.2": "Un fuego, luego otro, y toda la tierra lo sabe.",
    "inspect.beacon.3": "Seca y lista. Nadie la ha encendido aún.",
    "inspect.beehive.1": "Colmenas. Mejor no tocar.",
    "inspect.beehive.2": "Estamos ocupadas.",
    "inspect.birch.1": "Es un abedul.",
    "inspect.birch.2": "Corteza blanca, rayas negras. Alguien llevaba la cuenta.",
    "inspect.birch.3": "Su corteza arde incluso mojada. Conviene saberlo.",
    "inspect.birch.4": "El abedul es el primero en brotar, el primero en amarillear.",
    "inspect.boat.1": "Una barca de remos. Alguien querrá recuperarla.",
    "inspect.boat.2": "Remos dentro. Nadie a bordo.",
    "inspect.boathouse.1": "Huele a brea y a cuerda mojada.",
    "inspect.boathouse.2": "La barca ha salido. Nadie ha dicho cuándo vuelve.",
    "inspect.boulder.1": "Un peñasco. Se movió una vez, con el hielo.",
    "inspect.boulder.2": "Vine con el hielo. Me quedo.",
    "inspect.boulder.3": "El hielo dejó esto aquí y se fue a casa.",
    "inspect.bush.1": "Es un arbusto.",
    "inspect.bush.2": "En el arbusto no se esconde nada. Probablemente.",
    "inspect.bush.3": "Algo susurró. Era solo el arbusto.",
    "inspect.cabin": "Tu cabaña. La estufa sigue caliente.",
    "inspect.cairn.1": "Es un hito de piedras.",
    "inspect.cairn.2": "Quien pasa añade una piedra.",
    "inspect.cairn.3": "Alguien marcó el camino. O una tumba.",
    "inspect.campfire.1": "Es una fogata.",
    "inspect.campfire.2": "Un fuego, y nadie alrededor.",
    "inspect.campfire.3": "Alguien se fue a toda prisa.",
    "inspect.cart.1": "Es una carreta.",
    "inspect.cart.2": "Se quedó donde paró el caballo.",
    "inspect.cave.1": "Es una cueva. Va hacia dentro.",
    "inspect.cave.2": "Entra.",
    "inspect.cave.3": "Algo respira ahí dentro. O será el viento.",
    "inspect.church.1": "Una iglesia de madera. Siglos de brea.",
    "inspect.church.2": "Ni una piedra. Solo madera y paciencia.",
    "inspect.church.3": "Ahí dentro hay silencio. Siempre lo hubo.",
    "inspect.creature.bergstroll": "Aquí vivía un trol de montaña.",
    "inspect.creature.huldra": "Aquí vivía una huldra.",
    "inspect.creature.jatte": "Aquí vivía un gigante.",
    "inspect.creature.nacken": "Aquí vivía Näcken.",
    "inspect.creature.sjotroll": "Aquí vivía un trol del lago.",
    "inspect.creature.skogstroll": "Aquí vivía un trol del bosque.",
    "inspect.deer.1": "Un corzo. Ya te ha visto.",
    "inspect.deer.2": "Alza la cabeza y sigue comiendo.",
    "inspect.driftwood.1": "Madera de deriva. Nadie sabe de dónde.",
    "inspect.driftwood.2": "Ha visto más mar que nadie por aquí.",
    "inspect.duck.1": "Un ánade real. No se mete con nadie.",
    "inspect.duck.2": "Tiene su opinión al respecto.",
    "inspect.elk.1": "Un alce. Le da igual.",
    "inspect.elk.2": "Lo más grande del bosque, y lo más callado.",
    "inspect.faering.1": "Un faering. Cuatro remos y una vela.",
    "inspect.faering.2": "Hecho como se hacían las naves largas.",
    "inspect.fence.1": "Una valla de madera. Ni un solo clavo.",
    "inspect.fence.2": "Lo que debía retener se fue paseando.",
    "inspect.fern.1": "Es un helecho.",
    "inspect.fern.2": "Aquí hubo helechos antes que árboles.",
    "inspect.fern.3": "Dicen que florece la noche de San Juan. Nadie lo ha visto.",
    "inspect.fishhut.1": "Redes, flotadores y arenque viejo.",
    "inspect.fishhut.2": "Caseta de pesca. El olor llega primero.",
    "inspect.flottning.1": "Troncos rumbo a la costa.",
    "inspect.flottning.2": "Una balsa de troncos. El río carga con todo.",
    "inspect.fornborg.1": "Un fuerte antiguo. Cuando ardían las hogueras, venían corriendo.",
    "inspect.fornborg.2": "La muralla cayó. De los que detuvo tampoco queda nada.",
    "inspect.fornborg.3": "Nadie sabe quién apiló estas piedras.",
    "inspect.goahti.1": "Una choza de turba. Por dentro, calor.",
    "inspect.goahti.2": "El humo sale por arriba. Siempre ha sido así.",
    "inspect.gravhog.1": "Un túmulo. Alguien importante.",
    "inspect.gravhog.2": "Aquí yace alguien. Camina en silencio.",
    "inspect.gravhog.3": "Una tumba. Mil años de hierba encima.",
    "inspect.harbre.1": "Una despensa elevada. Sobre postes, a salvo de ratones.",
    "inspect.harbre.2": "Ahí dentro está el grano del año pasado.",
    "inspect.hassja.1": "Un secadero de heno. Lo seca el viento.",
    "inspect.hassja.2": "Heno en las varas. Que no llueva ahora.",
    "inspect.hides.1": "Pieles de reno en bastidores. Nada se desperdicia.",
    "inspect.hides.2": "Carne secándose al viento. Comida de invierno.",
    "inspect.hjell.1": "Bacalao secándose. El viento hace de cocinero.",
    "inspect.hjell.2": "Se huele desde aquí.",
    "inspect.home": "Aquí vive {name}.",
    "inspect.huntingtower.1": "Alguien se sienta ahí arriba y espera.",
    "inspect.huntingtower.2": "Los alces lo saben.",
    "inspect.jetty.1": "Es un embarcadero.",
    "inspect.jetty.2": "Avanza un poco y se rinde.",
    "inspect.jetty.3": "Un buen lugar para pies descalzos.",
    "inspect.juniper.1": "Es un enebro.",
    "inspect.juniper.2": "Un enebro. Devuelve el pinchazo.",
    "inspect.juniper.3": "Un enebro. De lejos parece alguien de pie, muy quieto.",
    "inspect.kastal.1": "Muros gruesos, ventanas pequeñas.",
    "inspect.kastal.2": "Alguien esperaba visitas, y no de las amables.",
    "inspect.kolmila.1": "Es una carbonera.",
    "inspect.kolmila.2": "Arde sin llama durante semanas. Alguien debe quedarse en vela.",
    "inspect.kolmila.3": "Entra leña. Sale carbón.",
    "inspect.kummel.1": "Un hito costero. Les dice a los marinos dónde están.",
    "inspect.kummel.2": "Se ve desde el mar. Solo sirve para eso.",
    "inspect.laundry.1": "La ropa de alguien.",
    "inspect.laundry.2": "Seca para la noche, si la niebla no se acerca.",
    "inspect.laundry.3": "Falta un calcetín.",
    "inspect.lavvu.1": "Un lavvu. Al amanecer puede que ya no esté.",
    "inspect.lavvu.2": "Varas y tela. No hace falta más.",
    "inspect.lilypads.1": "Nenúfares.",
    "inspect.lilypads.2": "Nenúfares. No los cortes. Alguien les tiene cariño.",
    "inspect.lilypads.3": "Nenúfares de tallos largos que bajan hasta lo oscuro.",
    "inspect.log.1": "Es un tronco caído.",
    "inspect.log.2": "Cayó hace mucho. El musgo se ha instalado.",
    "inspect.massif.1": "Es un macizo montañoso.",
    "inspect.massif.2": "La montaña no repara en las visitas.",
    "inspect.massif.3": "Nieve en las grietas, incluso en agosto.",
    "inspect.mushroom.1": "Hongos. Mejor no tocarlos.",
    "inspect.mushroom.2": "Todos los hongos son comestibles. Algunos, solo una vez.",
    "inspect.mushroom.3": "Alguien los querrá en su cesta.",
    "inspect.njalla.1": "Una njalla. Un poste, y los osos solo pueden mirar.",
    "inspect.njalla.2": "Comida, en lo alto, donde solo llega la gente.",
    "inspect.oak.1": "Es un roble.",
    "inspect.oak.2": "Un roble. Más viejo que la más vieja de sus historias.",
    "inspect.oak.3": "El roble ha visto reyes ir y venir.",
    "inspect.oak.4": "Antaño, todo roble era de la Corona.",
    "inspect.oats.1": "Es avena.",
    "inspect.oats.2": "Avena para los caballos, y para el desayuno.",
    "inspect.outcrop.1": "Roca desnuda. La tierra sin abrigo.",
    "inspect.outcrop.2": "Cálido al sol, frío de noche.",
    "inspect.outcrop.3": "Esto lo pulió el hielo.",
    "inspect.peak.1": "Pico. Nieve todo el año.",
    "inspect.peak.2": "Aquí arriba no crece nada.",
    "inspect.peak.3": "Dicen que la vista es buena. La niebla discrepa.",
    "inspect.pebbles.1": "Guijarros.",
    "inspect.pebbles.2": "Cada uno fue alguna vez una montaña.",
    "inspect.pine.1": "Es un pino.",
    "inspect.pine.2": "El pino estaba aquí primero.",
    "inspect.pine.3": "Los pinos piden tierra seca y pobre. Este está contento.",
    "inspect.pine.4": "El pino se inclina hacia donde le dijo el viento.",
    "inspect.reeds.1": "Juncos.",
    "inspect.reeds.2": "Los juncos susurran. Es solo el viento.",
    "inspect.reeds.3": "Algo se movió ahí dentro. Será un pájaro.",
    "inspect.reindeer.1": "Aquí todo reno tiene dueño.",
    "inspect.reindeer.2": "Va de camino. Sabe adónde.",
    "inspect.rengarde.1": "El rebaño se reúne aquí en otoño.",
    "inspect.rengarde.2": "Ahora está vacío. Los renos saben adónde van.",
    "inspect.rock.1": "Es una roca.",
    "inspect.rock.2": "¿Sí? Una roca.",
    "inspect.rock.3": "Una roca. No tiene opinión.",
    "inspect.rock.4": "No pasa nada. Es una roca.",
    "inspect.rockcarving.1": "Grabado en la roca, mucho antes que las runas.",
    "inspect.rockcarving.2": "Estuvimos aquí.",
    "inspect.rockcarving.3": "Nadie sabe leerlo. Sigue diciendo algo.",
    "inspect.rootcellar.1": "Tubérculos a oscuras.",
    "inspect.rootcellar.2": "Ahí dentro nunca hiela.",
    "inspect.rowan.1": "Es un serbal.",
    "inspect.rowan.2": "Un serbal. Año de bayas, año de nieves, dicen.",
    "inspect.rowan.3": "Dicen que los troles no se acercan al serbal.",
    "inspect.ruin.1": "Es una ruina.",
    "inspect.ruin.2": "Esto fue el orgullo de alguien.",
    "inspect.ruin.3": "Lo que hubo aquí ya no está. Las piedras se quedaron.",
    "inspect.runestone.1": "Es una piedra rúnica.",
    "inspect.runestone.2": "Alguien la mandó alzar por un hijo o una hija.",
    "inspect.runestone.3": "Piedra rúnica. Partió al este, dice. No volvió a casa.",
    "inspect.runestone.4": "Piedra rúnica. Que lea esto quien pueda.",
    "inspect.rye.1": "Es centeno.",
    "inspect.rye.2": "El centeno pasa el invierno en pie y no pide nada.",
    "inspect.sauna.1": "Es una sauna.",
    "inspect.sauna.2": "Una sauna. Aún caliente.",
    "inspect.sauna.3": "Ramas de abedul junto a la puerta. Alguien volverá.",
    "inspect.seamark.1": "Una baliza. Los marinos se guían por ella.",
    "inspect.seamark.2": "Aquí.",
    "inspect.shed.1": "Un cobertizo. Herramientas, cuerdas y olor a brea.",
    "inspect.shed.2": "Cerrado, y la llave está en otra parte.",
    "inspect.shipsetting.1": "Un barco de piedras, para un último viaje.",
    "inspect.shipsetting.2": "Alguien zarpó en este barco.",
    "inspect.shipsetting.3": "Barco de piedras. No se ha movido desde la Edad del Hierro.",
    "inspect.shorestones.1": "Las piedras planas rebotan mejor en el agua.",
    "inspect.shorestones.2": "El agua lleva mucho tiempo trabajándolas.",
    "inspect.smithy.1": "Es una herrería.",
    "inspect.smithy.2": "Huele a carbón y a hierro.",
    "inspect.smithy.3": "A los troles no les gusta el hierro, dicen.",
    "inspect.snag.1": "Está muerto. Aun así, sigue en pie.",
    "inspect.snag.2": "Un árbol seco. Seco hasta la médula, y buena leña.",
    "inspect.snag.3": "A los pájaros carpinteros aún les interesa.",
    "inspect.spruce.1": "Es un abeto.",
    "inspect.spruce.2": "Bajo un abeto siempre anochece un poco.",
    "inspect.spruce.3": "Agujas bajo los pies. Aquí no crece nada más.",
    "inspect.spruce.4": "Oscuro todo el año, y sin prisa.",
    "inspect.stonecircle.1": "Un círculo de piedras. Aquí se sentaban jueces, dicen.",
    "inspect.stonecircle.2": "En realidad, una tumba. Los jueces son solo un cuento.",
    "inspect.stonecircle.3": "Entra. O no.",
    "inspect.stones.1": "Alzados a mano. Nadie recuerda por qué.",
    "inspect.stones.2": "Menhires. Parece que acaban de callarse.",
    "inspect.stones.3": "Los menhires siguen esperando.",
    "inspect.stooks.1": "La cosecha ya está recogida.",
    "inspect.stooks.2": "Gavillas secándose. Alguien volverá por ellas.",
    "inspect.stump.1": "Es un tocón.",
    "inspect.stump.2": "Alguien estuvo aquí con un hacha.",
    "inspect.stump.3": "Cuenta los anillos, si hay tiempo.",
    "inspect.tent.1": "Una tienda de campaña de una expedición anterior.",
    "inspect.tent.2": "Esa expedición nunca volvió por ella.",
    "inspect.tent.3": "La última página del cuaderno está en blanco.",
    "inspect.tjardal.1": "Un horno de brea. Entra pino, sale brea.",
    "inspect.tjardal.2": "Con esto se embreaban los barcos.",
    "inspect.tuft.1": "Hierba.",
    "inspect.tuft.2": "Sin novedad. Hierba.",
    "inspect.tuft.3": "La hierba se dobla y vuelve a levantarse.",
    "inspect.tuft.4": "Solo hierba.",
    "inspect.watermill.1": "Es un molino de agua.",
    "inspect.watermill.2": "El agua muele día y noche.",
    "inspect.well.1": "Es un pozo.",
    "inspect.well.2": "Suelta una piedra y cuenta. Es hondo.",
    "inspect.well.3": "Agua fría, todo el año.",
    "inspect.wellsweep.1": "Un pozo con cigoñal. El palo largo hace el esfuerzo.",
    "inspect.wellsweep.2": "Sube el balde, si alguien tira de él.",
    "inspect.windmill.1": "Es un molino de viento.",
    "inspect.windmill.2": "Todo el molino gira para encarar el viento.",
    "inspect.windmill.3": "Aquí el viento muele la harina.",
    "inspect.windthrow.1": "Es un árbol arrancado.",
    "inspect.windthrow.2": "Esto lo hizo el viento, con raíces y todo.",
    "inspect.windthrow.3": "Árbol arrancado. Ni preguntes qué pasó.",
    "inspect.woodpile.1": "El próximo invierno, apilado.",
    "inspect.woodpile.2": "Apilada con cuidado. No saques el leño de abajo.",
    "lang.mist": "niebla",
    "lang.name": "Español",
    "lesson.cabinText": "Empiezas en la cabaña. Toca una casilla junto al terreno que has explorado y la niebla se levanta. Prueba con la casilla del círculo.",
    "lesson.cabinTextMouse": "Empiezas en la cabaña. Haz clic en una casilla junto al terreno que has explorado y la niebla se levanta. Prueba con la casilla del círculo.",
    "lesson.cabinTitle": "La cabaña",
    "lesson.done": "Terminar",
    "lesson.endDistance": "Has llegado a {distance} de la cabaña. Ese es tu resultado. Cuanto más lejos, mejor.",
    "lesson.endText": "Los números desaparecen en cuanto sus criaturas tienen bandera. Si despiertas a una criatura, la expedición termina.",
    "lesson.endTitle": "Todo listo",
    "lesson.invite": "Aprende a jugar primero. Dura un minuto y tus amigos te esperan.",
    "lesson.noCreature": "Ahí no duerme ninguna criatura.",
    "lesson.numberHold": "Mantén el dedo sobre la casilla para plantar una bandera.",
    "lesson.numberMode": "O activa el modo bandera y tócala.",
    "lesson.numberMouse": "Haz clic derecho en la casilla para plantar una bandera.",
    "lesson.numberText": "Un número cuenta las criaturas que hay en las ocho casillas que lo rodean. A este 1 le queda una sola casilla en la niebla, así que ahí duerme una.",
    "lesson.numberTitle": "Un número",
    "lesson.ownText": "Al 2 que encontraste le quedan dos casillas en la niebla. Planta una bandera en las dos.",
    "lesson.ownTitle": "Por tu cuenta",
    "lesson.safeText": "Este 1 ya ha encontrado a su criatura. Así que la otra casilla a su alrededor es segura. Descúbrela.",
    "lesson.safeTitle": "Terreno seguro",
    "lesson.woke": "Ahí dormía una criatura. Vuelve a intentarlo.",
    "list.add": "Añadir",
    "list.addBody": "Tu nombre y tu expedición son visibles para todos en mistsweeper.com y en la app. A partir de entonces, la expedición de cada día se añade en cuanto termina, hasta que lo desactives en Ajustes.",
    "list.addTitle": "Añadir tu nombre",
    "list.as": "como {name}",
    "list.countSoFar": "{count} exploradores hasta ahora",
    "list.countSoFarOne": "{count} explorador hasta ahora",
    "list.empty": "Hoy todavía no hay nadie en la lista. Tu expedición puede ser la primera.",
    "list.errorAlready": "Ya hay una expedición añadida desde aquí en la lista de hoy.",
    "list.errorBlocked": "Ya no se pueden añadir expediciones desde aquí.",
    "list.errorBusy": "Demasiadas solicitudes desde aquí en poco tiempo. Vuelve a intentarlo en unos minutos.",
    "list.errorClosed": "La lista de esta expedición ya está cerrada.",
    "list.errorName": "Usa entre 2 y 20 letras, números o espacios.",
    "list.errorOther": "No se puede acceder a la lista. Vuelve a intentarlo.",
    "list.errorRefused": "Ese nombre no se puede usar. Prueba con otro.",
    "list.hiddenName": "Nombre oculto",
    "list.loading": "Buscando a los mejores exploradores de hoy.",
    "list.nameLabel": "Tu nombre",
    "list.notAdded": "No está en la lista",
    "list.placeSoFar": "#{place} de {count} hasta ahora",
    "list.remove": "Retirar",
    "list.removeBody": "Todas las expediciones añadidas desde aquí se retiran de las listas. Se conservan en tus propias expediciones.",
    "list.removeTitle": "¿Retirar tus expediciones?",
    "list.renameBody": "Cambia en todas las expediciones que has añadido.",
    "list.renameTitle": "Tu nombre en la lista",
    "list.report": "Denunciar",
    "list.reportBody": "Un nombre que varios jugadores denuncian queda oculto hasta que lo revisemos.",
    "list.reportTitle": "¿Denunciar este nombre?",
    "list.tiles": "{tiles} casillas",
    "list.unreachable": "Ahora mismo no se puede acceder a la lista. Vuelve a intentarlo en un momento.",
    "list.waiting": "Pendiente de añadir",
    "list.you": "Tú",
    "list.yours": "Tu expedición",
    "menu.about": "Sobre Mistsweeper",
    "menu.apps": "Más de Great Scott!",
    "menu.appsLine": "Ordna, Krono, Tapotron, Color Tap",
    "menu.back": "Volver al menú",
    "menu.close": "Cerrar el menú",
    "menu.expeditions": "Tus expediciones",
    "menu.expeditionsLine": "Racha {streak}, récord {distance}",
    "menu.feedback": "Enviar comentarios",
    "menu.getApp": "Descargar para iOS",
    "menu.getAppLine": "Recordatorios y vibración, en beta",
    "menu.howto": "Cómo jugar",
    "menu.howtoLine": "Las reglas y los controles",
    "menu.list": "Mejores exploradores",
    "menu.listLine": "Quién ha llegado más lejos hoy",
    "menu.privacy": "Política de privacidad",
    "menu.settingsLine": "Tema {theme}, {language}",
    "menu.version": "Versión {version} · Great Scott! AB",
    "mode.daily": "Expedición #{n}",
    "mode.endless": "Sin fin",
    "mode.endlessBest": "Sin fin, récord {distance}",
    "note.banner": "Bandera plantada.",
    "note.bannerOff": "Modo bandera desactivado.",
    "note.bannerOn": "Modo bandera activado.",
    "note.cabin": "De vuelta a la cabaña.",
    "note.clearing": "Tu claro. Coloca tus hallazgos.",
    "note.copied": "Copiado al portapapeles.",
    "note.endless": "Sin fin. Un mundo nuevo cada vez.",
    "note.listRemoved": "Expediciones retiradas de las listas.",
    "note.listReported": "Nombre denunciado.",
    "note.north": "El norte vuelve a estar arriba.",
    "note.today": "Expedición de hoy.",
    "note.todayPractice": "Expedición de hoy, como práctica.",
    "over.bergstroll": "Despertaste a un trol de montaña.",
    "over.bergstrollLine": "Los troles de montaña están tan quietos entre las piedras que uno los toma por piedras.",
    "over.copied": "Copiado",
    "over.endlessRuns": "Rondas sin fin",
    "over.furthestLabel": "Punto más lejano",
    "over.huldra": "La huldra esperaba entre los árboles.",
    "over.huldraLine": "Parece una mujer joven hasta que se da la vuelta. Quien la sigue al bosque se queda allí.",
    "over.jatte": "Un gigante se levantó de la montaña.",
    "over.jatteLine": "Los gigantes duermen en las montañas con los hombros asomando sobre el suelo. Estabas encima de uno.",
    "over.jatteMeadow": "Un gigante salió de la niebla.",
    "over.jatteMeadowLine": "Los gigantes recorren el campo abierto lejos de cualquier cabaña. Nadie los oye llegar.",
    "over.kickerDaily": "Expedición #{n}, {dateShort}",
    "over.kickerEndless": "Sin fin",
    "over.kickerPractice": "Ronda de práctica en la expedición #{n}",
    "over.kickerTogether": "Sin fin, juntos",
    "over.memberLine": "{tiles}, {distance}",
    "over.nacken": "Näcken esperaba junto al agua.",
    "over.nackenLine": "Näcken toca el violín junto al agua quieta. Quien se detiene a escuchar no da un paso más.",
    "over.newWorld": "Explorar un mundo nuevo",
    "over.practiceBoard": "Practicar en el terreno de hoy",
    "over.setOutAgain": "En marcha de nuevo",
    "over.share": "Compartir",
    "over.shared": "Compartido",
    "over.sjotroll": "Despertaste a un trol del lago.",
    "over.sjotrollLine": "Lo que parecía un islote tenía ojos.",
    "over.skogstroll": "Despertaste a un trol del bosque.",
    "over.skogstrollLine": "Los troles del bosque duermen bajo el musgo, donde los abetos crecen más tupidos. Odian que los despierten.",
    "over.streak": "Racha",
    "over.streakDay": "{days} día",
    "over.streakDays": "{days} días",
    "over.title": "Algo se movió en la niebla.",
    "over.todayResult": "Resultado de hoy",
    "over.todayWaiting": "La expedición de hoy aún te espera",
    "over.togetherBest": "Récord juntos",
    "over.togetherMembers": "Exploradores",
    "over.yourBest": "Tu récord",
    "party.away": "Ausente",
    "party.back": "Juntos otra vez.",
    "party.cardLine": "{status}, {tiles}, {distance}",
    "party.copied": "Enlace copiado.",
    "party.fell": "Mirando",
    "party.follow": "Seguir",
    "party.following": "Siguiendo a {name}",
    "party.full": "Esa expedición está completa.",
    "party.guest": "Explorador {n}",
    "party.invite": "Invitar a un amigo",
    "party.inviteBody": "Envía el enlace o muestra el código QR. Quien lo abra se une a ti aquí, junto a tu cabaña, en esta expedición. Hasta {n} juntos.",
    "party.inviteTitle": "Explorar juntos",
    "party.join": "Unirme",
    "party.joinBody": "Una expedición a {distance} dentro de la niebla. Quien se encuentre con una criatura mira cómo siguen los demás.",
    "party.joinTitle": "{name} te invita",
    "party.joinTitleAnon": "Te han invitado",
    "party.joined": "{name} se unió.",
    "party.leave": "Dejar la expedición",
    "party.lock": "Cerrar a nuevos exploradores",
    "party.locked": "Esa expedición está cerrada a nuevos exploradores.",
    "party.lockedNote": "Cerrada a nuevos exploradores.",
    "party.lost": "Se perdió la conexión. Buscando a los demás.",
    "party.memberFell": "{name} cayó.",
    "party.memberRemoved": "{name} ya no está en la expedición.",
    "party.members": "Miembros de la expedición",
    "party.notNow": "Ahora no",
    "party.openNote": "Abierta a nuevos exploradores.",
    "party.out": "En la niebla",
    "party.over": "Esa expedición ya terminó.",
    "party.qrLabel": "Código QR con el enlace a esta expedición",
    "party.remove": "Quitar de la expedición",
    "party.removeAsk": "¿Quitar a {name} de la expedición? No podrá volver con el enlace.",
    "party.removed": "Ya no estás en esa expedición.",
    "party.share": "Compartir el enlace",
    "party.shareText": "Únete a mi expedición en la niebla.",
    "party.tiles": "{n} casillas",
    "party.tiles1": "1 casilla",
    "party.unavailable": "No se pudo empezar. Inténtalo de nuevo en un momento.",
    "party.unfollow": "Dejar de seguir",
    "party.unlock": "Abrir a nuevos exploradores",
    "party.you": "Tú",
    "party.youFell": "Caíste. Ahora miras a los demás.",
    "party.youNamed": "{name} (tú)",
    "party.yourName": "Tu nombre",
    "placeholder.store": "[Enlace al App Store]",
    "privacy.cloudApp": "Cuando iCloud está activado para Mistsweeper, tus ajustes, expediciones y claros, y dónde quedó la cámara en cada lugar, también se guardan en tu propio iCloud, para que te acompañen en tu iPhone y tu iPad. Solo tu cuenta de Apple puede leerlos. Nosotros no. Si eliminas la app, siguen en iCloud. Puedes borrarlos en los ajustes del sistema, en iCloud.",
    "privacy.cloudTitleApp": "En tu iCloud",
    "privacy.contact": "Mistsweeper lo crea Great Scott! AB en Estocolmo, Suecia. Escríbenos si tienes alguna pregunta sobre privacidad.",
    "privacy.contactTitle": "Contacto",
    "privacy.gameCenterApp": "Si tienes la sesión iniciada en Game Center en tu dispositivo, la app envía a Apple hasta dónde llegaste en la expedición de cada día y tu ronda sin fin más lejana. Aparecen en las clasificaciones de Game Center del juego, con tu nombre de Game Center, para las personas que permitan tus ajustes de Game Center. El juego no lee tu nombre ni tus amigos, y no guarda nada de Game Center. Si no tienes la sesión iniciada, no se envía nada. Puedes cerrarla en Game Center, dentro de los ajustes del sistema.",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "El sitio se sirve a través de Cloudflare. Como cualquier proveedor de alojamiento web, Cloudflare ve tu dirección IP para poder enviarte el sitio y puede guardarla durante poco tiempo en sus propios registros para mantener el servicio seguro. Nosotros no guardamos registros propios.",
    "privacy.hostTitle": "Alojamiento",
    "privacy.intro": "Mistsweeper está hecho para jugar, no para recopilar datos. Esto es todo lo que guarda.",
    "privacy.list": "No se envía nada sobre ti hasta que añadas una expedición con un nombre o denuncies un nombre. Tu puesto en la lista se calcula en tu dispositivo, a partir de la misma respuesta que recibe todo el mundo. Cuando añades una, guardamos el nombre, la expedición con sus jugadas y su resultado, cuándo se añadió, si vino de la web o de la app, y una forma alterada de un código que crea tu dispositivo. Todo se guarda en Cloudflare, y el nombre y la expedición se muestran a todo el mundo en mistsweeper.com y en la app. A partir de entonces, la expedición de cada día se añade sola, hasta que lo desactives en Ajustes. Para que la lista sea justa y amable, podemos leer lo que se ha añadido, ocultar o borrar un nombre o una expedición, e impedir que un dispositivo añada más. Cualquiera puede denunciar un nombre, y cada denuncia guarda esa misma forma alterada del código del dispositivo que la envió. Para evitar abusos, las peticiones de una misma dirección se cuentan durante diez minutos en una forma alterada que nunca se escribe.",
    "privacy.listRemove": "Lo que has añadido se queda hasta que lo retires. «Retirar mis expediciones», en Ajustes, lo borra de todas las listas, para lo que se añadió desde ahí: el navegador y la app retiran cada uno lo suyo. El código alterado se queda unos días, para que otro de tus dispositivos no pueda volver a añadir la expedición solo, y en las denuncias que hayas hecho. Si ya no tienes el dispositivo, escríbenos y borraremos lo que has añadido. Siempre puedes preguntarnos qué guardamos sobre ti.",
    "privacy.listRemoveTitle": "Salir de la lista",
    "privacy.none": "Sin cuentas, sin anuncios, sin seguimiento y sin cookies. No vendemos ni compartimos datos personales, y no recopilamos ninguno más allá de lo que añades a Mejores exploradores o envías al explorar juntos.",
    "privacy.noneTitle": "Lo que no hacemos",
    "privacy.share": "Cuando compartes un resultado, tú eliges adónde va el texto. Los enlaces al App Store y al correo electrónico se abren fuera del juego.",
    "privacy.shareTitle": "Compartir y enlaces",
    "privacy.stored": "Tus ajustes, expediciones y resultados se guardan en el almacenamiento local de este navegador, para que puedas seguir donde lo dejaste. Se quedan en tu dispositivo y solo se nos envían si añades una expedición a Mejores exploradores. Si borras los datos del sitio en tu navegador, se eliminan de aquí.",
    "privacy.storedApp": "Tus ajustes, expediciones y resultados se guardan en la app, en este dispositivo, para que puedas seguir donde lo dejaste. Solo se nos envían si añades una expedición a Mejores exploradores. Si eliminas la app, se borran de este dispositivo.",
    "privacy.storedTitle": "En tu navegador",
    "privacy.storedTitleApp": "En tu dispositivo",
    "privacy.title": "Privacidad",
    "privacy.together": "Cuando invitas a otros o te unes a una expedición con un enlace, la expedición se guarda en Cloudflare mientras jugáis: sus toques, el nombre y la bandera que eligió cada miembro, y un código que guarda cada navegador para poder volver a su sitio. Hacia dónde mira la cámara de cada miembro se envía a los demás mientras jugáis y nunca se guarda. Podemos ver las expediciones jugadas juntos, mirar una mientras sigue y volver a reproducirla, para que el juego funcione y sea justo. Todo lo de una expedición se borra una semana después de la última vez que se jugó.",
    "privacy.togetherTitle": "Explorar juntos",
    "privacy.updated": "Última actualización: 1 de noviembre de 2026",
    "privacy.updatedApp": "Última actualización: 1 de noviembre de 2026",
    "privacy.usageApp": "La app para iOS cuenta cómo se usa con TelemetryDeck, un servicio de analítica respetuoso con la privacidad, de Alemania y con servidores en la UE. Cuenta cuándo empieza una sesión, cuándo empieza o termina una expedición, cuándo se comparte un resultado y cuándo se abre el claro. Cada recuento incluye la versión de la app, el idioma del juego, datos del dispositivo como su modelo, sistema, pantalla y ajustes, y un código de la app en este dispositivo que se transforma de forma irreversible antes de enviarse, para que no se pueda relacionar contigo. Tu dirección IP no se guarda, y no se envía nada sobre tus resultados ni sobre quién eres.",
    "privacy.usageTitleApp": "Recuento de uso en la app",
    "privacy.visits": "Para saber cuántas personas nos visitan, usamos Plausible, un servicio de analítica respetuoso con la privacidad y alojado en la UE. No usa cookies ni guarda datos personales, solo totales como visitas, países, navegadores y el sitio que te trajo hasta aquí. Tu dirección IP no se guarda.",
    "privacy.visitsTitle": "Recuento de visitas",
    "punct.comma": ", ",
    "punct.join": "{first} {next}",
    "punct.period": ".",
    "reminder.body": "La expedición #{n} te espera en la niebla.",
    "sealed.body": "El día cambió mientras explorabas. Tu resultado, {distance}, está guardado. Puedes seguir explorando como práctica.",
    "sealed.next": "Empezar expedición #{n}",
    "sealed.title": "La expedición #{n} ha terminado.",
    "settings.appPromo": "Los recordatorios y la vibración vienen con la app para iOS, ahora en beta.",
    "settings.debug": "Mostrar tiempos de fotograma",
    "settings.developer": "Desarrollo",
    "settings.feel": "Sensaciones",
    "settings.haptics": "Vibración",
    "settings.hapticsLine": "Un pequeño toque cuando descubres una casilla o plantas una bandera.",
    "settings.language": "Idioma",
    "settings.languageAuto": "Automático",
    "settings.languageAutoLine": "Sigue el idioma del sistema: {language}",
    "settings.languageDraft": "Borrador",
    "settings.listAuto": "Añadir mis expediciones",
    "settings.listAutoLine": "La expedición de cada día se suma a la lista en cuanto termina.",
    "settings.listName": "Nombre en la lista",
    "settings.listNote": "Añade tu expedición cuando termine para unirte a la lista de hoy.",
    "settings.listRemove": "Retirar mis expediciones",
    "settings.motion": "Reducir movimiento",
    "settings.motionLine": "La niebla se queda quieta, el terreno nuevo aparece al instante y los bordes del mundo se mantienen nítidos. Sigue el ajuste del sistema hasta que lo cambies aquí.",
    "settings.music": "Música",
    "settings.musicLine": "Una melodía tranquila del bosque mientras exploras.",
    "settings.remind": "Recordatorio diario",
    "settings.remindDay": "Día",
    "settings.remindDenied": "Las notificaciones de Mistsweeper están desactivadas. Toca para permitirlas en los ajustes del sistema.",
    "settings.remindEarlier": "{n} minutos antes",
    "settings.remindEvening": "Noche",
    "settings.remindLater": "{n} minutos después",
    "settings.remindLine": "{time}, si la expedición de hoy aún te espera.",
    "settings.remindNext": "Nueva expedición: {time}",
    "settings.remindNight": "Madrugada",
    "settings.remindTime": "Hora del recordatorio",
    "settings.reminders": "Recordatorios",
    "settings.sounds": "Sonidos",
    "settings.soundsLine": "Un sonido para cada casilla descubierta, cada bandera y cada criatura.",
    "settings.theme": "Tema",
    "settings.themeAuto": "Automático",
    "settings.themeAutoLine": "Sigue el ajuste del sistema: Día en modo claro, Noche en modo oscuro.",
    "settings.themeSupporter": "Elegido en Supporter",
    "settings.tilt": "Tilt-shift",
    "settings.title": "Ajustes",
    "settings.zoom": "Zoom",
    "start.continue": "Continuar, {distance}",
    "start.endlessLine": "Un mundo nuevo cada vez, tantas veces como quieras.",
    "start.setOut": "En marcha",
    "start.tagDistance": "#{n}, {distance}",
    "start.tagDone": "#{n}, terminada, {distance}",
    "start.tagNew": "#{n}, nueva",
    "start.tagNewDate": "#{n}, {dateShort}, nueva",
    "start.tagProgress": "#{n}, en curso, {distance}",
    "start.todayDone": "Hasta aquí por hoy. Próxima expedición en {time}.",
    "start.todayDoneShort": "Próxima expedición en {time}.",
    "start.todayInProgress": "En curso. Sigue donde lo dejaste.",
    "start.todayInProgressShort": "Sigue donde lo dejaste.",
    "start.todayNew": "{dateLong}. Un intento, el mismo terreno para todos.",
    "start.todayNewShort": "Un intento, el mismo terreno para todos.",
    "support.devices": "Con iCloud, la app lleva tus expediciones y claros a tus otros dispositivos. En un navegador se quedan en ese navegador.",
    "support.devicesTitle": "Un dispositivo nuevo",
    "support.intro": "Mistsweeper lo hace un pequeño estudio de Estocolmo. Si algo no funciona o tienes una pregunta, escríbenos.",
    "support.list": "«{remove}», en {settings}, quita tus expediciones de todas las listas. Para denunciar un nombre, mantén pulsada su fila, o haz clic derecho en él en un ordenador.",
    "support.listTitle": "Tu nombre en {list}",
    "support.purchase": "Tu compra va con tu cuenta de Apple. Abre {supporter} en el menú de la app y elige {restore}.",
    "support.purchaseTitle": "Una compra que ha desaparecido",
    "support.title": "Soporte",
    "supporter.accent": "Color de acento",
    "supporter.accentLine": "El color de tus banderas.",
    "supporter.accentNumber": "Color {n}",
    "supporter.banner": "Bandera",
    "supporter.banners": "Banderas",
    "supporter.bannersLine": "Planta otra bandera en cada expedición.",
    "supporter.buy": "Hazte supporter, {price}",
    "supporter.buyLine": "Una sola compra, sin suscripción. Con En familia, tu familia también lo tiene.",
    "supporter.buyNoPrice": "Hazte supporter",
    "supporter.cabin": "Tu cabaña",
    "supporter.cabinLine": "Pon una casa que hayas encontrado en lugar de la cabaña, en cada expedición y en cada claro.",
    "supporter.chooseCabin": "Elegir en el claro",
    "supporter.clearingLocked": "Solo un supporter puede cambiar este claro.",
    "supporter.clearings": "Claros",
    "supporter.clearingsLine": "Un claro más grande, de 15 por 15 casillas, y tantos claros como quieras.",
    "supporter.failed": "La compra no se completó. Vuelve a intentarlo en un momento.",
    "supporter.free": "Todo lo que juegas es gratis, y lo seguirá siendo.",
    "supporter.icon": "Icono de la app",
    "supporter.icons": "Iconos de la app",
    "supporter.iconsLine": "Elige el icono de tu pantalla de inicio. Cada uno tiene un aspecto claro y uno oscuro.",
    "supporter.lead": "Como supporter, eliges cómo se ve el juego en tu pantalla y nos ayudas a seguir haciendo Mistsweeper.",
    "supporter.line": "Temas, iconos de la app, banderas, tu cabaña",
    "supporter.nothingToRestore": "No se encontró ninguna compra de Supporter en esta cuenta de Apple.",
    "supporter.pending": "Esperando aprobación. Supporter llega en cuanto se apruebe la compra.",
    "supporter.restore": "Restaurar compra",
    "supporter.since": "Supporter desde {date}",
    "supporter.thanks": "Gracias por apoyar Mistsweeper. Aquí eliges cómo se ve el juego en tu pantalla.",
    "supporter.theme": "Tema",
    "supporter.themeLine": "Día, Noche y Automático están en Ajustes.",
    "supporter.themes": "Temas",
    "supporter.themesLine": "Juega todo el juego en otros colores. En algunos también eliges el color de tus banderas.",
    "supporter.unreachable": "No se pudo conectar con el App Store. Vuelve a intentarlo en un momento.",
    "theme.day": "Día",
    "theme.fjord": "Fiordo",
    "theme.mossa": "Musgo",
    "theme.night": "Noche",
    "theme.pergament": "Pergamino",
    "theme.rosa": "Rosa",
    "theme.skymning": "Crepúsculo",
    "time.hoursMinutes": "{h} h {m} min",
    "time.minutes": "{m} min",
    "webgl.missing": "Mistsweeper necesita WebGL 2, que este navegador no admite.",
    "welcome.mistDaily": "Cada día trae una nueva expedición, el mismo terreno para todos y un solo intento. El modo Sin fin está ahí para los ratos tranquilos.",
    "welcome.mistNumbers": "Un número indica cuántas criaturas se esconden en las ocho casillas que lo rodean. Planta una bandera donde creas que duerme una y sigue adelante.",
    "welcome.mistText": "Empiezas en una cabaña, en un claro del bosque, y todo lo demás es niebla. Descubre las casillas una a una desde el terreno que has explorado.",
    "welcome.mistTitle": "Niebla adentro",
    "welcome.next": "Siguiente",
    "welcome.remindNo": "Ahora no",
    "welcome.remindText": "Cada día llega una nueva expedición. Elige una hora y te avisaremos cuando la de hoy aún te espere. Puedes cambiarlo en Ajustes.",
    "welcome.remindTitle": "Un recordatorio diario",
    "welcome.remindYes": "Avísame",
    "welcome.skip": "Omitir",
    "welcome.starsLater": "Un poco más adelante te preguntaremos qué te parece. Si entonces nos dedicas un momento, nos ayudas muchísimo.",
    "welcome.starsText": "Mistsweeper lo crea Great Scott!, un pequeño estudio de Estocolmo. Para un juego pequeño, las valoraciones en el App Store son la mejor manera de que otros lo encuentren.",
    "welcome.starsTitle": "Hecho por un pequeño estudio",
    "welcome.step": "Paso {n} de {total}",
    "widget.bestDay": "Mejor día {distance}",
    "widget.clearingDescription": "Tu claro, con lo que has encontrado y tus mejores distancias.",
    "widget.clearingName": "Tu claro",
    "widget.description": "La expedición de hoy tal como la dejaste, y tu racha.",
    "widget.next": "Siguiente en {time}",
    "widget.streak": "Racha de {days}",
    "widget.waiting": "En espera",
  },
  fr: {
    "a11y.bannerMode": "Mode bannière",
    "a11y.board.banner": "Bannière",
    "a11y.board.bannerRemoved": "Bannière retirée.",
    "a11y.board.banners1": "1 bannière",
    "a11y.board.bannersN": "{n} bannières",
    "a11y.board.cabin": "La cabane",
    "a11y.board.cellBanner": "bannière",
    "a11y.board.cellCabin": "cabane",
    "a11y.board.cellExplored": "explorée",
    "a11y.board.cellMist": "brume",
    "a11y.board.cellWrongBanner": "bannière mal placée",
    "a11y.board.chordWaits": "Les bannières autour ne correspondent pas à son chiffre.",
    "a11y.board.chosen": "Choix : {name}.",
    "a11y.board.confirmed": "Confirmée",
    "a11y.board.creature": "Une créature",
    "a11y.board.deepMist": "Brume épaisse",
    "a11y.board.describe": "Décrire les alentours",
    "a11y.board.dirEast": "Est",
    "a11y.board.dirNorth": "Nord",
    "a11y.board.dirSouth": "Sud",
    "a11y.board.dirWest": "Ouest",
    "a11y.board.east": "{n} à l’est",
    "a11y.board.explore": "Explorer autour",
    "a11y.board.explored": "Explorée",
    "a11y.board.exploredOn": "Explorée, {what}",
    "a11y.board.frontier0": "Aucune brume à explorer",
    "a11y.board.frontier1": "1 case de brume à explorer",
    "a11y.board.frontierN": "{n} cases de brume à explorer",
    "a11y.board.furthest": "Le plus loin : {distance}.",
    "a11y.board.hid": "Se cachait ici",
    "a11y.board.hintExplore": "Découvre les cases autour.",
    "a11y.board.hintPlant": "Plante une bannière.",
    "a11y.board.hintReveal": "Découvre la case.",
    "a11y.board.hintTakeAway": "Retire la bannière.",
    "a11y.board.inMist": "{n} dans la brume",
    "a11y.board.inView": "{what} en vue",
    "a11y.board.listAnd": "{list} et {last}",
    "a11y.board.mist": "Brume",
    "a11y.board.nextTo": "À côté de {numbers}",
    "a11y.board.north": "{n} au nord",
    "a11y.board.place": "{where} de la cabane, {distance}",
    "a11y.board.plant": "Planter une bannière",
    "a11y.board.revealed1": "1 case explorée.",
    "a11y.board.revealedN": "{n} cases explorées.",
    "a11y.board.rotorBanners": "Bannières",
    "a11y.board.rotorMist": "Brume à explorer",
    "a11y.board.rotorNorthSouth": "Nord et sud",
    "a11y.board.rotorNumbers": "Chiffres à résoudre",
    "a11y.board.roundIt": "{what} autour",
    "a11y.board.rowHere": "Ici : {tiles}.",
    "a11y.board.rowNorth": "Nord : {tiles}.",
    "a11y.board.rowSouth": "Sud : {tiles}.",
    "a11y.board.south": "{n} au sud",
    "a11y.board.takeAway": "Retirer la bannière",
    "a11y.board.turned": "Tourné.",
    "a11y.board.west": "{n} à l’ouest",
    "a11y.board.woke": "Son réveil ici a mis fin à l’expédition",
    "a11y.board.wrongBanner": "Bannière mal placée",
    "a11y.distance": "Distance maximale",
    "a11y.find": "Nouvelle trouvaille : {name}.",
    "a11y.findMore": "Nouvelles trouvailles : {name} et {n} de plus.",
    "a11y.map": "Carte de l’expédition",
    "about.body1": "Au-delà de la cabane commence la brume, et dans la brume vivent les êtres anciens : les trolls sous la mousse, la huldra parmi les arbres, Näcken au bord des eaux dormantes.",
    "about.body2": "Dans Mistsweeper, il s’agit de lire le terrain avant d’y poser le pied. Les chiffres te disent combien de créatures dorment tout près. Jusqu’où tu iras ne dépend que de toi.",
    "about.body3": "Mistsweeper revisite le Démineur, le grand classique des jeux de réflexion, en s’inspirant des mythes et des contes nordiques.",
    "about.made": "Créé par Great Scott! à Stockholm, en Suède.",
    "about.version": "Version {version}",
    "accessibility.contact": "Quelque chose t’empêche de jouer, ou pourrait te faciliter le jeu ? Écris-nous.",
    "accessibility.contactTitle": "Dis-le-nous",
    "accessibility.contrast": "Le monde et les menus sont dessinés à l’encre sur du papier, avec un contraste bien supérieur à ce dont le texte a besoin, de jour comme de nuit. Le rouge signale ce qui compte, mais jamais seul : une bannière a sa forme, une bannière mal placée reçoit une croix après l’expédition, et la case où celle-ci s’est terminée est encadrée.",
    "accessibility.contrastTitle": "Contraste et couleur",
    "accessibility.dark": "Le jeu suit le mode sombre de ton système : Nuit, c’est le monde au clair de lune. Tu peux aussi choisir Jour ou Nuit dans Réglages, Thème.",
    "accessibility.darkTitle": "Sombre et clair",
    "accessibility.intro": "Mistsweeper doit être jouable par le plus grand nombre. Voici ce que le jeu prend en charge aujourd’hui, sur le web et dans l’app iOS, et ce sur quoi nous travaillons.",
    "accessibility.keys": "Sur le web, tout le jeu se joue au clavier : les flèches ou ZQSD déplacent le curseur, Entrée ou Espace découvre une case, F plante ou retire une bannière, A et E tournent la caméra, T et G l’inclinent, plus et moins zooment, H ramène à la cabane et Échap ferme ce qui est ouvert.",
    "accessibility.keysTitle": "Clavier sur le web",
    "accessibility.motion": "Quand l’option Réduire les animations est activée dans ton système, ou celle du jeu dans Réglages, rien ne bouge de lui-même. La brume, le vent, les animaux et la caméra s’immobilisent, le nouveau terrain apparaît d’un coup et les bords du monde restent nets.",
    "accessibility.motionTitle": "Réduire les animations",
    "accessibility.sound": "Le son et la musique ne te disent jamais rien que tu ne puisses aussi voir. Le jeu n’a ni voix ni vidéo. Dans l’app iOS, des vibrations accompagnent les cases découvertes et les bannières. La musique, les sons et les vibrations peuvent être coupés séparément dans Réglages.",
    "accessibility.soundTitle": "Son",
    "accessibility.title": "Accessibilité",
    "accessibility.updated": "Mise à jour le 25 octobre 2026",
    "accessibility.work": "Dans l’app iOS, VoiceOver et Contrôle vocal permettent de lire la carte et d’y jouer, et le texte suit ta taille de texte. Sur le web, les menus et les boutons ont des étiquettes pour les lecteurs d’écran, mais on ne peut pas encore lire la carte ni y jouer avec l’un d’eux. Nous y travaillons.",
    "accessibility.workTitle": "Ce sur quoi nous travaillons",
    "app.tagline": "Une expédition sans fin",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "Un livre de coloriage en pixel art, sans publicité ni pistage.",
    "apps.intro": "Des petits jeux et des apps du même studio.",
    "apps.krono": "Remets l’histoire, la pop culture et la musique dans l’ordre sur une frise chronologique.",
    "apps.ordna": "Un paisible casse-tête de tri. Mille niveaux, et aucune interruption.",
    "apps.tapotron": "Des jeux à tapoter et des beats sur une grille de boutons impatients.",
    "archive.appNoteCloud": "Enregistrées dans iCloud, sur tous tes appareils.",
    "archive.appNoteDevice": "Enregistrées sur cet appareil. Active iCloud pour Mistsweeper pour les retrouver sur tous tes appareils.",
    "archive.best": "ton record",
    "archive.daily": "Expéditions quotidiennes",
    "archive.dayStreak": "Jours de suite",
    "archive.endlessBest": "Record",
    "archive.endlessLast": "Dernière",
    "archive.endlessRuns": "Expéditions",
    "archive.expeditions": "Expéditions",
    "archive.gameCenter": "Compare-toi à tes amis dans Game Center",
    "archive.notPlayed": "non jouée",
    "archive.sealed": "scellée",
    "archive.today": "aujourd’hui, en cours",
    "archive.todayWord": "aujourd’hui",
    "archive.webNote": "Enregistrées dans ce navigateur. L’app iOS garde ses propres expéditions, dans iCloud.",
    "archive.webNoteShort": "Enregistrées dans ce navigateur.",
    "banner.1": "Trois pointes",
    "banner.a1": "Queue d’aronde",
    "banner.a3": "Pointe de lance",
    "banner.b1": "Quart de cercle",
    "banner.b2": "Bannière au corbeau",
    "banner.b3": "Demi-cercle",
    "banner.c2": "Hampe en T",
    "banner.c3": "Balise",
    "banner.c4": "Torsadée",
    "beta.bugs": "Quelque chose ne marche pas ou paraît bizarre ? Écris-nous ce que tu as fait, ce qui s’est passé et sur quel appareil. Une capture d’écran aide.",
    "beta.bugsTitle": "Bugs",
    "beta.changes": "Le jeu change pendant la bêta. À sa sortie, les expéditions continuent là où elles en sont, sans repartir de #1.",
    "beta.changesTitle": "Ce qui va changer",
    "beta.intro": "Mistsweeper se joue déjà, mais il n’est pas terminé. Avant sa sortie, nous avons besoin de ton aide.",
    "beta.language": "Le jeu existe en neuf langues, et la plupart des traductions n’ont pas encore été lues par une personne dont c’est la langue maternelle. Quelque chose sonne faux ou raide ? Écris-nous où tu l’as vu et comment tu le dirais.",
    "beta.languageTitle": "Texte et langue",
    "beta.more": "Plus",
    "beta.ticker1": "Mistsweeper est en bêta",
    "beta.ticker2": "Aide-nous à trouver les bugs",
    "beta.ticker3": "Aide-nous à corriger les textes",
    "beta.title": "À propos de la bêta",
    "button.banner": "Bannière",
    "button.cancel": "Annuler",
    "button.close": "Fermer",
    "button.daily": "Expédition du jour",
    "button.endless": "Sans fin",
    "button.home": "Retour à la cabane",
    "button.practice": "Entraînement",
    "button.settings": "Réglages",
    "button.zoomIn": "Zoom avant",
    "button.zoomOut": "Zoom arrière",
    "clearing.arrange": "Placer",
    "clearing.cabin": "La cabane reste où elle est.",
    "clearing.cabinChosen": "Ta cabane : {name}.",
    "clearing.cabinHint": "Ta cabane peut être n’importe quelle maison que tu as trouvée. Appuie longuement dessus pour choisir.",
    "clearing.cat.creatures": "Créatures",
    "clearing.cat.ground": "Terrain",
    "clearing.cat.houses": "Maisons",
    "clearing.cat.plants": "Plantes",
    "clearing.cat.stones": "Pierres",
    "clearing.changeCabin": "Changer de cabane",
    "clearing.chooseCabin": "Choisis ta cabane",
    "clearing.clear": "Dégager",
    "clearing.delete": "Supprimer",
    "clearing.deleteBody": "Ce qui y est placé disparaît avec la clairière. Tu gardes tes trouvailles.",
    "clearing.deleteTitle": "Supprimer {name} ?",
    "clearing.deleted": "La clairière {name} est supprimée.",
    "clearing.discovered": "Trouvailles : {n} sur {total}",
    "clearing.done": "OK",
    "clearing.edit": "Modifier",
    "clearing.editing": "Édition : {name}",
    "clearing.family.barley": "Orge",
    "clearing.family.barn": "Grange",
    "clearing.family.beacon": "Feu de signal",
    "clearing.family.beehive": "Ruches",
    "clearing.family.bergstroll": "Troll des montagnes",
    "clearing.family.birch": "Bouleau",
    "clearing.family.boat": "Barque",
    "clearing.family.boathouse": "Hangar à bateaux",
    "clearing.family.boulder": "Rocher",
    "clearing.family.bush": "Buisson",
    "clearing.family.cairn": "Cairn",
    "clearing.family.campfire": "Feu de camp",
    "clearing.family.cart": "Charrette",
    "clearing.family.cave": "Grotte",
    "clearing.family.church": "Église en bois debout",
    "clearing.family.cottage": "Fermette",
    "clearing.family.driftwood": "Bois flotté",
    "clearing.family.fabod": "Ferme d’été",
    "clearing.family.faering": "Faering",
    "clearing.family.fence": "Clôture",
    "clearing.family.fern": "Fougère",
    "clearing.family.fishhut": "Cabane de pêcheur",
    "clearing.family.flottning": "Flottage",
    "clearing.family.fornborg": "Enceinte fortifiée",
    "clearing.family.goahti": "Hutte de tourbe",
    "clearing.family.gravhog": "Tumulus",
    "clearing.family.harbre": "Grenier sur pilotis",
    "clearing.family.hassja": "Séchoir à foin",
    "clearing.family.hides": "Peaux et viande",
    "clearing.family.hjell": "Séchoir à poisson",
    "clearing.family.house": "Cabane",
    "clearing.family.huldra": "Huldra",
    "clearing.family.huntingtower": "Mirador",
    "clearing.family.jatte": "Géant",
    "clearing.family.jetty": "Ponton",
    "clearing.family.juniper": "Genévrier",
    "clearing.family.kastal": "Tour de pierre",
    "clearing.family.kolmila": "Meule de charbonnier",
    "clearing.family.kummel": "Cairn côtier",
    "clearing.family.laundry": "Linge étendu",
    "clearing.family.lavvu": "Lavvu",
    "clearing.family.lilypads": "Nénuphars",
    "clearing.family.log": "Tronc couché",
    "clearing.family.longhouse": "Maison longue",
    "clearing.family.massif": "Massif",
    "clearing.family.mushroom": "Champignons",
    "clearing.family.nacken": "Näcken",
    "clearing.family.njalla": "Njalla",
    "clearing.family.oak": "Chêne",
    "clearing.family.oats": "Avoine",
    "clearing.family.outcrop": "Dalle rocheuse",
    "clearing.family.peak": "Sommet",
    "clearing.family.pebbles": "Cailloux",
    "clearing.family.pine": "Pin",
    "clearing.family.reeds": "Roseaux",
    "clearing.family.rengarde": "Enclos à rennes",
    "clearing.family.rock": "Pierre",
    "clearing.family.rockcarving": "Gravure rupestre",
    "clearing.family.rootcellar": "Cave enterrée",
    "clearing.family.rowan": "Sorbier",
    "clearing.family.ruin": "Ruine",
    "clearing.family.runestone": "Pierre runique",
    "clearing.family.rye": "Seigle",
    "clearing.family.sauna": "Sauna",
    "clearing.family.seamark": "Balise côtière",
    "clearing.family.shed": "Remise",
    "clearing.family.shipsetting": "Navire de pierres",
    "clearing.family.shorestones": "Pierres du rivage",
    "clearing.family.sjotroll": "Troll des lacs",
    "clearing.family.skogstroll": "Troll des forêts",
    "clearing.family.smithy": "Forge",
    "clearing.family.snag": "Arbre mort",
    "clearing.family.spruce": "Épicéa",
    "clearing.family.stonecircle": "Cercle de pierres",
    "clearing.family.stones": "Pierres levées",
    "clearing.family.stooks": "Champ moissonné",
    "clearing.family.stormannagard": "Grande halle",
    "clearing.family.stump": "Souche",
    "clearing.family.tent": "Tente",
    "clearing.family.tjardal": "Four à goudron",
    "clearing.family.tuft": "Herbe",
    "clearing.family.watermill": "Moulin à eau",
    "clearing.family.well": "Puits",
    "clearing.family.wellsweep": "Puits à balancier",
    "clearing.family.windmill": "Moulin à vent",
    "clearing.family.windthrow": "Arbre déraciné",
    "clearing.family.woodpile": "Pile de bois",
    "clearing.fold": "Replier",
    "clearing.ground.forest": "Forêt",
    "clearing.ground.meadow": "Prairie",
    "clearing.ground.mountain": "Montagne",
    "clearing.ground.water": "Eau",
    "clearing.grown": "La brume recule.",
    "clearing.hint": "Choisis un élément ci-dessous, puis touche une case. Touche-la encore pour le tourner. Appuie longuement sur une case pour la modifier.",
    "clearing.hintVoiceOver": "Choisis un élément ci-dessous, puis touche deux fois une case. Les actions d’une case la modifient, la tournent ou la dégagent.",
    "clearing.large": "Grande",
    "clearing.locked": "Encore à trouver, quelque part dans la brume.",
    "clearing.lockedName": "{name}, encore à trouver",
    "clearing.made": "Une nouvelle clairière : {name}.",
    "clearing.mist": "C’est dans la brume.",
    "clearing.needsLand": "Il lui faut la terre ferme.",
    "clearing.needsWater": "Il lui faut de l’eau.",
    "clearing.new": "Nouvelle clairière",
    "clearing.photo": "Photo",
    "clearing.photo.back": "Retour",
    "clearing.photo.failed": "Impossible de créer la photo ici.",
    "clearing.photo.file": "clairiere",
    "clearing.photo.formats": "Format",
    "clearing.photo.notSaved": "La photo n’a pas pu être enregistrée. Dans Réglages, tu peux autoriser Mistsweeper à ajouter des photos.",
    "clearing.photo.picture": "Ta photo",
    "clearing.photo.save": "Enregistrer",
    "clearing.photo.saved": "Enregistrée dans ta photothèque.",
    "clearing.photo.share": "Partager",
    "clearing.photo.shutter": "Prendre une photo",
    "clearing.photo.usage": "Mistsweeper enregistre les photos de ta clairière dans ta photothèque quand tu le lui demandes.",
    "clearing.rename": "Renommer",
    "clearing.renameSave": "Enregistrer",
    "clearing.renameTitle": "Nommer la clairière",
    "clearing.size": "Taille de la clairière",
    "clearing.small": "Petite",
    "clearing.supporter": "Supporter",
    "clearing.turn": "Tourner",
    "clearing.undo": "Annuler",
    "clearing.yours": "Tes clairières",
    "controls.banner": "Planter une bannière",
    "controls.click": "Clic",
    "controls.drag": "Glisser",
    "controls.pan": "Déplacer la vue",
    "controls.pinch": "Pincer",
    "controls.qe": "A et E",
    "controls.reveal": "Découvrir",
    "controls.rightClick": "Clic droit",
    "controls.rightDrag": "Glisser avec le bouton droit",
    "controls.scroll": "Faire défiler",
    "controls.tg": "T et G",
    "controls.tilt": "Incliner",
    "controls.title": "Se déplacer",
    "controls.turn": "Tourner",
    "controls.turnTilt": "Tourner et incliner",
    "controls.twist": "Faire pivoter deux doigts",
    "controls.twoFingers": "Deux doigts vers le haut ou le bas",
    "controls.voActions": "Balayer vers le haut ou le bas",
    "controls.voFind": "Brume à explorer, chiffres à résoudre, bannières, nord et sud",
    "controls.voMagicTap": "Toucher deux fois avec deux doigts",
    "controls.voMove": "Se déplacer de quatre cases sur la carte",
    "controls.voRotor": "Tourner le rotor",
    "controls.voScroll": "Balayer avec trois doigts",
    "controls.voSummary": "Où tu te trouves et la distance parcourue",
    "controls.voSwipe": "Balayer vers la gauche ou la droite",
    "controls.voTileActions": "Actions d’une case : bannières, explorer autour, décrire les alentours",
    "controls.voTiles": "Les cases en vue, rangée par rangée depuis le nord",
    "controls.zoom": "Zoomer",
    "daily.next": "Prochaine expédition dans {time}",
    "feedback.subject": "Avis sur Mistsweeper, version {version}",
    "find.new": "Nouvelle trouvaille",
    "getApp.beta": "L’app est en bêta. Elle s’installe avec TestFlight, l’app d’Apple pour essayer les apps avant leur sortie.",
    "getApp.haptics": "Des vibrations sous tes doigts.",
    "getApp.intro": "La même expédition chaque jour, avec quelques petites choses que seule une app sait faire.",
    "getApp.join": "Rejoindre la bêta sur TestFlight",
    "getApp.note": "Tes expéditions dans ce navigateur restent ici. L’app garde les siennes.",
    "getApp.offline": "Fonctionne sans connexion.",
    "getApp.qr": "Vise ce code avec l’appareil photo de ton iPhone pour rejoindre la bêta.",
    "getApp.qrLabel": "Code QR pour la bêta sur TestFlight",
    "getApp.reminder": "Un rappel quotidien, à l’heure de ton choix.",
    "getApp.widget": "Un widget avec l’expédition du jour et ta série.",
    "hint.clearingDesktop": "Choisis un élément et place-le dans la clairière. Clic droit sur une case pour la modifier.",
    "hint.photoDesktop": "Cadre la clairière dans la fenêtre, puis prends la photo.",
    "hint.reveal": "Touche une case à côté du terrain exploré pour la découvrir.",
    "hint.revealDesktop": "Clique près du terrain exploré pour découvrir. Clic droit pour une bannière.",
    "hint.revealVoiceOver": "Balaie jusqu’à une case de brume à côté du terrain exploré, ou trouve-la avec le rotor, puis touche deux fois pour la découvrir.",
    "howto.1": "Tu pars de la cabane. Tout le reste n’est que brume.",
    "howto.2": "Découvre une case à côté du terrain que tu as exploré. Tu avances à partir de ce que tu as déjà parcouru, une case à la fois.",
    "howto.3": "Un chiffre indique le nombre de créatures cachées dans les huit cases qui l’entourent.",
    "howto.3example": "Ici, des créatures se cachent dans deux des trois cases encore dans la brume.",
    "howto.4mouse": "Plante une bannière là où tu penses qu’une créature se cache : fais un clic droit sur la case.",
    "howto.4touch": "Plante une bannière là où tu penses qu’une créature se cache : active le mode bannière et touche la case.",
    "howto.4voiceOver": "Plante une bannière là où tu penses qu’une créature se cache : balaie vers le haut ou le bas sur la case pour choisir l’action Planter une bannière.",
    "howto.5": "Si tu réveilles une créature, l’expédition s’arrête. Ton score, c’est le point le plus éloigné de la cabane que tu as atteint.",
    "howto.6": "Chaque jour apporte une nouvelle expédition : le même terrain pour tout le monde, et une seule tentative. Le mode Sans fin est là pour les heures calmes.",
    "howto.tryLesson": "Essayer dans le monde",
    "hud.best": "Record {distance}",
    "hud.clearing": "Clairière",
    "hud.menu": "Menu",
    "hud.north": "Remettre le nord en haut",
    "hud.practice": "Entraînement, #{n}",
    "hud.today": "Aujourd’hui",
    "hud.turnLeft": "Tourner à gauche, A",
    "hud.turnLeftKey": "A",
    "hud.turnRight": "Tourner à droite, E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "C’est de l’orge.",
    "inspect.barley.2": "Bientôt du pain, ou quelque chose de mieux.",
    "inspect.barn.1": "C’est une grange.",
    "inspect.barn.2": "Pleine de foin et de chats.",
    "inspect.barn.3": "Du foin jusqu’au toit. De quoi tenir jusqu’au printemps.",
    "inspect.beacon.1": "Un feu de signal. À allumer dès que l’ennemi est en vue.",
    "inspect.beacon.2": "Un feu, puis le suivant, et tout le pays sait.",
    "inspect.beacon.3": "Sec et prêt. Personne ne l’a encore allumé.",
    "inspect.beehive.1": "Des ruches. Mieux vaut ne pas frapper.",
    "inspect.beehive.2": "Nous sommes occupées.",
    "inspect.birch.1": "C’est un bouleau.",
    "inspect.birch.2": "Écorce blanche, traits noirs. Quelqu’un a compté.",
    "inspect.birch.3": "L’écorce de bouleau brûle même mouillée. Bon à savoir.",
    "inspect.birch.4": "Le bouleau verdit le premier, jaunit le premier.",
    "inspect.boat.1": "Une barque. Quelqu’un voudra la récupérer.",
    "inspect.boat.2": "Rames rentrées. Personne à bord.",
    "inspect.boathouse.1": "Ça sent le goudron et la corde mouillée.",
    "inspect.boathouse.2": "Le bateau est sorti. Personne n’a dit quand il rentrera.",
    "inspect.boulder.1": "Un rocher. Il n’a bougé qu’une fois, avec la glace.",
    "inspect.boulder.2": "Je suis venu avec la glace. Je reste.",
    "inspect.boulder.3": "La glace l’a laissé là, puis est rentrée chez elle.",
    "inspect.bush.1": "C’est un buisson.",
    "inspect.bush.2": "Rien ne se cache dans ce buisson. Normalement.",
    "inspect.bush.3": "Un bruissement. Ce n’était que le buisson.",
    "inspect.cabin": "Ta cabane. Le poêle est encore chaud.",
    "inspect.cairn.1": "C’est un cairn.",
    "inspect.cairn.2": "Qui passe ajoute une pierre.",
    "inspect.cairn.3": "Quelqu’un a marqué le chemin. Ou une tombe.",
    "inspect.campfire.1": "C’est un feu de camp.",
    "inspect.campfire.2": "Un feu, et personne autour.",
    "inspect.campfire.3": "Quelqu’un est parti à la hâte.",
    "inspect.cart.1": "C’est une charrette.",
    "inspect.cart.2": "Laissée là où le cheval s’est arrêté.",
    "inspect.cave.1": "C’est une grotte. Elle s’enfonce.",
    "inspect.cave.2": "Entre donc.",
    "inspect.cave.3": "Quelque chose respire là-dedans. Ou c’est le vent.",
    "inspect.church.1": "Une église en bois debout. Des siècles de goudron.",
    "inspect.church.2": "Pas une pierre. Rien que du bois et de la patience.",
    "inspect.church.3": "Dedans, le silence. Il a toujours été là.",
    "inspect.creature.bergstroll": "Un troll des montagnes vivait ici.",
    "inspect.creature.huldra": "Une huldra vivait ici.",
    "inspect.creature.jatte": "Un géant vivait ici.",
    "inspect.creature.nacken": "Näcken vivait ici.",
    "inspect.creature.sjotroll": "Un troll des lacs vivait ici.",
    "inspect.creature.skogstroll": "Un troll des forêts vivait ici.",
    "inspect.deer.1": "Un chevreuil. Il sait déjà que tu es là.",
    "inspect.deer.2": "Il lève la tête, puis se remet à brouter.",
    "inspect.driftwood.1": "Du bois flotté. Personne ne sait d’où.",
    "inspect.driftwood.2": "Il a vu plus de mer que quiconque ici.",
    "inspect.duck.1": "Un colvert. Il vaque à ses occupations.",
    "inspect.duck.2": "Il a son idée sur la question.",
    "inspect.elk.1": "Un élan. Il s’en moque.",
    "inspect.elk.2": "Le plus grand de la forêt, et le plus silencieux.",
    "inspect.faering.1": "Un faering. Quatre rames et une voile.",
    "inspect.faering.2": "Fait à la manière des navires vikings.",
    "inspect.fence.1": "Une clôture. Pas un seul clou.",
    "inspect.fence.2": "Ce qu’elle devait retenir a pris le large.",
    "inspect.fern.1": "C’est une fougère.",
    "inspect.fern.2": "Les fougères étaient là avant les arbres.",
    "inspect.fern.3": "Elle fleurit, dit-on, la nuit de la Saint-Jean. Personne n’a vu ça.",
    "inspect.fishhut.1": "Filets, flotteurs et vieux harengs.",
    "inspect.fishhut.2": "Cabane de pêcheur. L’odeur arrive la première.",
    "inspect.flottning.1": "Des troncs en route vers la côte.",
    "inspect.flottning.2": "Flottage du bois. La rivière se charge du transport.",
    "inspect.fornborg.1": "Une enceinte fortifiée. On y courait à la vue des feux de signal.",
    "inspect.fornborg.2": "Le mur s’est écroulé. Ceux qu’il arrêtait ont disparu aussi.",
    "inspect.fornborg.3": "Personne ne sait qui a empilé ces pierres.",
    "inspect.goahti.1": "Une hutte de tourbe. Tourbe dehors, chaleur dedans.",
    "inspect.goahti.2": "La fumée sort par le haut. Depuis toujours.",
    "inspect.gravhog.1": "Un tumulus. Quelqu’un d’important.",
    "inspect.gravhog.2": "Quelqu’un repose ici. Marche sans bruit.",
    "inspect.gravhog.3": "Une tombe. Mille ans d’herbe par-dessus.",
    "inspect.harbre.1": "Un grenier sur pilotis. Hors de portée des souris.",
    "inspect.harbre.2": "Le grain de l’an dernier est là-dedans.",
    "inspect.hassja.1": "Un séchoir à foin. Le vent fait le reste.",
    "inspect.hassja.2": "Du foin sur les perches. Surtout, qu’il ne pleuve pas.",
    "inspect.hides.1": "Des peaux de renne sur des cadres. Rien ne se perd.",
    "inspect.hides.2": "De la viande qui sèche au vent. Des vivres pour l’hiver.",
    "inspect.hjell.1": "Du stockfisch qui sèche. Le vent fait la cuisine.",
    "inspect.hjell.2": "Ça se sent d’ici.",
    "inspect.home": "Ici vit {name}.",
    "inspect.huntingtower.1": "Quelqu’un s’assoit là-haut et attend.",
    "inspect.huntingtower.2": "Les élans sont au courant.",
    "inspect.jetty.1": "C’est un ponton.",
    "inspect.jetty.2": "Il s’avance un peu, puis renonce.",
    "inspect.jetty.3": "Un bon endroit pour les pieds nus.",
    "inspect.juniper.1": "C’est un genévrier.",
    "inspect.juniper.2": "Un genévrier. Il pique à son tour.",
    "inspect.juniper.3": "Un genévrier. De loin, on dirait quelqu’un qui ne bouge pas.",
    "inspect.kastal.1": "Murs épais, petites fenêtres.",
    "inspect.kastal.2": "Quelqu’un attendait de la visite, et pas de courtoisie.",
    "inspect.kolmila.1": "C’est une meule de charbonnier.",
    "inspect.kolmila.2": "Elle couve pendant des semaines. Quelqu’un doit veiller.",
    "inspect.kolmila.3": "Il entre du bois. Il sort du charbon.",
    "inspect.kummel.1": "Un cairn côtier. Il dit aux marins où ils sont.",
    "inspect.kummel.2": "On le voit depuis la mer. Il ne sert qu’à ça.",
    "inspect.laundry.1": "Le linge de quelqu’un.",
    "inspect.laundry.2": "Sec d’ici ce soir, si la brume reste à l’écart.",
    "inspect.laundry.3": "Une chaussette manque à l’appel.",
    "inspect.lavvu.1": "Une lavvu. Au matin, elle peut ne plus être là.",
    "inspect.lavvu.2": "Des perches et de la toile. Il n’en faut pas plus.",
    "inspect.lilypads.1": "Nénuphars.",
    "inspect.lilypads.2": "Nénuphars. Ne les cueille pas. Quelqu’un y tient.",
    "inspect.lilypads.3": "Des nénuphars aux longues tiges, jusque dans le noir.",
    "inspect.log.1": "C’est un tronc couché.",
    "inspect.log.2": "Tombé il y a longtemps. La mousse s’est installée.",
    "inspect.massif.1": "C’est un massif.",
    "inspect.massif.2": "La montagne ne remarque pas qui passe.",
    "inspect.massif.3": "De la neige dans les fissures, même en août.",
    "inspect.mushroom.1": "Des champignons. Mieux vaut les laisser là.",
    "inspect.mushroom.2": "Tous les champignons sont comestibles. Certains, une seule fois.",
    "inspect.mushroom.3": "Quelqu’un les voudra dans son panier.",
    "inspect.njalla.1": "Un njalla. Un seul poteau, et les ours n’ont plus qu’à regarder.",
    "inspect.njalla.2": "Des vivres tout en haut, où seuls les humains montent.",
    "inspect.oak.1": "C’est un chêne.",
    "inspect.oak.2": "Un chêne. Plus vieux que la plus vieille histoire sur lui.",
    "inspect.oak.3": "Le chêne a vu passer bien des rois.",
    "inspect.oak.4": "Autrefois, chaque chêne appartenait à la Couronne.",
    "inspect.oats.1": "C’est de l’avoine.",
    "inspect.oats.2": "De l’avoine pour les chevaux, et pour le petit déjeuner.",
    "inspect.outcrop.1": "Dalle rocheuse. La terre sans son manteau.",
    "inspect.outcrop.2": "Chaude au soleil, froide la nuit.",
    "inspect.outcrop.3": "La glace l’a polie.",
    "inspect.peak.1": "Sommet. Neige toute l’année.",
    "inspect.peak.2": "Rien ne pousse si haut.",
    "inspect.peak.3": "La vue serait belle. La brume n’est pas de cet avis.",
    "inspect.pebbles.1": "Cailloux.",
    "inspect.pebbles.2": "Autrefois, chacun était une montagne.",
    "inspect.pine.1": "C’est un pin.",
    "inspect.pine.2": "Le pin était là le premier.",
    "inspect.pine.3": "Le pin aime les sols secs et pauvres. Celui-ci est comblé.",
    "inspect.pine.4": "Le pin penche où le vent lui a dit de pencher.",
    "inspect.reeds.1": "Roseaux.",
    "inspect.reeds.2": "Les roseaux murmurent. Ce n’est que le vent.",
    "inspect.reeds.3": "Quelque chose a bougé là-dedans. Sans doute un oiseau.",
    "inspect.reindeer.1": "Ici, chaque renne appartient à quelqu’un.",
    "inspect.reindeer.2": "Il est en route. Il sait où.",
    "inspect.rengarde.1": "Le troupeau se rassemble ici à l’automne.",
    "inspect.rengarde.2": "Vide pour l’instant. Les rennes savent où ils vont.",
    "inspect.rock.1": "C’est une pierre.",
    "inspect.rock.2": "Oui ? Une pierre.",
    "inspect.rock.3": "Une pierre. Elle n’a pas d’avis.",
    "inspect.rock.4": "Il ne se passe rien. C’est une pierre.",
    "inspect.rockcarving.1": "Gravée dans la roche, bien avant les runes.",
    "inspect.rockcarving.2": "Nous étions là.",
    "inspect.rockcarving.3": "Personne ne sait la lire. Elle dit pourtant quelque chose.",
    "inspect.rootcellar.1": "Des pommes de terre dans le noir.",
    "inspect.rootcellar.2": "Il n’y gèle jamais.",
    "inspect.rowan.1": "C’est un sorbier.",
    "inspect.rowan.2": "Un sorbier. Année de baies, hiver de neige, dit-on.",
    "inspect.rowan.3": "On dit que les trolls évitent le sorbier.",
    "inspect.ruin.1": "C’est une ruine.",
    "inspect.ruin.2": "Quelqu’un en était fier, autrefois.",
    "inspect.ruin.3": "Ce qui se dressait ici a disparu. Les pierres sont restées.",
    "inspect.runestone.1": "C’est une pierre runique.",
    "inspect.runestone.2": "Quelqu’un l’a fait dresser pour son enfant.",
    "inspect.runestone.3": "Pierre runique. Vers l’est, dit-elle. Sans retour.",
    "inspect.runestone.4": "Pierre runique. Déchiffre qui pourra.",
    "inspect.rye.1": "C’est du seigle.",
    "inspect.rye.2": "Le seigle passe l’hiver debout et ne demande rien.",
    "inspect.sauna.1": "C’est un sauna.",
    "inspect.sauna.2": "Un sauna. Encore chaud.",
    "inspect.sauna.3": "Des rameaux de bouleau devant la porte. Quelqu’un reviendra.",
    "inspect.seamark.1": "Une balise côtière. Les marins s’y repèrent.",
    "inspect.seamark.2": "Ici.",
    "inspect.shed.1": "Une remise. Des outils, de la corde, une odeur de goudron.",
    "inspect.shed.2": "Fermée, et la clé est ailleurs.",
    "inspect.shipsetting.1": "Un navire de pierres, pour un dernier voyage.",
    "inspect.shipsetting.2": "On a fait partir quelqu’un sur ce navire.",
    "inspect.shipsetting.3": "Navire de pierres. Il n’a pas bougé depuis l’âge du fer.",
    "inspect.shorestones.1": "Les pierres plates font les meilleurs ricochets.",
    "inspect.shorestones.2": "L’eau les travaille depuis longtemps.",
    "inspect.smithy.1": "C’est une forge.",
    "inspect.smithy.2": "Ça sent le charbon et le fer.",
    "inspect.smithy.3": "Les trolls n’aiment pas le fer, dit-on.",
    "inspect.snag.1": "Il est mort. Il reste debout quand même.",
    "inspect.snag.2": "Un arbre mort. Sec jusqu’au cœur, et bon pour le feu.",
    "inspect.snag.3": "Les piverts s’y intéressent encore.",
    "inspect.spruce.1": "C’est un épicéa.",
    "inspect.spruce.2": "Sous un épicéa, c’est toujours un peu le soir.",
    "inspect.spruce.3": "Des aiguilles sous les pieds. Rien d’autre ne pousse ici.",
    "inspect.spruce.4": "Sombre toute l’année, et pas pressé.",
    "inspect.stonecircle.1": "Un cercle de pierres. Des juges y siégeaient, dit-on.",
    "inspect.stonecircle.2": "En réalité, une tombe. Les juges ne sont qu’une légende.",
    "inspect.stonecircle.3": "Entre. Ou pas.",
    "inspect.stones.1": "Levées à la main. Personne ne sait plus pourquoi.",
    "inspect.stones.2": "Pierres levées. On dirait qu’elles viennent de se taire.",
    "inspect.stones.3": "Les pierres levées attendent toujours.",
    "inspect.stooks.1": "La moisson est rentrée.",
    "inspect.stooks.2": "Les gerbes sèchent. Quelqu’un reviendra les chercher.",
    "inspect.stump.1": "C’est une souche.",
    "inspect.stump.2": "Quelqu’un est passé par ici, avec une hache.",
    "inspect.stump.3": "Compte les cernes, si le temps le permet.",
    "inspect.tent.1": "La tente d’une expédition précédente.",
    "inspect.tent.2": "Cette expédition n’est jamais revenue la chercher.",
    "inspect.tent.3": "La dernière page du carnet est blanche.",
    "inspect.tjardal.1": "Un four à goudron. Il entre du pin, il coule du goudron.",
    "inspect.tjardal.2": "C’est avec ça qu’on goudronnait les navires.",
    "inspect.tuft.1": "Herbe.",
    "inspect.tuft.2": "Rien à signaler. De l’herbe.",
    "inspect.tuft.3": "L’herbe plie et se relève.",
    "inspect.tuft.4": "Juste de l’herbe.",
    "inspect.watermill.1": "C’est un moulin à eau.",
    "inspect.watermill.2": "C’est l’eau qui moud, jour et nuit.",
    "inspect.well.1": "C’est un puits.",
    "inspect.well.2": "Lâche une pierre et compte. C’est profond.",
    "inspect.well.3": "De l’eau froide, toute l’année.",
    "inspect.wellsweep.1": "Un puits à balancier. La longue perche fait le travail.",
    "inspect.wellsweep.2": "Le seau remonte, si quelqu’un tire.",
    "inspect.windmill.1": "C’est un moulin à vent.",
    "inspect.windmill.2": "Tout le moulin se tourne face au vent.",
    "inspect.windmill.3": "Ici, c’est le vent qui moud le grain.",
    "inspect.windthrow.1": "C’est un arbre déraciné.",
    "inspect.windthrow.2": "Le vent a fait ça, racines comprises.",
    "inspect.windthrow.3": "Arbre déraciné. Ne demande pas ce qui s’est passé.",
    "inspect.woodpile.1": "L’hiver prochain, en piles.",
    "inspect.woodpile.2": "Empilé avec soin. Ne prends pas la bûche du bas.",
    "lang.mist": "brume",
    "lang.name": "Français",
    "lesson.cabinText": "Tu pars de la cabane. Touche une case à côté du terrain que tu as exploré, et la brume se lève. Essaie la case entourée.",
    "lesson.cabinTextMouse": "Tu pars de la cabane. Clique sur une case à côté du terrain que tu as exploré, et la brume se lève. Essaie la case entourée.",
    "lesson.cabinTitle": "La cabane",
    "lesson.done": "OK",
    "lesson.endDistance": "Tu as exploré jusqu’à {distance} de la cabane. C’est ton résultat. Plus tu vas loin, mieux c’est.",
    "lesson.endText": "Les chiffres disparaissent dès que leurs créatures ont une bannière. Si tu réveilles une créature, l’expédition s’arrête.",
    "lesson.endTitle": "Tout est prêt",
    "lesson.invite": "Apprends d’abord à jouer. Ça prend une minute, et tes amis t’attendent.",
    "lesson.noCreature": "Aucune créature ne dort là.",
    "lesson.numberHold": "Appuie longuement sur la case pour planter une bannière.",
    "lesson.numberMode": "Ou active le mode bannière et touche la case.",
    "lesson.numberMouse": "Fais un clic droit sur la case pour planter une bannière.",
    "lesson.numberText": "Un chiffre compte les créatures des huit cases qui l’entourent. Ce 1 n’a plus qu’une case dans la brume, alors une créature y dort.",
    "lesson.numberTitle": "Un chiffre",
    "lesson.ownText": "Le 2 que tu as trouvé a encore deux cases dans la brume. Plante une bannière sur les deux.",
    "lesson.ownTitle": "À toi de jouer",
    "lesson.safeText": "Ce 1 a déjà trouvé sa créature. L’autre case autour de lui est donc sûre. Découvre-la.",
    "lesson.safeTitle": "Terrain sûr",
    "lesson.woke": "Une créature dormait là. Réessaie.",
    "list.add": "Ajouter",
    "list.addBody": "Ton nom et ton expédition sont visibles par tout le monde sur mistsweeper.com et dans l’app. Ensuite, l’expédition de chaque jour est ajoutée dès qu’elle se termine, jusqu’à ce que tu désactives cette option dans Réglages.",
    "list.addTitle": "Ajouter ton nom",
    "list.as": "sous le nom {name}",
    "list.countSoFar": "{count} personnes jusqu’ici",
    "list.countSoFarOne": "{count} personne jusqu’ici",
    "list.empty": "Personne sur la liste aujourd’hui pour l’instant. Ton expédition pourrait être la première.",
    "list.errorAlready": "Une expédition ajoutée ici figure déjà sur la liste du jour.",
    "list.errorBlocked": "Il n’est plus possible d’ajouter des expéditions ici.",
    "list.errorBusy": "Trop de demandes ici en peu de temps. Réessaie dans quelques minutes.",
    "list.errorClosed": "La liste de cette expédition est fermée.",
    "list.errorName": "Utilise de 2 à 20 lettres, chiffres ou espaces.",
    "list.errorOther": "Impossible d’accéder à la liste. Réessaie.",
    "list.errorRefused": "Ce nom ne peut pas être utilisé. Essaie-en un autre.",
    "list.hiddenName": "Nom masqué",
    "list.loading": "Recherche du top du jour.",
    "list.nameLabel": "Ton nom",
    "list.notAdded": "Pas sur la liste",
    "list.placeSoFar": "#{place} sur {count} jusqu’ici",
    "list.remove": "Retirer",
    "list.removeBody": "Toutes les expéditions ajoutées ici sont retirées des listes. Elles restent dans tes propres expéditions.",
    "list.removeTitle": "Retirer tes expéditions ?",
    "list.renameBody": "Il change sur toutes les expéditions que tu as ajoutées.",
    "list.renameTitle": "Ton nom sur la liste",
    "list.report": "Signaler",
    "list.reportBody": "Un nom signalé par plusieurs personnes est masqué jusqu’à ce que nous l’ayons examiné.",
    "list.reportTitle": "Signaler ce nom ?",
    "list.tiles": "{tiles} cases",
    "list.unreachable": "Impossible d’accéder à la liste pour le moment. Réessaie dans un instant.",
    "list.waiting": "En attente d’ajout",
    "list.you": "Toi",
    "list.yours": "Ton expédition",
    "menu.about": "À propos de Mistsweeper",
    "menu.apps": "Aussi chez Great Scott!",
    "menu.appsLine": "Ordna, Krono, Tapotron, Color Tap",
    "menu.back": "Retour au menu",
    "menu.close": "Fermer le menu",
    "menu.expeditions": "Tes expéditions",
    "menu.expeditionsLine": "Série de {streak}, record {distance}",
    "menu.feedback": "Donner ton avis",
    "menu.getApp": "Obtenir l’app iOS",
    "menu.getAppLine": "Rappels et vibrations, en bêta",
    "menu.howto": "Comment jouer",
    "menu.howtoLine": "Les règles et les commandes",
    "menu.list": "Top du jour",
    "menu.listLine": "Qui va le plus loin aujourd’hui",
    "menu.privacy": "Politique de confidentialité",
    "menu.settingsLine": "Thème {theme}, {language}",
    "menu.version": "Version {version} · Great Scott! AB",
    "mode.daily": "Expédition #{n}",
    "mode.endless": "Sans fin",
    "mode.endlessBest": "Sans fin, record {distance}",
    "note.banner": "Bannière plantée.",
    "note.bannerOff": "Mode bannière désactivé.",
    "note.bannerOn": "Mode bannière activé.",
    "note.cabin": "Retour à la cabane.",
    "note.clearing": "Ta clairière, où placer tes trouvailles.",
    "note.copied": "Copié dans le presse-papiers.",
    "note.endless": "Sans fin. Un nouveau monde à chaque fois.",
    "note.listRemoved": "Expéditions retirées des listes.",
    "note.listReported": "Nom signalé.",
    "note.north": "Le nord est de nouveau en haut.",
    "note.today": "Expédition du jour.",
    "note.todayPractice": "Expédition du jour, pour s’entraîner.",
    "over.bergstroll": "Tu as réveillé un troll des montagnes.",
    "over.bergstrollLine": "Les trolls des montagnes se tiennent si immobiles parmi les pierres qu’on les prend pour des pierres.",
    "over.copied": "Texte copié",
    "over.endlessRuns": "Expéditions",
    "over.furthestLabel": "Le plus loin",
    "over.huldra": "La huldra attendait parmi les arbres.",
    "over.huldraLine": "Elle a l’air d’une jeune femme, jusqu’à ce qu’elle se retourne. Qui la suit dans la forêt y reste.",
    "over.jatte": "Un géant s’est levé de la montagne.",
    "over.jatteLine": "Les géants dorment dans les montagnes, les épaules hors de terre. Tu te tenais sur l’un d’eux.",
    "over.jatteMeadow": "Un géant est sorti de la brume.",
    "over.jatteMeadowLine": "Les géants arpentent les terres dégagées, loin de toute cabane. Personne ne les entend venir.",
    "over.kickerDaily": "Expédition #{n}, {dateShort}",
    "over.kickerEndless": "Sans fin",
    "over.kickerPractice": "Entraînement sur l’expédition #{n}",
    "over.kickerTogether": "Sans fin, ensemble",
    "over.memberLine": "{tiles}, {distance}",
    "over.nacken": "Näcken attendait au bord de l’eau.",
    "over.nackenLine": "Näcken joue au bord des eaux dormantes. Qui s’arrête pour l’écouter ne va pas plus loin.",
    "over.newWorld": "Explorer un nouveau monde",
    "over.practiceBoard": "S’entraîner sur le terrain du jour",
    "over.setOutAgain": "Repartir",
    "over.share": "Partager",
    "over.shared": "Partagé",
    "over.sjotroll": "Tu as réveillé un troll des lacs.",
    "over.sjotrollLine": "Ce qui ressemblait à un îlot avait des yeux.",
    "over.skogstroll": "Tu as réveillé un troll des forêts.",
    "over.skogstrollLine": "Les trolls des forêts dorment sous la mousse, là où les épicéas sont les plus serrés. Ils détestent qu’on les réveille.",
    "over.streak": "Série",
    "over.streakDay": "{days} jour",
    "over.streakDays": "{days} jours",
    "over.title": "Quelque chose a remué dans la brume.",
    "over.todayResult": "Résultat du jour",
    "over.todayWaiting": "L’expédition du jour attend encore",
    "over.togetherBest": "Record ensemble",
    "over.togetherMembers": "Explorateurs",
    "over.yourBest": "Ton record",
    "party.away": "Absent",
    "party.back": "De nouveau ensemble.",
    "party.cardLine": "{status}, {tiles}, {distance}",
    "party.copied": "Lien copié.",
    "party.fell": "Regarde",
    "party.follow": "Suivre",
    "party.following": "Tu suis {name}",
    "party.full": "Cette expédition est complète.",
    "party.guest": "Explorateur {n}",
    "party.invite": "Inviter un ami",
    "party.inviteBody": "Envoie le lien ou montre le code QR. Qui l'ouvre te rejoint ici, près de ta cabane, sur cette expédition. Jusqu'à {n} ensemble.",
    "party.inviteTitle": "Explorer ensemble",
    "party.join": "Rejoindre",
    "party.joinBody": "Une expédition à {distance} dans la brume. Qui croise une créature regarde les autres continuer.",
    "party.joinTitle": "{name} t'invite",
    "party.joinTitleAnon": "On t'invite",
    "party.joined": "{name} a rejoint l'expédition.",
    "party.leave": "Quitter l'expédition",
    "party.lock": "Fermer aux nouveaux explorateurs",
    "party.locked": "Cette expédition est fermée aux nouveaux explorateurs.",
    "party.lockedNote": "Fermée aux nouveaux explorateurs.",
    "party.lost": "Liaison perdue. On retrouve les autres.",
    "party.memberFell": "{name} a chuté.",
    "party.memberRemoved": "{name} ne fait plus partie de l’expédition.",
    "party.members": "Membres de l'expédition",
    "party.notNow": "Pas maintenant",
    "party.openNote": "Ouverte aux nouveaux explorateurs.",
    "party.out": "Dans la brume",
    "party.over": "Cette expédition est terminée.",
    "party.qrLabel": "Code QR avec le lien vers cette expédition",
    "party.remove": "Retirer de l’expédition",
    "party.removeAsk": "Retirer {name} de l’expédition ? Le lien ne permettra plus de revenir.",
    "party.removed": "Tu ne fais plus partie de cette expédition.",
    "party.share": "Partager le lien",
    "party.shareText": "Rejoins mon expédition dans la brume.",
    "party.tiles": "{n} cases",
    "party.tiles1": "1 case",
    "party.unavailable": "Impossible de commencer. Réessaie dans un instant.",
    "party.unfollow": "Ne plus suivre",
    "party.unlock": "Ouvrir aux nouveaux explorateurs",
    "party.you": "Toi",
    "party.youFell": "Tu as chuté. Tu regardes les autres.",
    "party.youNamed": "{name} (toi)",
    "party.yourName": "Ton nom",
    "placeholder.store": "[Lien vers l’App Store]",
    "privacy.cloudApp": "Quand iCloud est activé pour Mistsweeper, tes réglages, tes expéditions et tes clairières, et l’endroit où la caméra est restée dans chaque lieu, sont aussi enregistrés dans ton propre iCloud, pour te suivre sur ton iPhone et ton iPad. Seul ton compte Apple peut les lire. Nous ne le pouvons pas. Supprimer l’app ne les efface pas d’iCloud. Tu peux les supprimer dans iCloud, dans l’app Réglages.",
    "privacy.cloudTitleApp": "Dans ton iCloud",
    "privacy.contact": "Mistsweeper est créé par Great Scott! AB, à Stockholm, en Suède. Écris-nous pour toute question sur la confidentialité.",
    "privacy.contactTitle": "Contact",
    "privacy.gameCenterApp": "Si ta session Game Center est ouverte sur ton appareil, l’app envoie à Apple la distance atteinte à chaque expédition du jour et ton expédition sans fin la plus lointaine. Elles s’affichent dans les classements Game Center du jeu, sous ton nom Game Center, pour les personnes que tes réglages Game Center autorisent. Le jeu ne lit ni ton nom ni tes amis et ne garde rien de Game Center. Sans session ouverte, rien n’est envoyé. Tu peux te déconnecter sous Game Center dans l’app Réglages.",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "Le site est hébergé par Cloudflare. Comme tout hébergeur, Cloudflare voit ton adresse IP pour t’envoyer le site, et peut la conserver peu de temps dans ses propres journaux pour assurer la sécurité du service. Nous ne tenons aucun journal de notre côté.",
    "privacy.hostTitle": "Hébergement",
    "privacy.intro": "Mistsweeper est fait pour qu’on y joue, pas pour collecter des données. Voici tout ce qu’il conserve.",
    "privacy.list": "Rien sur toi n’est envoyé tant que tu n’as pas ajouté une expédition sous un nom ou signalé un nom. Ta place sur la liste est calculée sur ton appareil, à partir de la même réponse que tout le monde reçoit. Une fois une expédition ajoutée, nous gardons le nom, l’expédition avec ses actions et son résultat, le moment où elle a été ajoutée, si elle vient du web ou de l’app, et une forme brouillée d’un code créé par ton appareil. Tout cela est conservé chez Cloudflare, et le nom et l’expédition sont montrés à tout le monde sur mistsweeper.com et dans l’app. Ensuite, l’expédition de chaque jour s’ajoute toute seule, jusqu’à ce que tu désactives cela dans Réglages. Pour que la liste reste juste et amicale, nous pouvons lire ce qui a été ajouté, masquer ou supprimer un nom ou une expédition, et empêcher un appareil d’en ajouter d’autres. Tout le monde peut signaler un nom, et un signalement garde la même forme brouillée du code de l’appareil qui l’a envoyé. Pour éviter les abus, les requêtes venant d’une même adresse sont comptées pendant dix minutes sous une forme brouillée qui n’est jamais écrite.",
    "privacy.listRemove": "Ce que tu as ajouté reste jusqu’à ce que tu le retires. « Retirer mes expéditions », dans Réglages, l’efface de toutes les listes, pour ce qui a été ajouté depuis cet endroit. Le navigateur et l’app retirent chacun les leurs. Le code brouillé reste quelques jours, pour qu’un autre de tes appareils ne puisse pas rajouter l’expédition tout seul, ainsi que sur les signalements que tu as faits. Si tu n’as plus l’appareil, écris-nous et nous effacerons ce que tu as ajouté. Tu peux toujours nous demander ce que nous gardons sur toi.",
    "privacy.listRemoveTitle": "Quitter la liste",
    "privacy.none": "Pas de compte, pas de publicité, pas de pistage et pas de cookies. Nous ne vendons ni ne partageons aucune donnée personnelle, et nous n’en collectons aucune en dehors de ce que tu ajoutes au Top du jour ou envoies en explorant ensemble.",
    "privacy.noneTitle": "Ce que nous ne faisons pas",
    "privacy.share": "Quand tu partages un résultat, c’est toi qui choisis où va le texte. Les liens vers l’App Store et vers ta messagerie s’ouvrent en dehors du jeu.",
    "privacy.shareTitle": "Partage et liens",
    "privacy.stored": "Tes réglages, tes expéditions et tes résultats sont enregistrés dans le stockage local de ce navigateur, pour que tu puisses reprendre où tu en étais. Ils restent sur ton appareil et ne nous sont envoyés que si tu ajoutes une expédition au Top du jour. Effacer les données du site dans ton navigateur les supprime d’ici.",
    "privacy.storedApp": "Tes réglages, tes expéditions et tes résultats sont enregistrés dans l’app, sur cet appareil, pour que tu puisses reprendre où tu en étais. Ils ne nous sont envoyés que si tu ajoutes une expédition au Top du jour. Supprimer l’app les efface de cet appareil.",
    "privacy.storedTitle": "Dans ton navigateur",
    "privacy.storedTitleApp": "Sur ton appareil",
    "privacy.title": "Confidentialité",
    "privacy.together": "Quand tu invites d’autres personnes ou rejoins une expédition par un lien, l’expédition est conservée chez Cloudflare pendant que vous jouez : ses touches, le nom et la bannière choisis par chaque membre, et un code que chaque navigateur garde pour reprendre sa place. L’endroit où regarde la caméra de chaque membre est transmis aux autres pendant le jeu et n’est jamais conservé. Nous pouvons voir les expéditions jouées ensemble, en suivre une en direct et la rejouer, pour que le jeu fonctionne et reste juste. Tout ce qui concerne une expédition est supprimé une semaine après la dernière partie.",
    "privacy.togetherTitle": "Explorer ensemble",
    "privacy.updated": "Mise à jour le 1er novembre 2026",
    "privacy.updatedApp": "Mise à jour le 1er novembre 2026",
    "privacy.usageApp": "L’app iOS mesure son utilisation avec TelemetryDeck, un outil de mesure d’audience respectueux de la vie privée, allemand et hébergé dans l’UE. Elle compte le début d’une session, le début et la fin d’une expédition, le partage d’un résultat et l’ouverture de la clairière. Chaque mesure contient la version de l’app, la langue du jeu, des informations sur l’appareil comme son modèle, son système, son écran et ses réglages, et un code propre à l’app sur cet appareil, rendu illisible avant l’envoi pour qu’il ne puisse pas être relié à toi. Ton adresse IP n’est pas enregistrée, et rien sur tes résultats ni sur ton identité n’est envoyé.",
    "privacy.usageTitleApp": "Mesure d’utilisation de l’app",
    "privacy.visits": "Pour savoir combien de personnes visitent le site, nous utilisons Plausible, un outil de mesure d’audience respectueux de la vie privée, hébergé dans l’UE. Il n’utilise aucun cookie et ne conserve aucune donnée personnelle, seulement des totaux comme les visites, les pays, les navigateurs et le site d’où tu viens. Ton adresse IP n’est pas enregistrée.",
    "privacy.visitsTitle": "Mesure d’audience",
    "punct.comma": ", ",
    "punct.join": "{first} {next}",
    "punct.period": ".",
    "reminder.body": "L’expédition #{n} attend dans la brume.",
    "sealed.body": "Un nouveau jour a commencé pendant ton expédition. Ton résultat, {distance}, est enregistré. Tu peux continuer à explorer pour t’entraîner.",
    "sealed.next": "En route pour la #{n}",
    "sealed.title": "L’expédition #{n} est terminée.",
    "settings.appPromo": "L’app iOS, maintenant en bêta, apporte les rappels et les vibrations.",
    "settings.debug": "Afficher le temps par image",
    "settings.developer": "Développeur",
    "settings.feel": "Sensations",
    "settings.haptics": "Vibrations",
    "settings.hapticsLine": "Une petite vibration quand tu découvres une case ou que tu plantes une bannière.",
    "settings.language": "Langue",
    "settings.languageAuto": "Automatique",
    "settings.languageAutoLine": "Suit le réglage du système : {language}",
    "settings.languageDraft": "Brouillon",
    "settings.listAuto": "Ajouter mes expéditions",
    "settings.listAutoLine": "L’expédition de chaque jour rejoint la liste dès qu’elle se termine.",
    "settings.listName": "Nom sur la liste",
    "settings.listNote": "Ajoute ton expédition quand elle se termine pour rejoindre la liste du jour.",
    "settings.listRemove": "Retirer mes expéditions",
    "settings.motion": "Réduire les animations",
    "settings.motionLine": "La brume s’immobilise, le nouveau terrain apparaît d’un coup et les bords du monde restent nets. Suit le réglage du système tant que tu ne le changes pas ici.",
    "settings.music": "Musique",
    "settings.musicLine": "Un air paisible venu de la forêt pendant que tu explores.",
    "settings.remind": "Rappel quotidien",
    "settings.remindDay": "Jour",
    "settings.remindDenied": "Les notifications sont désactivées pour Mistsweeper. Touche ici pour les autoriser dans Réglages.",
    "settings.remindEarlier": "{n} minutes plus tôt",
    "settings.remindEvening": "Soir",
    "settings.remindLater": "{n} minutes plus tard",
    "settings.remindLine": "À {time}, si l’expédition du jour attend encore.",
    "settings.remindNext": "Nouvelle expédition à {time}",
    "settings.remindNight": "Nuit",
    "settings.remindTime": "Heure du rappel",
    "settings.reminders": "Rappels",
    "settings.sounds": "Sons",
    "settings.soundsLine": "Un son pour chaque case découverte, chaque bannière et chaque créature.",
    "settings.theme": "Thème",
    "settings.themeAuto": "Automatique",
    "settings.themeAutoLine": "Suit le réglage du système : Jour en mode clair, Nuit en mode sombre.",
    "settings.themeSupporter": "Choisi dans Supporter",
    "settings.tilt": "Tilt-shift",
    "settings.title": "Réglages",
    "settings.zoom": "Zoom",
    "start.continue": "Reprendre, {distance}",
    "start.endlessLine": "Un nouveau monde à chaque fois, aussi souvent que tu veux.",
    "start.setOut": "En route",
    "start.tagDistance": "#{n}, {distance}",
    "start.tagDone": "#{n}, terminée, {distance}",
    "start.tagNew": "#{n}, nouvelle",
    "start.tagNewDate": "#{n}, {dateShort}, nouvelle",
    "start.tagProgress": "#{n}, en cours, {distance}",
    "start.todayDone": "Fini pour aujourd’hui. Prochaine expédition dans {time}.",
    "start.todayDoneShort": "Prochaine expédition dans {time}.",
    "start.todayInProgress": "En cours. Reprends où tu en étais.",
    "start.todayInProgressShort": "Reprends où tu en étais.",
    "start.todayNew": "{dateLong}. Une seule tentative, le même terrain pour tout le monde.",
    "start.todayNewShort": "Une seule tentative, le même terrain pour tout le monde.",
    "support.devices": "Avec iCloud, l’app emmène tes expéditions et tes clairières sur tes autres appareils. Dans un navigateur, elles restent dans ce navigateur.",
    "support.devicesTitle": "Un nouvel appareil",
    "support.intro": "Mistsweeper est fait par un petit studio à Stockholm. Si quelque chose ne marche pas, ou si tu as une question, écris-nous.",
    "support.list": "« {remove} », dans {settings}, retire tes expéditions de toutes les listes. Pour signaler un nom, maintiens sa ligne appuyée, ou fais un clic droit dessus sur un ordinateur.",
    "support.listTitle": "Ton nom sur {list}",
    "support.purchase": "Ton achat suit ton compte Apple. Ouvre {supporter} dans le menu de l’app et choisis {restore}.",
    "support.purchaseTitle": "Un achat a disparu",
    "support.title": "Assistance",
    "supporter.accent": "Couleur d’accentuation",
    "supporter.accentLine": "La couleur de tes bannières.",
    "supporter.accentNumber": "Couleur {n}",
    "supporter.banner": "Bannière",
    "supporter.banners": "Bannières",
    "supporter.bannersLine": "Plante une autre bannière à chaque expédition.",
    "supporter.buy": "Devenir supporter, {price}",
    "supporter.buyLine": "Un seul achat, sans abonnement. Avec le Partage familial, ta famille en profite aussi.",
    "supporter.buyNoPrice": "Devenir supporter",
    "supporter.cabin": "Ta cabane",
    "supporter.cabinLine": "Mets une maison que tu as trouvée à la place de la cabane, à chaque expédition et dans chaque clairière.",
    "supporter.chooseCabin": "Choisir dans la clairière",
    "supporter.clearingLocked": "Seul un supporter peut modifier cette clairière.",
    "supporter.clearings": "Clairières",
    "supporter.clearingsLine": "Une clairière plus grande, de 15 cases sur 15, et autant de clairières que tu veux.",
    "supporter.failed": "L’achat n’a pas abouti. Réessaie dans un instant.",
    "supporter.free": "Tout ce à quoi tu joues est gratuit, et le restera.",
    "supporter.icon": "Icône d’app",
    "supporter.icons": "Icônes d’app",
    "supporter.iconsLine": "Choisis l’icône de ton écran d’accueil. Chacune a une apparence claire et une sombre.",
    "supporter.lead": "En tant que supporter, tu choisis l’apparence du jeu sur ton écran, et tu nous aides à continuer de faire Mistsweeper.",
    "supporter.line": "Thèmes, icônes d’app, bannières, ta cabane",
    "supporter.nothingToRestore": "Aucun achat de Supporter n’a été trouvé pour ce compte Apple.",
    "supporter.pending": "En attente d’approbation. Supporter arrive dès que l’achat est approuvé.",
    "supporter.restore": "Restaurer l’achat",
    "supporter.since": "Supporter depuis {date}",
    "supporter.thanks": "Merci de soutenir Mistsweeper. Ici, tu choisis l’apparence du jeu sur ton écran.",
    "supporter.theme": "Thème",
    "supporter.themeLine": "Jour, Nuit et Automatique sont dans Réglages.",
    "supporter.themes": "Thèmes",
    "supporter.themesLine": "Joue à tout le jeu dans d’autres couleurs. Dans certains, tu choisis aussi la couleur de tes bannières.",
    "supporter.unreachable": "Impossible de joindre l’App Store. Réessaie dans un instant.",
    "theme.day": "Jour",
    "theme.fjord": "Fjord",
    "theme.mossa": "Mousse",
    "theme.night": "Nuit",
    "theme.pergament": "Parchemin",
    "theme.rosa": "Rose",
    "theme.skymning": "Crépuscule",
    "time.hoursMinutes": "{h} h {m} min",
    "time.minutes": "{m} min",
    "webgl.missing": "Mistsweeper a besoin de WebGL 2, que ce navigateur ne prend pas en charge.",
    "welcome.mistDaily": "Chaque jour apporte une nouvelle expédition, le même terrain pour tout le monde et une seule tentative. Le mode Sans fin est là pour les heures calmes.",
    "welcome.mistNumbers": "Un chiffre indique le nombre de créatures cachées dans les huit cases qui l’entourent. Plante une bannière là où tu penses qu’une créature dort, et poursuis ta route.",
    "welcome.mistText": "Tu pars d’une cabane dans une clairière, et tout le reste n’est que brume. Découvre une case à la fois, depuis le terrain que tu as exploré.",
    "welcome.mistTitle": "Dans la brume",
    "welcome.next": "Suivant",
    "welcome.remindNo": "Pas maintenant",
    "welcome.remindText": "Une nouvelle expédition arrive chaque jour. Choisis une heure, et nous te préviendrons si celle du jour attend encore. Tu peux la changer dans Réglages.",
    "welcome.remindTitle": "Un rappel quotidien",
    "welcome.remindYes": "Me le rappeler",
    "welcome.skip": "Passer",
    "welcome.starsLater": "Un peu plus tard, nous te demanderons ce que tu en penses. Prendre un instant pour y répondre nous aidera beaucoup.",
    "welcome.starsText": "Mistsweeper est créé par Great Scott!, un petit studio de Stockholm. Pour un petit jeu, les notes sur l’App Store sont le meilleur moyen de se faire connaître.",
    "welcome.starsTitle": "Créé par un petit studio",
    "welcome.step": "Étape {n} sur {total}",
    "widget.bestDay": "Meilleur jour {distance}",
    "widget.clearingDescription": "Ta clairière, avec tes trouvailles et tes meilleures distances.",
    "widget.clearingName": "Ta clairière",
    "widget.description": "L’expédition du jour telle que tu l’as laissée, et ta série.",
    "widget.next": "Prochaine dans {time}",
    "widget.streak": "Série de {days}",
    "widget.waiting": "En attente",
  },
  ja: {
    "a11y.bannerMode": "旗モード",
    "a11y.board.banner": "旗",
    "a11y.board.bannerRemoved": "旗を外した。",
    "a11y.board.banners1": "旗1本",
    "a11y.board.bannersN": "旗{n}本",
    "a11y.board.cabin": "小屋",
    "a11y.board.cellBanner": "旗",
    "a11y.board.cellCabin": "小屋",
    "a11y.board.cellExplored": "探検済み",
    "a11y.board.cellMist": "霧",
    "a11y.board.cellWrongBanner": "まちがった旗",
    "a11y.board.chordWaits": "まわりの旗の数が、数字と合っていない。",
    "a11y.board.chosen": "選択中：{name}。",
    "a11y.board.confirmed": "確認済み",
    "a11y.board.creature": "妖精",
    "a11y.board.deepMist": "深い霧",
    "a11y.board.describe": "まわりを読み上げる",
    "a11y.board.dirEast": "東",
    "a11y.board.dirNorth": "北",
    "a11y.board.dirSouth": "南",
    "a11y.board.dirWest": "西",
    "a11y.board.east": "東へ{n}マス",
    "a11y.board.explore": "まわりの霧を晴らす",
    "a11y.board.explored": "探検済み",
    "a11y.board.exploredOn": "探検済み、{what}",
    "a11y.board.frontier0": "晴らせる霧はない",
    "a11y.board.frontier1": "晴らせる霧が1マス",
    "a11y.board.frontierN": "晴らせる霧が{n}マス",
    "a11y.board.furthest": "最遠地点 {distance}。",
    "a11y.board.hid": "ここにひそんでいた",
    "a11y.board.hintExplore": "まわりのマスの霧を晴らします。",
    "a11y.board.hintPlant": "旗を立てます。",
    "a11y.board.hintReveal": "マスの霧を晴らします。",
    "a11y.board.hintTakeAway": "旗を外します。",
    "a11y.board.inMist": "霧{n}マス",
    "a11y.board.inView": "画面内に{what}",
    "a11y.board.listAnd": "{list}と{last}",
    "a11y.board.mist": "霧",
    "a11y.board.nextTo": "となりの数字は{numbers}",
    "a11y.board.north": "北へ{n}マス",
    "a11y.board.place": "小屋から{where}、{distance}",
    "a11y.board.plant": "旗を立てる",
    "a11y.board.revealed1": "1マスの霧が晴れた。",
    "a11y.board.revealedN": "{n}マスの霧が晴れた。",
    "a11y.board.rotorBanners": "旗",
    "a11y.board.rotorMist": "晴らせる霧",
    "a11y.board.rotorNorthSouth": "北と南",
    "a11y.board.rotorNumbers": "霧の残る数字",
    "a11y.board.roundIt": "まわりに{what}",
    "a11y.board.rowHere": "ここ：{tiles}。",
    "a11y.board.rowNorth": "北：{tiles}。",
    "a11y.board.rowSouth": "南：{tiles}。",
    "a11y.board.south": "南へ{n}マス",
    "a11y.board.takeAway": "旗を外す",
    "a11y.board.turned": "向きを変えた。",
    "a11y.board.west": "西へ{n}マス",
    "a11y.board.woke": "ここで目を覚まし、探検を終わらせた",
    "a11y.board.wrongBanner": "まちがった旗",
    "a11y.distance": "最遠距離",
    "a11y.find": "新発見：{name}。",
    "a11y.findMore": "新発見：{name}ほか{n}種。",
    "a11y.map": "探検の地図",
    "about.body1": "小屋の先から霧がはじまる。霧の中には古きものたちが住んでいる。苔の下のトロール、木々のあいだのフルドラ、静かな水辺のネッケン。",
    "about.body2": "Mistsweeperは、足を踏み出す前に地面を読むゲーム。数字は、近くで眠る妖精の数を教えてくれる。どこまで行けるかは、あなた次第。",
    "about.body3": "Mistsweeperは、北欧の神話と民話に着想を得た、定番パズル「マインスイーパー」の新しいかたち。",
    "about.made": "スウェーデンのストックホルムで、Great Scott!が制作。",
    "about.version": "バージョン {version}",
    "accessibility.contact": "遊ぶうえで困っていることや、もっと遊びやすくなる工夫があれば、以下までお知らせください。",
    "accessibility.contactTitle": "お知らせください",
    "accessibility.contrast": "世界もメニューも紙にインクで描かれていて、昼も夜も、文字に必要な基準を大きく上回るコントラストがあります。大事なものには赤を使いますが、赤だけには頼りません。旗には旗の形があり、探検のあとのまちがった旗には×印が、探検が終わったマスには枠がつきます。",
    "accessibility.contrastTitle": "コントラストと色",
    "accessibility.dark": "ゲームはシステムのダークモードに従います。夜は、月明かりに照らされた世界です。設定の「テーマ」で、昼か夜を選ぶこともできます。",
    "accessibility.darkTitle": "ダークとライト",
    "accessibility.intro": "Mistsweeperは、できるだけ多くの人が遊べるゲームを目指しています。ウェブ版とiOSアプリで現在対応していることと、いま取り組んでいることをまとめました。",
    "accessibility.keys": "ウェブ版では、ゲームのすべてをキーボードで操作できます。矢印キーかWASDでカーソルを動かし、Enterキーかスペースキーでマスの霧を晴らし、Fで旗を立てたり外したりします。QとEでカメラを回し、TとGで傾け、プラスとマイナスでズームし、Hで小屋に戻り、Escキーで開いているものを閉じます。",
    "accessibility.keysTitle": "ウェブ版のキーボード操作",
    "accessibility.motion": "システムの「視差効果を減らす」か、ゲームの設定にある同じ名前のスイッチをオンにすると、ひとりでに動くものはなくなります。霧も風も動物もカメラも止まり、新しい土地はすぐに現れ、世界のふちはぼやけません。",
    "accessibility.motionTitle": "視差効果を減らす",
    "accessibility.sound": "音や音楽でしか伝わらない情報はありません。音声や動画もありません。iOSアプリでは、霧を晴らすときと旗を立てるときに触覚フィードバックがあります。音楽、効果音、触覚は、設定でそれぞれオフにできます。",
    "accessibility.soundTitle": "サウンド",
    "accessibility.title": "アクセシビリティ",
    "accessibility.updated": "2026年10月25日更新",
    "accessibility.work": "iOSアプリでは、VoiceOverと音声コントロールで地図を読み、遊ぶことができます。文字も設定した文字サイズに合わせて表示されます。ウェブ版のメニューやボタンにはスクリーンリーダー用のラベルがありますが、地図はまだスクリーンリーダーで読んだり遊んだりできません。現在、取り組んでいます。",
    "accessibility.workTitle": "取り組んでいること",
    "app.tagline": "終わりなき探検",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "広告もトラッキングもない、ドット絵のぬりえ。",
    "apps.intro": "同じスタジオの、小さなゲームとアプリ。",
    "apps.krono": "歴史、ポップカルチャー、音楽の出来事を、年表の上で正しい順に並べるゲーム。",
    "apps.ordna": "静かな並べ替えパズル。全1000問、途中で邪魔が入ることもありません。",
    "apps.tapotron": "やる気満々のボタンが並ぶグリッドで、タップゲームとビートづくり。",
    "archive.appNoteCloud": "iCloudに保存されています。お使いのすべての端末で見られます。",
    "archive.appNoteDevice": "この端末に保存されています。MistsweeperのiCloudをオンにすると、すべての端末で見られます。",
    "archive.best": "自己ベスト",
    "archive.daily": "毎日の探検",
    "archive.dayStreak": "連続日数",
    "archive.endlessBest": "ベスト",
    "archive.endlessLast": "前回",
    "archive.endlessRuns": "回数",
    "archive.expeditions": "探検数",
    "archive.gameCenter": "Game Centerで友だちと比べる",
    "archive.notPlayed": "未挑戦",
    "archive.sealed": "未完のまま確定",
    "archive.today": "今日、探検中",
    "archive.todayWord": "今日",
    "archive.webNote": "このブラウザに保存されています。iOSアプリの探検の記録は、iCloudに別に保存されます。",
    "archive.webNoteShort": "このブラウザに保存されています。",
    "banner.1": "三つ尾",
    "banner.a1": "燕尾",
    "banner.a3": "槍先",
    "banner.b1": "扇形",
    "banner.b2": "大鴉の旗",
    "banner.b3": "半円",
    "banner.c2": "T字旗",
    "banner.c3": "道しるべ",
    "banner.c4": "ねじれ",
    "beta.bugs": "動かないところや、おかしな表示はありませんか？何をしたか、何が起きたか、どの端末かを教えてください。スクリーンショットがあると助かります。",
    "beta.bugsTitle": "バグ",
    "beta.changes": "ベータ版の間、ゲームは変わっていきます。公開時も探検は#1に戻らず、そのまま続きます。",
    "beta.changesTitle": "変わること",
    "beta.intro": "Mistsweeperは遊べますが、まだ完成していません。公開に向けて、遊んでくださる皆さんの力を貸してください。",
    "beta.language": "ゲームは9つの言語に対応していますが、ほとんどの翻訳は、その言語を母語とする人にまだ読んでもらっていません。間違いや不自然な表現があれば、どこで見たかと、どう書くのが自然かを教えてください。",
    "beta.languageTitle": "文章と言葉",
    "beta.more": "詳しく",
    "beta.ticker1": "Mistsweeperはベータ版です",
    "beta.ticker2": "バグを見つけてください",
    "beta.ticker3": "言葉の間違いを教えてください",
    "beta.title": "ベータ版について",
    "button.banner": "旗",
    "button.cancel": "キャンセル",
    "button.close": "閉じる",
    "button.daily": "今日の探検",
    "button.endless": "エンドレス",
    "button.home": "小屋に戻る",
    "button.practice": "練習する",
    "button.settings": "設定",
    "button.zoomIn": "ズームイン",
    "button.zoomOut": "ズームアウト",
    "clearing.arrange": "並べる",
    "clearing.cabin": "小屋は動かせない。",
    "clearing.cabinChosen": "あなたの小屋：{name}。",
    "clearing.cabinHint": "小屋は、見つけた家ならどれにでも変えられます。小屋を長押しして選びましょう。",
    "clearing.cat.creatures": "妖精",
    "clearing.cat.ground": "地面",
    "clearing.cat.houses": "建物",
    "clearing.cat.plants": "植物",
    "clearing.cat.stones": "石",
    "clearing.changeCabin": "小屋を変える",
    "clearing.chooseCabin": "小屋を選ぶ",
    "clearing.clear": "片づける",
    "clearing.delete": "削除",
    "clearing.deleteBody": "そこに並べたものも一緒に消えます。見つけたものは残ります。",
    "clearing.deleteTitle": "{name}を削除しますか？",
    "clearing.deleted": "{name}を削除した。",
    "clearing.discovered": "全{total}種のうち{n}種を発見",
    "clearing.done": "完了",
    "clearing.edit": "編集",
    "clearing.editing": "編集中：{name}",
    "clearing.family.barley": "大麦",
    "clearing.family.barn": "納屋",
    "clearing.family.beacon": "のろし台",
    "clearing.family.beehive": "ミツバチの巣箱",
    "clearing.family.bergstroll": "山のトロール",
    "clearing.family.birch": "シラカバ",
    "clearing.family.boat": "小舟",
    "clearing.family.boathouse": "舟小屋",
    "clearing.family.boulder": "迷子石",
    "clearing.family.bush": "茂み",
    "clearing.family.cairn": "ケルン",
    "clearing.family.campfire": "たき火",
    "clearing.family.cart": "荷車",
    "clearing.family.cave": "洞窟",
    "clearing.family.church": "スターヴ教会",
    "clearing.family.cottage": "農家",
    "clearing.family.driftwood": "流木",
    "clearing.family.fabod": "夏の牧場",
    "clearing.family.faering": "帆つきの小舟",
    "clearing.family.fence": "木の柵",
    "clearing.family.fern": "シダ",
    "clearing.family.fishhut": "漁師小屋",
    "clearing.family.flottning": "いかだ流し",
    "clearing.family.fornborg": "丘の砦",
    "clearing.family.goahti": "芝土の小屋",
    "clearing.family.gravhog": "古墳",
    "clearing.family.harbre": "高床の倉",
    "clearing.family.hassja": "干し草掛け",
    "clearing.family.hides": "毛皮と干し肉",
    "clearing.family.hjell": "魚の干し場",
    "clearing.family.house": "小屋",
    "clearing.family.huldra": "フルドラ",
    "clearing.family.huntingtower": "狩りのやぐら",
    "clearing.family.jatte": "巨人",
    "clearing.family.jetty": "桟橋",
    "clearing.family.juniper": "ジュニパー",
    "clearing.family.kastal": "石の塔",
    "clearing.family.kolmila": "炭焼き窯",
    "clearing.family.kummel": "海のケルン",
    "clearing.family.laundry": "洗濯物",
    "clearing.family.lavvu": "サーミのテント",
    "clearing.family.lilypads": "スイレン",
    "clearing.family.log": "倒木",
    "clearing.family.longhouse": "ロングハウス",
    "clearing.family.massif": "連峰",
    "clearing.family.mushroom": "キノコ",
    "clearing.family.nacken": "ネッケン",
    "clearing.family.njalla": "一本柱の倉",
    "clearing.family.oak": "ナラ",
    "clearing.family.oats": "オーツ麦",
    "clearing.family.outcrop": "岩場",
    "clearing.family.peak": "峰",
    "clearing.family.pebbles": "小石",
    "clearing.family.pine": "マツ",
    "clearing.family.reeds": "アシ",
    "clearing.family.rengarde": "トナカイの囲い",
    "clearing.family.rock": "岩",
    "clearing.family.rockcarving": "岩絵",
    "clearing.family.rootcellar": "土の貯蔵庫",
    "clearing.family.rowan": "ナナカマド",
    "clearing.family.ruin": "廃墟",
    "clearing.family.runestone": "ルーン石碑",
    "clearing.family.rye": "ライ麦",
    "clearing.family.sauna": "サウナ",
    "clearing.family.seamark": "海の目印",
    "clearing.family.shed": "物置小屋",
    "clearing.family.shipsetting": "舟形列石",
    "clearing.family.shorestones": "岸辺の石",
    "clearing.family.sjotroll": "湖のトロール",
    "clearing.family.skogstroll": "森のトロール",
    "clearing.family.smithy": "鍛冶場",
    "clearing.family.snag": "枯れ木",
    "clearing.family.spruce": "トウヒ",
    "clearing.family.stonecircle": "ストーンサークル",
    "clearing.family.stones": "立石",
    "clearing.family.stooks": "収穫後の畑",
    "clearing.family.stormannagard": "族長の館",
    "clearing.family.stump": "切り株",
    "clearing.family.tent": "テント",
    "clearing.family.tjardal": "タール窯",
    "clearing.family.tuft": "草",
    "clearing.family.watermill": "水車小屋",
    "clearing.family.well": "井戸",
    "clearing.family.wellsweep": "はねつるべ",
    "clearing.family.windmill": "風車小屋",
    "clearing.family.windthrow": "根返りの木",
    "clearing.family.woodpile": "薪の山",
    "clearing.fold": "しまう",
    "clearing.ground.forest": "森",
    "clearing.ground.meadow": "草地",
    "clearing.ground.mountain": "山",
    "clearing.ground.water": "水",
    "clearing.grown": "霧が引いていく。",
    "clearing.hint": "下から選んで、マスをタップします。もう一度タップすると向きが変わります。マスを長押しすると、置いたものを変更できます。",
    "clearing.hintVoiceOver": "下から選んで、マスをダブルタップします。マスのアクションから「編集」「回す」「片づける」を選べます。",
    "clearing.large": "広い",
    "clearing.locked": "まだ見つけていない。霧の向こうで待っている。",
    "clearing.lockedName": "{name}、未発見",
    "clearing.made": "新しい空き地：{name}。",
    "clearing.mist": "そこは霧の中。",
    "clearing.needsLand": "陸の上にしか置けない。",
    "clearing.needsWater": "水の上にしか置けない。",
    "clearing.new": "新しい空き地",
    "clearing.photo": "写真",
    "clearing.photo.back": "戻る",
    "clearing.photo.failed": "この環境では写真を撮れなかった。",
    "clearing.photo.file": "clearing",
    "clearing.photo.formats": "写真の縦横比",
    "clearing.photo.notSaved": "写真を保存できませんでした。「設定」アプリで、Mistsweeperに写真の追加を許可できます。",
    "clearing.photo.picture": "撮った写真",
    "clearing.photo.save": "保存",
    "clearing.photo.saved": "「写真」に保存した。",
    "clearing.photo.share": "シェア",
    "clearing.photo.shutter": "撮影する",
    "clearing.photo.usage": "保存を選んだときに、Mistsweeperが空き地の写真を写真ライブラリに追加します。",
    "clearing.rename": "名前を変更",
    "clearing.renameSave": "保存",
    "clearing.renameTitle": "空き地に名前をつける",
    "clearing.size": "空き地の広さ",
    "clearing.small": "狭い",
    "clearing.supporter": "サポーター",
    "clearing.turn": "回す",
    "clearing.undo": "元に戻す",
    "clearing.yours": "空き地の一覧",
    "controls.banner": "旗を立てる",
    "controls.click": "クリック",
    "controls.drag": "ドラッグ",
    "controls.pan": "視点を動かす",
    "controls.pinch": "ピンチ",
    "controls.qe": "QとE",
    "controls.reveal": "霧を晴らす",
    "controls.rightClick": "右クリック",
    "controls.rightDrag": "右ドラッグ",
    "controls.scroll": "スクロール",
    "controls.tg": "TとG",
    "controls.tilt": "傾ける",
    "controls.title": "操作",
    "controls.turn": "回す",
    "controls.turnTilt": "回して傾ける",
    "controls.twist": "2本指でひねる",
    "controls.twoFingers": "2本指を上下に",
    "controls.voActions": "上下にスワイプ",
    "controls.voFind": "晴らせる霧、霧の残る数字、旗、北と南",
    "controls.voMagicTap": "2本指でダブルタップ",
    "controls.voMove": "地図を4マス動かす",
    "controls.voRotor": "ローターを回す",
    "controls.voScroll": "3本指でスワイプ",
    "controls.voSummary": "今いる場所と、ここまでの距離",
    "controls.voSwipe": "左右にスワイプ",
    "controls.voTileActions": "マスのアクション：旗、まわりの霧を晴らす、まわりを読み上げる",
    "controls.voTiles": "画面内のマスを、北から1行ずつ",
    "controls.zoom": "ズームする",
    "daily.next": "次の探検まであと{time}",
    "feedback.subject": "Mistsweeperへのフィードバック（バージョン {version}）",
    "find.new": "新発見",
    "getApp.beta": "アプリは現在ベータ版です。公開前のアプリを試せるAppleのアプリ、TestFlightを使ってインストールします。",
    "getApp.haptics": "指先に伝わる触覚フィードバック。",
    "getApp.intro": "毎日の探検はそのままに、アプリならではの機能が加わります。",
    "getApp.join": "TestFlightでベータ版に参加",
    "getApp.note": "このブラウザの探検の記録は、ここに残ります。アプリの記録は別になります。",
    "getApp.offline": "オフラインでも遊べます。",
    "getApp.qr": "iPhoneのカメラをここに向けると、ベータ版に参加できます。",
    "getApp.qrLabel": "TestFlightのベータ版のQRコード",
    "getApp.reminder": "好きな時刻に届く、毎日のリマインダー。",
    "getApp.widget": "今日の探検と連続記録がわかるウィジェット。",
    "hint.clearingDesktop": "空き地に並べるものを選んで、マスをクリックします。マスを右クリックすると変更できます。",
    "hint.photoDesktop": "空き地を枠の中に収めて、撮影します。",
    "hint.reveal": "探検した場所のとなりをタップして、霧を晴らしましょう。",
    "hint.revealDesktop": "探検した場所のとなりをクリックして、霧を晴らします。右クリックで旗を立てます。",
    "hint.revealVoiceOver": "探検した場所のとなりの霧を、スワイプかローターで探して、ダブルタップで晴らしましょう。",
    "howto.1": "はじまりは小屋。ほかはすべて霧です。",
    "howto.2": "探検した場所にとなり合うマスの霧を晴らします。歩いてきたところから、1マスずつ進みます。",
    "howto.3": "数字は、まわりの8マスにひそむ妖精の数です。",
    "howto.3example": "この例では、霧が残る3マスのうち2マスに妖精がひそんでいます。",
    "howto.4mouse": "妖精がひそんでいると思うマスには、旗を立てましょう。そのマスを右クリックします。",
    "howto.4touch": "妖精がひそんでいると思うマスには、旗を立てましょう。旗モードをオンにして、そのマスをタップします。",
    "howto.4voiceOver": "妖精がひそんでいると思うマスには、旗を立てましょう。そのマスで上下にスワイプして、アクションから「旗を立てる」を選びます。",
    "howto.5": "妖精を起こすと、探検はそこで終わります。記録は、小屋からいちばん遠くまで行った地点の距離です。",
    "howto.6": "毎日、新しい探検がひとつ。だれもが同じ土地を歩き、挑戦は1回だけです。静かなひとときには、エンドレスをどうぞ。",
    "howto.tryLesson": "世界で試す",
    "hud.best": "ベスト {distance}",
    "hud.clearing": "空き地",
    "hud.menu": "メニュー",
    "hud.north": "北を上にする",
    "hud.practice": "練習、#{n}",
    "hud.today": "今日",
    "hud.turnLeft": "左に回す、Q",
    "hud.turnLeftKey": "Q",
    "hud.turnRight": "右に回す、E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "大麦だ。",
    "inspect.barley.2": "じきにパン、あるいはもっといいもの。",
    "inspect.barn.1": "納屋だ。",
    "inspect.barn.2": "干し草と猫でいっぱい。",
    "inspect.barn.3": "屋根まで干し草。春までもつ。",
    "inspect.beacon.1": "のろし台。敵が見えたら火をつける。",
    "inspect.beacon.2": "ひとつの火が次の火へ。やがて国じゅうが知る。",
    "inspect.beacon.3": "乾いて準備よし。火をつけた者はまだいない。",
    "inspect.beehive.1": "ミツバチの巣箱。たたかないほうがいい。",
    "inspect.beehive.2": "われわれは忙しい。",
    "inspect.birch.1": "シラカバだ。",
    "inspect.birch.2": "白い樹皮に黒い線。だれかが数えていたらしい。",
    "inspect.birch.3": "シラカバの皮は、ぬれていても燃える。覚えておこう。",
    "inspect.birch.4": "シラカバは、まっ先に芽吹き、まっ先に黄色くなる。",
    "inspect.boat.1": "小舟。だれかが返してほしがるだろう。",
    "inspect.boat.2": "オールは中に。だれも乗っていない。",
    "inspect.boathouse.1": "タールと、ぬれた縄のにおいがする。",
    "inspect.boathouse.2": "舟は出ている。いつ戻るかは、だれも言っていない。",
    "inspect.boulder.1": "迷子石。氷とともに、一度だけ動いた。",
    "inspect.boulder.2": "氷とともに来た。わしは残る。",
    "inspect.boulder.3": "氷はこれを置いて、帰っていった。",
    "inspect.bush.1": "茂みだ。",
    "inspect.bush.2": "茂みには何もひそんでいない。たぶん。",
    "inspect.bush.3": "何かが音を立てた。ただの茂みだった。",
    "inspect.cabin": "いつもの小屋。ストーブはまだ温かい。",
    "inspect.cairn.1": "ケルンだ。",
    "inspect.cairn.2": "通る者はみな、石をひとつ積んでいく。",
    "inspect.cairn.3": "だれかが道を示した。あるいは墓を。",
    "inspect.campfire.1": "たき火だ。",
    "inspect.campfire.2": "火はある。だれもいない。",
    "inspect.campfire.3": "だれかが急いで立ち去った。",
    "inspect.cart.1": "荷車だ。",
    "inspect.cart.2": "馬が止まったところに置かれたまま。",
    "inspect.cave.1": "洞窟だ。奥がある。",
    "inspect.cave.2": "おはいり。",
    "inspect.cave.3": "奥で何かが息をしている。風かもしれない。",
    "inspect.church.1": "スターヴ教会。何百年分ものタール。",
    "inspect.church.2": "石はひとつも使っていない。木と忍耐だけ。",
    "inspect.church.3": "中は静かだ。ずっとそうだった。",
    "inspect.creature.bergstroll": "ここに山のトロールが住んでいた。",
    "inspect.creature.huldra": "ここにフルドラが住んでいた。",
    "inspect.creature.jatte": "ここに巨人が住んでいた。",
    "inspect.creature.nacken": "ここにネッケンが住んでいた。",
    "inspect.creature.sjotroll": "ここに湖のトロールが住んでいた。",
    "inspect.creature.skogstroll": "ここに森のトロールが住んでいた。",
    "inspect.deer.1": "ノロジカ。もう気づかれている。",
    "inspect.deer.2": "顔を上げて、また草を食べはじめた。",
    "inspect.driftwood.1": "流木。どこから来たか、だれも知らない。",
    "inspect.driftwood.2": "ここのだれよりも、海を見てきた。",
    "inspect.duck.1": "マガモ。我関せず。",
    "inspect.duck.2": "これには、ひとことあるらしい。",
    "inspect.elk.1": "ヘラジカ。気にもしていない。",
    "inspect.elk.2": "森でいちばん大きく、いちばん静か。",
    "inspect.faering.1": "帆つきの小舟。オール4本に、帆が1枚。",
    "inspect.faering.2": "作りはヴァイキング船と同じ。",
    "inspect.fence.1": "木の柵。釘は一本も使っていない。",
    "inspect.fence.2": "中にいるはずのものは、どこかへ行った。",
    "inspect.fern.1": "シダだ。",
    "inspect.fern.2": "シダは、木よりも先にここにいた。",
    "inspect.fern.3": "シダは夏至の夜に花咲くという。見た者はいない。",
    "inspect.fishhut.1": "網と、浮きと、古いニシン。",
    "inspect.fishhut.2": "漁師小屋。においが先にやって来る。",
    "inspect.flottning.1": "海岸へ向かう途中の丸太。",
    "inspect.flottning.2": "いかだ流し。運ぶのは川の仕事。",
    "inspect.fornborg.1": "丘の砦。のろしが上がると、人々はここへ走った。",
    "inspect.fornborg.2": "壁は崩れた。止められた者も、もういない。",
    "inspect.fornborg.3": "だれが積んだ石か、だれも知らない。",
    "inspect.goahti.1": "芝土の小屋。外は土と草、中は暖かい。",
    "inspect.goahti.2": "煙はてっぺんから出ていく。昔からそうだ。",
    "inspect.gravhog.1": "古墳。だれか偉い人の墓だ。",
    "inspect.gravhog.2": "ここにだれかが眠る。静かに歩こう。",
    "inspect.gravhog.3": "墓。上には、草が千年分。",
    "inspect.harbre.1": "高床の倉。柱の上なら、ネズミも届かない。",
    "inspect.harbre.2": "中には去年の穀物。",
    "inspect.hassja.1": "干し草掛け。草は風で乾く。",
    "inspect.hassja.2": "横木に干し草。今、雨だけは困る。",
    "inspect.hides.1": "枠に張ったトナカイの毛皮。何ひとつ無駄にしない。",
    "inspect.hides.2": "肉が風で乾いていく。冬の食料だ。",
    "inspect.hjell.1": "干しダラ。料理は風の仕事。",
    "inspect.hjell.2": "ここまでにおう。",
    "inspect.home": "ここに住むのは{name}。",
    "inspect.huntingtower.1": "あの上で、だれかが座って待っている。",
    "inspect.huntingtower.2": "ヘラジカはとうに知っている。",
    "inspect.jetty.1": "桟橋だ。",
    "inspect.jetty.2": "少し沖へ出て、あきらめている。",
    "inspect.jetty.3": "はだしにちょうどいい場所。",
    "inspect.juniper.1": "ジュニパーだ。",
    "inspect.juniper.2": "ジュニパー。刺し返された。",
    "inspect.juniper.3": "ジュニパー。遠目には、じっと立つ人のように見える。",
    "inspect.kastal.1": "厚い壁に、小さな窓。",
    "inspect.kastal.2": "だれかが来客を待っていた。ありがたくない客を。",
    "inspect.kolmila.1": "炭焼き窯だ。",
    "inspect.kolmila.2": "何週間もくすぶり続ける。だれかが起きていなくては。",
    "inspect.kolmila.3": "木が入る。炭が出る。",
    "inspect.kummel.1": "海のケルン。船乗りに現在地を教える。",
    "inspect.kummel.2": "海から見える。それだけのためにある。",
    "inspect.laundry.1": "だれかの洗濯物。",
    "inspect.laundry.2": "夕方には乾く。霧が来なければ。",
    "inspect.laundry.3": "靴下が片方、足りない。",
    "inspect.lavvu.1": "サーミのテント。朝にはないこともある。",
    "inspect.lavvu.2": "柱と布。ほかには何もいらない。",
    "inspect.lilypads.1": "スイレン。",
    "inspect.lilypads.2": "スイレン。摘まないほうがいい。気に入っている者がいる。",
    "inspect.lilypads.3": "スイレンの長い茎が、暗い水の底へ。",
    "inspect.log.1": "倒木だ。",
    "inspect.log.2": "とうの昔に倒れた。苔が住みついている。",
    "inspect.massif.1": "連峰だ。",
    "inspect.massif.2": "山は、訪れる者に気づきもしない。",
    "inspect.massif.3": "岩のすきまには、8月でも雪が残る。",
    "inspect.mushroom.1": "キノコ。そっとしておこう。",
    "inspect.mushroom.2": "どのキノコも食べられる。ものによっては一度きり。",
    "inspect.mushroom.3": "だれかが籠に入れたがるだろう。",
    "inspect.njalla.1": "一本柱の倉。クマは見上げるしかない。",
    "inspect.njalla.2": "食料は高いところに。届くのは人だけ。",
    "inspect.oak.1": "ナラだ。",
    "inspect.oak.2": "ナラの木。いちばん古い言い伝えより、なお古い。",
    "inspect.oak.3": "このナラは、王を何人も見送ってきた。",
    "inspect.oak.4": "かつて、ナラはすべて王室のものだった。",
    "inspect.oats.1": "オーツ麦だ。",
    "inspect.oats.2": "オーツ麦。馬の分と、朝ごはんの分。",
    "inspect.outcrop.1": "むき出しの岩場。上着を脱いだ大地。",
    "inspect.outcrop.2": "日なたでは温かく、夜は冷たい。",
    "inspect.outcrop.3": "これを磨いたのは氷だ。",
    "inspect.peak.1": "峰。一年じゅう雪。",
    "inspect.peak.2": "ここまで来ると、何も生えない。",
    "inspect.peak.3": "眺めはいいらしい。霧の見解はちがう。",
    "inspect.pebbles.1": "小石。",
    "inspect.pebbles.2": "どれも、かつては山だった。",
    "inspect.pine.1": "マツだ。",
    "inspect.pine.2": "ここには、マツが先にいた。",
    "inspect.pine.3": "マツは乾いたやせ地を好む。この一本は満足そうだ。",
    "inspect.pine.4": "マツは、風に言われたほうへ傾いている。",
    "inspect.reeds.1": "アシ。",
    "inspect.reeds.2": "アシがささやく。ただの風だ。",
    "inspect.reeds.3": "中で何かが動いた。たぶん鳥だ。",
    "inspect.reindeer.1": "どのトナカイにも、持ち主がいる。",
    "inspect.reindeer.2": "移動の途中。行き先は本人が知っている。",
    "inspect.rengarde.1": "秋になると、群れがここに集まる。",
    "inspect.rengarde.2": "今は空っぽ。行き先はトナカイが知っている。",
    "inspect.rock.1": "岩だ。",
    "inspect.rock.2": "何か？　岩だ。",
    "inspect.rock.3": "岩。特に意見はないらしい。",
    "inspect.rock.4": "何も起きない。岩だ。",
    "inspect.rockcarving.1": "岩に刻まれた。ルーン文字よりずっと前に。",
    "inspect.rockcarving.2": "われら、ここにいた。",
    "inspect.rockcarving.3": "だれにも読めない。それでも何かを語っている。",
    "inspect.rootcellar.1": "暗がりにジャガイモ。",
    "inspect.rootcellar.2": "中は決して凍らない。",
    "inspect.rowan.1": "ナナカマドだ。",
    "inspect.rowan.2": "ナナカマド。実の多い年は雪も多いという。",
    "inspect.rowan.3": "トロールはナナカマドに近づかないという。",
    "inspect.ruin.1": "廃墟だ。",
    "inspect.ruin.2": "かつて、だれかの自慢だった。",
    "inspect.ruin.3": "ここにあったものは消えた。石は残った。",
    "inspect.runestone.1": "ルーン石碑だ。",
    "inspect.runestone.2": "だれかが立てさせた。わが子のために。",
    "inspect.runestone.3": "ルーン石碑。東へ向かった、とある。帰らず。",
    "inspect.runestone.4": "ルーン石碑。読める者は読め。",
    "inspect.rye.1": "ライ麦だ。",
    "inspect.rye.2": "ライ麦は立ったまま冬を越し、何も求めない。",
    "inspect.sauna.1": "サウナだ。",
    "inspect.sauna.2": "サウナ。まだ温かい。",
    "inspect.sauna.3": "戸口にシラカバの小枝。だれかが戻ってくる。",
    "inspect.seamark.1": "海の目印。船乗りはこれを頼りに進む。",
    "inspect.seamark.2": "ここ。",
    "inspect.shed.1": "物置小屋。道具と縄と、タールのにおい。",
    "inspect.shed.2": "鍵がかかっている。鍵は、どこかよそに。",
    "inspect.shipsetting.1": "石の舟。最後の旅のために。",
    "inspect.shipsetting.2": "この舟で、だれかが送り出された。",
    "inspect.shipsetting.3": "舟形列石。鉄器時代から、一度も動いていない。",
    "inspect.shorestones.1": "水切りには、平たい石がいちばん。",
    "inspect.shorestones.2": "水は長いこと、この石に取り組んできた。",
    "inspect.smithy.1": "鍛冶場だ。",
    "inspect.smithy.2": "炭と鉄のにおいがする。",
    "inspect.smithy.3": "トロールは鉄が嫌いだという。",
    "inspect.snag.1": "枯れている。それでも立っている。",
    "inspect.snag.2": "枯れ木。芯まで乾いて、たき火にちょうどいい。",
    "inspect.snag.3": "キツツキには、まだ用があるらしい。",
    "inspect.spruce.1": "トウヒだ。",
    "inspect.spruce.2": "トウヒの下は、いつも少し夕暮れ。",
    "inspect.spruce.3": "足もとに針葉。ほかには何も生えない。",
    "inspect.spruce.4": "一年じゅう暗く、急ぐ様子もない。",
    "inspect.stonecircle.1": "ストーンサークル。裁きの場だったという。",
    "inspect.stonecircle.2": "本当は墓だ。裁きの場は、ただの言い伝え。",
    "inspect.stonecircle.3": "中へどうぞ。やめてもいい。",
    "inspect.stones.1": "人の手で立てられた。理由は忘れられた。",
    "inspect.stones.2": "立石。たった今、話をやめたように見える。",
    "inspect.stones.3": "立石は、まだ待っている。",
    "inspect.stooks.1": "刈り入れは終わった。",
    "inspect.stooks.2": "麦の束が干してある。だれかが取りに戻る。",
    "inspect.stump.1": "切り株だ。",
    "inspect.stump.2": "だれかが斧を持って、ここに来た。",
    "inspect.stump.3": "年輪を数えてみよう。時間があれば。",
    "inspect.tent.1": "前の探検隊のテント。",
    "inspect.tent.2": "その探検隊は、取りに戻らなかった。",
    "inspect.tent.3": "手帳の最後のページは白紙だ。",
    "inspect.tjardal.1": "タール窯。マツが入り、タールが流れる。",
    "inspect.tjardal.2": "船はここのタールで塗られた。",
    "inspect.tuft.1": "草むら。",
    "inspect.tuft.2": "異状なし。草あり。",
    "inspect.tuft.3": "草は、しなって、また立ち上がる。",
    "inspect.tuft.4": "ただの草。",
    "inspect.watermill.1": "水車小屋だ。",
    "inspect.watermill.2": "粉をひくのは水の仕事。昼も夜も。",
    "inspect.well.1": "井戸だ。",
    "inspect.well.2": "石を落として数えてみよう。深い。",
    "inspect.well.3": "一年じゅう、冷たい水。",
    "inspect.wellsweep.1": "はねつるべ。持ち上げるのは長い棒の仕事。",
    "inspect.wellsweep.2": "桶は上がってくる。だれかが引けば。",
    "inspect.windmill.1": "風車小屋だ。",
    "inspect.windmill.2": "小屋ごと回って、風のほうを向く。",
    "inspect.windmill.3": "ここでは、風が粉をひく。",
    "inspect.windthrow.1": "根返りの木だ。",
    "inspect.windthrow.2": "風のしわざだ。根こそぎ。",
    "inspect.windthrow.3": "根返りの木。何があったかは聞くな。",
    "inspect.woodpile.1": "次の冬が、積んである。",
    "inspect.woodpile.2": "ていねいに積んである。いちばん下は抜かないこと。",
    "lang.mist": "霧",
    "lang.name": "日本語",
    "lesson.cabinText": "はじまりは小屋。探検した場所のとなりのマスをタップすると、霧が晴れます。丸で囲んだマスで試してみましょう。",
    "lesson.cabinTextMouse": "はじまりは小屋。探検した場所のとなりのマスをクリックすると、霧が晴れます。丸で囲んだマスで試してみましょう。",
    "lesson.cabinTitle": "小屋",
    "lesson.done": "完了",
    "lesson.endDistance": "小屋から{distance}の地点まで来ました。これが記録です。遠くまで行くほど、よい記録になります。",
    "lesson.endText": "まわりの妖精すべてに旗を立てると、その数字は消えます。妖精を起こすと、探検はそこで終わります。",
    "lesson.endTitle": "準備完了",
    "lesson.invite": "まずは遊び方を覚えましょう。1分ほどで終わります。友だちが待っています。",
    "lesson.noCreature": "そこに妖精は眠っていない。",
    "lesson.numberHold": "そのマスを長押しして、旗を立てましょう。",
    "lesson.numberMode": "または、旗モードをオンにして、そのマスをタップします。",
    "lesson.numberMouse": "そのマスを右クリックして、旗を立てましょう。",
    "lesson.numberText": "数字は、まわりの8マスにひそむ妖精の数です。この1のまわりで霧が残っているマスは、ひとつだけです。だから、そこに妖精が眠っています。",
    "lesson.numberTitle": "数字",
    "lesson.ownText": "見つけた2のまわりでは、まだ2マスが霧の中です。両方に旗を立てましょう。",
    "lesson.ownTitle": "今度は自分で",
    "lesson.safeText": "この1の妖精は、もう見つかっています。だから、まわりに残るもうひとつのマスは安全です。そのマスの霧を晴らしましょう。",
    "lesson.safeTitle": "安全な場所",
    "lesson.woke": "そこには妖精が眠っていました。もう一度どうぞ。",
    "list.add": "追加",
    "list.addBody": "名前と探検は、mistsweeper.comとアプリで、だれでも見られます。これからは、「設定」でオフにするまで、毎日の探検が終わるたびに自動で追加されます。",
    "list.addTitle": "名前を追加",
    "list.as": "{name}として",
    "list.countSoFar": "これまでに{count}人の探検家",
    "list.countSoFarOne": "これまでに{count}人の探検家",
    "list.empty": "今日はまだ一覧にだれもいません。最初の探検家になれるかもしれません。",
    "list.errorAlready": "この端末から追加した探検が、すでに今日の一覧にあります。",
    "list.errorBlocked": "この端末からは、探検を追加できなくなりました。",
    "list.errorBusy": "短時間に送信が多すぎます。数分待ってから、もう一度お試しください。",
    "list.errorClosed": "この探検の一覧は、受付を終了しました。",
    "list.errorName": "文字、数字、スペースを使って、2文字以上20文字以内で入力してください。",
    "list.errorOther": "一覧に接続できませんでした。もう一度お試しください。",
    "list.errorRefused": "その名前は使えません。別の名前をお試しください。",
    "list.hiddenName": "名前は非表示",
    "list.loading": "今日のトップ探検家を読み込んでいます。",
    "list.nameLabel": "名前",
    "list.notAdded": "一覧に未追加",
    "list.placeSoFar": "これまでの{count}人中{place}位",
    "list.remove": "削除",
    "list.removeBody": "この端末から追加した探検は、すべて一覧から削除されます。「探検の記録」には残ります。",
    "list.removeTitle": "探検を一覧から削除しますか？",
    "list.renameBody": "追加したすべての探検で、名前が変わります。",
    "list.renameTitle": "一覧に表示する名前",
    "list.report": "通報する",
    "list.reportBody": "複数の人が通報した名前は、私たちが確認するまで非表示になります。",
    "list.reportTitle": "この名前を通報しますか？",
    "list.tiles": "{tiles}マス",
    "list.unreachable": "いまは一覧に接続できません。少し待ってから、もう一度お試しください。",
    "list.waiting": "追加待ち",
    "list.you": "自分",
    "list.yours": "自分の探検",
    "menu.about": "Mistsweeperについて",
    "menu.apps": "Great Scott!のアプリ",
    "menu.appsLine": "Ordna、Krono、Tapotron、Color Tap",
    "menu.back": "メニューに戻る",
    "menu.close": "メニューを閉じる",
    "menu.expeditions": "探検の記録",
    "menu.expeditionsLine": "連続 {streak}、ベスト {distance}",
    "menu.feedback": "フィードバックを送る",
    "menu.getApp": "iOSアプリを入手",
    "menu.getAppLine": "リマインダーと触覚、ベータ版",
    "menu.howto": "遊び方",
    "menu.howtoLine": "ルールと操作",
    "menu.list": "トップ探検家",
    "menu.listLine": "だれがいちばん遠くまで行ったか",
    "menu.privacy": "プライバシーポリシー",
    "menu.settingsLine": "{theme}のテーマ、{language}",
    "menu.version": "バージョン {version} · Great Scott! AB",
    "mode.daily": "探検 #{n}",
    "mode.endless": "エンドレス",
    "mode.endlessBest": "エンドレス、ベスト {distance}",
    "note.banner": "旗を立てた。",
    "note.bannerOff": "旗モード：オフ。",
    "note.bannerOn": "旗モード：オン。",
    "note.cabin": "小屋に戻った。",
    "note.clearing": "ここはあなたの空き地。見つけたものを並べましょう。",
    "note.copied": "クリップボードにコピーした。",
    "note.endless": "エンドレス。毎回ちがう世界。",
    "note.listRemoved": "一覧から削除した。",
    "note.listReported": "名前を通報した。",
    "note.north": "北が上に戻った。",
    "note.today": "今日の探検。",
    "note.todayPractice": "今日の探検を、練習として。",
    "over.bergstroll": "山のトロールを起こしてしまった",
    "over.bergstrollLine": "山のトロールは石のあいだにじっと座っていて、つい石だと思ってしまう。",
    "over.copied": "コピー済み",
    "over.endlessRuns": "エンドレスの回数",
    "over.furthestLabel": "最遠地点",
    "over.huldra": "フルドラが木々のあいだで待っていた",
    "over.huldraLine": "背を向けるまでは、若い娘にしか見えない。あとを追って森に入った者は、そのまま帰らない。",
    "over.jatte": "巨人が山から身を起こした",
    "over.jatteLine": "巨人は山に眠っていて、肩だけが地面から出ている。そのひとりの上に立っていたのだ。",
    "over.jatteMeadow": "霧の中から巨人が歩み出た",
    "over.jatteMeadowLine": "巨人は、どの小屋からも遠いひらけた土地を歩く。近づく足音は、だれにも聞こえない。",
    "over.kickerDaily": "探検 #{n}、{dateShort}",
    "over.kickerEndless": "エンドレス",
    "over.kickerPractice": "探検 #{n}の練習",
    "over.kickerTogether": "エンドレス、いっしょに",
    "over.memberLine": "{tiles}、{distance}",
    "over.nacken": "ネッケンが水辺で待っていた",
    "over.nackenLine": "ネッケンは静かな水辺で調べを奏でる。足を止めて聞き入った者は、そこから先へ歩くことはない。",
    "over.newWorld": "新しい世界を探検",
    "over.practiceBoard": "今日の地図で練習",
    "over.setOutAgain": "もう一度出発",
    "over.share": "シェア",
    "over.shared": "シェア済み",
    "over.sjotroll": "湖のトロールを起こしてしまった",
    "over.sjotrollLine": "小島だと思ったものには、目があった。",
    "over.skogstroll": "森のトロールを起こしてしまった",
    "over.skogstrollLine": "森のトロールは、トウヒがいちばん深く茂るあたりの苔の下で眠っている。起こされるのをひどく嫌う。",
    "over.streak": "連続記録",
    "over.streakDay": "{days}日",
    "over.streakDays": "{days}日",
    "over.title": "霧の中で何かが動いた",
    "over.todayResult": "今日の記録",
    "over.todayWaiting": "今日の探検がまだ待っている",
    "over.togetherBest": "いっしょのベスト",
    "over.togetherMembers": "探検家",
    "over.yourBest": "自己ベスト",
    "party.away": "不在",
    "party.back": "また合流した。",
    "party.cardLine": "{status}、{tiles}、{distance}",
    "party.copied": "リンクをコピーした。",
    "party.fell": "見守り中",
    "party.follow": "ついていく",
    "party.following": "{name}についていく",
    "party.full": "その探検は満員だ。",
    "party.guest": "探検家{n}",
    "party.invite": "友だちを招待",
    "party.inviteBody": "リンクを送るかQRコードを見せると、開いた人がこの探検に加わり、小屋のそばに来る。{n}人までいっしょに。",
    "party.inviteTitle": "いっしょに探検",
    "party.join": "参加する",
    "party.joinBody": "霧の中を{distance}進んだ探検。妖精に出会った人は、ほかの仲間を見守る。",
    "party.joinTitle": "{name}からの招待",
    "party.joinTitleAnon": "探検への招待",
    "party.joined": "{name}が加わった。",
    "party.leave": "探検から抜ける",
    "party.lock": "新しい探検家を締め切る",
    "party.locked": "その探検は新しい探検家を締め切っている。",
    "party.lockedNote": "新しい探検家を締め切った。",
    "party.lost": "接続が切れた。仲間を探している。",
    "party.memberFell": "{name}が落ちた。",
    "party.memberRemoved": "{name}は探検から抜けた。",
    "party.members": "探検の仲間",
    "party.notNow": "今はしない",
    "party.openNote": "新しい探検家を受け入れた。",
    "party.out": "霧の中",
    "party.over": "その探検は終わった。",
    "party.qrLabel": "この探検へのリンクのQRコード",
    "party.remove": "探検から外す",
    "party.removeAsk": "{name}を探検から外しますか？リンクから戻ることはできなくなります。",
    "party.removed": "その探検にはもう参加していない。",
    "party.share": "リンクを共有",
    "party.shareText": "霧の中の探検にいっしょに行こう。",
    "party.tiles": "{n}マス",
    "party.tiles1": "1マス",
    "party.unavailable": "始められなかった。少ししてからもう一度。",
    "party.unfollow": "ついていくのをやめる",
    "party.unlock": "新しい探検家を受け入れる",
    "party.you": "自分",
    "party.youFell": "落ちてしまった。ここからは仲間を見守る。",
    "party.youNamed": "{name}（自分）",
    "party.yourName": "名前",
    "placeholder.store": "[App Storeのリンク]",
    "privacy.cloudApp": "MistsweeperのiCloudがオンのとき、設定、探検、空き地、各場所でのカメラの位置は、あなた自身のiCloudにも保存され、iPhoneでもiPadでも続きから遊べます。読めるのはあなたのApple Accountだけです。私たちには読めません。アプリを削除しても、iCloudには残ります。「設定」アプリのiCloudから削除できます。",
    "privacy.cloudTitleApp": "お使いのiCloud",
    "privacy.contact": "Mistsweeperは、スウェーデンのストックホルムにあるGreat Scott! ABが制作しています。プライバシーに関するご質問は、以下までお寄せください。",
    "privacy.contactTitle": "お問い合わせ",
    "privacy.gameCenterApp": "この端末でGame Centerにサインインしていると、アプリは毎日の探検で到達した距離とエンドレスの最長記録をAppleに送ります。これらはゲームのGame Centerリーダーボードに、Game Centerの名前で、Game Centerの設定で許可した人に表示されます。ゲームがあなたの名前や友だちを読み取ることはなく、Game Centerの情報を保存することもありません。サインインしていなければ、何も送られません。サインアウトは「設定」アプリのGame Centerからできます。",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "このサイトはCloudflareから配信されています。ほかのウェブホストと同じく、Cloudflareはサイトを届けるために利用者のIPアドレスを受け取り、サービスを安全に保つため、自社のログに短期間保存することがあります。私たちが独自にログを保存することはありません。",
    "privacy.hostTitle": "ホスティング",
    "privacy.intro": "Mistsweeperは遊ぶためのもので、データを集めるためのものではありません。保存する情報は、以下がすべてです。",
    "privacy.list": "名前を付けて探検を追加するか、名前を通報するまで、あなたに関する情報は何も送信されません。一覧での順位は、全員が受け取る同じ応答をもとに、お使いの端末で計算されます。探検を追加すると、名前、タップの内容と結果を含む探検、追加した日時、ウェブとアプリのどちらからか、そしてお使いの端末が作るコードを変換したものを保存します。これらはCloudflareに保存され、名前と探検はmistsweeper.comとアプリで全員に表示されます。その後は、設定でオフにするまで、毎日の探検が自動で追加されます。一覧を公平で気持ちのよいものに保つため、私たちは追加された内容を読み、名前や探検を非表示にしたり削除したり、端末からの追加を止めたりすることがあります。名前はだれでも通報でき、通報にはそれを送った端末の、同じように変換したコードが保存されます。不正利用を防ぐため、同じアドレスからのリクエストは変換した形で10分間数えられ、書き残されることはありません。",
    "privacy.listRemove": "追加した内容は、削除するまで残ります。設定の「探検を一覧から削除」を使うと、そこから追加した内容がすべての一覧から削除されます。ブラウザとアプリは、それぞれ自分の分を削除します。変換したコードは、別の端末が探検を自動で追加し直さないように数日間残り、あなたが送った通報にも残ります。端末が手元にない場合は、ご連絡いただければ私たちが削除します。あなたについて私たちが保存している内容は、いつでもお問い合わせいただけます。",
    "privacy.listRemoveTitle": "一覧から抜ける",
    "privacy.none": "アカウントも、広告も、トラッキングも、Cookieもありません。個人データを販売、共有することはなく、「トップ探検家」に追加したものと、いっしょに探検するときに送るもの以外は収集しません。",
    "privacy.noneTitle": "私たちがしないこと",
    "privacy.share": "記録をシェアするとき、テキストの送り先はご自身で選べます。App Storeやメールへのリンクは、ゲームの外で開きます。",
    "privacy.shareTitle": "シェアとリンク",
    "privacy.stored": "設定、探検、記録は、続きから遊べるように、このブラウザのローカルストレージに保存されます。データはお使いの端末にとどまり、「トップ探検家」に探検を追加したときだけ私たちに送信されます。ブラウザでこのサイトのデータを消去すると、ここから消去されます。",
    "privacy.storedApp": "設定、探検、記録は、続きから遊べるように、この端末のアプリ内に保存されます。「トップ探検家」に探検を追加したときだけ私たちに送信されます。アプリを削除すると、これらもこの端末から削除されます。",
    "privacy.storedTitle": "お使いのブラウザ",
    "privacy.storedTitleApp": "お使いの端末",
    "privacy.title": "プライバシー",
    "privacy.together": "ほかの人を招待したり、リンクから探検に参加したりすると、遊んでいるあいだ探検はCloudflareに保存されます。保存されるのは、探検の操作、仲間それぞれが選んだ名前と旗、そして各ブラウザが自分の場所に戻るためのコードです。仲間それぞれのカメラの向きは、遊んでいるあいだほかの仲間に送られるだけで、保存されません。ゲームが正しく公平に動くよう、私たちはいっしょに遊ばれた探検を見たり、進行中の探検を見守ったり、もう一度再生したりできます。探検に関するすべては、最後に遊ばれてから1週間後に削除されます。",
    "privacy.togetherTitle": "いっしょに探検",
    "privacy.updated": "2026年11月1日更新",
    "privacy.updatedApp": "2026年11月1日更新",
    "privacy.usageApp": "iOSアプリでは、使われ方を知るために、ドイツの企業が提供し、EU内にサーバーを置く、プライバシーに配慮した解析サービスTelemetryDeckを使っています。計測するのは、セッションの開始、探検の開始と終了、記録のシェア、空き地を開いたときです。それぞれには、アプリのバージョン、ゲームの言語、機種、OS、画面、設定といった端末の情報と、この端末のアプリを表すコードが含まれます。このコードは送信前に元に戻せない形に変換されるため、あなたにたどり着くことはできません。IPアドレスは保存されず、あなたの記録や、あなたが誰かに関する情報は送信されません。",
    "privacy.usageTitleApp": "アプリの利用状況の計測",
    "privacy.visits": "訪問者数を知るために、EU内でホストされている、プライバシーに配慮した解析サービスPlausibleを使っています。PlausibleはCookieを使わず、個人データも保存しません。保存するのは、訪問数、国、ブラウザ、参照元のサイトといった合計値だけです。IPアドレスは保存されません。",
    "privacy.visitsTitle": "アクセスの計測",
    "punct.comma": "、",
    "punct.join": "{first}{next}",
    "punct.period": "。",
    "reminder.body": "探検 #{n}が霧の中で待っています。",
    "sealed.body": "探検しているうちに、次の探検が始まりました。{distance}の記録は保存されています。このまま練習として続けることもできます。",
    "sealed.next": "探検 #{n}に出発",
    "sealed.title": "探検 #{n}は終わりました",
    "settings.appPromo": "リマインダーと触覚フィードバックは、ベータ版のiOSアプリで使えます。",
    "settings.debug": "フレーム時間を表示",
    "settings.developer": "開発者",
    "settings.feel": "演出とサウンド",
    "settings.haptics": "触覚",
    "settings.hapticsLine": "マスの霧を晴らしたり旗を立てたりすると、小さく振動します。",
    "settings.language": "言語",
    "settings.languageAuto": "自動",
    "settings.languageAutoLine": "システムの設定に従う：{language}",
    "settings.languageDraft": "下書き",
    "settings.listAuto": "探検を自動で追加",
    "settings.listAutoLine": "毎日の探検が、終わるたびに一覧に加わります。",
    "settings.listName": "一覧での名前",
    "settings.listNote": "探検が終わったときに追加すると、今日の一覧に加わります。",
    "settings.listRemove": "探検を一覧から削除",
    "settings.motion": "視差効果を減らす",
    "settings.motionLine": "霧は動かず、新しい土地はすぐに現れ、世界のふちはぼやけません。変更するまでは、システムの設定に従います。",
    "settings.music": "音楽",
    "settings.musicLine": "探検のあいだ、森から静かな調べが流れます。",
    "settings.remind": "毎日のリマインダー",
    "settings.remindDay": "日中",
    "settings.remindDenied": "Mistsweeperの通知がオフになっています。タップして、「設定」アプリで許可してください。",
    "settings.remindEarlier": "{n}分早める",
    "settings.remindEvening": "夜",
    "settings.remindLater": "{n}分遅らせる",
    "settings.remindLine": "今日の探検がまだのとき、{time}にお知らせします。",
    "settings.remindNext": "新しい探検 {time}",
    "settings.remindNight": "深夜",
    "settings.remindTime": "リマインダーの時刻",
    "settings.reminders": "リマインダー",
    "settings.sounds": "効果音",
    "settings.soundsLine": "霧を晴らすとき、旗を立てるとき、妖精に出会ったときに音が鳴ります。",
    "settings.theme": "テーマ",
    "settings.themeAuto": "自動",
    "settings.themeAutoLine": "システムの設定に従う：ライトモードでは「昼」、ダークモードでは「夜」",
    "settings.themeSupporter": "サポーターで選択",
    "settings.tilt": "ティルトシフト",
    "settings.title": "設定",
    "settings.zoom": "ズーム",
    "start.continue": "続きから、{distance}",
    "start.endlessLine": "毎回ちがう世界を、好きなだけ。",
    "start.setOut": "出発する",
    "start.tagDistance": "#{n}、{distance}",
    "start.tagDone": "#{n}、完了、{distance}",
    "start.tagNew": "#{n}、未踏",
    "start.tagNewDate": "#{n}、{dateShort}、未踏",
    "start.tagProgress": "#{n}、探検中、{distance}",
    "start.todayDone": "今日はここまで。次の探検まであと{time}。",
    "start.todayDoneShort": "次の探検まであと{time}。",
    "start.todayInProgress": "探検の途中です。続きから再開できます。",
    "start.todayInProgressShort": "続きから再開できます。",
    "start.todayNew": "{dateLong}。挑戦は1回だけ、だれもが同じ土地を歩きます。",
    "start.todayNewShort": "挑戦は1回だけ、だれもが同じ土地を歩きます。",
    "support.devices": "iCloudがオンなら、探検と空き地はほかの端末にも届きます。ブラウザでは、そのブラウザの中にだけ残ります。",
    "support.devicesTitle": "新しい端末",
    "support.intro": "Mistsweeperはストックホルムの小さなスタジオが作っています。うまく動かないときや、質問があるときは、メールでお知らせください。",
    "support.list": "{settings}の「{remove}」で、探検をすべての一覧から削除できます。名前を通報するには、その行を長押しします。パソコンでは右クリックです。",
    "support.listTitle": "{list}の名前",
    "support.purchase": "購入はApple Accountに結びついています。アプリのメニューで{supporter}を開き、「{restore}」を選んでください。",
    "support.purchaseTitle": "購入が見つからないとき",
    "support.title": "サポート",
    "supporter.accent": "アクセントカラー",
    "supporter.accentLine": "旗の色です。",
    "supporter.accentNumber": "色{n}",
    "supporter.banner": "旗",
    "supporter.banners": "旗",
    "supporter.bannersLine": "すべての探検で、別の旗を立てられます。",
    "supporter.buy": "サポーターになる（{price}）",
    "supporter.buyLine": "1回きりの購入で、サブスクリプションではありません。ファミリー共有で家族も使えます。",
    "supporter.buyNoPrice": "サポーターになる",
    "supporter.cabin": "自分の小屋",
    "supporter.cabinLine": "見つけた家を、すべての探検とすべての空き地で、小屋の場所に置けます。",
    "supporter.chooseCabin": "空き地で選ぶ",
    "supporter.clearingLocked": "この空き地はサポーターしか変えられない。",
    "supporter.clearings": "空き地",
    "supporter.clearingsLine": "15×15マスの広い空き地と、好きなだけの数の空き地が持てます。",
    "supporter.failed": "購入できませんでした。少し待ってから、もう一度お試しください。",
    "supporter.free": "遊べるものはすべて無料で、これからも無料です。",
    "supporter.icon": "アプリアイコン",
    "supporter.icons": "アプリアイコン",
    "supporter.iconsLine": "ホーム画面のアイコンを選べます。どのアイコンにも、ライトとダークの見た目があります。",
    "supporter.lead": "サポーターになると、画面に映るゲームの見た目を選べます。そして、Mistsweeperを作り続ける力になります。",
    "supporter.line": "テーマ、アプリアイコン、旗、小屋",
    "supporter.nothingToRestore": "このApple Accountでは、サポーターの購入が見つかりませんでした。",
    "supporter.pending": "承認を待っています。購入が承認されると、すぐにサポーターになります。",
    "supporter.restore": "購入を復元",
    "supporter.since": "{date}からサポーター",
    "supporter.thanks": "Mistsweeperを応援してくださり、ありがとうございます。ここで、画面に映るゲームの見た目を選べます。",
    "supporter.theme": "テーマ",
    "supporter.themeLine": "昼、夜、自動は「設定」にあります。",
    "supporter.themes": "テーマ",
    "supporter.themesLine": "ゲーム全体を別の色で遊べます。テーマによっては、旗の色も選べます。",
    "supporter.unreachable": "App Storeに接続できませんでした。少し待ってから、もう一度お試しください。",
    "theme.day": "昼",
    "theme.fjord": "フィヨルド",
    "theme.mossa": "苔",
    "theme.night": "夜",
    "theme.pergament": "羊皮紙",
    "theme.rosa": "桃色",
    "theme.skymning": "黄昏",
    "time.hoursMinutes": "{h}時間{m}分",
    "time.minutes": "{m}分",
    "webgl.missing": "MistsweeperにはWebGL 2が必要ですが、このブラウザは対応していません。",
    "welcome.mistDaily": "毎日、新しい探検がひとつ。だれもが同じ土地を歩き、挑戦は1回だけです。静かなひとときには、エンドレスをどうぞ。",
    "welcome.mistNumbers": "数字は、まわりの8マスにひそむ妖精の数です。妖精が眠っていると思うマスに旗を立てて、先へ進みましょう。",
    "welcome.mistText": "はじまりは森の空き地に立つ小屋。そのほかはすべて霧です。探検した場所から、1マスずつ霧を晴らしていきましょう。",
    "welcome.mistTitle": "霧の中へ",
    "welcome.next": "次へ",
    "welcome.remindNo": "今はしない",
    "welcome.remindText": "新しい探検は毎日やってきます。時刻を選んでおくと、今日の探検がまだのときにお知らせします。ゲームの設定から、あとで変更できます。",
    "welcome.remindTitle": "毎日のリマインダー",
    "welcome.remindYes": "通知を受け取る",
    "welcome.skip": "スキップ",
    "welcome.starsLater": "のちほど、感想をおうかがいします。そのとき少しだけお時間をいただけると、大きな助けになります。",
    "welcome.starsText": "Mistsweeperは、ストックホルムの小さなスタジオ、Great Scott!が作っています。小さなゲームにとって、App Storeの評価は、ほかの人に見つけてもらういちばんの方法です。",
    "welcome.starsTitle": "小さなスタジオから",
    "welcome.step": "{total}ページ中{n}ページ目",
    "widget.bestDay": "1日のベスト {distance}",
    "widget.clearingDescription": "あなたの空き地と、見つけたものの数、ベスト記録を表示します。",
    "widget.clearingName": "あなたの空き地",
    "widget.description": "今日の探検を離れたときのままの姿で、連続記録とともに表示します。",
    "widget.next": "次まであと{time}",
    "widget.streak": "連続記録：{days}",
    "widget.waiting": "出発前",
  },
  ko: {
    "a11y.bannerMode": "깃발 모드",
    "a11y.board.banner": "깃발",
    "a11y.board.bannerRemoved": "깃발을 뽑았어요.",
    "a11y.board.banners1": "깃발 1개",
    "a11y.board.bannersN": "깃발 {n}개",
    "a11y.board.cabin": "오두막",
    "a11y.board.cellBanner": "깃발",
    "a11y.board.cellCabin": "오두막",
    "a11y.board.cellExplored": "탐험됨",
    "a11y.board.cellMist": "안개",
    "a11y.board.cellWrongBanner": "틀린 깃발",
    "a11y.board.chordWaits": "주변 깃발 수가 숫자와 맞지 않아요.",
    "a11y.board.chosen": "선택: {name}.",
    "a11y.board.confirmed": "확인됨",
    "a11y.board.creature": "어떤 존재",
    "a11y.board.deepMist": "짙은 안개",
    "a11y.board.describe": "주변 설명하기",
    "a11y.board.dirEast": "동쪽",
    "a11y.board.dirNorth": "북쪽",
    "a11y.board.dirSouth": "남쪽",
    "a11y.board.dirWest": "서쪽",
    "a11y.board.east": "동쪽 {n}칸",
    "a11y.board.explore": "주변 탐험하기",
    "a11y.board.explored": "탐험됨",
    "a11y.board.exploredOn": "탐험됨, {what}",
    "a11y.board.frontier0": "탐험할 안개 없음",
    "a11y.board.frontier1": "탐험할 안개 1칸",
    "a11y.board.frontierN": "탐험할 안개 {n}칸",
    "a11y.board.furthest": "가장 먼 지점 {distance}.",
    "a11y.board.hid": "여기 숨어 있었어요",
    "a11y.board.hintExplore": "주변 칸을 탐험해요.",
    "a11y.board.hintPlant": "깃발을 꽂아요.",
    "a11y.board.hintReveal": "칸을 탐험해요.",
    "a11y.board.hintTakeAway": "깃발을 뽑아요.",
    "a11y.board.inMist": "안개 {n}칸",
    "a11y.board.inView": "화면에 {what}",
    "a11y.board.listAnd": "{list}, {last}",
    "a11y.board.mist": "안개",
    "a11y.board.nextTo": "옆에 숫자 {numbers}",
    "a11y.board.north": "북쪽 {n}칸",
    "a11y.board.place": "오두막에서 {where}, {distance}",
    "a11y.board.plant": "깃발 꽂기",
    "a11y.board.revealed1": "1칸을 탐험했어요.",
    "a11y.board.revealedN": "{n}칸을 탐험했어요.",
    "a11y.board.rotorBanners": "깃발",
    "a11y.board.rotorMist": "탐험할 안개",
    "a11y.board.rotorNorthSouth": "북쪽과 남쪽",
    "a11y.board.rotorNumbers": "열린 숫자",
    "a11y.board.roundIt": "주변에 {what}",
    "a11y.board.rowHere": "여기: {tiles}.",
    "a11y.board.rowNorth": "북쪽: {tiles}.",
    "a11y.board.rowSouth": "남쪽: {tiles}.",
    "a11y.board.south": "남쪽 {n}칸",
    "a11y.board.takeAway": "깃발 뽑기",
    "a11y.board.turned": "회전했어요.",
    "a11y.board.west": "서쪽 {n}칸",
    "a11y.board.woke": "여기서 깨어나 탐험을 끝냈어요",
    "a11y.board.wrongBanner": "틀린 깃발",
    "a11y.distance": "가장 먼 거리",
    "a11y.find": "새 발견: {name}.",
    "a11y.findMore": "새 발견: {name} 외 {n}개.",
    "a11y.map": "탐험 지도",
    "about.body1": "오두막 너머에서 안개가 시작되고, 안개 속에는 옛 존재들이 산다. 이끼 밑의 트롤, 나무 사이의 훌드라, 고요한 물가의 네켄.",
    "about.body2": "Mistsweeper는 발을 딛기 전에 땅을 읽는 게임이에요. 숫자는 근처에 잠든 존재가 몇인지 알려 줘요. 얼마나 멀리 갈지는 하기 나름이에요.",
    "about.body3": "Mistsweeper는 고전 퍼즐 게임 지뢰찾기를 북유럽 신화와 민담에서 영감을 받아 새롭게 해석한 게임이에요.",
    "about.made": "스웨덴 스톡홀름의 Great Scott!에서 만들었어요.",
    "about.version": "버전 {version}",
    "accessibility.contact": "플레이를 가로막는 것이 있거나, 게임을 더 편하게 즐길 방법이 있다면 연락 주세요.",
    "accessibility.contactTitle": "알려 주세요",
    "accessibility.contrast": "세계와 메뉴는 종이에 잉크로 그려져 있어서, 낮에도 밤에도 텍스트에 필요한 수준보다 대비가 훨씬 높아요. 빨간색은 중요한 것을 표시하지만, 빨간색만으로 알리지는 않아요. 깃발에는 고유한 모양이 있고, 탐험이 끝난 뒤 틀린 깃발에는 X 표시가, 탐험이 끝난 칸에는 테두리가 붙어요.",
    "accessibility.contrastTitle": "대비와 색",
    "accessibility.dark": "게임은 시스템의 다크 모드를 따라요. 밤은 달빛 아래의 세계예요. 설정의 테마에서 낮이나 밤을 고를 수도 있어요.",
    "accessibility.darkTitle": "다크 모드와 라이트 모드",
    "accessibility.intro": "Mistsweeper는 되도록 많은 사람이 즐길 수 있어야 해요. 지금 웹과 iOS 앱에서 지원하는 것과 작업하고 있는 것을 소개해요.",
    "accessibility.keys": "웹에서는 키보드만으로 게임 전체를 플레이할 수 있어요. 화살표 키나 WASD로 커서를 옮기고, Enter나 Space로 칸을 탐험하고, F로 깃발을 꽂거나 뽑고, Q와 E로 카메라를 회전하고, T와 G로 기울이고, 더하기와 빼기 키로 확대/축소하고, H로 오두막으로 돌아가고, Esc로 열린 것을 닫아요.",
    "accessibility.keysTitle": "웹의 키보드 조작",
    "accessibility.motion": "시스템의 동작 줄이기나 게임 설정의 스위치를 켜면 아무것도 저절로 움직이지 않아요. 안개, 바람, 동물, 카메라가 멈추고, 새 땅은 바로 나타나며, 세계의 가장자리는 선명하게 남아요.",
    "accessibility.motionTitle": "동작 줄이기",
    "accessibility.sound": "소리와 음악으로만 알 수 있는 것은 없어요. 게임에는 음성도 영상도 없어요. iOS 앱에서는 칸을 탐험하거나 깃발을 꽂을 때 햅틱이 함께해요. 음악, 효과음, 햅틱은 설정에서 각각 끌 수 있어요.",
    "accessibility.soundTitle": "소리",
    "accessibility.title": "접근성",
    "accessibility.updated": "2026년 10월 25일 업데이트",
    "accessibility.work": "iOS 앱에서는 VoiceOver와 음성 제어로 지도를 읽고 플레이할 수 있고, 글자도 설정한 텍스트 크기를 따라요. 웹에서는 메뉴와 버튼에 스크린 리더용 레이블이 있지만, 지도는 아직 스크린 리더로 읽거나 플레이할 수 없어요. 이 부분은 지금 작업하고 있어요.",
    "accessibility.workTitle": "지금 작업 중인 것",
    "app.tagline": "끝없는 탐험",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "광고도 추적도 없는 픽셀 아트 컬러링북.",
    "apps.intro": "같은 스튜디오에서 만든 작은 게임과 앱.",
    "apps.krono": "역사, 대중문화, 음악을 연표 위에 순서대로 놓아 보세요.",
    "apps.ordna": "조용한 정렬 퍼즐. 퍼즐 천 개, 방해는 없어요.",
    "apps.tapotron": "의욕 넘치는 버튼 격자 위에서 즐기는 탭 게임과 비트.",
    "archive.appNoteCloud": "iCloud에 저장돼요. 모든 기기에서 볼 수 있어요.",
    "archive.appNoteDevice": "이 기기에 저장돼요. Mistsweeper의 iCloud를 켜면 모든 기기에서 볼 수 있어요.",
    "archive.best": "최고 기록",
    "archive.daily": "일일 탐험",
    "archive.dayStreak": "연속 일수",
    "archive.endlessBest": "최고",
    "archive.endlessLast": "최근",
    "archive.endlessRuns": "횟수",
    "archive.expeditions": "탐험 횟수",
    "archive.gameCenter": "Game Center에서 친구와 비교하기",
    "archive.notPlayed": "탐험하지 않음",
    "archive.sealed": "봉인됨",
    "archive.today": "오늘, 진행 중",
    "archive.todayWord": "오늘",
    "archive.webNote": "이 브라우저에 저장돼요. iOS 앱은 iCloud에 탐험 기록을 따로 보관해요.",
    "archive.webNoteShort": "이 브라우저에 저장돼요.",
    "banner.1": "세 갈래",
    "banner.a1": "제비꼬리",
    "banner.a3": "창끝",
    "banner.b1": "부채꼴",
    "banner.b2": "까마귀 깃발",
    "banner.b3": "반원",
    "banner.c2": "T자 깃대",
    "banner.c3": "이정표",
    "banner.c4": "꼬인 깃발",
    "beta.bugs": "제대로 작동하지 않거나 이상해 보이는 부분이 있나요? 무엇을 했고, 무슨 일이 있었고, 어떤 기기인지 적어 주세요. 스크린샷이 있으면 도움이 돼요.",
    "beta.bugsTitle": "버그",
    "beta.changes": "베타 기간에는 게임이 계속 바뀌어요. 출시되어도 탐험은 #1부터 다시 시작하지 않고 그대로 이어져요.",
    "beta.changesTitle": "달라지는 것",
    "beta.intro": "Mistsweeper는 플레이할 수 있지만 아직 완성되지 않았어요. 출시 전에 플레이하는 분들의 도움이 필요해요.",
    "beta.language": "게임은 9개 언어로 제공되지만, 대부분의 번역은 아직 원어민이 읽어 보지 않았어요. 틀리거나 어색한 표현이 있으면 어디에서 봤는지, 어떻게 쓰면 자연스러운지 알려 주세요.",
    "beta.languageTitle": "글과 언어",
    "beta.more": "더 보기",
    "beta.ticker1": "Mistsweeper는 베타 버전이에요",
    "beta.ticker2": "버그를 찾아 주세요",
    "beta.ticker3": "번역을 도와주세요",
    "beta.title": "베타 소개",
    "button.banner": "깃발",
    "button.cancel": "취소",
    "button.close": "닫기",
    "button.daily": "오늘의 탐험",
    "button.endless": "무한",
    "button.home": "오두막으로 돌아가기",
    "button.practice": "연습 탐험",
    "button.settings": "설정",
    "button.zoomIn": "확대",
    "button.zoomOut": "축소",
    "clearing.arrange": "배치",
    "clearing.cabin": "오두막은 그 자리를 지켜요.",
    "clearing.cabinChosen": "내 오두막: {name}.",
    "clearing.cabinHint": "오두막은 지금까지 찾은 집 중 아무것으로나 바꿀 수 있어요. 오두막을 길게 눌러 골라 보세요.",
    "clearing.cat.creatures": "존재",
    "clearing.cat.ground": "땅",
    "clearing.cat.houses": "집",
    "clearing.cat.plants": "식물",
    "clearing.cat.stones": "돌",
    "clearing.changeCabin": "오두막 바꾸기",
    "clearing.chooseCabin": "오두막 고르기",
    "clearing.clear": "비우기",
    "clearing.delete": "삭제",
    "clearing.deleteBody": "그곳에 배치한 것들도 함께 사라져요. 발견한 것들은 그대로 남아요.",
    "clearing.deleteTitle": "{name} 빈터를 삭제할까요?",
    "clearing.deleted": "{name} 빈터를 삭제했어요.",
    "clearing.discovered": "{total}개 중 {n}개 발견",
    "clearing.done": "완료",
    "clearing.edit": "편집",
    "clearing.editing": "{name} 편집 중",
    "clearing.family.barley": "보리",
    "clearing.family.barn": "헛간",
    "clearing.family.beacon": "봉화대",
    "clearing.family.beehive": "벌통",
    "clearing.family.bergstroll": "산트롤",
    "clearing.family.birch": "자작나무",
    "clearing.family.boat": "나룻배",
    "clearing.family.boathouse": "배 창고",
    "clearing.family.boulder": "큰 바위",
    "clearing.family.bush": "덤불",
    "clearing.family.cairn": "돌무더기",
    "clearing.family.campfire": "모닥불",
    "clearing.family.cart": "수레",
    "clearing.family.cave": "동굴",
    "clearing.family.church": "목조 교회",
    "clearing.family.cottage": "작은 농가",
    "clearing.family.driftwood": "떠내려온 나무",
    "clearing.family.fabod": "여름 목장",
    "clearing.family.faering": "돛단배",
    "clearing.family.fence": "나무 울타리",
    "clearing.family.fern": "고사리",
    "clearing.family.fishhut": "어부 오두막",
    "clearing.family.flottning": "뗏목",
    "clearing.family.fornborg": "산성",
    "clearing.family.goahti": "뗏장 오두막",
    "clearing.family.gravhog": "고분",
    "clearing.family.harbre": "높은 곳간",
    "clearing.family.hassja": "건초 건조대",
    "clearing.family.hides": "가죽과 고기",
    "clearing.family.hjell": "덕장",
    "clearing.family.house": "오두막",
    "clearing.family.huldra": "훌드라",
    "clearing.family.huntingtower": "사냥 망루",
    "clearing.family.jatte": "거인",
    "clearing.family.jetty": "선착장",
    "clearing.family.juniper": "노간주나무",
    "clearing.family.kastal": "돌 망루",
    "clearing.family.kolmila": "숯가마",
    "clearing.family.kummel": "바닷가 돌탑",
    "clearing.family.laundry": "빨래",
    "clearing.family.lavvu": "라부",
    "clearing.family.lilypads": "수련",
    "clearing.family.log": "통나무",
    "clearing.family.longhouse": "긴 집",
    "clearing.family.massif": "산맥",
    "clearing.family.mushroom": "버섯",
    "clearing.family.nacken": "네켄",
    "clearing.family.njalla": "냘라",
    "clearing.family.oak": "참나무",
    "clearing.family.oats": "귀리",
    "clearing.family.outcrop": "너럭바위",
    "clearing.family.peak": "산봉우리",
    "clearing.family.pebbles": "조약돌",
    "clearing.family.pine": "소나무",
    "clearing.family.reeds": "갈대",
    "clearing.family.rengarde": "순록 우리",
    "clearing.family.rock": "바윗돌",
    "clearing.family.rockcarving": "암각화",
    "clearing.family.rootcellar": "토굴 저장고",
    "clearing.family.rowan": "마가목",
    "clearing.family.ruin": "폐허",
    "clearing.family.runestone": "룬석",
    "clearing.family.rye": "호밀",
    "clearing.family.sauna": "사우나",
    "clearing.family.seamark": "항로 표지",
    "clearing.family.shed": "곳간",
    "clearing.family.shipsetting": "배 모양 돌무덤",
    "clearing.family.shorestones": "물가 돌",
    "clearing.family.sjotroll": "호수트롤",
    "clearing.family.skogstroll": "숲트롤",
    "clearing.family.smithy": "대장간",
    "clearing.family.snag": "고사목",
    "clearing.family.spruce": "가문비나무",
    "clearing.family.stonecircle": "원형 열석",
    "clearing.family.stones": "선돌",
    "clearing.family.stooks": "추수한 밭",
    "clearing.family.stormannagard": "족장의 집",
    "clearing.family.stump": "그루터기",
    "clearing.family.tent": "천막",
    "clearing.family.tjardal": "타르 가마",
    "clearing.family.tuft": "풀",
    "clearing.family.watermill": "물레방아",
    "clearing.family.well": "우물",
    "clearing.family.wellsweep": "장대 우물",
    "clearing.family.windmill": "풍차",
    "clearing.family.windthrow": "뿌리 뽑힌 나무",
    "clearing.family.woodpile": "장작더미",
    "clearing.fold": "접기",
    "clearing.ground.forest": "숲",
    "clearing.ground.meadow": "풀밭",
    "clearing.ground.mountain": "산",
    "clearing.ground.water": "물",
    "clearing.grown": "안개가 물러나요.",
    "clearing.hint": "아래에서 하나를 고른 다음 칸을 탭하세요. 다시 탭하면 회전해요. 칸을 길게 누르면 바꿀 수 있어요.",
    "clearing.hintVoiceOver": "아래에서 하나를 고른 다음 칸을 이중 탭하세요. 칸의 동작으로 편집, 회전, 비우기를 할 수 있어요.",
    "clearing.large": "크게",
    "clearing.locked": "아직 발견하지 못했어요. 안개 속에서 기다리고 있어요.",
    "clearing.lockedName": "{name}, 아직 발견하지 못함",
    "clearing.made": "새 빈터: {name}.",
    "clearing.mist": "그곳은 안개 속이에요.",
    "clearing.needsLand": "땅이 필요해요.",
    "clearing.needsWater": "물이 필요해요.",
    "clearing.new": "새 빈터",
    "clearing.photo": "사진",
    "clearing.photo.back": "뒤로",
    "clearing.photo.failed": "여기서는 사진을 찍지 못했어요.",
    "clearing.photo.file": "clearing",
    "clearing.photo.formats": "사진 비율",
    "clearing.photo.notSaved": "사진을 저장하지 못했어요. 설정에서 Mistsweeper가 사진을 추가하도록 허용할 수 있어요.",
    "clearing.photo.picture": "찍은 사진",
    "clearing.photo.save": "저장",
    "clearing.photo.saved": "사진 앱에 저장했어요.",
    "clearing.photo.share": "공유",
    "clearing.photo.shutter": "사진 찍기",
    "clearing.photo.usage": "요청하면 Mistsweeper가 빈터 사진을 사진 앱에 저장해요.",
    "clearing.rename": "이름 변경",
    "clearing.renameSave": "저장",
    "clearing.renameTitle": "빈터 이름",
    "clearing.size": "빈터 크기",
    "clearing.small": "작게",
    "clearing.supporter": "서포터",
    "clearing.turn": "회전",
    "clearing.undo": "되돌리기",
    "clearing.yours": "나의 빈터 목록",
    "controls.banner": "깃발 꽂기",
    "controls.click": "클릭",
    "controls.drag": "드래그",
    "controls.pan": "이동",
    "controls.pinch": "핀치",
    "controls.qe": "Q와 E",
    "controls.reveal": "칸 탐험",
    "controls.rightClick": "오른쪽 클릭",
    "controls.rightDrag": "오른쪽 드래그",
    "controls.scroll": "스크롤",
    "controls.tg": "T와 G",
    "controls.tilt": "기울이기",
    "controls.title": "조작법",
    "controls.turn": "회전",
    "controls.turnTilt": "회전과 기울이기",
    "controls.twist": "두 손가락 돌리기",
    "controls.twoFingers": "두 손가락 위아래로",
    "controls.voActions": "위아래로 쓸어넘기기",
    "controls.voFind": "탐험할 안개, 열린 숫자, 깃발, 북쪽과 남쪽",
    "controls.voMagicTap": "두 손가락으로 이중 탭",
    "controls.voMove": "지도에서 네 칸씩 이동",
    "controls.voRotor": "로터 돌리기",
    "controls.voScroll": "세 손가락으로 쓸어넘기기",
    "controls.voSummary": "현재 위치와 지금까지 온 거리",
    "controls.voSwipe": "좌우로 쓸어넘기기",
    "controls.voTileActions": "칸의 동작: 깃발, 주변 탐험하기, 주변 설명하기",
    "controls.voTiles": "화면 속 칸을 북쪽부터 한 줄씩",
    "controls.zoom": "확대/축소",
    "daily.next": "다음 탐험까지 {time}",
    "feedback.subject": "Mistsweeper 피드백, 버전 {version}",
    "find.new": "새 발견",
    "getApp.beta": "앱은 베타 버전이에요. 출시 전의 앱을 미리 써 볼 수 있는 Apple의 앱, TestFlight로 설치해요.",
    "getApp.haptics": "손끝에 전해지는 햅틱.",
    "getApp.intro": "매일의 탐험은 그대로 두고, 앱에서만 할 수 있는 몇 가지를 더했어요.",
    "getApp.join": "TestFlight에서 베타 참여하기",
    "getApp.note": "이 브라우저의 탐험 기록은 여기에 남아요. 앱은 따로 기록을 보관해요.",
    "getApp.offline": "인터넷 연결 없이도 플레이할 수 있어요.",
    "getApp.qr": "iPhone 카메라를 여기에 비추면 베타에 참여할 수 있어요.",
    "getApp.qrLabel": "TestFlight 베타 QR 코드",
    "getApp.reminder": "원하는 시간에 받는 매일 알림.",
    "getApp.widget": "오늘의 탐험과 연속 기록을 보여 주는 위젯.",
    "hint.clearingDesktop": "하나를 골라 빈터에 배치하세요. 칸을 오른쪽 클릭하면 바꿀 수 있어요.",
    "hint.photoDesktop": "창 안에 빈터를 담은 다음 사진을 찍으세요.",
    "hint.reveal": "탐험한 땅 옆의 칸을 탭해 탐험하세요.",
    "hint.revealDesktop": "탐험한 땅 옆의 칸을 클릭해 탐험하세요. 깃발은 오른쪽 클릭으로 꽂아요.",
    "hint.revealVoiceOver": "탐험한 땅 옆의 안개로 쓸어넘겨 이동하거나 로터로 찾은 다음, 이중 탭해서 탐험하세요.",
    "howto.1": "오두막에서 시작해요. 나머지는 모두 안개예요.",
    "howto.2": "탐험한 땅 옆의 칸을 하나 탐험하세요. 지나온 곳에서부터 한 칸씩 걸어 나가요.",
    "howto.3": "숫자는 주변 여덟 칸에 숨어 있는 존재의 수예요.",
    "howto.3example": "여기서는 아직 안개 속에 있는 세 칸 중 두 칸에 존재가 숨어 있어요.",
    "howto.4mouse": "존재가 숨어 있을 것 같은 칸에 깃발을 꽂으세요. 그 칸을 오른쪽 클릭하면 돼요.",
    "howto.4touch": "존재가 숨어 있을 것 같은 칸에 깃발을 꽂으세요. 깃발 모드를 켜고 그 칸을 탭하면 돼요.",
    "howto.4voiceOver": "존재가 숨어 있을 것 같은 칸에 깃발을 꽂으세요. 그 칸에서 위나 아래로 쓸어넘겨 동작을 찾고, 깃발 꽂기를 고르면 돼요.",
    "howto.5": "존재를 깨우면 탐험이 끝나요. 점수는 오두막에서 가장 멀리 간 지점까지의 거리예요.",
    "howto.6": "매일 새로운 탐험이 찾아와요. 모두에게 같은 땅이고, 기회는 한 번이에요. 한가로운 시간에는 무한 탐험이 있어요.",
    "howto.tryLesson": "세계에서 해 보기",
    "hud.best": "최고 {distance}",
    "hud.clearing": "빈터",
    "hud.menu": "메뉴",
    "hud.north": "북쪽이 위로 오게 돌리기",
    "hud.practice": "연습 탐험, #{n}",
    "hud.today": "오늘",
    "hud.turnLeft": "왼쪽으로 회전, Q",
    "hud.turnLeftKey": "Q",
    "hud.turnRight": "오른쪽으로 회전, E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "보리예요.",
    "inspect.barley.2": "곧 빵, 아니면 더 좋은 것.",
    "inspect.barn.1": "헛간이에요.",
    "inspect.barn.2": "건초와 고양이로 가득해요.",
    "inspect.barn.3": "지붕까지 건초. 봄까지 버틸 거예요.",
    "inspect.beacon.1": "봉화대. 적이 보이면 불을 붙여요.",
    "inspect.beacon.2": "불 하나, 또 하나, 그러면 온 나라가 알아요.",
    "inspect.beacon.3": "잘 말랐고 준비됐어요. 불을 붙인 사람은 아직 없어요.",
    "inspect.beehive.1": "벌통. 두드리지 않는 게 좋아요.",
    "inspect.beehive.2": "우리는 바쁘다.",
    "inspect.birch.1": "자작나무예요.",
    "inspect.birch.2": "흰 껍질, 검은 빗금. 누군가 세고 있었나 봐요.",
    "inspect.birch.3": "자작나무 껍질은 젖어도 타요. 알아 두면 좋아요.",
    "inspect.birch.4": "자작나무는 가장 먼저 잎이 나고, 가장 먼저 노랗게 물들어요.",
    "inspect.boat.1": "나룻배. 누군가 찾으러 올 거예요.",
    "inspect.boat.2": "배 안에 노가 있어요. 탄 사람은 없어요.",
    "inspect.boathouse.1": "타르와 젖은 밧줄 냄새가 나요.",
    "inspect.boathouse.2": "배는 나갔어요. 언제 돌아올지는 아무도 말이 없어요.",
    "inspect.boulder.1": "큰 바위. 딱 한 번 움직였어요, 얼음에 실려서요.",
    "inspect.boulder.2": "얼음과 함께 왔다. 나는 남는다.",
    "inspect.boulder.3": "얼음이 이걸 두고 집에 갔어요.",
    "inspect.bush.1": "덤불이에요.",
    "inspect.bush.2": "덤불에는 아무것도 숨어 있지 않아요. 아마도요.",
    "inspect.bush.3": "무언가 스치는 소리가 났어요. 그냥 덤불이었어요.",
    "inspect.cabin": "나의 오두막. 난로는 아직 따뜻해요.",
    "inspect.cairn.1": "돌무더기예요.",
    "inspect.cairn.2": "지나가는 사람마다 돌을 하나씩 얹어요.",
    "inspect.cairn.3": "누군가 길을 표시해 두었어요. 아니면 무덤을요.",
    "inspect.campfire.1": "모닥불이에요.",
    "inspect.campfire.2": "불은 있는데, 곁에 아무도 없어요.",
    "inspect.campfire.3": "누군가 급히 떠났어요.",
    "inspect.cart.1": "수레예요.",
    "inspect.cart.2": "말이 멈춘 자리에 그대로 있어요.",
    "inspect.cave.1": "동굴이에요. 안으로 이어져요.",
    "inspect.cave.2": "들어와.",
    "inspect.cave.3": "안에서 무언가 숨 쉬고 있어요. 아니면 바람이겠죠.",
    "inspect.church.1": "목조 교회. 수백 년 치 타르.",
    "inspect.church.2": "돌은 하나도 없어요. 나무와 인내뿐이에요.",
    "inspect.church.3": "안은 조용해요. 늘 그랬어요.",
    "inspect.creature.bergstroll": "여기 산트롤이 살았다.",
    "inspect.creature.huldra": "여기 훌드라가 살았다.",
    "inspect.creature.jatte": "여기 거인이 살았다.",
    "inspect.creature.nacken": "여기 네켄이 살았다.",
    "inspect.creature.sjotroll": "여기 호수트롤이 살았다.",
    "inspect.creature.skogstroll": "여기 숲트롤이 살았다.",
    "inspect.deer.1": "노루. 벌써 눈치챘어요.",
    "inspect.deer.2": "고개를 들었다가, 다시 풀을 뜯어요.",
    "inspect.driftwood.1": "떠내려온 나무. 어디서 왔는지는 아무도 몰라요.",
    "inspect.driftwood.2": "여기 누구보다 바다를 많이 봤어요.",
    "inspect.duck.1": "청둥오리. 제 할 일만 해요.",
    "inspect.duck.2": "할 말이 많은 눈치예요.",
    "inspect.elk.1": "말코손바닥사슴. 신경도 안 써요.",
    "inspect.elk.2": "숲에서 가장 크고, 가장 조용해요.",
    "inspect.faering.1": "돛단배. 노 넷에 돛 하나.",
    "inspect.faering.2": "바이킹 배를 만들던 방식 그대로예요.",
    "inspect.fence.1": "나무 울타리. 못은 하나도 안 썼어요.",
    "inspect.fence.2": "가둬 두려던 것들은 어디론가 가 버렸어요.",
    "inspect.fern.1": "고사리예요.",
    "inspect.fern.2": "나무보다 고사리가 먼저였어요.",
    "inspect.fern.3": "하짓날 밤에 고사리꽃이 핀다고 해요. 본 사람은 없어요.",
    "inspect.fishhut.1": "그물, 부표, 묵은 청어.",
    "inspect.fishhut.2": "어부 오두막. 냄새가 먼저 마중 나와요.",
    "inspect.flottning.1": "바닷가로 가는 통나무.",
    "inspect.flottning.2": "뗏목. 나르는 일은 강이 해요.",
    "inspect.fornborg.1": "산성. 봉화가 오르면 사람들이 이리로 달려왔어요.",
    "inspect.fornborg.2": "돌담은 무너졌어요. 그 담이 막던 이들도 사라졌어요.",
    "inspect.fornborg.3": "이 돌을 누가 쌓았는지 아무도 몰라요.",
    "inspect.goahti.1": "뗏장 오두막. 겉은 뗏장, 속은 따뜻해요.",
    "inspect.goahti.2": "연기는 꼭대기로 나가요. 늘 그래 왔어요.",
    "inspect.gravhog.1": "고분. 중요한 분이었나 봐요.",
    "inspect.gravhog.2": "여기 누군가 잠들어 있어요. 조용히 걸으세요.",
    "inspect.gravhog.3": "무덤. 그 위로 천 년의 풀.",
    "inspect.harbre.1": "높은 곳간. 기둥 위라서 쥐가 닿지 못해요.",
    "inspect.harbre.2": "안에 지난해 곡식이 들어 있어요.",
    "inspect.hassja.1": "건초 건조대. 바람이 말려 줘요.",
    "inspect.hassja.2": "가로대에 건초. 이제 비가 오면 안 돼요.",
    "inspect.hides.1": "틀에 걸린 순록 가죽. 버리는 것이 없어요.",
    "inspect.hides.2": "바람에 마르는 고기. 겨울 양식이에요.",
    "inspect.hjell.1": "대구를 말리는 중. 요리는 바람이 해요.",
    "inspect.hjell.2": "여기까지 냄새가 나요.",
    "inspect.home": "{name}의 집이에요.",
    "inspect.huntingtower.1": "누군가 저 위에 앉아 기다리고 있어요.",
    "inspect.huntingtower.2": "말코손바닥사슴은 다 알고 있어요.",
    "inspect.jetty.1": "선착장이에요.",
    "inspect.jetty.2": "조금 나아가다 포기해요.",
    "inspect.jetty.3": "맨발이 어울리는 곳이에요.",
    "inspect.juniper.1": "노간주나무예요.",
    "inspect.juniper.2": "노간주나무. 찌르면 되찔러요.",
    "inspect.juniper.3": "노간주나무. 멀리서 보면 누군가 가만히 서 있는 것 같아요.",
    "inspect.kastal.1": "두꺼운 벽, 작은 창.",
    "inspect.kastal.2": "누군가 손님을 기다렸어요. 반가운 손님은 아니었고요.",
    "inspect.kolmila.1": "숯가마예요.",
    "inspect.kolmila.2": "몇 주씩 서서히 타요. 누군가는 깨어 있어야 해요.",
    "inspect.kolmila.3": "나무가 들어가요. 숯이 나와요.",
    "inspect.kummel.1": "바닷가 돌탑. 뱃사람에게 여기가 어디인지 알려 줘요.",
    "inspect.kummel.2": "바다에서 보여요. 하는 일은 그게 다예요.",
    "inspect.laundry.1": "누군가의 빨래.",
    "inspect.laundry.2": "저녁엔 마를 거예요. 안개만 안 오면요.",
    "inspect.laundry.3": "양말이 한 짝 모자라요.",
    "inspect.lavvu.1": "라부. 아침이면 없을 수도 있어요.",
    "inspect.lavvu.2": "장대와 천. 더 필요한 건 없어요.",
    "inspect.lilypads.1": "수련.",
    "inspect.lilypads.2": "수련. 꺾지 마세요. 아끼는 분이 있어요.",
    "inspect.lilypads.3": "수련의 긴 줄기, 저 아래 어둠 속으로.",
    "inspect.log.1": "통나무예요.",
    "inspect.log.2": "오래전에 쓰러졌어요. 이끼가 이사 왔어요.",
    "inspect.massif.1": "산맥이에요.",
    "inspect.massif.2": "산은 손님이 온 줄도 몰라요.",
    "inspect.massif.3": "바위틈엔 눈이 남아 있어요. 8월에도요.",
    "inspect.mushroom.1": "버섯. 그냥 두는 게 좋아요.",
    "inspect.mushroom.2": "버섯은 다 먹을 수 있어요. 어떤 건 딱 한 번만요.",
    "inspect.mushroom.3": "누군가 바구니에 담고 싶어 할 거예요.",
    "inspect.njalla.1": "냘라. 기둥 하나면 곰은 쳐다만 봐요.",
    "inspect.njalla.2": "식량은 높이, 사람 손만 닿는 곳에.",
    "inspect.oak.1": "참나무예요.",
    "inspect.oak.2": "참나무. 이 나무에 얽힌 가장 오랜 이야기보다 더 오래됐어요.",
    "inspect.oak.3": "참나무는 왕들이 오고 가는 것을 보아 왔어요.",
    "inspect.oak.4": "한때 참나무는 모두 왕실의 것이었어요.",
    "inspect.oats.1": "귀리예요.",
    "inspect.oats.2": "귀리. 말 먹이, 그리고 아침밥.",
    "inspect.outcrop.1": "너럭바위. 외투를 벗은 땅이에요.",
    "inspect.outcrop.2": "해가 나면 따뜻하고, 밤이면 차가워요.",
    "inspect.outcrop.3": "얼음이 갈고닦았어요.",
    "inspect.peak.1": "산봉우리. 일 년 내내 눈.",
    "inspect.peak.2": "이 위에선 아무것도 자라지 않아요.",
    "inspect.peak.3": "경치가 좋다고들 해요. 안개는 생각이 달라요.",
    "inspect.pebbles.1": "조약돌.",
    "inspect.pebbles.2": "하나하나가 한때는 산이었어요.",
    "inspect.pine.1": "소나무예요.",
    "inspect.pine.2": "여기는 소나무가 먼저였어요.",
    "inspect.pine.3": "소나무는 척박한 땅을 좋아해요. 이 나무는 만족해요.",
    "inspect.pine.4": "소나무는 바람이 시킨 쪽으로 기울어 있어요.",
    "inspect.reeds.1": "갈대.",
    "inspect.reeds.2": "갈대가 속삭여요. 바람일 뿐이에요.",
    "inspect.reeds.3": "저 안에서 무언가 움직였어요. 아마 새일 거예요.",
    "inspect.reindeer.1": "이곳의 순록은 모두 주인이 있어요.",
    "inspect.reindeer.2": "가는 길이에요. 어디로 가는지는 알아요.",
    "inspect.rengarde.1": "가을이면 순록 떼가 이곳에 모여요.",
    "inspect.rengarde.2": "지금은 비어 있어요. 순록은 갈 곳을 알아요.",
    "inspect.rock.1": "바윗돌이에요.",
    "inspect.rock.2": "왜? 바윗돌이에요.",
    "inspect.rock.3": "바윗돌. 별다른 의견은 없어요.",
    "inspect.rock.4": "아무 일도 일어나지 않아요. 바윗돌이니까요.",
    "inspect.rockcarving.1": "바위에 새겼어요, 룬 문자보다 훨씬 전에요.",
    "inspect.rockcarving.2": "우리는 여기 있었다.",
    "inspect.rockcarving.3": "아무도 읽지 못해요. 그래도 무언가 말하고 있어요.",
    "inspect.rootcellar.1": "어둠 속의 감자.",
    "inspect.rootcellar.2": "안은 절대 얼지 않아요.",
    "inspect.rowan.1": "마가목이에요.",
    "inspect.rowan.2": "마가목. 열매가 많으면 눈도 많다고 해요.",
    "inspect.rowan.3": "트롤은 마가목을 피한다고 해요.",
    "inspect.ruin.1": "폐허예요.",
    "inspect.ruin.2": "한때는 누군가의 자랑이었어요.",
    "inspect.ruin.3": "여기 서 있던 것은 사라졌어요. 돌만 남았어요.",
    "inspect.runestone.1": "룬석이에요.",
    "inspect.runestone.2": "누군가 자식을 위해 세운 돌이에요.",
    "inspect.runestone.3": "룬석. 동쪽으로 떠났다고 새겨져 있어요. 돌아오지 못했어요.",
    "inspect.runestone.4": "룬석. 읽을 수 있는 자는 읽어라.",
    "inspect.rye.1": "호밀이에요.",
    "inspect.rye.2": "호밀은 겨울을 서서 나면서도 바라는 게 없어요.",
    "inspect.sauna.1": "사우나예요.",
    "inspect.sauna.2": "사우나. 아직 따뜻해요.",
    "inspect.sauna.3": "문가에 자작나무 가지. 누군가 돌아올 거예요.",
    "inspect.seamark.1": "항로 표지. 뱃사람들이 이걸 보고 키를 잡아요.",
    "inspect.seamark.2": "여기.",
    "inspect.shed.1": "곳간. 연장과 밧줄, 타르 냄새.",
    "inspect.shed.2": "잠겨 있어요. 열쇠는 다른 곳에 있고요.",
    "inspect.shipsetting.1": "돌로 만든 배, 마지막 항해를 위해.",
    "inspect.shipsetting.2": "이 배로 누군가를 떠나보냈어요.",
    "inspect.shipsetting.3": "배 모양 돌무덤. 철기 시대 이후로 움직인 적이 없어요.",
    "inspect.shorestones.1": "물수제비엔 납작한 돌이 제일이에요.",
    "inspect.shorestones.2": "물이 오랫동안 매만져 온 돌이에요.",
    "inspect.smithy.1": "대장간이에요.",
    "inspect.smithy.2": "숯과 쇠 냄새가 나요.",
    "inspect.smithy.3": "트롤은 쇠를 싫어한다고 해요.",
    "inspect.snag.1": "죽었어요. 그래도 서 있어요.",
    "inspect.snag.2": "고사목. 속까지 말라서 불 피우기 좋아요.",
    "inspect.snag.3": "딱따구리들은 아직 미련이 있어요.",
    "inspect.spruce.1": "가문비나무예요.",
    "inspect.spruce.2": "가문비나무 밑은 늘 조금 저녁이에요.",
    "inspect.spruce.3": "발밑엔 바늘잎. 다른 건 자라지 않아요.",
    "inspect.spruce.4": "사철 어둡고, 서두르는 법이 없어요.",
    "inspect.stonecircle.1": "원형 열석. 여기 재판관들이 앉았다고 해요.",
    "inspect.stonecircle.2": "사실은 무덤이에요. 재판관은 이야기일 뿐이에요.",
    "inspect.stonecircle.3": "들어가 보세요. 아니면 말고요.",
    "inspect.stones.1": "손으로 세웠어요. 이유는 아무도 기억하지 못해요.",
    "inspect.stones.2": "선돌. 다들 방금 말을 멈춘 것 같아요.",
    "inspect.stones.3": "선돌은 아직 기다리고 있어요.",
    "inspect.stooks.1": "추수가 끝났어요.",
    "inspect.stooks.2": "곡식 단이 마르는 중. 누군가 가지러 올 거예요.",
    "inspect.stump.1": "그루터기예요.",
    "inspect.stump.2": "누군가 도끼를 들고 다녀갔어요.",
    "inspect.stump.3": "나이테를 세어 보세요. 시간이 있다면요.",
    "inspect.tent.1": "먼저 온 탐험대의 천막.",
    "inspect.tent.2": "그 탐험대는 끝내 돌아오지 않았어요.",
    "inspect.tent.3": "수첩의 마지막 장은 비어 있어요.",
    "inspect.tjardal.1": "타르 가마. 소나무가 들어가고 타르가 흘러나와요.",
    "inspect.tjardal.2": "여기서 나온 타르를 배에 칠했어요.",
    "inspect.tuft.1": "풀.",
    "inspect.tuft.2": "특이 사항 없음. 풀.",
    "inspect.tuft.3": "풀은 누웠다가 다시 일어나요.",
    "inspect.tuft.4": "그냥 풀.",
    "inspect.watermill.1": "물레방아예요.",
    "inspect.watermill.2": "곡식 빻는 일은 물이 해요, 밤낮없이.",
    "inspect.well.1": "우물이에요.",
    "inspect.well.2": "돌을 떨어뜨리고 세어 보세요. 깊어요.",
    "inspect.well.3": "일 년 내내 찬물.",
    "inspect.wellsweep.1": "장대 우물. 들어 올리는 일은 긴 장대가 해요.",
    "inspect.wellsweep.2": "두레박이 올라와요. 누군가 당기면요.",
    "inspect.windmill.1": "풍차예요.",
    "inspect.windmill.2": "풍차가 통째로 바람을 향해 돌아서요.",
    "inspect.windmill.3": "여기서는 바람이 곡식을 빻아요.",
    "inspect.windthrow.1": "뿌리 뽑힌 나무예요.",
    "inspect.windthrow.2": "바람이 한 짓이에요. 뿌리까지 통째로요.",
    "inspect.windthrow.3": "뿌리 뽑힌 나무. 무슨 일이었는지 묻지 마라.",
    "inspect.woodpile.1": "다음 겨울이 쌓여 있어요.",
    "inspect.woodpile.2": "정성껏 쌓았어요. 맨 아래 것은 빼지 마세요.",
    "lang.mist": "안개",
    "lang.name": "한국어",
    "lesson.cabinText": "오두막에서 시작해요. 탐험한 땅 옆의 칸을 탭하면 안개가 걷혀요. 동그라미 친 칸부터 해 보세요.",
    "lesson.cabinTextMouse": "오두막에서 시작해요. 탐험한 땅 옆의 칸을 클릭하면 안개가 걷혀요. 동그라미 친 칸부터 해 보세요.",
    "lesson.cabinTitle": "오두막",
    "lesson.done": "완료",
    "lesson.endDistance": "오두막에서 {distance} 떨어진 곳까지 왔어요. 이 거리가 결과예요. 멀리 갈수록 좋아요.",
    "lesson.endText": "숫자가 세는 존재에 모두 깃발이 꽂히면 그 숫자는 사라져요. 존재를 깨우면 탐험이 끝나요.",
    "lesson.endTitle": "준비 완료",
    "lesson.invite": "먼저 게임을 배워 보세요. 1분이면 돼요. 친구들이 기다리고 있어요.",
    "lesson.noCreature": "거기에는 잠든 존재가 없어요.",
    "lesson.numberHold": "그 칸을 길게 눌러 깃발을 꽂으세요.",
    "lesson.numberMode": "또는 깃발 모드를 켜고 그 칸을 탭하세요.",
    "lesson.numberMouse": "그 칸을 오른쪽 클릭해 깃발을 꽂으세요.",
    "lesson.numberText": "숫자는 주변 여덟 칸에 숨어 있는 존재의 수예요. 이 1은 안개 속에 남은 칸이 하나뿐이에요. 그러니 거기에 존재가 하나 잠들어 있어요.",
    "lesson.numberTitle": "숫자",
    "lesson.ownText": "찾아낸 2는 안개 속에 남은 칸이 두 개예요. 두 칸 모두에 깃발을 꽂으세요.",
    "lesson.ownTitle": "이제 혼자서",
    "lesson.safeText": "이 1이 세는 존재는 이미 찾았어요. 그러니 주변에 남은 다른 칸은 안전해요. 그 칸을 탐험하세요.",
    "lesson.safeTitle": "안전한 땅",
    "lesson.woke": "거기에 존재가 잠들어 있었어요. 다시 해 보세요.",
    "list.add": "추가",
    "list.addBody": "이름과 탐험은 mistsweeper.com에서도 앱에서도 누구나 볼 수 있어요. 앞으로는 매일 탐험이 끝나면 자동으로 추가돼요. 설정에서 끌 수 있어요.",
    "list.addTitle": "이름 추가하기",
    "list.as": "{name} 이름으로",
    "list.countSoFar": "지금까지 탐험가 {count}명",
    "list.countSoFarOne": "지금까지 탐험가 {count}명",
    "list.empty": "오늘은 아직 목록에 아무도 없어요. 첫 번째 탐험가가 될 수 있어요.",
    "list.errorAlready": "여기서 추가한 탐험이 이미 오늘의 목록에 있어요.",
    "list.errorBlocked": "여기서는 더 이상 탐험을 추가할 수 없어요.",
    "list.errorBusy": "여기서 보낸 요청이 한꺼번에 너무 많아요. 몇 분 후 다시 시도해 주세요.",
    "list.errorClosed": "이 탐험의 목록에는 이제 추가할 수 없어요.",
    "list.errorName": "글자, 숫자, 공백으로 2~20자를 입력하세요.",
    "list.errorOther": "목록에 연결할 수 없어요. 다시 시도해 주세요.",
    "list.errorRefused": "이 이름은 쓸 수 없어요. 다른 이름을 입력해 보세요.",
    "list.hiddenName": "이름 숨김",
    "list.loading": "오늘의 최고의 탐험가를 불러오고 있어요.",
    "list.nameLabel": "이름",
    "list.notAdded": "목록에 없음",
    "list.placeSoFar": "지금까지 {count}명 중 {place}위",
    "list.remove": "제거",
    "list.removeBody": "여기서 추가한 탐험은 모두 목록에서 사라져요. 탐험 기록에는 그대로 남아요.",
    "list.removeTitle": "목록에서 탐험을 제거할까요?",
    "list.renameBody": "지금까지 추가한 모든 탐험에서 이름이 바뀌어요.",
    "list.renameTitle": "목록에 표시할 이름",
    "list.report": "신고",
    "list.reportBody": "여러 플레이어가 신고한 이름은 저희가 확인할 때까지 숨겨져요.",
    "list.reportTitle": "이 이름을 신고할까요?",
    "list.tiles": "{tiles}칸",
    "list.unreachable": "지금은 목록에 연결할 수 없어요. 잠시 후 다시 시도해 주세요.",
    "list.waiting": "추가 대기 중",
    "list.you": "나",
    "list.yours": "나의 탐험",
    "menu.about": "Mistsweeper 소개",
    "menu.apps": "Great Scott!의 다른 앱",
    "menu.appsLine": "Ordna, Krono, Tapotron, Color Tap",
    "menu.back": "메뉴로 돌아가기",
    "menu.close": "메뉴 닫기",
    "menu.expeditions": "탐험 기록",
    "menu.expeditionsLine": "연속 {streak}, 최고 {distance}",
    "menu.feedback": "피드백 보내기",
    "menu.getApp": "iOS 앱 받기",
    "menu.getAppLine": "알림과 햅틱, 베타 버전",
    "menu.howto": "플레이 방법",
    "menu.howtoLine": "규칙과 조작법",
    "menu.list": "최고의 탐험가",
    "menu.listLine": "오늘 가장 멀리 간 사람들",
    "menu.privacy": "개인정보 처리방침",
    "menu.settingsLine": "{theme} 테마, {language}",
    "menu.version": "버전 {version} · Great Scott! AB",
    "mode.daily": "탐험 #{n}",
    "mode.endless": "무한",
    "mode.endlessBest": "무한, 최고 {distance}",
    "note.banner": "깃발을 꽂았어요.",
    "note.bannerOff": "깃발 모드 끔.",
    "note.bannerOn": "깃발 모드 켬.",
    "note.cabin": "오두막으로 돌아왔어요.",
    "note.clearing": "나의 빈터. 발견한 것들을 배치해 보세요.",
    "note.copied": "클립보드에 복사했어요.",
    "note.endless": "무한. 매번 새로운 세계.",
    "note.listRemoved": "목록에서 제거했어요.",
    "note.listReported": "이름을 신고했어요.",
    "note.north": "다시 북쪽이 위예요.",
    "note.today": "오늘의 탐험.",
    "note.todayPractice": "오늘의 탐험, 연습으로.",
    "over.bergstroll": "산트롤을 깨웠다.",
    "over.bergstrollLine": "산트롤은 돌 틈에 어찌나 가만히 앉아 있는지, 다들 돌인 줄 안다.",
    "over.copied": "클립보드에 복사됨",
    "over.endlessRuns": "무한 탐험 횟수",
    "over.furthestLabel": "가장 먼 지점",
    "over.huldra": "훌드라가 나무 사이에서 기다리고 있었다.",
    "over.huldraLine": "뒤돌아서기 전까지는 젊은 여인처럼 보인다. 그녀를 따라 숲에 들어간 사람은 그곳에 남는다.",
    "over.jatte": "산에서 거인이 일어섰다.",
    "over.jatteLine": "거인은 어깨를 땅 위로 드러낸 채 산속에서 잠든다. 그중 하나 위에 서 있었던 것이다.",
    "over.jatteMeadow": "안개 속에서 거인이 걸어 나왔다.",
    "over.jatteMeadowLine": "거인은 오두막에서 멀리 떨어진 너른 땅을 걷는다. 다가오는 소리는 아무도 듣지 못한다.",
    "over.kickerDaily": "탐험 #{n}, {dateShort}",
    "over.kickerEndless": "무한",
    "over.kickerPractice": "탐험 #{n} 연습",
    "over.kickerTogether": "무한, 함께",
    "over.memberLine": "{tiles}, {distance}",
    "over.nacken": "네켄이 물가에서 기다리고 있었다.",
    "over.nackenLine": "네켄은 고요한 물가에서 연주한다. 걸음을 멈추고 귀 기울인 사람은 더는 걸어가지 못한다.",
    "over.newWorld": "새로운 세계 탐험하기",
    "over.practiceBoard": "오늘의 지도로 연습하기",
    "over.setOutAgain": "다시 출발",
    "over.share": "공유",
    "over.shared": "공유됨",
    "over.sjotroll": "호수트롤을 깨웠다.",
    "over.sjotrollLine": "작은 섬인 줄 알았던 것에 눈이 있었다.",
    "over.skogstroll": "숲트롤을 깨웠다.",
    "over.skogstrollLine": "숲트롤은 가문비나무가 가장 빽빽한 곳의 이끼 밑에서 잠든다. 누가 깨우는 것을 몹시 싫어한다.",
    "over.streak": "연속 기록",
    "over.streakDay": "{days}일",
    "over.streakDays": "{days}일",
    "over.title": "안개 속에서 무언가 움직였다.",
    "over.todayResult": "오늘의 결과",
    "over.todayWaiting": "오늘의 탐험이 아직 기다리고 있어요",
    "over.togetherBest": "함께한 최고 기록",
    "over.togetherMembers": "탐험가",
    "over.yourBest": "최고 기록",
    "party.away": "자리 비움",
    "party.back": "다시 함께예요.",
    "party.cardLine": "{status}, {tiles}, {distance}",
    "party.copied": "링크를 복사했어요.",
    "party.fell": "지켜보는 중",
    "party.follow": "따라가기",
    "party.following": "{name}님을 따라가는 중",
    "party.full": "그 탐험은 인원이 다 찼어요.",
    "party.guest": "탐험가 {n}",
    "party.invite": "친구 초대",
    "party.inviteBody": "링크를 보내거나 QR 코드를 보여 주세요. 참여한 사람은 이 탐험의 오두막으로 와서 함께해요. 최대 {n}명까지.",
    "party.inviteTitle": "함께 탐험하기",
    "party.join": "참여하기",
    "party.joinBody": "안개 속으로 {distance} 나아간 탐험. 존재를 만난 사람은 나머지 동료를 지켜봐요.",
    "party.joinTitle": "{name}님의 초대",
    "party.joinTitleAnon": "탐험 초대",
    "party.joined": "{name}님이 합류했어요.",
    "party.leave": "탐험에서 나가기",
    "party.lock": "새 탐험가 받지 않기",
    "party.locked": "그 탐험은 새 탐험가를 받지 않아요.",
    "party.lockedNote": "새 탐험가를 받지 않아요.",
    "party.lost": "연결이 끊겼어요. 동료를 다시 찾는 중이에요.",
    "party.memberFell": "{name}님이 떨어졌어요.",
    "party.memberRemoved": "{name}님은 더 이상 탐험에 없어요.",
    "party.members": "탐험 동료",
    "party.notNow": "나중에",
    "party.openNote": "새 탐험가를 받아요.",
    "party.out": "안개 속",
    "party.over": "그 탐험은 끝났어요.",
    "party.qrLabel": "이 탐험으로 가는 링크의 QR 코드",
    "party.remove": "탐험에서 내보내기",
    "party.removeAsk": "{name}님을 탐험에서 내보낼까요? 링크로 다시 들어올 수 없어요.",
    "party.removed": "더 이상 그 탐험에 참여하고 있지 않아요.",
    "party.share": "링크 공유",
    "party.shareText": "안개 속 탐험에 함께해요.",
    "party.tiles": "{n}칸",
    "party.tiles1": "1칸",
    "party.unavailable": "시작하지 못했어요. 잠시 후 다시 시도하세요.",
    "party.unfollow": "따라가기 중지",
    "party.unlock": "새 탐험가 받기",
    "party.you": "나",
    "party.youFell": "떨어졌어요. 이제 동료를 지켜봐요.",
    "party.youNamed": "{name} (나)",
    "party.yourName": "이름",
    "placeholder.store": "[App Store 링크]",
    "privacy.cloudApp": "Mistsweeper의 iCloud가 켜져 있으면 설정, 탐험, 빈터, 그리고 장소마다 카메라를 둔 위치가 내 iCloud에도 저장되어, iPhone에서도 iPad에서도 이어서 할 수 있어요. 읽을 수 있는 건 내 Apple 계정뿐이에요. 저희는 읽을 수 없어요. 앱을 삭제해도 iCloud에는 남아 있어요. 설정 앱의 iCloud에서 지울 수 있어요.",
    "privacy.cloudTitleApp": "iCloud에 저장되는 정보",
    "privacy.contact": "Mistsweeper는 스웨덴 스톡홀름의 Great Scott! AB에서 만들어요. 개인정보에 관한 질문이 있으면 연락 주세요.",
    "privacy.contactTitle": "문의",
    "privacy.gameCenterApp": "이 기기에서 Game Center에 로그인되어 있으면, 앱은 매일의 탐험에서 도달한 거리와 무한 탐험의 최장 기록을 Apple에 보내요. 이 기록은 게임의 Game Center 순위표에 내 Game Center 이름으로, 내 Game Center 설정이 허용하는 사람에게 표시돼요. 게임은 내 이름이나 친구를 읽지 않고, Game Center의 어떤 정보도 저장하지 않아요. 로그인되어 있지 않으면 아무것도 보내지 않아요. 설정 앱의 Game Center에서 로그아웃할 수 있어요.",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "이 사이트는 Cloudflare를 통해 제공돼요. 여느 웹 호스팅 업체처럼 Cloudflare는 사이트를 보내기 위해 IP 주소를 받으며, 서비스를 안전하게 지키기 위해 자체 로그에 짧은 기간 보관할 수 있어요. 저희는 따로 로그를 남기지 않아요.",
    "privacy.hostTitle": "호스팅",
    "privacy.intro": "Mistsweeper는 데이터를 모으기 위한 게임이 아니라 즐기기 위한 게임이에요. 보관하는 정보는 아래에 적은 것이 전부예요.",
    "privacy.list": "이름으로 탐험을 추가하거나 이름을 신고하기 전에는 나에 관한 정보가 전송되지 않아요. 목록에서의 순위는 모두가 받는 같은 응답을 바탕으로 내 기기에서 계산돼요. 탐험을 추가하면 이름, 탭 기록과 결과가 담긴 탐험, 추가한 시각, 웹과 앱 중 어디서 왔는지, 그리고 기기가 만드는 코드를 변환한 값을 저장해요. 이 정보는 Cloudflare에 저장되고, 이름과 탐험은 mistsweeper.com과 앱에서 모두에게 보여요. 그다음부터는 설정에서 끌 때까지 매일의 탐험이 자동으로 추가돼요. 목록을 공정하고 기분 좋게 유지하기 위해, 저희는 추가된 내용을 읽고, 이름이나 탐험을 숨기거나 삭제하고, 기기가 더 추가하지 못하게 막을 수 있어요. 이름은 누구나 신고할 수 있고, 신고에는 보낸 기기의 코드를 같은 방식으로 변환한 값이 저장돼요. 악용을 막기 위해 같은 주소에서 온 요청은 변환된 형태로 10분 동안 세고, 어디에도 기록하지 않아요.",
    "privacy.listRemove": "추가한 내용은 직접 제거할 때까지 남아 있어요. 설정의 ‘목록에서 탐험 제거하기’를 쓰면 그곳에서 추가한 내용이 모든 목록에서 삭제돼요. 브라우저와 앱은 각자 자기 것을 제거해요. 변환된 코드는 다른 기기가 탐험을 자동으로 다시 추가하지 못하도록 며칠 동안 남고, 내가 한 신고에도 남아 있어요. 기기가 더 이상 없다면 저희에게 연락해 주세요. 저희가 삭제해 드릴게요. 저희가 나에 관해 무엇을 보관하는지는 언제든 물어볼 수 있어요.",
    "privacy.listRemoveTitle": "목록에서 나가기",
    "privacy.none": "계정도, 광고도, 추적도, 쿠키도 없어요. 개인정보를 판매하거나 공유하지 않고, 최고의 탐험가에 추가하거나 함께 탐험할 때 보내는 것 외에는 수집하지 않아요.",
    "privacy.noneTitle": "저희가 하지 않는 것",
    "privacy.share": "결과를 공유할 때 텍스트를 어디로 보낼지는 직접 정해요. App Store와 이메일 링크는 게임 밖에서 열려요.",
    "privacy.shareTitle": "공유와 링크",
    "privacy.stored": "설정, 탐험, 결과는 이 브라우저의 로컬 저장소에 저장되어, 멈춘 곳에서 이어서 할 수 있어요. 이 정보는 기기에 남고, 최고의 탐험가에 탐험을 추가할 때만 저희에게 전송돼요. 브라우저에서 이 사이트의 데이터를 지우면 여기서 삭제돼요.",
    "privacy.storedApp": "설정, 탐험, 결과는 이 기기의 앱 안에 저장되어, 멈춘 곳에서 이어서 할 수 있어요. 최고의 탐험가에 탐험을 추가할 때만 저희에게 전송돼요. 앱을 삭제하면 이 기기에서 함께 지워져요.",
    "privacy.storedTitle": "브라우저에 저장되는 정보",
    "privacy.storedTitleApp": "기기에 저장되는 정보",
    "privacy.title": "개인정보 보호",
    "privacy.together": "다른 사람을 초대하거나 링크로 탐험에 참여하면, 함께 노는 동안 탐험이 Cloudflare에 저장돼요. 탐험의 탭, 동료마다 고른 이름과 깃발, 그리고 각 브라우저가 자기 자리로 돌아오기 위해 간직하는 코드예요. 동료마다 카메라가 어디를 보는지는 노는 동안 다른 동료에게 전달될 뿐 저장되지 않아요. 게임이 잘 돌아가고 공정하도록, 저희는 함께한 탐험을 보고, 진행 중인 탐험을 지켜보고, 다시 재생할 수 있어요. 탐험에 관한 모든 것은 마지막으로 플레이한 지 일주일 뒤에 삭제돼요.",
    "privacy.togetherTitle": "함께 탐험하기",
    "privacy.updated": "2026년 11월 1일 업데이트",
    "privacy.updatedApp": "2026년 11월 1일 업데이트",
    "privacy.usageApp": "iOS 앱은 어떻게 사용되는지 알기 위해 독일의 개인정보 보호 중심 분석 서비스 TelemetryDeck을 사용해요. 서버는 EU에 있어요. 세션이 시작될 때, 탐험이 시작되거나 끝날 때, 결과를 공유할 때, 빈터를 열 때를 집계해요. 각 집계에는 앱 버전, 게임 언어, 기기 모델, 시스템, 화면, 설정 같은 기기 정보와 이 기기의 앱을 나타내는 코드가 함께 담겨요. 이 코드는 보내기 전에 되돌릴 수 없게 변환되므로 사용자를 알아낼 수 없어요. IP 주소는 저장하지 않으며, 결과나 사용자가 누구인지에 관한 정보는 보내지 않아요.",
    "privacy.usageTitleApp": "앱 사용 집계",
    "privacy.visits": "방문자 수를 알기 위해 EU에서 호스팅되는 개인정보 보호 중심의 분석 서비스 Plausible을 사용해요. Plausible은 쿠키를 쓰지 않고 개인정보도 보관하지 않으며, 방문 수, 국가, 브라우저, 여기로 연결해 준 사이트 같은 전체 통계만 남겨요. IP 주소는 저장하지 않아요.",
    "privacy.visitsTitle": "방문 집계",
    "punct.comma": ", ",
    "punct.join": "{first} {next}",
    "punct.period": ".",
    "reminder.body": "탐험 #{n}, 안개 속에서 기다리고 있어요.",
    "sealed.body": "탐험하는 사이에 날짜가 바뀌었어요. 결과({distance})는 저장해 두었어요. 연습으로 계속 탐험할 수 있어요.",
    "sealed.next": "탐험 #{n} 출발",
    "sealed.title": "탐험 #{n}의 하루가 끝났어요.",
    "settings.appPromo": "알림과 햅틱은 지금 베타인 iOS 앱에서 쓸 수 있어요.",
    "settings.debug": "프레임 시간 표시",
    "settings.developer": "개발자",
    "settings.feel": "감각",
    "settings.haptics": "햅틱",
    "settings.hapticsLine": "칸을 탐험하거나 깃발을 꽂을 때 느껴지는 작은 진동.",
    "settings.language": "언어",
    "settings.languageAuto": "자동",
    "settings.languageAutoLine": "시스템 설정 따름: {language}",
    "settings.languageDraft": "초안",
    "settings.listAuto": "탐험 자동 추가",
    "settings.listAutoLine": "매일 탐험이 끝나면 목록에 추가돼요.",
    "settings.listName": "목록에 표시되는 이름",
    "settings.listNote": "탐험이 끝나면 오늘의 목록에 추가해 보세요.",
    "settings.listRemove": "목록에서 탐험 제거하기",
    "settings.motion": "동작 줄이기",
    "settings.motionLine": "안개가 멈추고, 새 땅이 바로 나타나며, 세계의 가장자리가 선명하게 남아요. 직접 바꾸기 전까지는 시스템 설정을 따라요.",
    "settings.music": "음악",
    "settings.musicLine": "탐험하는 동안 숲에서 들려오는 잔잔한 선율.",
    "settings.remind": "매일 알림",
    "settings.remindDay": "낮",
    "settings.remindDenied": "Mistsweeper 알림이 꺼져 있어요. 탭해서 설정에서 허용하세요.",
    "settings.remindEarlier": "{n}분 일찍",
    "settings.remindEvening": "저녁",
    "settings.remindLater": "{n}분 늦게",
    "settings.remindLine": "오늘의 탐험이 아직 기다리고 있으면 {time}에 알려 드려요.",
    "settings.remindNext": "새 탐험 {time}",
    "settings.remindNight": "새벽",
    "settings.remindTime": "알림 시간",
    "settings.reminders": "알림",
    "settings.sounds": "효과음",
    "settings.soundsLine": "탐험, 깃발, 존재마다 들리는 소리.",
    "settings.theme": "테마",
    "settings.themeAuto": "자동",
    "settings.themeAutoLine": "시스템 설정 따름: 라이트 모드에서는 낮, 다크 모드에서는 밤",
    "settings.themeSupporter": "서포터에서 선택함",
    "settings.tilt": "틸트 시프트",
    "settings.title": "설정",
    "settings.zoom": "확대/축소",
    "start.continue": "계속하기, {distance}",
    "start.endlessLine": "매번 새로운 세계를, 원할 때마다.",
    "start.setOut": "출발",
    "start.tagDistance": "#{n}, {distance}",
    "start.tagDone": "#{n}, 완료, {distance}",
    "start.tagNew": "#{n}, 새 탐험",
    "start.tagNewDate": "#{n}, {dateShort}, 새 탐험",
    "start.tagProgress": "#{n}, 진행 중, {distance}",
    "start.todayDone": "오늘의 탐험을 마쳤어요. 다음 탐험까지 {time}.",
    "start.todayDoneShort": "다음 탐험까지 {time}.",
    "start.todayInProgress": "진행 중이에요. 멈춘 곳에서 이어 가세요.",
    "start.todayInProgressShort": "멈춘 곳에서 이어 가세요.",
    "start.todayNew": "{dateLong}. 기회는 한 번, 모두에게 같은 땅.",
    "start.todayNewShort": "기회는 한 번, 모두에게 같은 땅.",
    "support.devices": "iCloud가 켜져 있으면 앱이 탐험과 빈터를 다른 기기로 가져다줘요. 브라우저에서는 그 브라우저에만 남아요.",
    "support.devicesTitle": "새 기기",
    "support.intro": "Mistsweeper는 스톡홀름의 작은 스튜디오가 만들어요. 문제가 있거나 궁금한 점이 있으면 메일을 보내 주세요.",
    "support.list": "{settings}의 {remove}로 모든 목록에서 탐험을 지울 수 있어요. 이름을 신고하려면 해당 행을 길게 누르거나, 컴퓨터에서는 오른쪽 클릭하세요.",
    "support.listTitle": "{list} 목록의 내 이름",
    "support.purchase": "구입은 Apple 계정에 연결되어 있어요. 앱 메뉴에서 {supporter}를 열고 {restore}을 선택하세요.",
    "support.purchaseTitle": "구입 내역이 보이지 않을 때",
    "support.title": "지원",
    "supporter.accent": "강조 색상",
    "supporter.accentLine": "깃발의 색이에요.",
    "supporter.accentNumber": "색상 {n}",
    "supporter.banner": "깃발",
    "supporter.banners": "깃발",
    "supporter.bannersLine": "모든 탐험에서 다른 깃발을 꽂을 수 있어요.",
    "supporter.buy": "서포터 되기, {price}",
    "supporter.buyLine": "한 번만 구입하며, 구독이 아니에요. 가족 공유로 가족도 함께 쓸 수 있어요.",
    "supporter.buyNoPrice": "서포터 되기",
    "supporter.cabin": "나의 오두막",
    "supporter.cabinLine": "찾은 집을 모든 탐험과 모든 빈터에서 오두막 자리에 세울 수 있어요.",
    "supporter.chooseCabin": "빈터에서 고르기",
    "supporter.clearingLocked": "이 빈터는 서포터만 바꿀 수 있어요.",
    "supporter.clearings": "빈터",
    "supporter.clearingsLine": "15×15칸의 더 넓은 빈터와, 원하는 만큼의 빈터를 가질 수 있어요.",
    "supporter.failed": "구입하지 못했어요. 잠시 후 다시 시도해 주세요.",
    "supporter.free": "플레이하는 모든 것은 무료이고, 앞으로도 무료예요.",
    "supporter.icon": "앱 아이콘",
    "supporter.icons": "앱 아이콘",
    "supporter.iconsLine": "홈 화면의 아이콘을 골라 보세요. 아이콘마다 밝은 모습과 어두운 모습이 있어요.",
    "supporter.lead": "서포터가 되면 화면에 보이는 게임의 모습을 고를 수 있고, Mistsweeper를 계속 만드는 데 힘이 돼요.",
    "supporter.line": "테마, 앱 아이콘, 깃발, 오두막",
    "supporter.nothingToRestore": "이 Apple 계정에서 서포터 구입 내역을 찾지 못했어요.",
    "supporter.pending": "승인을 기다리고 있어요. 구입이 승인되면 바로 서포터가 돼요.",
    "supporter.restore": "구입 복원",
    "supporter.since": "{date}부터 서포터",
    "supporter.thanks": "Mistsweeper를 응원해 주셔서 고마워요. 여기에서 화면에 보이는 게임의 모습을 고를 수 있어요.",
    "supporter.theme": "테마",
    "supporter.themeLine": "낮, 밤, 자동은 설정에 있어요.",
    "supporter.themes": "테마",
    "supporter.themesLine": "게임 전체를 다른 색으로 즐길 수 있어요. 일부 테마에서는 깃발 색도 고를 수 있어요.",
    "supporter.unreachable": "App Store에 연결할 수 없어요. 잠시 후 다시 시도해 주세요.",
    "theme.day": "낮",
    "theme.fjord": "피오르",
    "theme.mossa": "이끼",
    "theme.night": "밤",
    "theme.pergament": "양피지",
    "theme.rosa": "분홍",
    "theme.skymning": "황혼",
    "time.hoursMinutes": "{h}시간 {m}분",
    "time.minutes": "{m}분",
    "webgl.missing": "Mistsweeper에는 WebGL 2가 필요하지만, 이 브라우저는 지원하지 않아요.",
    "welcome.mistDaily": "매일 새로운 탐험이 찾아와요. 모두에게 같은 땅이고, 기회는 한 번이에요. 한가로운 시간에는 무한 탐험이 있어요.",
    "welcome.mistNumbers": "숫자는 주변 여덟 칸에 숨어 있는 존재의 수예요. 존재가 잠든 것 같은 곳에 깃발을 꽂고 계속 나아가세요.",
    "welcome.mistText": "숲속 빈터에 있는 오두막에서 시작해요. 그 밖은 모두 안개예요. 탐험한 땅에서부터 한 번에 한 칸씩 탐험하세요.",
    "welcome.mistTitle": "안개 속으로",
    "welcome.next": "다음",
    "welcome.remindNo": "나중에",
    "welcome.remindText": "새로운 탐험은 매일 찾아와요. 시간을 고르면 오늘의 탐험이 아직 기다리고 있을 때 알려 드릴게요. 설정에서 바꿀 수 있어요.",
    "welcome.remindTitle": "매일 알림",
    "welcome.remindYes": "알림 받기",
    "welcome.skip": "건너뛰기",
    "welcome.starsLater": "조금 뒤에 어떻게 생각하는지 물어볼게요. 그때 잠깐 시간을 내 주시면 큰 도움이 돼요.",
    "welcome.starsText": "Mistsweeper는 스톡홀름의 작은 스튜디오 Great Scott!에서 만들었어요. 작은 게임이 더 많은 사람에게 알려지려면 App Store 평가가 가장 큰 힘이 돼요.",
    "welcome.starsTitle": "작은 스튜디오가 만든 게임",
    "welcome.step": "{total}단계 중 {n}단계",
    "widget.bestDay": "하루 최고 {distance}",
    "widget.clearingDescription": "내 빈터와 지금까지 찾은 것, 최고 기록을 보여 줘요.",
    "widget.clearingName": "내 빈터",
    "widget.description": "오늘의 탐험을 떠났던 모습 그대로, 연속 기록과 함께 보여 줘요.",
    "widget.next": "다음까지 {time}",
    "widget.streak": "연속 기록 {days}",
    "widget.waiting": "출발 전",
  },
  sv: {
    "a11y.bannerMode": "Fanläge",
    "a11y.board.banner": "Fana",
    "a11y.board.bannerRemoved": "Fanan är borttagen.",
    "a11y.board.banners1": "1 fana",
    "a11y.board.bannersN": "{n} fanor",
    "a11y.board.cabin": "Stugan",
    "a11y.board.cellBanner": "fana",
    "a11y.board.cellCabin": "stuga",
    "a11y.board.cellExplored": "utforskad",
    "a11y.board.cellMist": "dimma",
    "a11y.board.cellWrongBanner": "fel fana",
    "a11y.board.chordWaits": "Fanorna runt den stämmer inte med siffran.",
    "a11y.board.chosen": "Valt: {name}.",
    "a11y.board.confirmed": "Bekräftad",
    "a11y.board.creature": "Ett väsen",
    "a11y.board.deepMist": "Djup dimma",
    "a11y.board.describe": "Beskriv omgivningen",
    "a11y.board.dirEast": "Öster",
    "a11y.board.dirNorth": "Norr",
    "a11y.board.dirSouth": "Söder",
    "a11y.board.dirWest": "Väster",
    "a11y.board.east": "{n} öster",
    "a11y.board.explore": "Utforska runt den",
    "a11y.board.explored": "Utforskad",
    "a11y.board.exploredOn": "Utforskad, {what}",
    "a11y.board.frontier0": "Ingen dimma att utforska",
    "a11y.board.frontier1": "1 ruta dimma att utforska",
    "a11y.board.frontierN": "{n} rutor dimma att utforska",
    "a11y.board.furthest": "Längst bort {distance}.",
    "a11y.board.hid": "Gömde sig här",
    "a11y.board.hintExplore": "Utforskar rutorna runt den.",
    "a11y.board.hintPlant": "Sätter en fana.",
    "a11y.board.hintReveal": "Utforskar rutan.",
    "a11y.board.hintTakeAway": "Tar bort fanan.",
    "a11y.board.inMist": "{n} i dimma",
    "a11y.board.inView": "{what} i bild",
    "a11y.board.listAnd": "{list} och {last}",
    "a11y.board.mist": "Dimma",
    "a11y.board.nextTo": "Intill {numbers}",
    "a11y.board.north": "{n} norr",
    "a11y.board.place": "{where} om stugan, {distance}",
    "a11y.board.plant": "Sätt en fana",
    "a11y.board.revealed1": "Utforskade 1 ruta.",
    "a11y.board.revealedN": "Utforskade {n} rutor.",
    "a11y.board.rotorBanners": "Fanor",
    "a11y.board.rotorMist": "Dimma att utforska",
    "a11y.board.rotorNorthSouth": "Norr och söder",
    "a11y.board.rotorNumbers": "Öppna siffror",
    "a11y.board.roundIt": "{what} runt den",
    "a11y.board.rowHere": "Här: {tiles}.",
    "a11y.board.rowNorth": "Norr: {tiles}.",
    "a11y.board.rowSouth": "Söder: {tiles}.",
    "a11y.board.south": "{n} söder",
    "a11y.board.takeAway": "Ta bort fanan",
    "a11y.board.turned": "Vriden.",
    "a11y.board.west": "{n} väster",
    "a11y.board.woke": "Vaknade här och avslutade expeditionen",
    "a11y.board.wrongBanner": "Fel fana",
    "a11y.distance": "Längsta avstånd",
    "a11y.find": "Nytt fynd: {name}.",
    "a11y.findMore": "Nya fynd: {name} och {n} till.",
    "a11y.map": "Expeditionskarta",
    "about.body1": "Bortom stugan börjar dimman, och i dimman bor de gamla: troll under mossan, huldran bland träden, näcken vid stilla vatten.",
    "about.body2": "Mistsweeper handlar om att läsa marken innan du kliver på den. Siffrorna säger hur många väsen som sover runt omkring. Hur långt du kommer är upp till dig.",
    "about.body3": "Mistsweeper är en ny tolkning av klassikern Röj, Minesweeper på engelska, inspirerad av nordisk mytologi och folksagor.",
    "about.made": "Gjort av Great Scott! i Stockholm, Sverige.",
    "about.version": "Version {version}",
    "accessibility.contact": "Om något hindrar dig från att spela, eller skulle göra spelet lättare för dig, skriv till oss.",
    "accessibility.contactTitle": "Berätta för oss",
    "accessibility.contrast": "Världen och menyerna är tecknade med bläck på papper, med en kontrast långt över vad text behöver, både på dagen och på natten. Rött markerar det viktiga men aldrig ensamt: en fana har sin form, en fel fana efter en expedition får ett kryss och rutan där den tog slut får en ram.",
    "accessibility.contrastTitle": "Kontrast och färg",
    "accessibility.dark": "Spelet följer systemets mörka läge: Natt är världen i månsken. Du kan också välja Dag eller Natt under Inställningar, Tema.",
    "accessibility.darkTitle": "Mörkt och ljust",
    "accessibility.intro": "Mistsweeper ska gå att spela för så många som möjligt. Här är vad spelet klarar i dag, på webben och i iOS-appen, och vad vi arbetar med.",
    "accessibility.keys": "På webben kan hela spelet spelas med tangentbordet: piltangenterna eller WASD flyttar markören, Enter eller mellanslag utforskar en ruta, F sätter eller tar bort en fana, Q och E vrider kameran, T och G lutar den, plus och minus zoomar, H går tillbaka till stugan och Escape stänger det som är öppet.",
    "accessibility.keysTitle": "Tangentbord på webben",
    "accessibility.motion": "När Minska rörelse är på i systemet, eller spelets egen knapp under Inställningar, rör sig ingenting av sig självt. Dimman, vinden, djuren och kameran står still, ny mark syns direkt och världens kanter är skarpa.",
    "accessibility.motionTitle": "Minska rörelse",
    "accessibility.sound": "Ljud och musik berättar aldrig något som du inte också kan se. Spelet har inget tal och ingen video. I iOS-appen följer haptiken när du utforskar och sätter fanor. Musik, ljud och haptik kan var för sig stängas av under Inställningar.",
    "accessibility.soundTitle": "Ljud",
    "accessibility.title": "Tillgänglighet",
    "accessibility.updated": "Uppdaterad 25 oktober 2026",
    "accessibility.work": "I iOS-appen går kartan att läsa och spela med VoiceOver och Röststyrning, och texten följer din textstorlek. På webben har menyerna och knapparna etiketter för skärmläsare, men kartan går ännu inte att läsa eller spela med en. Vi arbetar på det.",
    "accessibility.workTitle": "Det här arbetar vi med",
    "app.tagline": "En oändlig expedition",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "En målarbok i pixelkonst, utan annonser och spårning.",
    "apps.intro": "Små spel och appar från samma studio.",
    "apps.krono": "Lägg historia, popkultur och musik i rätt ordning på en tidslinje.",
    "apps.ordna": "Ett tyst sorteringspussel. Tusen stycken, och inga avbrott.",
    "apps.tapotron": "Spel och beats på ett rutnät av ivriga knappar.",
    "archive.appNoteCloud": "Sparas i iCloud, på alla dina enheter.",
    "archive.appNoteDevice": "Sparas på den här enheten. Slå på iCloud för Mistsweeper så finns de på alla dina enheter.",
    "archive.best": "ditt rekord",
    "archive.daily": "Dagliga expeditioner",
    "archive.dayStreak": "Dagar i rad",
    "archive.endlessBest": "Rekord",
    "archive.endlessLast": "Senaste",
    "archive.endlessRuns": "Rundor",
    "archive.expeditions": "Expeditioner",
    "archive.gameCenter": "Jämför med vänner i Game Center",
    "archive.notPlayed": "inte spelad",
    "archive.sealed": "förseglad",
    "archive.today": "idag, påbörjad",
    "archive.todayWord": "idag",
    "archive.webNote": "Sparat i den här webbläsaren. iOS-appen har sina egna expeditioner, i iCloud.",
    "archive.webNoteShort": "Sparat i den här webbläsaren.",
    "banner.1": "Tre spetsar",
    "banner.a1": "Svalstjärt",
    "banner.a3": "Spjutspets",
    "banner.b1": "Kvarts­cirkel",
    "banner.b2": "Korpfana",
    "banner.b3": "Halvrund",
    "banner.c2": "T-stav",
    "banner.c3": "Vägmärke",
    "banner.c4": "Vriden",
    "beta.bugs": "Krånglar något, eller ser något konstigt ut? Skriv vad du gjorde, vad som hände och på vilken enhet. Skicka gärna med en skärmbild.",
    "beta.bugsTitle": "Buggar",
    "beta.changes": "Spelet ändras under betan. När det släpps fortsätter expeditionerna där de är, utan att börja om från #1.",
    "beta.changesTitle": "Det här ändras",
    "beta.intro": "Mistsweeper går att spela, men det är inte färdigt. Innan spelet släpps behöver vi hjälp av dig som spelar.",
    "beta.language": "Spelet finns på nio språk, och de flesta översättningarna har ännu inte lästs av någon med språket som modersmål. Låter något fel eller stelt? Skriv var du såg det och hur du själv skulle säga det.",
    "beta.languageTitle": "Text och språk",
    "beta.more": "Mer",
    "beta.ticker1": "Mistsweeper är i beta",
    "beta.ticker2": "Hitta buggar åt oss",
    "beta.ticker3": "Hjälp oss med språket",
    "beta.title": "Om betan",
    "button.banner": "Fana",
    "button.cancel": "Avbryt",
    "button.close": "Stäng",
    "button.daily": "Dagens expedition",
    "button.endless": "Oändlig",
    "button.home": "Tillbaka till stugan",
    "button.practice": "Övningsrunda",
    "button.settings": "Inställningar",
    "button.zoomIn": "Zooma in",
    "button.zoomOut": "Zooma ut",
    "clearing.arrange": "Placera",
    "clearing.cabin": "Stugan står kvar.",
    "clearing.cabinChosen": "Din stuga: {name}.",
    "clearing.cabinHint": "Stugan kan bli vilket hus du har hittat. Håll på den för att välja.",
    "clearing.cat.creatures": "Väsen",
    "clearing.cat.ground": "Mark",
    "clearing.cat.houses": "Hus",
    "clearing.cat.plants": "Växter",
    "clearing.cat.stones": "Stenar",
    "clearing.changeCabin": "Byt stuga",
    "clearing.chooseCabin": "Välj din stuga",
    "clearing.clear": "Rensa",
    "clearing.delete": "Ta bort",
    "clearing.deleteBody": "Det som står där försvinner med den. Dina fynd finns kvar.",
    "clearing.deleteTitle": "Ta bort {name}?",
    "clearing.deleted": "{name} är borttagen.",
    "clearing.discovered": "{n} av {total} upptäckta",
    "clearing.done": "Klar",
    "clearing.edit": "Ändra",
    "clearing.editing": "Ändrar {name}",
    "clearing.family.barley": "Korn",
    "clearing.family.barn": "Lada",
    "clearing.family.beacon": "Vårdkase",
    "clearing.family.beehive": "Bikupor",
    "clearing.family.bergstroll": "Bergstroll",
    "clearing.family.birch": "Björk",
    "clearing.family.boat": "Eka",
    "clearing.family.boathouse": "Båthus",
    "clearing.family.boulder": "Flyttblock",
    "clearing.family.bush": "Buske",
    "clearing.family.cairn": "Röse",
    "clearing.family.campfire": "Lägereld",
    "clearing.family.cart": "Kärra",
    "clearing.family.cave": "Grotta",
    "clearing.family.church": "Stavkyrka",
    "clearing.family.cottage": "Torp",
    "clearing.family.driftwood": "Drivved",
    "clearing.family.fabod": "Fäbod",
    "clearing.family.faering": "Färing",
    "clearing.family.fence": "Gärdesgård",
    "clearing.family.fern": "Ormbunke",
    "clearing.family.fishhut": "Sjöbod",
    "clearing.family.flottning": "Flottning",
    "clearing.family.fornborg": "Fornborg",
    "clearing.family.goahti": "Torvkåta",
    "clearing.family.gravhog": "Gravhög",
    "clearing.family.harbre": "Härbre",
    "clearing.family.hassja": "Hässja",
    "clearing.family.hides": "Hudar och kött",
    "clearing.family.hjell": "Fiskhjell",
    "clearing.family.house": "Stuga",
    "clearing.family.huldra": "Huldra",
    "clearing.family.huntingtower": "Jakttorn",
    "clearing.family.jatte": "Jätte",
    "clearing.family.jetty": "Brygga",
    "clearing.family.juniper": "En",
    "clearing.family.kastal": "Kastal",
    "clearing.family.kolmila": "Kolmila",
    "clearing.family.kummel": "Kummel",
    "clearing.family.laundry": "Tvätt",
    "clearing.family.lavvu": "Tältkåta",
    "clearing.family.lilypads": "Näckrosor",
    "clearing.family.log": "Stock",
    "clearing.family.longhouse": "Långhus",
    "clearing.family.massif": "Fjällmassiv",
    "clearing.family.mushroom": "Svamp",
    "clearing.family.nacken": "Näcken",
    "clearing.family.njalla": "Njalla",
    "clearing.family.oak": "Ek",
    "clearing.family.oats": "Havre",
    "clearing.family.outcrop": "Berghäll",
    "clearing.family.peak": "Bergstopp",
    "clearing.family.pebbles": "Småsten",
    "clearing.family.pine": "Tall",
    "clearing.family.reeds": "Vass",
    "clearing.family.rengarde": "Rengärde",
    "clearing.family.rock": "Sten",
    "clearing.family.rockcarving": "Hällristning",
    "clearing.family.rootcellar": "Jordkällare",
    "clearing.family.rowan": "Rönn",
    "clearing.family.ruin": "Ruin",
    "clearing.family.runestone": "Runsten",
    "clearing.family.rye": "Råg",
    "clearing.family.sauna": "Bastu",
    "clearing.family.seamark": "Sjömärke",
    "clearing.family.shed": "Bod",
    "clearing.family.shipsetting": "Skeppssättning",
    "clearing.family.shorestones": "Strandstenar",
    "clearing.family.sjotroll": "Sjötroll",
    "clearing.family.skogstroll": "Skogstroll",
    "clearing.family.smithy": "Smedja",
    "clearing.family.snag": "Torraka",
    "clearing.family.spruce": "Gran",
    "clearing.family.stonecircle": "Domarring",
    "clearing.family.stones": "Resta stenar",
    "clearing.family.stooks": "Skördad åker",
    "clearing.family.stormannagard": "Stormannagård",
    "clearing.family.stump": "Stubbe",
    "clearing.family.tent": "Tält",
    "clearing.family.tjardal": "Tjärdal",
    "clearing.family.tuft": "Gräs",
    "clearing.family.watermill": "Vattenkvarn",
    "clearing.family.well": "Brunn",
    "clearing.family.wellsweep": "Brunnsvinge",
    "clearing.family.windmill": "Väderkvarn",
    "clearing.family.windthrow": "Rotvälta",
    "clearing.family.woodpile": "Vedtrave",
    "clearing.fold": "Fäll undan",
    "clearing.ground.forest": "Skog",
    "clearing.ground.meadow": "Äng",
    "clearing.ground.mountain": "Berg",
    "clearing.ground.water": "Vatten",
    "clearing.grown": "Dimman drar sig undan.",
    "clearing.hint": "Välj något här nedanför och tryck på en ruta. Tryck igen för att vrida den. Håll på en ruta för att ändra den.",
    "clearing.hintVoiceOver": "Välj något här nedanför och dubbeltryck på en ruta. Rutans åtgärder ändrar, vrider eller rensar den.",
    "clearing.large": "Stor",
    "clearing.locked": "Inte upptäckt än. Den väntar ute i dimman.",
    "clearing.lockedName": "{name}, inte upptäckt än",
    "clearing.made": "En ny glänta: {name}.",
    "clearing.mist": "Där ligger dimman.",
    "clearing.needsLand": "Den behöver land.",
    "clearing.needsWater": "Den behöver vatten.",
    "clearing.new": "Ny glänta",
    "clearing.photo": "Foto",
    "clearing.photo.back": "Tillbaka",
    "clearing.photo.failed": "Bilden gick inte att göra här.",
    "clearing.photo.file": "glanta",
    "clearing.photo.formats": "Format",
    "clearing.photo.notSaved": "Bilden kunde inte sparas. I Inställningar kan du låta Mistsweeper lägga till bilder.",
    "clearing.photo.picture": "Din bild",
    "clearing.photo.save": "Spara",
    "clearing.photo.saved": "Sparad bland dina bilder.",
    "clearing.photo.share": "Dela",
    "clearing.photo.shutter": "Ta en bild",
    "clearing.photo.usage": "Mistsweeper sparar bilderna av din glänta bland dina bilder när du ber om det.",
    "clearing.rename": "Byt namn",
    "clearing.renameSave": "Spara",
    "clearing.renameTitle": "Namnge gläntan",
    "clearing.size": "Gläntans storlek",
    "clearing.small": "Liten",
    "clearing.supporter": "Supporter",
    "clearing.turn": "Vrid",
    "clearing.undo": "Ångra",
    "clearing.yours": "Dina gläntor",
    "controls.banner": "Sätt en fana",
    "controls.click": "Klicka",
    "controls.drag": "Dra",
    "controls.pan": "Flytta",
    "controls.pinch": "Nyp",
    "controls.qe": "Q och E",
    "controls.reveal": "Utforska",
    "controls.rightClick": "Högerklicka",
    "controls.rightDrag": "Högerdra",
    "controls.scroll": "Scrolla",
    "controls.tg": "T och G",
    "controls.tilt": "Luta",
    "controls.title": "Så rör du dig",
    "controls.turn": "Vrid",
    "controls.turnTilt": "Vrid och luta",
    "controls.twist": "Vrid två fingrar",
    "controls.twoFingers": "Två fingrar upp eller ner",
    "controls.voActions": "Svep uppåt eller nedåt",
    "controls.voFind": "Dimma att utforska, öppna siffror, fanor, norr och söder",
    "controls.voMagicTap": "Dubbeltryck med två fingrar",
    "controls.voMove": "Flytta fyra rutor över kartan",
    "controls.voRotor": "Vrid rotorn",
    "controls.voScroll": "Svep med tre fingrar",
    "controls.voSummary": "Var du är och hur långt du har kommit",
    "controls.voSwipe": "Svep åt vänster eller höger",
    "controls.voTileActions": "Rutans åtgärder: fanor, utforska runt den, beskriv omgivningen",
    "controls.voTiles": "Rutorna i bild, rad för rad från norr",
    "controls.zoom": "Zooma",
    "daily.next": "Nästa expedition om {time}",
    "feedback.subject": "Feedback om Mistsweeper, version {version}",
    "find.new": "Nytt fynd",
    "getApp.beta": "Appen är i beta. Den installeras med TestFlight, Apples app för att prova appar innan de släpps.",
    "getApp.haptics": "Haptik under fingrarna.",
    "getApp.intro": "Samma expedition varje dag, med några saker som bara en app kan.",
    "getApp.join": "Gå med i betan på TestFlight",
    "getApp.note": "Dina expeditioner i den här webbläsaren stannar här. Appen har sina egna.",
    "getApp.offline": "Fungerar utan uppkoppling.",
    "getApp.qr": "Rikta iPhonens kamera hit för att gå med i betan.",
    "getApp.qrLabel": "QR-kod till betan på TestFlight",
    "getApp.reminder": "En daglig påminnelse vid en tid du väljer.",
    "getApp.widget": "En widget med dagens expedition och din svit.",
    "hint.clearingDesktop": "Välj ett objekt och placera ut det i gläntan. Högerklicka på en ruta för att ändra den.",
    "hint.photoDesktop": "Rama in gläntan i fönstret och ta bilden.",
    "hint.reveal": "Tryck på en ruta intill utforskad mark för att utforska den.",
    "hint.revealDesktop": "Klicka på en ruta intill utforskad mark för att utforska den. Högerklicka för att sätta en fana.",
    "hint.revealVoiceOver": "Svep till dimma intill utforskad mark, eller hitta den med rotorn, och dubbeltryck för att utforska den.",
    "howto.1": "Du börjar vid stugan. Allt annat är dimma.",
    "howto.2": "Utforska en ruta intill mark du redan har utforskat. Du går vidare från där du har varit, en ruta i taget.",
    "howto.3": "En siffra räknar väsendena som gömmer sig i de åtta rutorna runt den.",
    "howto.3example": "Här gömmer sig väsen i två av de tre rutorna som fortfarande ligger i dimma.",
    "howto.4mouse": "Sätt en fana där du tror att ett väsen gömmer sig: högerklicka på rutan.",
    "howto.4touch": "Sätt en fana där du tror att ett väsen gömmer sig: slå på fanläget och tryck på rutan.",
    "howto.4voiceOver": "Sätt en fana där du tror att ett väsen gömmer sig: svep uppåt eller nedåt på rutan till dess åtgärder och välj Sätt en fana.",
    "howto.5": "Väcker du ett väsen är expeditionen slut. Din poäng är den punkt längst från stugan som du nådde.",
    "howto.6": "Varje dag kommer en ny expedition: samma mark för alla, och ett försök. Oändlig finns för de lugna stunderna.",
    "howto.tryLesson": "Prova i världen",
    "hud.best": "Rekord {distance}",
    "hud.clearing": "Glänta",
    "hud.menu": "Meny",
    "hud.north": "Vrid norr uppåt",
    "hud.practice": "Övningsrunda, #{n}",
    "hud.today": "Idag",
    "hud.turnLeft": "Vrid åt vänster, Q",
    "hud.turnLeftKey": "Q",
    "hud.turnRight": "Vrid åt höger, E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "Det är korn.",
    "inspect.barley.2": "Snart bröd, eller något bättre.",
    "inspect.barn.1": "Det är en lada.",
    "inspect.barn.2": "Full av hö och katter.",
    "inspect.barn.3": "Hö upp till taket. Det räcker till våren.",
    "inspect.beacon.1": "En vårdkase. Tänds när fienden syns.",
    "inspect.beacon.2": "En eld, sedan nästa, och hela landet vet.",
    "inspect.beacon.3": "Torr och klar. Ingen har tänt den än.",
    "inspect.beehive.1": "Bikupor. Knacka inte.",
    "inspect.beehive.2": "Vi är upptagna.",
    "inspect.birch.1": "Det är en björk.",
    "inspect.birch.2": "Vit bark, svarta streck. Någon har räknat.",
    "inspect.birch.3": "Näver brinner även när den är blöt. Bra att veta.",
    "inspect.birch.4": "Björken är först med löven, först att gulna.",
    "inspect.boat.1": "En eka. Någon vill nog ha tillbaka den.",
    "inspect.boat.2": "Årorna inne. Ingen ombord.",
    "inspect.boathouse.1": "Det luktar tjära och blött rep.",
    "inspect.boathouse.2": "Båten är ute. Ingen har sagt när den kommer tillbaka.",
    "inspect.boulder.1": "Ett flyttblock. Det flyttade sig en gång, med isen.",
    "inspect.boulder.2": "Jag kom med isen. Jag stannar.",
    "inspect.boulder.3": "Isen lämnade det här och gick hem.",
    "inspect.bush.1": "Det är en buske.",
    "inspect.bush.2": "Inget gömmer sig i busken. Antagligen.",
    "inspect.bush.3": "Något prasslade. Det var bara busken.",
    "inspect.cabin": "Din stuga. Spisen är fortfarande varm.",
    "inspect.cairn.1": "Det är ett röse.",
    "inspect.cairn.2": "Alla som går förbi lägger till en sten.",
    "inspect.cairn.3": "Någon märkte ut vägen. Eller en grav.",
    "inspect.campfire.1": "Det är en lägereld.",
    "inspect.campfire.2": "En eld, och ingen vid den.",
    "inspect.campfire.3": "Någon gav sig av i all hast.",
    "inspect.cart.1": "Det är en kärra.",
    "inspect.cart.2": "Lämnad där hästen stannade.",
    "inspect.cave.1": "Det är en grotta. Den går inåt.",
    "inspect.cave.2": "Kom in.",
    "inspect.cave.3": "Något andas där inne. Eller så är det vinden.",
    "inspect.church.1": "En stavkyrka. Hundratals år av tjära.",
    "inspect.church.2": "Inte en sten i den. Bara trä och tålamod.",
    "inspect.church.3": "Det är tyst där inne. Det har det alltid varit.",
    "inspect.creature.bergstroll": "Här bodde ett bergstroll.",
    "inspect.creature.huldra": "Här bodde en huldra.",
    "inspect.creature.jatte": "Här bodde en jätte.",
    "inspect.creature.nacken": "Här bodde Näcken.",
    "inspect.creature.sjotroll": "Här bodde ett sjötroll.",
    "inspect.creature.skogstroll": "Här bodde ett skogstroll.",
    "inspect.deer.1": "Ett rådjur. Det har redan sett dig.",
    "inspect.deer.2": "Det lyfter på huvudet och fortsätter äta.",
    "inspect.driftwood.1": "Drivved. Ingen vet varifrån.",
    "inspect.driftwood.2": "Den har sett mer av havet än någon här.",
    "inspect.duck.1": "En gräsand. Den sköter sitt.",
    "inspect.duck.2": "Den har synpunkter.",
    "inspect.elk.1": "En älg. Den bryr sig inte.",
    "inspect.elk.2": "Det största i skogen, och det tystaste.",
    "inspect.faering.1": "En färing. Fyra åror och ett segel.",
    "inspect.faering.2": "Gjord som långskeppen var.",
    "inspect.fence.1": "En gärdesgård. Inte en enda spik.",
    "inspect.fence.2": "Det den skulle hålla inne har gått sin väg.",
    "inspect.fern.1": "Det är en ormbunke.",
    "inspect.fern.2": "Ormbunkar fanns här före träden.",
    "inspect.fern.3": "Ormbunken sägs blomma på midsommarnatten. Ingen har sett det.",
    "inspect.fishhut.1": "Nät, flöten och gammal sill.",
    "inspect.fishhut.2": "Sjöbod. Lukten kommer först.",
    "inspect.flottning.1": "Timmer på väg mot kusten.",
    "inspect.flottning.2": "Flottning. Älven bär stockarna.",
    "inspect.fornborg.1": "En fornborg. Hit sprang man när vårdkasarna tändes.",
    "inspect.fornborg.2": "Muren har rasat. De den stoppade är också borta.",
    "inspect.fornborg.3": "Ingen vet vem som staplade de här stenarna.",
    "inspect.goahti.1": "En torvkåta. Torv utanpå, varmt inuti.",
    "inspect.goahti.2": "Röken går ut genom toppen. Det har den alltid gjort.",
    "inspect.gravhog.1": "En gravhög. Någon viktig.",
    "inspect.gravhog.2": "Här ligger någon. Gå tyst.",
    "inspect.gravhog.3": "En grav. Tusen år av gräs ovanpå.",
    "inspect.harbre.1": "Ett härbre. Uppe på stolpar, utom räckhåll för möss.",
    "inspect.harbre.2": "Förra årets säd ligger där inne.",
    "inspect.hassja.1": "En hässja. Höet torkar i vinden.",
    "inspect.hassja.2": "Hö på slanorna. Nu får det inte regna.",
    "inspect.hides.1": "Renhudar på ramar. Inget går till spillo.",
    "inspect.hides.2": "Kött som torkar i vinden. Vintermat.",
    "inspect.hjell.1": "Stockfisk på tork. Vinden lagar maten.",
    "inspect.hjell.2": "Det luktar ända hit.",
    "inspect.home": "Här bor {name}.",
    "inspect.huntingtower.1": "Där uppe sitter någon och väntar.",
    "inspect.huntingtower.2": "Älgarna känner till det.",
    "inspect.jetty.1": "Det är en brygga.",
    "inspect.jetty.2": "Den går en bit ut och ger upp.",
    "inspect.jetty.3": "Ett bra ställe för bara fötter.",
    "inspect.juniper.1": "Det är en en.",
    "inspect.juniper.2": "En en. Den sticks tillbaka.",
    "inspect.juniper.3": "En en. På avstånd ser den ut som någon som står stilla.",
    "inspect.kastal.1": "Tjocka murar, små fönster.",
    "inspect.kastal.2": "Någon väntade besök, och inte den trevliga sorten.",
    "inspect.kolmila.1": "Det är en kolmila.",
    "inspect.kolmila.2": "Den pyr i veckor. Någon måste hålla sig vaken.",
    "inspect.kolmila.3": "In går ved. Ut kommer kol.",
    "inspect.kummel.1": "Ett kummel. Det visar sjöfolk var de är.",
    "inspect.kummel.2": "Det syns från havet. Det är allt det är till för.",
    "inspect.laundry.1": "Någons tvätt.",
    "inspect.laundry.2": "Torrt till kvällen, om dimman håller sig borta.",
    "inspect.laundry.3": "En strumpa saknas.",
    "inspect.lavvu.1": "En tältkåta. Den kan vara borta till morgonen.",
    "inspect.lavvu.2": "Stänger och duk. Mer behövs inte.",
    "inspect.lilypads.1": "Näckrosor.",
    "inspect.lilypads.2": "Näckrosor. Plocka dem inte. Någon är fäst vid dem.",
    "inspect.lilypads.3": "Näckrosor med långa stjälkar, ner i mörkret.",
    "inspect.log.1": "Det är en stock.",
    "inspect.log.2": "Föll för länge sedan. Mossan har flyttat in.",
    "inspect.massif.1": "Det är ett fjällmassiv.",
    "inspect.massif.2": "Fjället lägger inte märke till besökare.",
    "inspect.massif.3": "Snö i skrevorna, även i augusti.",
    "inspect.mushroom.1": "Svamp. Låt den stå.",
    "inspect.mushroom.2": "All svamp går att äta. Viss svamp bara en gång.",
    "inspect.mushroom.3": "Någon kommer att vilja ha dem i en korg.",
    "inspect.njalla.1": "En njalla. En stolpe, och björnarna får bara titta.",
    "inspect.njalla.2": "Mat högt uppe, dit bara människor når.",
    "inspect.oak.1": "Det är en ek.",
    "inspect.oak.2": "En ek. Äldre än den äldsta historien om den.",
    "inspect.oak.3": "Eken har sett kungar komma och gå.",
    "inspect.oak.4": "En gång tillhörde varje ek kronan.",
    "inspect.oats.1": "Det är havre.",
    "inspect.oats.2": "Havre till hästarna och till frukost.",
    "inspect.outcrop.1": "Berghäll. Landet utan kappa.",
    "inspect.outcrop.2": "Varm i solen, kall om natten.",
    "inspect.outcrop.3": "Isen har slipat den här.",
    "inspect.peak.1": "Bergstopp. Snö året om.",
    "inspect.peak.2": "Här uppe växer ingenting.",
    "inspect.peak.3": "Utsikten sägs vara fin. Dimman håller inte med.",
    "inspect.pebbles.1": "Småsten.",
    "inspect.pebbles.2": "Var och en var en gång ett berg.",
    "inspect.pine.1": "Det är en tall.",
    "inspect.pine.2": "Tallen var här först.",
    "inspect.pine.3": "Tallar trivs där det är torrt och magert. Den här är nöjd.",
    "inspect.pine.4": "Tallen lutar dit vinden sa åt den.",
    "inspect.reeds.1": "Vass.",
    "inspect.reeds.2": "Vassen viskar. Det är bara vinden.",
    "inspect.reeds.3": "Något rörde sig där inne. Antagligen en fågel.",
    "inspect.reindeer.1": "Varje ren här tillhör någon.",
    "inspect.reindeer.2": "Den är på väg. Den vet vart.",
    "inspect.rengarde.1": "Hit samlas hjorden på hösten.",
    "inspect.rengarde.2": "Tomt nu. Renarna vet vart de ska.",
    "inspect.rock.1": "Det är en sten.",
    "inspect.rock.2": "Ja? En sten.",
    "inspect.rock.3": "En sten. Den har ingen åsikt.",
    "inspect.rock.4": "Ingenting händer. Det är en sten.",
    "inspect.rockcarving.1": "Huggen i berget, långt före runorna.",
    "inspect.rockcarving.2": "Vi var här.",
    "inspect.rockcarving.3": "Ingen kan läsa det. Det säger något ändå.",
    "inspect.rootcellar.1": "Potatis i mörkret.",
    "inspect.rootcellar.2": "Där inne fryser det aldrig.",
    "inspect.rowan.1": "Det är en rönn.",
    "inspect.rowan.2": "En rönn. Mycket rönnbär, mycket snö, säger man.",
    "inspect.rowan.3": "Troll sägs hålla sig borta från rönn.",
    "inspect.ruin.1": "Det är en ruin.",
    "inspect.ruin.2": "Någon var stolt över det här en gång.",
    "inspect.ruin.3": "Det som stod här är borta. Stenarna blev kvar.",
    "inspect.runestone.1": "Det är en runsten.",
    "inspect.runestone.2": "Någon lät resa den efter sitt barn.",
    "inspect.runestone.3": "Runsten. For österut, står det. Kom aldrig hem.",
    "inspect.runestone.4": "Runsten. Tyd detta, den som kan.",
    "inspect.rye.1": "Det är råg.",
    "inspect.rye.2": "Råg står över vintern och begär ingenting.",
    "inspect.sauna.1": "Det är en bastu.",
    "inspect.sauna.2": "En bastu. Fortfarande varm.",
    "inspect.sauna.3": "Björkris vid dörren. Någon kommer tillbaka.",
    "inspect.seamark.1": "Ett sjömärke. Sjöfolk styr efter det.",
    "inspect.seamark.2": "Här.",
    "inspect.shed.1": "En bod. Verktyg, rep och en doft av tjära.",
    "inspect.shed.2": "Låst, och nyckeln är någon annanstans.",
    "inspect.shipsetting.1": "Ett skepp av sten, för en sista resa.",
    "inspect.shipsetting.2": "Någon skickades iväg med det här skeppet.",
    "inspect.shipsetting.3": "Gravskepp. Det har inte rört sig sedan järnåldern.",
    "inspect.shorestones.1": "Platta stenar. Bra att kasta smörgås med.",
    "inspect.shorestones.2": "Vattnet har arbetat på dem länge.",
    "inspect.smithy.1": "Det är en smedja.",
    "inspect.smithy.2": "Det luktar kol och järn.",
    "inspect.smithy.3": "Troll tycker inte om järn, sägs det.",
    "inspect.snag.1": "Den är död. Den står ändå.",
    "inspect.snag.2": "En torraka. Torr ända in, och bra till elden.",
    "inspect.snag.3": "Hackspettarna är fortfarande intresserade.",
    "inspect.spruce.1": "Det är en gran.",
    "inspect.spruce.2": "Under en gran är det alltid lite kväll.",
    "inspect.spruce.3": "Barr under fötterna. Inget annat växer här.",
    "inspect.spruce.4": "Mörk året om, och utan brådska.",
    "inspect.stonecircle.1": "En domarring. Här satt domare, sägs det.",
    "inspect.stonecircle.2": "Egentligen en grav. Domarna är bara en historia.",
    "inspect.stonecircle.3": "Kliv in. Eller låt bli.",
    "inspect.stones.1": "Resta för hand. Ingen minns varför.",
    "inspect.stones.2": "Resta stenar. De ser ut som om de just slutat prata.",
    "inspect.stones.3": "Resta stenar väntar fortfarande.",
    "inspect.stooks.1": "Skörden är bärgad.",
    "inspect.stooks.2": "Kärvar på tork. Någon kommer tillbaka efter dem.",
    "inspect.stump.1": "Det är en stubbe.",
    "inspect.stump.2": "Någon har varit här med yxa.",
    "inspect.stump.3": "Räkna ringarna, om tiden räcker.",
    "inspect.tent.1": "Ett tält från en tidigare expedition.",
    "inspect.tent.2": "Den expeditionen kom aldrig tillbaka efter det.",
    "inspect.tent.3": "Sista sidan i anteckningsboken är tom.",
    "inspect.tjardal.1": "En tjärdal. In går tall, ut rinner tjära.",
    "inspect.tjardal.2": "Med det här tjärades skeppen.",
    "inspect.tuft.1": "Gräs.",
    "inspect.tuft.2": "Inget att rapportera. Gräs.",
    "inspect.tuft.3": "Gräset böjer sig och reser sig igen.",
    "inspect.tuft.4": "Bara gräs.",
    "inspect.watermill.1": "Det är en vattenkvarn.",
    "inspect.watermill.2": "Vattnet mal, dag som natt.",
    "inspect.well.1": "Det är en brunn.",
    "inspect.well.2": "Släpp en sten och räkna. Den är djup.",
    "inspect.well.3": "Kallt vatten, året om.",
    "inspect.wellsweep.1": "En brunnsvinge. Den långa stången sköter lyftet.",
    "inspect.wellsweep.2": "Upp kommer hinken, om någon drar.",
    "inspect.windmill.1": "Det är en väderkvarn.",
    "inspect.windmill.2": "Hela kvarnen vrids mot vinden.",
    "inspect.windmill.3": "Här mal vinden mjölet.",
    "inspect.windthrow.1": "Det är en rotvälta.",
    "inspect.windthrow.2": "Det här gjorde vinden, med rötter och allt.",
    "inspect.windthrow.3": "Rotvälta. Fråga inte vad som hänt.",
    "inspect.woodpile.1": "Nästa vinter, i travar.",
    "inspect.woodpile.2": "Staplad med omsorg. Ta inte den understa.",
    "lang.mist": "dimma",
    "lang.name": "Svenska",
    "lesson.cabinText": "Du börjar vid stugan. Tryck på en ruta intill marken du utforskat, så lyfter dimman. Prova den i ringen.",
    "lesson.cabinTextMouse": "Du börjar vid stugan. Klicka på en ruta intill marken du utforskat, så lyfter dimman. Prova den i ringen.",
    "lesson.cabinTitle": "Stugan",
    "lesson.done": "Klar",
    "lesson.endDistance": "Du kom {distance} från stugan. Det är ditt resultat. Ju längre, desto bättre.",
    "lesson.endText": "Siffrorna försvinner när deras väsen har fått fanor. Väcker du ett väsen slutar expeditionen.",
    "lesson.endTitle": "Redo",
    "lesson.invite": "Lär dig spelet först. Det tar en minut, och dina vänner väntar.",
    "lesson.noCreature": "Där sover inget väsen.",
    "lesson.numberHold": "Håll fingret på rutan för att sätta en fana.",
    "lesson.numberMode": "Eller slå på fanläget och tryck på den.",
    "lesson.numberMouse": "Högerklicka på rutan för att sätta en fana.",
    "lesson.numberText": "En siffra räknar väsnen i de åtta rutorna runt den. Den här 1:an har bara en ruta kvar i dimman, så där sover ett.",
    "lesson.numberTitle": "Siffran",
    "lesson.ownText": "2:an du hittade har två rutor kvar i dimman. Sätt en fana på båda.",
    "lesson.ownTitle": "Nu själv",
    "lesson.safeText": "Den här 1:an har redan hittat sitt väsen. Då är den andra rutan runt den säker. Utforska den.",
    "lesson.safeTitle": "Säker mark",
    "lesson.woke": "Där sov ett väsen. Försök igen.",
    "list.add": "Lägg till",
    "list.addBody": "Ditt namn och din expedition visas för alla på mistsweeper.com och i appen. Sedan läggs varje dags expedition till när den tar slut, tills du stänger av det i Inställningar.",
    "list.addTitle": "Lägg till ditt namn",
    "list.as": "som {name}",
    "list.countSoFar": "{count} upptäckare hittills",
    "list.countSoFarOne": "{count} upptäckare hittills",
    "list.empty": "Inga upptäckare än i dag. Du kan bli den första.",
    "list.errorAlready": "En expedition härifrån finns redan på dagens lista.",
    "list.errorBlocked": "Expeditioner härifrån kan inte längre läggas till.",
    "list.errorBusy": "För många på en gång härifrån. Försök igen om några minuter.",
    "list.errorClosed": "Listan för den här expeditionen har stängt.",
    "list.errorName": "Använd 2 till 20 bokstäver, siffror eller mellanslag.",
    "list.errorOther": "Listan går inte att nå. Försök igen.",
    "list.errorRefused": "Det namnet går inte att använda. Prova ett annat.",
    "list.hiddenName": "Namnet är dolt",
    "list.loading": "Letar efter dagens främsta.",
    "list.nameLabel": "Ditt namn",
    "list.notAdded": "Inte med på listan",
    "list.placeSoFar": "#{place} av {count} hittills",
    "list.remove": "Ta bort",
    "list.removeBody": "Varje expedition som lagts till härifrån försvinner från listorna. De finns kvar bland dina egna expeditioner.",
    "list.removeTitle": "Ta bort dina expeditioner?",
    "list.renameBody": "Det ändras på varje expedition du har lagt till.",
    "list.renameTitle": "Ditt namn på listan",
    "list.report": "Anmäl",
    "list.reportBody": "Ett namn som flera spelare anmäler döljs tills vi har tittat på det.",
    "list.reportTitle": "Anmäla det här namnet?",
    "list.tiles": "{tiles} rutor",
    "list.unreachable": "Listan går inte att nå just nu. Försök igen om en stund.",
    "list.waiting": "Väntar på att läggas till",
    "list.you": "Du",
    "list.yours": "Din expedition",
    "menu.about": "Om Mistsweeper",
    "menu.apps": "Mer från Great Scott!",
    "menu.appsLine": "Ordna, Krono, Tapotron, Color Tap",
    "menu.back": "Tillbaka till menyn",
    "menu.close": "Stäng menyn",
    "menu.expeditions": "Dina expeditioner",
    "menu.expeditionsLine": "Svit {streak}, rekord {distance}",
    "menu.feedback": "Skicka feedback",
    "menu.getApp": "Hämta iOS-appen",
    "menu.getAppLine": "Påminnelser och haptik, i beta",
    "menu.howto": "Så spelar du",
    "menu.howtoLine": "Reglerna och kontrollerna",
    "menu.list": "Dagens främsta",
    "menu.listLine": "Vem som kom längst i dag",
    "menu.privacy": "Integritetspolicy",
    "menu.settingsLine": "Tema {theme}, {language}",
    "menu.version": "Version {version} · Great Scott! AB",
    "mode.daily": "Expedition #{n}",
    "mode.endless": "Oändlig",
    "mode.endlessBest": "Oändlig, rekord {distance}",
    "note.banner": "Fanan är satt.",
    "note.bannerOff": "Fanläge av.",
    "note.bannerOn": "Fanläge på.",
    "note.cabin": "Tillbaka till stugan.",
    "note.clearing": "Din glänta. Placera ut dina fynd.",
    "note.copied": "Kopierat.",
    "note.endless": "Oändlig. En ny värld varje gång.",
    "note.listRemoved": "Borttagna från listorna.",
    "note.listReported": "Namnet anmält.",
    "note.north": "Norr är uppåt igen.",
    "note.today": "Dagens expedition.",
    "note.todayPractice": "Dagens expedition, som övning.",
    "over.bergstroll": "Du väckte ett bergstroll.",
    "over.bergstrollLine": "Bergstroll sitter så stilla bland stenarna att man tar dem för sten.",
    "over.copied": "Kopierat",
    "over.endlessRuns": "Oändliga rundor",
    "over.furthestLabel": "Längst bort",
    "over.huldra": "Huldran väntade bland träden.",
    "over.huldraLine": "Hon ser ut som en ung kvinna tills hon vänder sig om. Den som följer henne in i skogen blir kvar där.",
    "over.jatte": "En jätte reste sig ur berget.",
    "over.jatteLine": "Jättar sover i bergen med axlarna ovan jord. Du stod på en.",
    "over.jatteMeadow": "En jätte klev ut ur dimman.",
    "over.jatteMeadowLine": "Jättar vandrar över öppen mark långt från stugorna. Ingen hör dem komma.",
    "over.kickerDaily": "Expedition #{n}, {dateShort}",
    "over.kickerEndless": "Oändlig",
    "over.kickerPractice": "Övningsrunda på expedition #{n}",
    "over.kickerTogether": "Oändlig, tillsammans",
    "over.memberLine": "{tiles}, {distance}",
    "over.nacken": "Näcken väntade vid vattnet.",
    "over.nackenLine": "Näcken spelar vid stilla vatten. Den som stannar för att lyssna går inte längre.",
    "over.newWorld": "Utforska en ny värld",
    "over.practiceBoard": "Öva på dagens karta",
    "over.setOutAgain": "Ge dig av igen",
    "over.share": "Dela",
    "over.shared": "Delat",
    "over.sjotroll": "Du väckte ett sjötroll.",
    "over.sjotrollLine": "Det som såg ut som en holme hade ögon.",
    "over.skogstroll": "Du väckte ett skogstroll.",
    "over.skogstrollLine": "Skogstroll sover under mossan där granarna står tätast. De hatar att bli väckta.",
    "over.streak": "Svit",
    "over.streakDay": "{days} dag",
    "over.streakDays": "{days} dagar",
    "over.title": "Något rörde sig i dimman.",
    "over.todayResult": "Dagens resultat",
    "over.todayWaiting": "Dagens expedition väntar fortfarande",
    "over.togetherBest": "Rekord tillsammans",
    "over.togetherMembers": "Upptäckare",
    "over.yourBest": "Ditt rekord",
    "party.away": "Borta",
    "party.back": "Tillsammans igen.",
    "party.cardLine": "{status}, {tiles}, {distance}",
    "party.copied": "Länken är kopierad.",
    "party.fell": "Ser på",
    "party.follow": "Följ",
    "party.following": "Följer {name}",
    "party.full": "Den expeditionen är full.",
    "party.guest": "Upptäckare {n}",
    "party.invite": "Bjud in en vän",
    "party.inviteBody": "Skicka länken eller visa QR-koden. Den som följer med kliver in här, vid din stuga, på den här expeditionen. Upp till {n} tillsammans.",
    "party.inviteTitle": "Utforska tillsammans",
    "party.join": "Följ med",
    "party.joinBody": "En expedition {distance} in i dimman. Den som möter ett väsen ser på medan de andra fortsätter.",
    "party.joinTitle": "{name} bjuder in dig",
    "party.joinTitleAnon": "Du är inbjuden",
    "party.joined": "{name} följde med.",
    "party.leave": "Lämna expeditionen",
    "party.lock": "Stäng för nya upptäckare",
    "party.locked": "Den expeditionen är stängd för nya upptäckare.",
    "party.lockedNote": "Stängd för nya upptäckare.",
    "party.lost": "Kontakten bröts. Letar upp de andra igen.",
    "party.memberFell": "{name} föll.",
    "party.memberRemoved": "{name} är inte längre med på expeditionen.",
    "party.members": "Expeditionens medlemmar",
    "party.notNow": "Inte nu",
    "party.openNote": "Öppen för nya upptäckare.",
    "party.out": "I dimman",
    "party.over": "Den expeditionen är över.",
    "party.qrLabel": "QR-kod med länken till den här expeditionen",
    "party.remove": "Ta bort från expeditionen",
    "party.removeAsk": "Ta bort {name} från expeditionen? Hen kan inte komma tillbaka med länken.",
    "party.removed": "Du är inte längre med på den expeditionen.",
    "party.share": "Dela länken",
    "party.shareText": "Följ med på min expedition i dimman.",
    "party.tiles": "{n} rutor",
    "party.tiles1": "1 ruta",
    "party.unavailable": "Det gick inte att starta. Försök igen om en stund.",
    "party.unfollow": "Sluta följa",
    "party.unlock": "Öppna för nya upptäckare",
    "party.you": "Du",
    "party.youFell": "Du föll. Nu ser du på de andra.",
    "party.youNamed": "{name} (du)",
    "party.yourName": "Ditt namn",
    "placeholder.store": "[Länk till App Store]",
    "privacy.cloudApp": "När iCloud är på för Mistsweeper sparas dina inställningar, expeditioner och gläntor, och var kameran lämnades på varje plats, också i din egen iCloud, så att de följer med dig till din iPhone och iPad. Bara ditt Apple-konto kan läsa dem. Vi kan inte det. Om du tar bort appen finns de kvar i iCloud. Du kan ta bort dem under iCloud i appen Inställningar.",
    "privacy.cloudTitleApp": "I din iCloud",
    "privacy.contact": "Mistsweeper görs av Great Scott! AB i Stockholm, Sverige. Skriv till oss om du har frågor om integritet.",
    "privacy.contactTitle": "Kontakt",
    "privacy.gameCenterApp": "Om du är inloggad i Game Center på din enhet skickar appen till Apple hur långt du nådde på varje dags expedition och din längsta oändliga runda. De visas på spelets topplistor i Game Center, under ditt Game Center-namn, för dem som dina Game Center-inställningar tillåter. Spelet läser inte ditt namn eller dina vänner och sparar inget från Game Center. Är du inte inloggad skickas ingenting. Du kan logga ut under Game Center i appen Inställningar.",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "Sajten levereras av Cloudflare. Som alla webbvärdar ser Cloudflare din IP-adress för att kunna skicka sajten till dig, och kan spara den en kort tid i sina egna loggar för att hålla tjänsten säker. Vi sparar inga egna loggar.",
    "privacy.hostTitle": "Drift",
    "privacy.intro": "Mistsweeper är gjort för att spelas, inte för att samla data. Det här är allt det sparar.",
    "privacy.list": "Inget om dig skickas förrän du lägger till en expedition under ett namn eller anmäler ett namn. Din plats på listan räknas ut på din enhet, från samma svar som alla får. När du har lagt till en sparar vi namnet, expeditionen med dess drag och resultat, när den lades till, om den kom från webben eller appen och en förvrängd form av en kod som din enhet skapar. Det sparas hos Cloudflare, och namnet och expeditionen visas för alla på mistsweeper.com och i appen. Därefter läggs varje dags expedition till av sig själv, tills du stänger av det i Inställningar. För att hålla listan rättvis och vänlig kan vi läsa det som lagts till, dölja eller radera ett namn eller en expedition och stoppa en enhet från att lägga till fler. Vem som helst kan anmäla ett namn, och en anmälan sparar samma förvrängda form av koden för enheten som skickade den. För att stoppa missbruk räknas anrop från en adress i tio minuter i en förvrängd form som aldrig skrivs ner.",
    "privacy.listRemove": "Det du har lagt till finns kvar tills du tar bort det. Ta bort mina expeditioner i Inställningar raderar det från alla listor, för det som lagts till därifrån: webbläsaren och appen tar bort sina egna. Den förvrängda koden finns kvar i några dagar, så att en annan av dina enheter inte kan lägga till expeditionen igen av sig själv, och på anmälningar du har gjort. Har du inte kvar enheten, skriv till oss så raderar vi det. Du kan alltid fråga oss vad vi sparar om dig.",
    "privacy.listRemoveTitle": "Lämna listan",
    "privacy.none": "Inga konton, inga annonser, ingen spårning och inga cookies. Vi säljer inte personuppgifter och delar dem inte, och vi samlar inte in några utöver det du lägger till i Dagens främsta eller skickar när ni utforskar tillsammans.",
    "privacy.noneTitle": "Det här gör vi inte",
    "privacy.share": "När du delar ett resultat väljer du själv vart texten tar vägen. Länkar till App Store och e-post öppnas utanför spelet.",
    "privacy.shareTitle": "Delning och länkar",
    "privacy.stored": "Dina inställningar, expeditioner och resultat sparas i webbläsarens lokala lagring, så att du kan fortsätta där du slutade. De stannar på din enhet och skickas till oss bara om du lägger till en expedition i Dagens främsta. Om du rensar sajtens data i webbläsaren försvinner de härifrån.",
    "privacy.storedApp": "Dina inställningar, expeditioner och resultat sparas i appen på den här enheten, så att du kan fortsätta där du slutade. De skickas till oss bara om du lägger till en expedition i Dagens främsta. Om du tar bort appen försvinner de från den här enheten.",
    "privacy.storedTitle": "I din webbläsare",
    "privacy.storedTitleApp": "På din enhet",
    "privacy.title": "Integritet",
    "privacy.together": "När du bjuder in andra eller följer med på en expedition via en länk sparas expeditionen hos Cloudflare medan ni spelar: dess tryck, namnet och banderollen varje medlem valt, och en kod som varje webbläsare behåller för att kunna ta sin plats igen. Var varje medlems kamera tittar skickas till de andra medan ni spelar och sparas aldrig. Vi kan se expeditionerna som spelas tillsammans, titta på en medan den pågår och spela upp den igen, för att hålla spelet fungerande och rättvist. Allt om en expedition raderas en vecka efter att den senast spelades.",
    "privacy.togetherTitle": "Utforska tillsammans",
    "privacy.updated": "Uppdaterad 1 november 2026",
    "privacy.updatedApp": "Uppdaterad 1 november 2026",
    "privacy.usageApp": "iOS-appen räknar hur den används med TelemetryDeck, en integritetsvänlig analystjänst från Tyskland med servrar i EU. Den räknar när en session börjar, en expedition startar eller tar slut, ett resultat delas och gläntan öppnas. Varje räkning har med sig appens version, spelets språk, uppgifter om enheten som modell, system, skärm och inställningar, och en kod för appen på den här enheten som förvrängs innan den skickas, så att den inte kan spåras till dig. Din IP-adress sparas inte, och inget om dina resultat eller om vem du är skickas.",
    "privacy.usageTitleApp": "Användningsstatistik i appen",
    "privacy.visits": "För att se hur många som besöker sajten använder vi Plausible, en integritetsvänlig analystjänst med servrar i EU. Den använder inga cookies och sparar inga personuppgifter, bara summor som antal besök, länder, webbläsare och vilken sajt som skickade dig hit. Din IP-adress sparas inte.",
    "privacy.visitsTitle": "Besöksstatistik",
    "punct.comma": ", ",
    "punct.join": "{first} {next}",
    "punct.period": ".",
    "reminder.body": "Expedition #{n} väntar i dimman.",
    "sealed.body": "Dygnet bytte medan du var ute. Ditt resultat, {distance}, är sparat. Du kan fortsätta utforska som övning.",
    "sealed.next": "Starta expedition #{n}",
    "sealed.title": "Expedition #{n} är slut.",
    "settings.appPromo": "Påminnelser och haptik finns i iOS-appen, nu i beta.",
    "settings.debug": "Visa bildtider",
    "settings.developer": "Utvecklare",
    "settings.feel": "Känsla",
    "settings.haptics": "Haptik",
    "settings.hapticsLine": "Ett litet tick när du utforskar en ruta eller sätter en fana.",
    "settings.language": "Språk",
    "settings.languageAuto": "Automatiskt",
    "settings.languageAutoLine": "Följer systemets inställning: {language}",
    "settings.languageDraft": "Utkast",
    "settings.listAuto": "Lägg till mina expeditioner",
    "settings.listAutoLine": "Varje dags expedition kommer med på listan när den tar slut.",
    "settings.listName": "Namn på listan",
    "settings.listNote": "Lägg till din expedition när den tar slut för att komma med på dagens lista.",
    "settings.listRemove": "Ta bort mina expeditioner",
    "settings.motion": "Minska rörelse",
    "settings.motionLine": "Dimman står still, ny mark syns direkt och världens kanter är skarpa. Följer systemets inställning tills du ändrar den.",
    "settings.music": "Musik",
    "settings.musicLine": "En stilla melodi från skogen medan du utforskar.",
    "settings.remind": "Daglig påminnelse",
    "settings.remindDay": "Dag",
    "settings.remindDenied": "Notiser är avstängda för Mistsweeper. Tryck för att tillåta dem i Inställningar.",
    "settings.remindEarlier": "{n} minuter tidigare",
    "settings.remindEvening": "Kväll",
    "settings.remindLater": "{n} minuter senare",
    "settings.remindLine": "Klockan {time}, om dagens expedition fortfarande väntar.",
    "settings.remindNext": "Ny expedition {time}",
    "settings.remindNight": "Natt",
    "settings.remindTime": "Tid för påminnelsen",
    "settings.reminders": "Påminnelser",
    "settings.sounds": "Ljud",
    "settings.soundsLine": "Ett ljud för varje ruta, fana och väsen.",
    "settings.theme": "Tema",
    "settings.themeAuto": "Automatiskt",
    "settings.themeAutoLine": "Följer systemets inställning: Dag i ljust läge, Natt i mörkt läge.",
    "settings.themeSupporter": "Valt i Supporter",
    "settings.tilt": "Tilt-shift",
    "settings.title": "Inställningar",
    "settings.zoom": "Zoom",
    "start.continue": "Fortsätt, {distance}",
    "start.endlessLine": "En ny värld varje gång, så ofta du vill.",
    "start.setOut": "Ge dig av",
    "start.tagDistance": "#{n}, {distance}",
    "start.tagDone": "#{n}, klar, {distance}",
    "start.tagNew": "#{n}, ny",
    "start.tagNewDate": "#{n}, {dateShort}, ny",
    "start.tagProgress": "#{n}, påbörjad, {distance}",
    "start.todayDone": "Klar för idag. Nästa expedition om {time}.",
    "start.todayDoneShort": "Nästa expedition om {time}.",
    "start.todayInProgress": "Påbörjad. Fortsätt där du slutade.",
    "start.todayInProgressShort": "Fortsätt där du slutade.",
    "start.todayNew": "{dateLong}. Ett försök, samma mark för alla.",
    "start.todayNewShort": "Ett försök, samma mark för alla.",
    "support.devices": "Med iCloud på tar appen med dina expeditioner och gläntor till dina andra enheter. I en webbläsare stannar de i den webbläsaren.",
    "support.devicesTitle": "En ny enhet",
    "support.intro": "Mistsweeper görs av en liten studio i Stockholm. Om något inte fungerar, eller om du har en fråga, skriv till oss.",
    "support.list": "”{remove}” i {settings} tar bort dina expeditioner från alla listor. Vill du anmäla ett namn håller du in dess rad, eller högerklickar på det på en dator.",
    "support.listTitle": "Ditt namn på {list}",
    "support.purchase": "Ditt köp följer ditt Apple-konto. Öppna {supporter} i appens meny och välj {restore}.",
    "support.purchaseTitle": "Ett köp som försvunnit",
    "support.title": "Support",
    "supporter.accent": "Accentfärg",
    "supporter.accentLine": "Färgen på dina fanor.",
    "supporter.accentNumber": "Färg {n}",
    "supporter.banner": "Fana",
    "supporter.banners": "Fanor",
    "supporter.bannersLine": "Sätt en annan fana på varje expedition.",
    "supporter.buy": "Bli supporter, {price}",
    "supporter.buyLine": "Ett köp, ingen prenumeration. Med Familjedelning får din familj det också.",
    "supporter.buyNoPrice": "Bli supporter",
    "supporter.cabin": "Din stuga",
    "supporter.cabinLine": "Låt ett hus du har hittat stå där stugan står, på varje expedition och i varje glänta.",
    "supporter.chooseCabin": "Välj i gläntan",
    "supporter.clearingLocked": "Bara en supporter kan ändra den här gläntan.",
    "supporter.clearings": "Gläntor",
    "supporter.clearingsLine": "En större glänta, 15 gånger 15 rutor, och så många gläntor du vill.",
    "supporter.failed": "Köpet gick inte igenom. Försök igen om en stund.",
    "supporter.free": "Allt du spelar är gratis, och förblir det.",
    "supporter.icon": "Appikon",
    "supporter.icons": "Appikoner",
    "supporter.iconsLine": "Välj ikonen på din hemskärm. Var och en har ett ljust och ett mörkt utseende.",
    "supporter.lead": "Som supporter väljer du hur spelet ser ut på din skärm, och du hjälper oss att fortsätta göra Mistsweeper.",
    "supporter.line": "Teman, appikoner, fanor, din stuga",
    "supporter.nothingToRestore": "Inget köp av Supporter hittades för det här Apple-kontot.",
    "supporter.pending": "Väntar på godkännande. Supporter kommer så fort köpet är godkänt.",
    "supporter.restore": "Återställ köp",
    "supporter.since": "Supporter sedan {date}",
    "supporter.thanks": "Tack för att du stöttar Mistsweeper. Här väljer du hur spelet ser ut på din skärm.",
    "supporter.theme": "Tema",
    "supporter.themeLine": "Dag, Natt och Automatiskt finns i Inställningar.",
    "supporter.themes": "Teman",
    "supporter.themesLine": "Spela hela spelet i andra färger. I vissa väljer du också färgen på dina fanor.",
    "supporter.unreachable": "Det gick inte att nå App Store. Försök igen om en stund.",
    "theme.day": "Dag",
    "theme.fjord": "Fjord",
    "theme.mossa": "Mossa",
    "theme.night": "Natt",
    "theme.pergament": "Pergament",
    "theme.rosa": "Rosa",
    "theme.skymning": "Skymning",
    "time.hoursMinutes": "{h} h {m} min",
    "time.minutes": "{m} min",
    "webgl.missing": "Mistsweeper behöver WebGL 2, som den här webbläsaren saknar.",
    "welcome.mistDaily": "Varje dag kommer en ny expedition: samma mark för alla, och ett försök. Oändlig finns för de lugna stunderna.",
    "welcome.mistNumbers": "En siffra räknar väsendena som gömmer sig i de åtta rutorna runt den. Sätt en fana där du tror att ett sover, och gå vidare.",
    "welcome.mistText": "Du börjar vid en stuga i en skogsglänta, och allt annat är dimma. Utforska en ruta i taget från marken du redan har utforskat.",
    "welcome.mistTitle": "In i dimman",
    "welcome.next": "Nästa",
    "welcome.remindNo": "Inte nu",
    "welcome.remindText": "Varje dag kommer en ny expedition. Välj en tid, så säger vi till när dagens fortfarande väntar. Du kan ändra det i Inställningar.",
    "welcome.remindTitle": "En daglig påminnelse",
    "welcome.remindYes": "Påminn mig",
    "welcome.skip": "Hoppa över",
    "welcome.starsLater": "Lite senare frågar vi vad du tycker. Ett ögonblick då hjälper oss mycket.",
    "welcome.starsText": "Mistsweeper görs av Great Scott!, en liten studio i Stockholm. För ett litet spel är betyg i App Store det bästa sättet att hittas av fler.",
    "welcome.starsTitle": "Gjort av en liten studio",
    "welcome.step": "Steg {n} av {total}",
    "widget.bestDay": "Bästa dag {distance}",
    "widget.clearingDescription": "Din glänta, med hur mycket du har upptäckt och dina bästa sträckor.",
    "widget.clearingName": "Din glänta",
    "widget.description": "Dagens expedition som du lämnade den, och din svit.",
    "widget.next": "Nästa om {time}",
    "widget.streak": "Svit {days}",
    "widget.waiting": "Väntar",
  },
  "zh-Hans": {
    "a11y.bannerMode": "插旗模式",
    "a11y.board.banner": "旗帜",
    "a11y.board.bannerRemoved": "已拔起旗帜。",
    "a11y.board.banners1": "1面旗帜",
    "a11y.board.bannersN": "{n}面旗帜",
    "a11y.board.cabin": "小木屋",
    "a11y.board.cellBanner": "旗帜",
    "a11y.board.cellCabin": "小木屋",
    "a11y.board.cellExplored": "已探索",
    "a11y.board.cellMist": "雾",
    "a11y.board.cellWrongBanner": "插错的旗帜",
    "a11y.board.chordWaits": "周围的旗帜与数字不符。",
    "a11y.board.chosen": "已选择：{name}。",
    "a11y.board.confirmed": "已确认",
    "a11y.board.creature": "一个精怪",
    "a11y.board.deepMist": "浓雾",
    "a11y.board.describe": "描述周围",
    "a11y.board.dirEast": "向东",
    "a11y.board.dirNorth": "向北",
    "a11y.board.dirSouth": "向南",
    "a11y.board.dirWest": "向西",
    "a11y.board.east": "以东{n}格",
    "a11y.board.explore": "探索周围",
    "a11y.board.explored": "已探索",
    "a11y.board.exploredOn": "已探索，{what}",
    "a11y.board.frontier0": "没有雾可以探索",
    "a11y.board.frontier1": "1格雾可以探索",
    "a11y.board.frontierN": "{n}格雾可以探索",
    "a11y.board.furthest": "最远距离 {distance}。",
    "a11y.board.hid": "藏在这里",
    "a11y.board.hintExplore": "探索周围的格子。",
    "a11y.board.hintPlant": "插上一面旗帜。",
    "a11y.board.hintReveal": "探索这一格。",
    "a11y.board.hintTakeAway": "拔起这面旗帜。",
    "a11y.board.inMist": "{n}格雾",
    "a11y.board.inView": "画面中：{what}",
    "a11y.board.listAnd": "{list}和{last}",
    "a11y.board.mist": "雾",
    "a11y.board.nextTo": "旁边的数字：{numbers}",
    "a11y.board.north": "以北{n}格",
    "a11y.board.place": "小木屋{where}，距离 {distance}",
    "a11y.board.plant": "插上旗帜",
    "a11y.board.revealed1": "探索了1格。",
    "a11y.board.revealedN": "探索了{n}格。",
    "a11y.board.rotorBanners": "旗帜",
    "a11y.board.rotorMist": "可探索的雾",
    "a11y.board.rotorNorthSouth": "南北",
    "a11y.board.rotorNumbers": "待解数字",
    "a11y.board.roundIt": "周围有{what}",
    "a11y.board.rowHere": "这里：{tiles}。",
    "a11y.board.rowNorth": "北边：{tiles}。",
    "a11y.board.rowSouth": "南边：{tiles}。",
    "a11y.board.south": "以南{n}格",
    "a11y.board.takeAway": "拔起旗帜",
    "a11y.board.turned": "已旋转。",
    "a11y.board.west": "以西{n}格",
    "a11y.board.woke": "在这里醒来，结束了探险",
    "a11y.board.wrongBanner": "插错的旗帜",
    "a11y.distance": "最远距离",
    "a11y.find": "新发现：{name}。",
    "a11y.findMore": "新发现：{name}，另有{n}个。",
    "a11y.map": "探险地图",
    "about.body1": "过了小木屋，便是雾。雾里住着古老的精怪：苔藓下的巨怪、林间的胡尔德拉、静水边的内肯。",
    "about.body2": "Mistsweeper 讲的是在落脚之前，先读懂脚下的土地。数字会告诉你附近睡着几个精怪。能走多远，由你决定。",
    "about.body3": "Mistsweeper 是经典益智游戏《扫雷》的全新演绎，灵感来自北欧神话与民间故事。",
    "about.made": "由瑞典斯德哥尔摩的 Great Scott! 制作。",
    "about.version": "版本{version}",
    "accessibility.contact": "如果有什么妨碍你玩游戏，或者有什么能让你玩得更轻松，请写信告诉我们。",
    "accessibility.contactTitle": "告诉我们",
    "accessibility.contrast": "世界和菜单都以墨水画在纸上，无论白天还是夜晚，对比度都远高于文字所需。红色用来标示重要的东西，但从不单独使用：旗帜有自己的形状，探险结束后插错的旗帜会打上叉，探险结束的那一格会加上边框。",
    "accessibility.contrastTitle": "对比度与颜色",
    "accessibility.dark": "游戏会跟随系统的深色模式：“夜晚”是月光下的世界。你也可以在“设置”的“主题”中选择“白天”或“夜晚”。",
    "accessibility.darkTitle": "深色与浅色",
    "accessibility.intro": "我们希望尽可能多的人都能玩 Mistsweeper。以下是游戏目前在网页版和 iOS App 中支持的功能，以及我们正在改进的地方。",
    "accessibility.keys": "在网页上，整个游戏都可以用键盘来玩：方向键或 WASD 键移动光标，Enter 键或空格键探索一格，F 键插上或拔起旗帜，Q 和 E 键旋转视角，T 和 G 键倾斜视角，加号和减号键缩放，H 键回到小木屋，Esc 键关闭当前打开的内容。",
    "accessibility.keysTitle": "网页版的键盘操作",
    "accessibility.motion": "打开系统的“减弱动态效果”，或打开游戏“设置”中的对应开关后，画面中的一切都不会自行移动。雾、风、动物和视角都静止不动，新的土地立即出现，世界的边缘保持清晰。",
    "accessibility.motionTitle": "减弱动态效果",
    "accessibility.sound": "声音和音乐传达的一切，你都能在画面上看到。游戏没有语音，也没有视频。在 iOS App 中，探索和插旗时会有触感反馈。音乐、音效和触感反馈都可以在“设置”中分别关闭。",
    "accessibility.soundTitle": "声音",
    "accessibility.title": "无障碍",
    "accessibility.updated": "更新于2026年10月25日",
    "accessibility.work": "在 iOS App 中，可以用“旁白”和“语音控制”浏览地图并进行游戏，文字大小也会跟随你的系统设置。在网页上，菜单和按钮已有供屏幕阅读器使用的标签，但还不能用屏幕阅读器浏览地图或进行游戏。我们正在为此努力。",
    "accessibility.workTitle": "我们正在改进的地方",
    "app.tagline": "一场无尽的探险",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "像素画涂色书，没有广告，也没有跟踪。",
    "apps.intro": "来自同一家工作室的小游戏和 App。",
    "apps.krono": "把历史、流行文化和音乐按顺序排在时间线上。",
    "apps.ordna": "安静的分类解谜。一千关，没有任何打扰。",
    "apps.tapotron": "在一格格跃跃欲试的按钮上，玩点击游戏、打节拍。",
    "archive.appNoteCloud": "保存在 iCloud 中，你的所有设备都能看到。",
    "archive.appNoteDevice": "保存在此设备上。为 Mistsweeper 打开 iCloud，就能在你的所有设备上看到。",
    "archive.best": "个人最佳",
    "archive.daily": "每日探险",
    "archive.dayStreak": "连续天数",
    "archive.endlessBest": "最佳",
    "archive.endlessLast": "上次",
    "archive.endlessRuns": "次数",
    "archive.expeditions": "探险次数",
    "archive.gameCenter": "在 Game Center 与朋友比较",
    "archive.notPlayed": "未出发",
    "archive.sealed": "未完成，已封存",
    "archive.today": "今天，进行中",
    "archive.todayWord": "今天",
    "archive.webNote": "保存在此浏览器中。iOS App 有自己的探险记录，保存在 iCloud 中。",
    "archive.webNoteShort": "保存在此浏览器中。",
    "banner.1": "三尾",
    "banner.a1": "燕尾",
    "banner.a3": "矛尖",
    "banner.b1": "扇形",
    "banner.b2": "渡鸦旗",
    "banner.b3": "半圆",
    "banner.c2": "T字旗",
    "banner.c3": "路标",
    "banner.c4": "扭转旗",
    "beta.bugs": "有什么地方不正常，或者看起来不对劲吗？请告诉我们你做了什么、发生了什么，以及使用的设备。附上截图会很有帮助。",
    "beta.bugsTitle": "问题",
    "beta.changes": "测试期间游戏会不断变化。正式发布后，探险会接着现在的编号继续，不会从 #1 重新开始。",
    "beta.changesTitle": "将会改变的内容",
    "beta.intro": "Mistsweeper 已经可以玩了，但还没有完成。在正式发布之前，我们需要你的帮助。",
    "beta.language": "游戏支持九种语言，但大部分译文还没有经过母语使用者阅读。如果有地方读起来不对或不自然，请告诉我们你在哪里看到它，以及你会怎么说。",
    "beta.languageTitle": "文字与语言",
    "beta.more": "了解更多",
    "beta.ticker1": "Mistsweeper 正在测试中",
    "beta.ticker2": "帮我们找出问题",
    "beta.ticker3": "帮我们改进文字",
    "beta.title": "关于测试",
    "button.banner": "旗帜",
    "button.cancel": "取消",
    "button.close": "关闭",
    "button.daily": "今日探险",
    "button.endless": "无尽",
    "button.home": "回到小木屋",
    "button.practice": "练习",
    "button.settings": "设置",
    "button.zoomIn": "放大",
    "button.zoomOut": "缩小",
    "clearing.arrange": "摆放",
    "clearing.cabin": "小木屋留在原地。",
    "clearing.cabinChosen": "你的小木屋：{name}。",
    "clearing.cabinHint": "小木屋可以换成你找到的任何房屋。按住它来选择。",
    "clearing.cat.creatures": "精怪",
    "clearing.cat.ground": "地形",
    "clearing.cat.houses": "房屋",
    "clearing.cat.plants": "植物",
    "clearing.cat.stones": "岩石",
    "clearing.changeCabin": "更换小木屋",
    "clearing.chooseCabin": "选择你的小木屋",
    "clearing.clear": "清除",
    "clearing.delete": "删除",
    "clearing.deleteBody": "摆放在那里的东西会一起消失。你的发现会保留。",
    "clearing.deleteTitle": "删除 {name}？",
    "clearing.deleted": "{name} 已删除。",
    "clearing.discovered": "已发现{n}/{total}",
    "clearing.done": "完成",
    "clearing.edit": "编辑",
    "clearing.editing": "正在编辑：{name}",
    "clearing.family.barley": "大麦",
    "clearing.family.barn": "谷仓",
    "clearing.family.beacon": "烽火堆",
    "clearing.family.beehive": "蜂箱",
    "clearing.family.bergstroll": "山岭巨怪",
    "clearing.family.birch": "白桦",
    "clearing.family.boat": "小船",
    "clearing.family.boathouse": "船库",
    "clearing.family.boulder": "巨石",
    "clearing.family.bush": "灌木丛",
    "clearing.family.cairn": "石堆",
    "clearing.family.campfire": "篝火",
    "clearing.family.cart": "板车",
    "clearing.family.cave": "洞穴",
    "clearing.family.church": "木板教堂",
    "clearing.family.cottage": "农舍",
    "clearing.family.driftwood": "浮木",
    "clearing.family.fabod": "夏季牧场",
    "clearing.family.faering": "挪威小艇",
    "clearing.family.fence": "木栅栏",
    "clearing.family.fern": "蕨类",
    "clearing.family.fishhut": "渔屋",
    "clearing.family.flottning": "放木排",
    "clearing.family.fornborg": "古垒",
    "clearing.family.goahti": "草皮屋",
    "clearing.family.gravhog": "坟丘",
    "clearing.family.harbre": "高脚仓",
    "clearing.family.hassja": "晒草架",
    "clearing.family.hides": "兽皮与肉干",
    "clearing.family.hjell": "晒鱼架",
    "clearing.family.house": "小木屋",
    "clearing.family.huldra": "胡尔德拉",
    "clearing.family.huntingtower": "狩猎台",
    "clearing.family.jatte": "巨人",
    "clearing.family.jetty": "栈桥",
    "clearing.family.juniper": "杜松",
    "clearing.family.kastal": "石塔楼",
    "clearing.family.kolmila": "炭窑",
    "clearing.family.kummel": "海岸石标",
    "clearing.family.laundry": "晾衣绳",
    "clearing.family.lavvu": "萨米帐篷",
    "clearing.family.lilypads": "睡莲",
    "clearing.family.log": "原木",
    "clearing.family.longhouse": "长屋",
    "clearing.family.massif": "群峰",
    "clearing.family.mushroom": "蘑菇",
    "clearing.family.nacken": "内肯",
    "clearing.family.njalla": "单柱仓",
    "clearing.family.oak": "橡树",
    "clearing.family.oats": "燕麦",
    "clearing.family.outcrop": "裸岩",
    "clearing.family.peak": "山峰",
    "clearing.family.pebbles": "小石子",
    "clearing.family.pine": "松树",
    "clearing.family.reeds": "芦苇",
    "clearing.family.rengarde": "驯鹿围栏",
    "clearing.family.rock": "石头",
    "clearing.family.rockcarving": "岩画",
    "clearing.family.rootcellar": "地窖",
    "clearing.family.rowan": "花楸",
    "clearing.family.ruin": "废墟",
    "clearing.family.runestone": "符文石",
    "clearing.family.rye": "黑麦",
    "clearing.family.sauna": "桑拿房",
    "clearing.family.seamark": "航标",
    "clearing.family.shed": "仓房",
    "clearing.family.shipsetting": "船形石阵",
    "clearing.family.shorestones": "岸边石",
    "clearing.family.sjotroll": "湖中巨怪",
    "clearing.family.skogstroll": "森林巨怪",
    "clearing.family.smithy": "铁匠铺",
    "clearing.family.snag": "枯树",
    "clearing.family.spruce": "云杉",
    "clearing.family.stonecircle": "石圈",
    "clearing.family.stones": "立石",
    "clearing.family.stooks": "收割后的田",
    "clearing.family.stormannagard": "首领大厅",
    "clearing.family.stump": "树桩",
    "clearing.family.tent": "帐篷",
    "clearing.family.tjardal": "焦油窑",
    "clearing.family.tuft": "青草",
    "clearing.family.watermill": "水磨坊",
    "clearing.family.well": "水井",
    "clearing.family.wellsweep": "吊杆井",
    "clearing.family.windmill": "风车",
    "clearing.family.windthrow": "风倒木",
    "clearing.family.woodpile": "柴堆",
    "clearing.fold": "收起",
    "clearing.ground.forest": "森林",
    "clearing.ground.meadow": "草地",
    "clearing.ground.mountain": "山地",
    "clearing.ground.water": "水域",
    "clearing.grown": "雾退去了。",
    "clearing.hint": "在下方选一样东西，然后轻点一格。再轻点一次可以旋转。按住一格可以更改。",
    "clearing.hintVoiceOver": "在下方选一样东西，然后在格子上轻点两下。用格子的操作可以编辑、旋转或清除它。",
    "clearing.large": "大",
    "clearing.locked": "尚未发现。它还在雾中等待。",
    "clearing.lockedName": "{name}，尚未发现",
    "clearing.made": "新的空地：{name}。",
    "clearing.mist": "那里还在雾中。",
    "clearing.needsLand": "这个需要放在陆地上。",
    "clearing.needsWater": "这个需要放在水上。",
    "clearing.new": "新空地",
    "clearing.photo": "拍照",
    "clearing.photo.back": "返回",
    "clearing.photo.failed": "这里无法生成照片。",
    "clearing.photo.file": "clearing",
    "clearing.photo.formats": "画面比例",
    "clearing.photo.notSaved": "无法保存照片。可以在“设置”中允许 Mistsweeper 添加照片。",
    "clearing.photo.picture": "你的照片",
    "clearing.photo.save": "保存",
    "clearing.photo.saved": "已保存到“照片”。",
    "clearing.photo.share": "分享",
    "clearing.photo.shutter": "拍一张照片",
    "clearing.photo.usage": "在你要求时，Mistsweeper 会把空地的照片保存到你的照片图库。",
    "clearing.rename": "重命名",
    "clearing.renameSave": "保存",
    "clearing.renameTitle": "为空地命名",
    "clearing.size": "空地大小",
    "clearing.small": "小",
    "clearing.supporter": "支持者",
    "clearing.turn": "旋转",
    "clearing.undo": "撤销",
    "clearing.yours": "你的空地",
    "controls.banner": "插上旗帜",
    "controls.click": "点击",
    "controls.drag": "拖动",
    "controls.pan": "平移",
    "controls.pinch": "双指捏合",
    "controls.qe": "Q 和 E",
    "controls.reveal": "探索",
    "controls.rightClick": "右键点击",
    "controls.rightDrag": "右键拖动",
    "controls.scroll": "滚动",
    "controls.tg": "T 和 G",
    "controls.tilt": "倾斜视角",
    "controls.title": "操作方式",
    "controls.turn": "旋转视角",
    "controls.turnTilt": "旋转和倾斜视角",
    "controls.twist": "双指转动",
    "controls.twoFingers": "双指上下滑动",
    "controls.voActions": "向上或向下轻扫",
    "controls.voFind": "可探索的雾、待解数字、旗帜、南北",
    "controls.voMagicTap": "双指轻点两下",
    "controls.voMove": "在地图上移动四格",
    "controls.voRotor": "转动转子",
    "controls.voScroll": "三指轻扫",
    "controls.voSummary": "你在哪里，走了多远",
    "controls.voSwipe": "向左或向右轻扫",
    "controls.voTileActions": "格子的操作：旗帜、探索周围、描述周围",
    "controls.voTiles": "从北边起，逐行读出画面中的格子",
    "controls.zoom": "缩放",
    "daily.next": "距下次探险还有{time}",
    "feedback.subject": "Mistsweeper 反馈，版本{version}",
    "find.new": "新发现",
    "getApp.beta": "这款 App 正在测试中，需要通过 TestFlight 安装。TestFlight 是 Apple 的 App，用来在 App 正式发布前抢先试用。",
    "getApp.haptics": "指尖下的触感反馈。",
    "getApp.intro": "同样的每日探险，外加几件只有 App 才能做到的事。",
    "getApp.join": "在 TestFlight 上加入测试",
    "getApp.note": "你在此浏览器中的探险会留在这里。App 有自己的记录。",
    "getApp.offline": "离线也能玩。",
    "getApp.qr": "用 iPhone 相机对准这里，加入测试。",
    "getApp.qrLabel": "TestFlight 测试版的二维码",
    "getApp.reminder": "每天在你选定的时间提醒你。",
    "getApp.widget": "显示今日探险和连续天数的小组件。",
    "hint.clearingDesktop": "选一样东西，摆放到空地上。右键点击一格可以更改。",
    "hint.photoDesktop": "把空地放进取景框，然后拍照。",
    "hint.reveal": "轻点已探索区域旁的雾来探索。",
    "hint.revealDesktop": "点击已探索区域旁的雾来探索。右键点击可以插上旗帜。",
    "hint.revealVoiceOver": "轻扫到已探索区域旁边的雾，或用转子找到它，然后轻点两下来探索。",
    "howto.1": "你从小木屋出发。其余的一切都是雾。",
    "howto.2": "探索紧挨着已探索区域的一格。你只能从去过的地方往前走，一次一格。",
    "howto.3": "数字表示它周围八格中藏着几个精怪。",
    "howto.3example": "比如这里，仍在雾中的三格里有两格藏着精怪。",
    "howto.4mouse": "在你认为藏着精怪的地方插上旗帜：右键点击那一格。",
    "howto.4touch": "在你认为藏着精怪的地方插上旗帜：打开插旗模式，然后轻点那一格。",
    "howto.4voiceOver": "在你认为藏着精怪的地方插上旗帜：在那一格上向上或向下轻扫，切换到它的操作，然后选择“插上旗帜”。",
    "howto.5": "惊醒精怪，探险就会结束。你的成绩，就是你离小木屋最远的距离。",
    "howto.6": "每天都有新的探险：人人踏上同一片土地，只有一次机会。无尽模式留给安静的时光。",
    "howto.tryLesson": "在世界中试玩",
    "hud.best": "最佳 {distance}",
    "hud.clearing": "空地",
    "hud.menu": "菜单",
    "hud.north": "转回正北朝上",
    "hud.practice": "练习，#{n}",
    "hud.today": "今日",
    "hud.turnLeft": "向左旋转，Q",
    "hud.turnLeftKey": "Q",
    "hud.turnRight": "向右旋转，E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "这是大麦。",
    "inspect.barley.2": "很快就是面包，或者更好的东西。",
    "inspect.barn.1": "这是一座谷仓。",
    "inspect.barn.2": "里面全是干草和猫。",
    "inspect.barn.3": "干草堆到了屋顶。够吃到开春。",
    "inspect.beacon.1": "一座烽火堆。见到敌人便点燃。",
    "inspect.beacon.2": "一处火起，又一处，全境皆知。",
    "inspect.beacon.3": "干透了，备好了。还没有人点燃。",
    "inspect.beehive.1": "蜂箱。最好别敲。",
    "inspect.beehive.2": "我们很忙。",
    "inspect.birch.1": "这是一棵白桦。",
    "inspect.birch.2": "白树皮，黑记号。有人一直在数。",
    "inspect.birch.3": "白桦皮湿了也能点着。知道总没坏处。",
    "inspect.birch.4": "白桦最先长叶，最先变黄。",
    "inspect.boat.1": "一条小船。有人会来找它。",
    "inspect.boat.2": "桨收好了。船上没人。",
    "inspect.boathouse.1": "一股焦油和湿绳子的味道。",
    "inspect.boathouse.2": "船出去了。没人说什么时候回来。",
    "inspect.boulder.1": "一块巨石。它只动过一次，跟着冰川。",
    "inspect.boulder.2": "我随冰川而来。我不走了。",
    "inspect.boulder.3": "冰川把它留在这里，自己回家了。",
    "inspect.bush.1": "这是一丛灌木。",
    "inspect.bush.2": "灌木丛里什么也没藏。大概。",
    "inspect.bush.3": "有什么响了一下。只是灌木丛。",
    "inspect.cabin": "你的小木屋。炉子还热着。",
    "inspect.cairn.1": "这是一座石堆。",
    "inspect.cairn.2": "路过的人，都会添一块石头。",
    "inspect.cairn.3": "有人标出了路。或者一座坟。",
    "inspect.campfire.1": "这是一堆篝火。",
    "inspect.campfire.2": "一堆火，旁边没有人。",
    "inspect.campfire.3": "有人走得很匆忙。",
    "inspect.cart.1": "这是一辆板车。",
    "inspect.cart.2": "马停在哪里，它就留在哪里。",
    "inspect.cave.1": "这是一个洞穴。它通往里面。",
    "inspect.cave.2": "进来。",
    "inspect.cave.3": "里面有什么在呼吸。或者只是风。",
    "inspect.church.1": "一座木板教堂。几百年的焦油。",
    "inspect.church.2": "没有一块石头。只有木头和耐心。",
    "inspect.church.3": "里面很安静。一直都是。",
    "inspect.creature.bergstroll": "这里住过一个山岭巨怪。",
    "inspect.creature.huldra": "这里住过胡尔德拉。",
    "inspect.creature.jatte": "这里住过一个巨人。",
    "inspect.creature.nacken": "这里住过内肯。",
    "inspect.creature.sjotroll": "这里住过一个湖中巨怪。",
    "inspect.creature.skogstroll": "这里住过一个森林巨怪。",
    "inspect.deer.1": "一只狍子。它早就看见你了。",
    "inspect.deer.2": "它抬起头，又低头吃起来。",
    "inspect.driftwood.1": "浮木。没人知道从哪里来。",
    "inspect.driftwood.2": "它见过的海，比这里任何人都多。",
    "inspect.duck.1": "一只绿头鸭。它从不多管闲事。",
    "inspect.duck.2": "它对此有看法。",
    "inspect.elk.1": "一头驼鹿。它不在乎。",
    "inspect.elk.2": "森林里最大的东西，也是最安静的。",
    "inspect.faering.1": "一条挪威小艇。四支桨，一面帆。",
    "inspect.faering.2": "做法和维京长船一样。",
    "inspect.fence.1": "一道木栅栏。一颗钉子也没有。",
    "inspect.fence.2": "它本该圈住的，已经溜走了。",
    "inspect.fern.1": "这是一丛蕨类。",
    "inspect.fern.2": "蕨类来的时候，树还没到。",
    "inspect.fern.3": "据说蕨类在仲夏夜开花。没人见过。",
    "inspect.fishhut.1": "渔网、浮子，还有陈年的鲱鱼。",
    "inspect.fishhut.2": "渔屋。气味先到一步。",
    "inspect.flottning.1": "木头正在去海边的路上。",
    "inspect.flottning.2": "放木排。运木头的是河。",
    "inspect.fornborg.1": "一座古垒。烽火一起，人们便往这里跑。",
    "inspect.fornborg.2": "墙塌了。被它挡住的人，也不在了。",
    "inspect.fornborg.3": "没人知道这些石头是谁垒的。",
    "inspect.goahti.1": "一间草皮屋。外面是草皮，里面很暖。",
    "inspect.goahti.2": "烟从顶上出去。一直都是这样。",
    "inspect.gravhog.1": "一座坟丘。葬着一位要人。",
    "inspect.gravhog.2": "有人长眠于此。脚步放轻。",
    "inspect.gravhog.3": "一座坟。上面的草，已经长了一千年。",
    "inspect.harbre.1": "一座高脚仓。架在柱子上，老鼠够不着。",
    "inspect.harbre.2": "里面是去年的粮食。",
    "inspect.hassja.1": "一个晒草架。草在风里晾干。",
    "inspect.hassja.2": "架上晾着草。现在可不能下雨。",
    "inspect.hides.1": "驯鹿皮绷在架子上。一点也不浪费。",
    "inspect.hides.2": "风里晾着肉。冬天的口粮。",
    "inspect.hjell.1": "晾着的鳕鱼干。掌勺的是风。",
    "inspect.hjell.2": "这里都闻得到。",
    "inspect.home": "这里住着 {name}。",
    "inspect.huntingtower.1": "有人坐在上面等着。",
    "inspect.huntingtower.2": "驼鹿都知道。",
    "inspect.jetty.1": "这是一座栈桥。",
    "inspect.jetty.2": "它往外走了一小段，就放弃了。",
    "inspect.jetty.3": "这地方最适合光脚。",
    "inspect.juniper.1": "这是一棵杜松。",
    "inspect.juniper.2": "一棵杜松。它会扎回来。",
    "inspect.juniper.3": "一棵杜松。远远看去，像有人站着不动。",
    "inspect.kastal.1": "墙很厚，窗很小。",
    "inspect.kastal.2": "有人早料到会有客人，而且来者不善。",
    "inspect.kolmila.1": "这是一座炭窑。",
    "inspect.kolmila.2": "它要闷烧好几周。总得有人醒着。",
    "inspect.kolmila.3": "木头进去。木炭出来。",
    "inspect.kummel.1": "一座海岸石标。它告诉水手身在何处。",
    "inspect.kummel.2": "从海上看得见。它的用处仅此而已。",
    "inspect.laundry.1": "不知谁家的衣服。",
    "inspect.laundry.2": "傍晚就能干，只要雾不来。",
    "inspect.laundry.3": "少了一只袜子。",
    "inspect.lavvu.1": "一顶萨米帐篷。天亮时也许就不在了。",
    "inspect.lavvu.2": "几根杆子，一块布。别的都不需要。",
    "inspect.lilypads.1": "睡莲。",
    "inspect.lilypads.2": "睡莲。别摘。有人舍不得。",
    "inspect.lilypads.3": "睡莲的长茎，一直伸进黑暗。",
    "inspect.log.1": "这是一根原木。",
    "inspect.log.2": "倒下很久了。苔藓已经搬进来了。",
    "inspect.massif.1": "这是群峰。",
    "inspect.massif.2": "山不理会来客。",
    "inspect.massif.3": "岩缝里的雪，到八月也还在。",
    "inspect.mushroom.1": "蘑菇。最好别碰。",
    "inspect.mushroom.2": "所有蘑菇都能吃。有些只能吃一次。",
    "inspect.mushroom.3": "总有人想把它们装进篮子。",
    "inspect.njalla.1": "一座单柱仓。一根柱子，熊只能干看着。",
    "inspect.njalla.2": "食物放在高处，只有人够得着。",
    "inspect.oak.1": "这是一棵橡树。",
    "inspect.oak.2": "一棵橡树。关于它最古老的故事，也没有它老。",
    "inspect.oak.3": "这棵橡树看着国王来来去去。",
    "inspect.oak.4": "从前，每棵橡树都归王室所有。",
    "inspect.oats.1": "这是燕麦。",
    "inspect.oats.2": "燕麦，喂马，也当早饭。",
    "inspect.outcrop.1": "裸岩。大地脱了外衣。",
    "inspect.outcrop.2": "太阳下温热，夜里冰冷。",
    "inspect.outcrop.3": "这是冰川磨出来的。",
    "inspect.peak.1": "山峰。终年积雪。",
    "inspect.peak.2": "这上面什么也不长。",
    "inspect.peak.3": "据说这里景色很好。雾不这么看。",
    "inspect.pebbles.1": "小石子。",
    "inspect.pebbles.2": "每一颗都曾是一座山。",
    "inspect.pine.1": "这是一棵松树。",
    "inspect.pine.2": "是松树先来的。",
    "inspect.pine.3": "松树喜欢干燥贫瘠的地方。这一棵很知足。",
    "inspect.pine.4": "风叫松树往哪边歪，它就往哪边歪。",
    "inspect.reeds.1": "芦苇。",
    "inspect.reeds.2": "芦苇在低语。不过是风。",
    "inspect.reeds.3": "里面有什么动了一下。大概是鸟。",
    "inspect.reindeer.1": "这里的每头驯鹿都有主人。",
    "inspect.reindeer.2": "它在赶路。去哪里，它知道。",
    "inspect.rengarde.1": "秋天，鹿群聚到这里。",
    "inspect.rengarde.2": "现在空着。驯鹿知道自己要去哪里。",
    "inspect.rock.1": "这是一块石头。",
    "inspect.rock.2": "有事？一块石头。",
    "inspect.rock.3": "一块石头。它没有意见。",
    "inspect.rock.4": "什么也没发生。这是一块石头。",
    "inspect.rockcarving.1": "刻在岩石上，比符文早得多。",
    "inspect.rockcarving.2": "我们曾在这里。",
    "inspect.rockcarving.3": "没人读得懂。它仍在说着什么。",
    "inspect.rootcellar.1": "黑暗里的土豆。",
    "inspect.rootcellar.2": "里面从不结冰。",
    "inspect.rowan.1": "这是一棵花楸。",
    "inspect.rowan.2": "一棵花楸。老话说，果子多，雪就多。",
    "inspect.rowan.3": "据说巨怪都绕着花楸走。",
    "inspect.ruin.1": "这是一片废墟。",
    "inspect.ruin.2": "曾经有人为它骄傲。",
    "inspect.ruin.3": "曾立在这里的已经不在了。石头还在。",
    "inspect.runestone.1": "这是一块符文石。",
    "inspect.runestone.2": "这是有人为孩子立的。",
    "inspect.runestone.3": "符文石。上面刻着：东行。未归。",
    "inspect.runestone.4": "符文石。读吧，如果读得懂。",
    "inspect.rye.1": "这是黑麦。",
    "inspect.rye.2": "黑麦在地里站过一冬，一无所求。",
    "inspect.sauna.1": "这是一间桑拿房。",
    "inspect.sauna.2": "一间桑拿房。还热着。",
    "inspect.sauna.3": "门边放着白桦枝。有人会回来。",
    "inspect.seamark.1": "一座航标。水手靠它认路。",
    "inspect.seamark.2": "这里。",
    "inspect.shed.1": "一间仓房。工具、绳子，还有一股焦油味。",
    "inspect.shed.2": "锁着，钥匙在别处。",
    "inspect.shipsetting.1": "一艘石船，送人走最后一程。",
    "inspect.shipsetting.2": "有人是乘这艘船被送走的。",
    "inspect.shipsetting.3": "船形石阵。自铁器时代起，它就没有动过。",
    "inspect.shorestones.1": "扁平的石头，最适合打水漂。",
    "inspect.shorestones.2": "这些石头，水已经磨了很久。",
    "inspect.smithy.1": "这是一间铁匠铺。",
    "inspect.smithy.2": "一股炭和铁的味道。",
    "inspect.smithy.3": "据说巨怪不喜欢铁。",
    "inspect.snag.1": "它死了。照样站着。",
    "inspect.snag.2": "一棵枯树。里外干透，正好生火。",
    "inspect.snag.3": "啄木鸟依然很感兴趣。",
    "inspect.spruce.1": "这是一棵云杉。",
    "inspect.spruce.2": "云杉树下，总有几分暮色。",
    "inspect.spruce.3": "脚下全是针叶。别的什么也不长。",
    "inspect.spruce.4": "终年暗沉，不慌不忙。",
    "inspect.stonecircle.1": "一座石圈。据说曾有法官坐在这里。",
    "inspect.stonecircle.2": "其实是一座坟。法官只是传说。",
    "inspect.stonecircle.3": "走进去。或者算了。",
    "inspect.stones.1": "靠人力立起来的。没人记得为什么。",
    "inspect.stones.2": "立石。它们看上去像是刚刚住了口。",
    "inspect.stones.3": "立石还在等。",
    "inspect.stooks.1": "庄稼已收完。",
    "inspect.stooks.2": "麦捆晾在田里。有人会回来取。",
    "inspect.stump.1": "这是一截树桩。",
    "inspect.stump.2": "有人来过这里，带着斧头。",
    "inspect.stump.3": "数数年轮，如果还有时间。",
    "inspect.tent.1": "早前一支探险队留下的帐篷。",
    "inspect.tent.2": "那支探险队再也没有回来取它。",
    "inspect.tent.3": "笔记本的最后一页是空白的。",
    "inspect.tjardal.1": "一座焦油窑。松木进去，焦油流出来。",
    "inspect.tjardal.2": "从前的船，涂的就是这种焦油。",
    "inspect.tuft.1": "青草。",
    "inspect.tuft.2": "无事可报。青草。",
    "inspect.tuft.3": "青草弯下去，又站起来。",
    "inspect.tuft.4": "只是青草。",
    "inspect.watermill.1": "这是一座水磨坊。",
    "inspect.watermill.2": "磨面的是水，日夜不停。",
    "inspect.well.1": "这是一口水井。",
    "inspect.well.2": "丢一块石头，数一数。很深。",
    "inspect.well.3": "冰凉的水，一年四季。",
    "inspect.wellsweep.1": "一口吊杆井。提水的活，长杆来干。",
    "inspect.wellsweep.2": "水桶会上来，只要有人拉。",
    "inspect.windmill.1": "这是一座风车。",
    "inspect.windmill.2": "整座风车转过身，迎着风。",
    "inspect.windmill.3": "在这里，磨面的是风。",
    "inspect.windthrow.1": "这是一棵风倒木。",
    "inspect.windthrow.2": "风把它放倒了，连根带土。",
    "inspect.windthrow.3": "风倒木。别问发生过什么。",
    "inspect.woodpile.1": "这是下个冬天，一垛一垛。",
    "inspect.woodpile.2": "码得很仔细。别抽最下面那根。",
    "lang.mist": "雾",
    "lang.name": "简体中文",
    "lesson.cabinText": "你从小木屋出发。轻点已探索区域旁边的格子，雾就会散去。试试圈起来的那一格。",
    "lesson.cabinTextMouse": "你从小木屋出发。点击已探索区域旁边的格子，雾就会散去。试试圈起来的那一格。",
    "lesson.cabinTitle": "小木屋",
    "lesson.done": "完成",
    "lesson.endDistance": "你走到了离小木屋 {distance} 的地方。这就是你的成绩。越远越好。",
    "lesson.endText": "数字周围的精怪都有了旗帜，这个数字就会消失。惊醒精怪，探险就会结束。",
    "lesson.endTitle": "准备就绪",
    "lesson.invite": "先学会怎么玩。只要一分钟，朋友们在等你。",
    "lesson.noCreature": "那里没有精怪。",
    "lesson.numberHold": "按住那一格来插上旗帜。",
    "lesson.numberMode": "或者打开插旗模式，然后轻点那一格。",
    "lesson.numberMouse": "右键点击那一格来插上旗帜。",
    "lesson.numberText": "数字表示它周围八格中藏着几个精怪。这个1周围只剩一格还在雾中，所以那里睡着一个精怪。",
    "lesson.numberTitle": "数字",
    "lesson.ownText": "你找到的2周围还有两格在雾中。在这两格上都插上旗帜。",
    "lesson.ownTitle": "轮到你了",
    "lesson.safeText": "这个1已经找到了它的精怪。所以它周围的另一格是安全的。探索那一格。",
    "lesson.safeTitle": "安全地带",
    "lesson.woke": "那里睡着一个精怪。再试一次。",
    "list.add": "添加",
    "list.addBody": "所有人都能在 mistsweeper.com 和 App 上看到你的昵称和探险。之后每天的探险一结束，就会自动加入名单，直到你在“设置”中关闭为止。",
    "list.addTitle": "添加你的昵称",
    "list.as": "昵称：{name}",
    "list.countSoFar": "目前共{count}位探险家",
    "list.countSoFarOne": "目前共{count}位探险家",
    "list.empty": "今天的名单上还没有人。你可以成为第一个。",
    "list.errorAlready": "今天的名单上已经有一次从这里添加的探险。",
    "list.errorBlocked": "从这里已无法再添加探险。",
    "list.errorBusy": "这里的操作过于频繁。请过几分钟再试。",
    "list.errorClosed": "这次探险的名单已截止。",
    "list.errorName": "请使用2到20个汉字、字母、数字或空格。",
    "list.errorOther": "无法连接名单。请再试一次。",
    "list.errorRefused": "这个昵称不能使用。请换一个。",
    "list.hiddenName": "昵称已隐藏",
    "list.loading": "正在寻找今日的顶尖探险家。",
    "list.nameLabel": "你的昵称",
    "list.notAdded": "不在名单上",
    "list.placeSoFar": "目前第{place}名，共{count}位探险家",
    "list.remove": "移除",
    "list.removeBody": "从这里添加的探险都会从所有名单中移除。它们仍会保留在“你的探险”中。",
    "list.removeTitle": "移除你的探险？",
    "list.renameBody": "你添加过的每次探险都会改用新昵称。",
    "list.renameTitle": "你在名单上的昵称",
    "list.report": "举报",
    "list.reportBody": "多位玩家举报的昵称会先隐藏，直到我们查看过为止。",
    "list.reportTitle": "举报这个昵称？",
    "list.tiles": "{tiles}格",
    "list.unreachable": "暂时无法连接名单。请稍后再试。",
    "list.waiting": "等待添加",
    "list.you": "你",
    "list.yours": "你的探险",
    "menu.about": "关于 Mistsweeper",
    "menu.apps": "Great Scott! 的更多作品",
    "menu.appsLine": "Ordna、Krono、Tapotron、Color Tap",
    "menu.back": "返回菜单",
    "menu.close": "关闭菜单",
    "menu.expeditions": "你的探险",
    "menu.expeditionsLine": "连续{streak}，最佳 {distance}",
    "menu.feedback": "发送反馈",
    "menu.getApp": "获取 iOS App",
    "menu.getAppLine": "提醒与触感反馈，测试中",
    "menu.howto": "玩法说明",
    "menu.howtoLine": "规则与操作",
    "menu.list": "顶尖探险家",
    "menu.listLine": "今天谁走得最远",
    "menu.privacy": "隐私政策",
    "menu.settingsLine": "{theme}主题，{language}",
    "menu.version": "版本{version} · Great Scott! AB",
    "mode.daily": "探险 #{n}",
    "mode.endless": "无尽",
    "mode.endlessBest": "无尽，最佳 {distance}",
    "note.banner": "已插上旗帜。",
    "note.bannerOff": "插旗模式已关闭。",
    "note.bannerOn": "插旗模式已开启。",
    "note.cabin": "回到小木屋。",
    "note.clearing": "你的空地。摆放你的发现。",
    "note.copied": "已复制到剪贴板。",
    "note.endless": "无尽模式。每次都是新的世界。",
    "note.listRemoved": "已从所有名单中移除。",
    "note.listReported": "已举报昵称。",
    "note.north": "已恢复正北朝上。",
    "note.today": "今日探险。",
    "note.todayPractice": "今日探险，当作练习。",
    "over.bergstroll": "你惊醒了一个山岭巨怪。",
    "over.bergstrollLine": "山岭巨怪坐在石头之间，静得让人把它们当成石头。",
    "over.copied": "已复制到剪贴板",
    "over.endlessRuns": "无尽探险次数",
    "over.furthestLabel": "最远距离",
    "over.huldra": "胡尔德拉一直在林间等着。",
    "over.huldraLine": "她看起来像个年轻女子，直到她背过身去。跟着她走进森林的人，都留在了那里。",
    "over.jatte": "一个巨人从山中站了起来。",
    "over.jatteLine": "巨人睡在山里，肩膀露出地面。你刚才就站在其中一个身上。",
    "over.jatteMeadow": "一个巨人从雾中走了出来。",
    "over.jatteMeadowLine": "巨人行走在远离人烟的旷野上。谁也听不见它们走近。",
    "over.kickerDaily": "探险 #{n}，{dateShort}",
    "over.kickerEndless": "无尽",
    "over.kickerPractice": "探险 #{n} 的练习",
    "over.kickerTogether": "无尽，一起",
    "over.memberLine": "{tiles}，{distance}",
    "over.nacken": "内肯一直在水边等着。",
    "over.nackenLine": "内肯在静水边拉琴。驻足聆听的人，不会再往前走了。",
    "over.newWorld": "探索新的世界",
    "over.practiceBoard": "在今日地图上练习",
    "over.setOutAgain": "再次出发",
    "over.share": "分享",
    "over.shared": "已分享",
    "over.sjotroll": "你惊醒了一个湖中巨怪。",
    "over.sjotrollLine": "那看似小岛的东西，长着眼睛。",
    "over.skogstroll": "你惊醒了一个森林巨怪。",
    "over.skogstrollLine": "森林巨怪睡在苔藓底下，就在云杉长得最密的地方。它们最恨被人吵醒。",
    "over.streak": "连续天数",
    "over.streakDay": "{days}天",
    "over.streakDays": "{days}天",
    "over.title": "雾中有什么动了一下。",
    "over.todayResult": "今日成绩",
    "over.todayWaiting": "今日探险还在等你",
    "over.togetherBest": "组队最佳",
    "over.togetherMembers": "探险者",
    "over.yourBest": "个人最佳",
    "party.away": "离开",
    "party.back": "重新会合。",
    "party.cardLine": "{status}，{tiles}，{distance}",
    "party.copied": "已复制链接。",
    "party.fell": "观看中",
    "party.follow": "跟随",
    "party.following": "跟随 {name}",
    "party.full": "那次探险已满员。",
    "party.guest": "探险者 {n}",
    "party.invite": "邀请朋友",
    "party.inviteBody": "发送链接或出示二维码。对方打开后会来到你的小木屋旁，加入这次探险。最多 {n} 人。",
    "party.inviteTitle": "一起探险",
    "party.join": "加入",
    "party.joinBody": "一次深入雾中 {distance} 的探险。遇到精怪的人，会在一旁看着队友继续前进。",
    "party.joinTitle": "{name} 邀请你",
    "party.joinTitleAnon": "你收到了邀请",
    "party.joined": "{name} 加入了。",
    "party.leave": "离开这次探险",
    "party.lock": "不再接受新探险者",
    "party.locked": "那次探险不再接受新探险者。",
    "party.lockedNote": "已不再接受新探险者。",
    "party.lost": "连接中断。正在重新寻找队友。",
    "party.memberFell": "{name} 掉下去了。",
    "party.memberRemoved": "{name} 已不在这次探险中。",
    "party.members": "探险队员",
    "party.notNow": "以后再说",
    "party.openNote": "已重新接受新探险者。",
    "party.out": "在雾中",
    "party.over": "那次探险已经结束。",
    "party.qrLabel": "这次探险的链接二维码",
    "party.remove": "移出这次探险",
    "party.removeAsk": "要把 {name} 移出这次探险吗？对方将无法再通过链接回来。",
    "party.removed": "你已不在那次探险中。",
    "party.share": "分享链接",
    "party.shareText": "来和我一起在雾中探险。",
    "party.tiles": "{n}格",
    "party.tiles1": "1格",
    "party.unavailable": "无法开始。请稍后再试。",
    "party.unfollow": "停止跟随",
    "party.unlock": "重新接受新探险者",
    "party.you": "你",
    "party.youFell": "你掉下去了。现在看着队友。",
    "party.youNamed": "{name}（你）",
    "party.yourName": "你的名字",
    "placeholder.store": "[App Store 链接]",
    "privacy.cloudApp": "当 Mistsweeper 的 iCloud 打开时，你的设置、探险和空地，以及每个地方的视角，也会保存在你自己的 iCloud 中，让你在 iPhone 和 iPad 上都能接着玩。只有你的 Apple 账户能读取它们。我们无法读取。删除 App 后，它们仍会留在 iCloud 中。你可以在“设置” App 的 iCloud 中删除它们。",
    "privacy.cloudTitleApp": "在你的 iCloud 中",
    "privacy.contact": "Mistsweeper 由瑞典斯德哥尔摩的 Great Scott! AB 制作。如有任何关于隐私的问题，欢迎来信。",
    "privacy.contactTitle": "联系我们",
    "privacy.gameCenterApp": "如果你在设备上登录了 Game Center，App 会把你在每天的探险中到达的距离和无尽模式的最远成绩发送给 Apple。它们会以你的 Game Center 昵称显示在游戏的 Game Center 排行榜上，你的 Game Center 设置允许的玩家可以看到。游戏不会读取你的昵称或好友，也不保存来自 Game Center 的任何内容。如果你没有登录，就不会发送任何内容。你可以在“设置” App 的 Game Center 中退出登录。",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "本网站由 Cloudflare 提供服务。和所有网站托管服务一样，Cloudflare 需要获取你的 IP 地址才能把网站发送给你，并可能将其在自己的日志中短期保存，以保障服务安全。我们自己不保存任何日志。",
    "privacy.hostTitle": "网站托管",
    "privacy.intro": "Mistsweeper 是用来玩的，不是用来收集数据的。以下就是它保存的全部内容。",
    "privacy.list": "在你用昵称添加探险或举报昵称之前，不会发送任何关于你的信息。你在名单上的名次是在你的设备上算出的，依据的是所有人收到的同一份回复。添加之后，我们会保存昵称、探险及其点按记录和成绩、添加时间、来自网页还是 App，以及你的设备生成的一段代码经过转换后的形式。这些内容保存在 Cloudflare，昵称和探险会在 mistsweeper.com 和 App 中向所有人显示。此后，每天的探险都会自动添加，直到你在“设置”中关闭。为了让名单公平友好，我们可以查看添加的内容，隐藏或删除昵称或探险，并阻止某台设备继续添加。任何人都可以举报昵称，举报会保存发送设备的代码，同样经过转换。为防止滥用，同一地址的请求会以转换后的形式计数十分钟，且绝不写入记录。",
    "privacy.listRemove": "你添加的内容会一直保留，直到你移除。“设置”中的“移除我的探险”会把从那里添加的内容从所有名单中删除：浏览器和 App 各自移除自己的内容。转换后的代码会再保留几天，以免你的其他设备自动重新添加这次探险，你做过的举报中也会保留。如果你已经没有那台设备，请写信给我们，我们会替你删除。你随时可以询问我们保存了哪些关于你的内容。",
    "privacy.listRemoveTitle": "离开名单",
    "privacy.none": "没有账号，没有广告，没有跟踪，也没有 Cookie。我们不出售也不分享个人数据，除了你添加到“顶尖探险家”的内容和一起探险时发送的内容，也不收集任何个人数据。",
    "privacy.noneTitle": "我们不做的事",
    "privacy.share": "分享成绩时，文字发到哪里由你决定。指向 App Store 和电子邮件的链接会在游戏之外打开。",
    "privacy.shareTitle": "分享与链接",
    "privacy.stored": "你的设置、探险和成绩保存在此浏览器的本地存储中，方便你从上次离开的地方继续。这些数据留在你的设备上，只有在你把探险添加到“顶尖探险家”时才会发送给我们。在浏览器中清除本网站的数据，就会将它们从这里删除。",
    "privacy.storedApp": "你的设置、探险和成绩保存在此设备上的 App 中，方便你从上次离开的地方继续。只有在你把探险添加到“顶尖探险家”时，这些数据才会发送给我们。删除 App 就会将它们从此设备上移除。",
    "privacy.storedTitle": "在你的浏览器中",
    "privacy.storedTitleApp": "在你的设备上",
    "privacy.title": "隐私",
    "privacy.together": "当你邀请他人或通过链接加入一次探险时，在你们游玩期间，这次探险会保存在 Cloudflare：包括它的点按操作、每位队员选择的名字和旗帜，以及每个浏览器为回到自己位置而保留的一个代码。每位队员的镜头朝向只会在游玩时传给其他队员，从不保存。为了让游戏正常而公平地运行，我们可以查看一起进行的探险、实时观看正在进行的探险，并重新播放。一次探险的所有内容会在最后一次游玩一周后删除。",
    "privacy.togetherTitle": "一起探险",
    "privacy.updated": "更新于2026年11月1日",
    "privacy.updatedApp": "更新于2026年11月1日",
    "privacy.usageApp": "iOS App 通过 TelemetryDeck 统计使用情况。这是一项来自德国、服务器位于欧盟、注重隐私的分析服务。统计的内容包括：会话开始、探险开始或结束、分享成绩，以及打开空地。每条统计都带有 App 版本、游戏语言、设备信息（如型号、系统、屏幕和设置），以及一个代表此设备上本 App 的代码。这个代码在发送前会被不可逆地转换，无法追溯到你。你的 IP 地址不会被存储，也不会发送任何关于你的成绩或身份的信息。",
    "privacy.usageTitleApp": "App 使用统计",
    "privacy.visits": "为了了解有多少人访问，我们使用 Plausible，这是一项托管在欧盟、注重隐私的网站统计服务。它不使用 Cookie，也不保存任何个人数据，只记录总数，例如访问量、国家或地区、浏览器，以及把你带到这里的网站。你的 IP 地址不会被存储。",
    "privacy.visitsTitle": "访问统计",
    "punct.comma": "，",
    "punct.join": "{first}{next}",
    "punct.period": "。",
    "reminder.body": "探险 #{n} 正在雾中等你。",
    "sealed.body": "你还在外探索时，下一次探险已经开始了。你的成绩已保存：{distance}。你可以继续探索，当作练习。",
    "sealed.next": "开始探险 #{n}",
    "sealed.title": "探险 #{n} 已结束。",
    "settings.appPromo": "iOS App 提供提醒与触感反馈，目前正在测试中。",
    "settings.debug": "显示帧时间",
    "settings.developer": "开发者",
    "settings.feel": "体验",
    "settings.haptics": "触感反馈",
    "settings.hapticsLine": "探索一格或插上旗帜时，轻轻振动一下。",
    "settings.language": "语言",
    "settings.languageAuto": "自动",
    "settings.languageAutoLine": "跟随系统设置：{language}",
    "settings.languageDraft": "草稿",
    "settings.listAuto": "添加我的探险",
    "settings.listAutoLine": "每天的探险一结束，就会自动加入名单。",
    "settings.listName": "名单上的昵称",
    "settings.listNote": "探险结束时添加你的探险，就能加入今天的名单。",
    "settings.listRemove": "移除我的探险",
    "settings.motion": "减弱动态效果",
    "settings.motionLine": "雾静止不动，新的土地立即出现，世界的边缘保持清晰。默认跟随系统设置，直到你更改为止。",
    "settings.music": "音乐",
    "settings.musicLine": "探索时，森林里传来一段安静的旋律。",
    "settings.remind": "每日提醒",
    "settings.remindDay": "白天",
    "settings.remindDenied": "Mistsweeper 的通知已关闭。轻点即可在“设置”中允许通知。",
    "settings.remindEarlier": "提前{n}分钟",
    "settings.remindEvening": "晚上",
    "settings.remindLater": "推迟{n}分钟",
    "settings.remindLine": "如果今日探险还在等你，就在{time}提醒你。",
    "settings.remindNext": "新探险：{time}",
    "settings.remindNight": "凌晨",
    "settings.remindTime": "提醒时间",
    "settings.reminders": "提醒",
    "settings.sounds": "音效",
    "settings.soundsLine": "每次探索、每面旗帜、每个精怪，都有自己的声音。",
    "settings.theme": "主题",
    "settings.themeAuto": "自动",
    "settings.themeAutoLine": "跟随系统设置：浅色模式下为“白天”，深色模式下为“夜晚”",
    "settings.themeSupporter": "在“支持者”中选择",
    "settings.tilt": "移轴",
    "settings.title": "设置",
    "settings.zoom": "缩放",
    "start.continue": "继续，{distance}",
    "start.endlessLine": "每次都是新的世界，想玩几次都行。",
    "start.setOut": "出发",
    "start.tagDistance": "#{n}，{distance}",
    "start.tagDone": "#{n}，已完成，{distance}",
    "start.tagNew": "#{n}，全新",
    "start.tagNewDate": "#{n}，{dateShort}，全新",
    "start.tagProgress": "#{n}，进行中，{distance}",
    "start.todayDone": "今天已完成。距下次探险还有{time}。",
    "start.todayDoneShort": "距下次探险还有{time}。",
    "start.todayInProgress": "进行中。从上次离开的地方继续。",
    "start.todayInProgressShort": "从上次离开的地方继续。",
    "start.todayNew": "{dateLong}。一次机会，人人踏上同一片土地。",
    "start.todayNewShort": "一次机会，人人踏上同一片土地。",
    "support.devices": "打开 iCloud 后，App 会把你的探险和空地带到你的其他设备上。在浏览器中，它们只留在那个浏览器里。",
    "support.devicesTitle": "新设备",
    "support.intro": "Mistsweeper 由斯德哥尔摩的一家小工作室制作。如果遇到问题，或者有任何疑问，请写信给我们。",
    "support.list": "在{settings}中选择“{remove}”，就能把你的探险从所有名单上移除。要举报某个昵称，请长按所在的行，在电脑上则点按右键。",
    "support.listTitle": "你在{list}上的昵称",
    "support.purchase": "购买记录跟随你的 Apple 账户。在 App 菜单中打开{supporter}，然后选择“{restore}”。",
    "support.purchaseTitle": "购买记录不见了",
    "support.title": "支持",
    "supporter.accent": "强调色",
    "supporter.accentLine": "你的旗帜的颜色。",
    "supporter.accentNumber": "颜色 {n}",
    "supporter.banner": "旗帜",
    "supporter.banners": "旗帜",
    "supporter.bannersLine": "每次探险都可以插上另一面旗帜。",
    "supporter.buy": "成为支持者，{price}",
    "supporter.buyLine": "一次购买，不是订阅。通过“家人共享”，你的家人也能使用。",
    "supporter.buyNoPrice": "成为支持者",
    "supporter.cabin": "你的小木屋",
    "supporter.cabinLine": "让你找到的一座房屋立在小木屋的位置，每次探险和每块空地都是如此。",
    "supporter.chooseCabin": "在空地中选择",
    "supporter.clearingLocked": "只有支持者才能更改这块空地。",
    "supporter.clearings": "空地",
    "supporter.clearingsLine": "更大的空地（15×15格），以及想要多少就有多少的空地。",
    "supporter.failed": "购买未能完成。请稍后再试。",
    "supporter.free": "你玩的一切都免费，以后也免费。",
    "supporter.icon": "App 图标",
    "supporter.icons": "App 图标",
    "supporter.iconsLine": "选择你主屏幕上的图标。每个图标都有浅色和深色两种外观。",
    "supporter.lead": "成为支持者后，你可以选择游戏在你屏幕上的样子，也能帮助我们继续制作 Mistsweeper。",
    "supporter.line": "主题、App 图标、旗帜、小木屋",
    "supporter.nothingToRestore": "在此 Apple 账户中没有找到支持者的购买记录。",
    "supporter.pending": "正在等待批准。购买获批后，你就会成为支持者。",
    "supporter.restore": "恢复购买",
    "supporter.since": "支持者，自{date}起",
    "supporter.thanks": "感谢你支持 Mistsweeper。你可以在这里选择游戏在你屏幕上的样子。",
    "supporter.theme": "主题",
    "supporter.themeLine": "“白天”、“夜晚”和“自动”在“设置”中。",
    "supporter.themes": "主题",
    "supporter.themesLine": "用别的颜色玩整个游戏。有些主题还能选择旗帜的颜色。",
    "supporter.unreachable": "无法连接 App Store。请稍后再试。",
    "theme.day": "白天",
    "theme.fjord": "峡湾",
    "theme.mossa": "苔藓",
    "theme.night": "夜晚",
    "theme.pergament": "羊皮纸",
    "theme.rosa": "粉红",
    "theme.skymning": "黄昏",
    "time.hoursMinutes": "{h}小时{m}分钟",
    "time.minutes": "{m}分钟",
    "webgl.missing": "Mistsweeper 需要 WebGL 2，但此浏览器不支持。",
    "welcome.mistDaily": "每天都有新的探险：人人踏上同一片土地，只有一次机会。无尽模式留给安静的时光。",
    "welcome.mistNumbers": "数字表示它周围八格中藏着几个精怪。在你认为有精怪沉睡的地方插上旗帜，然后继续前进。",
    "welcome.mistText": "你从林间空地上的一座小木屋出发，其余的一切都笼罩在雾中。从你已探索的区域开始，一次探索一格。",
    "welcome.mistTitle": "走进雾中",
    "welcome.next": "下一步",
    "welcome.remindNo": "以后再说",
    "welcome.remindText": "每天都有新的探险。选一个时间，如果当天的探险还在等你，我们会提醒你。你可以在“设置”中更改。",
    "welcome.remindTitle": "每日提醒",
    "welcome.remindYes": "提醒我",
    "welcome.skip": "跳过",
    "welcome.starsLater": "过一阵子，我们会问问你的看法。到时候花一点时间，就能帮我们很大的忙。",
    "welcome.starsText": "Mistsweeper 由斯德哥尔摩的小工作室 Great Scott! 制作。对一款小游戏来说，App Store 上的评分是让更多人发现它的最好方式。",
    "welcome.starsTitle": "出自一家小工作室",
    "welcome.step": "第{n}步，共{total}步",
    "widget.bestDay": "单日最佳 {distance}",
    "widget.clearingDescription": "你的空地，以及已发现的数量和最佳成绩。",
    "widget.clearingName": "你的空地",
    "widget.description": "显示今日探险离开时的样子，以及连续天数。",
    "widget.next": "下次还有{time}",
    "widget.streak": "连续天数：{days}",
    "widget.waiting": "待出发",
  },
  "zh-Hant": {
    "a11y.bannerMode": "插旗模式",
    "a11y.board.banner": "旗幟",
    "a11y.board.bannerRemoved": "已拔起旗幟。",
    "a11y.board.banners1": "1面旗幟",
    "a11y.board.bannersN": "{n}面旗幟",
    "a11y.board.cabin": "小木屋",
    "a11y.board.cellBanner": "旗幟",
    "a11y.board.cellCabin": "小木屋",
    "a11y.board.cellExplored": "已探索",
    "a11y.board.cellMist": "霧",
    "a11y.board.cellWrongBanner": "插錯的旗幟",
    "a11y.board.chordWaits": "周圍的旗幟與數字不符。",
    "a11y.board.chosen": "已選擇：{name}。",
    "a11y.board.confirmed": "已確認",
    "a11y.board.creature": "一個精怪",
    "a11y.board.deepMist": "濃霧",
    "a11y.board.describe": "描述周圍",
    "a11y.board.dirEast": "向東",
    "a11y.board.dirNorth": "向北",
    "a11y.board.dirSouth": "向南",
    "a11y.board.dirWest": "向西",
    "a11y.board.east": "以東{n}格",
    "a11y.board.explore": "探索周圍",
    "a11y.board.explored": "已探索",
    "a11y.board.exploredOn": "已探索，{what}",
    "a11y.board.frontier0": "沒有霧可以探索",
    "a11y.board.frontier1": "有1格霧可以探索",
    "a11y.board.frontierN": "有{n}格霧可以探索",
    "a11y.board.furthest": "最遠距離 {distance}。",
    "a11y.board.hid": "藏在這裡",
    "a11y.board.hintExplore": "探索周圍的格子。",
    "a11y.board.hintPlant": "插上一面旗幟。",
    "a11y.board.hintReveal": "探索這一格。",
    "a11y.board.hintTakeAway": "拔起這面旗幟。",
    "a11y.board.inMist": "{n}格霧",
    "a11y.board.inView": "畫面中{what}",
    "a11y.board.listAnd": "{list}和{last}",
    "a11y.board.mist": "霧",
    "a11y.board.nextTo": "旁邊的數字：{numbers}",
    "a11y.board.north": "以北{n}格",
    "a11y.board.place": "小木屋{where}，距離 {distance}",
    "a11y.board.plant": "插上旗幟",
    "a11y.board.revealed1": "探索了1格。",
    "a11y.board.revealedN": "探索了{n}格。",
    "a11y.board.rotorBanners": "旗幟",
    "a11y.board.rotorMist": "可探索的霧",
    "a11y.board.rotorNorthSouth": "南北",
    "a11y.board.rotorNumbers": "待解數字",
    "a11y.board.roundIt": "周圍有{what}",
    "a11y.board.rowHere": "這裡：{tiles}。",
    "a11y.board.rowNorth": "北邊：{tiles}。",
    "a11y.board.rowSouth": "南邊：{tiles}。",
    "a11y.board.south": "以南{n}格",
    "a11y.board.takeAway": "拔起旗幟",
    "a11y.board.turned": "已旋轉。",
    "a11y.board.west": "以西{n}格",
    "a11y.board.woke": "在這裡醒來，結束了探險",
    "a11y.board.wrongBanner": "插錯的旗幟",
    "a11y.distance": "最遠距離",
    "a11y.find": "新發現：{name}。",
    "a11y.findMore": "新發現：{name}，另有{n}個。",
    "a11y.map": "探險地圖",
    "about.body1": "過了小木屋，便是霧。霧裡住著古老的精怪：苔蘚下的巨怪、林間的胡爾德拉、靜水邊的內肯。",
    "about.body2": "Mistsweeper 講的是先讀懂土地，再踏上去。數字會告訴你附近睡著幾個精怪。能走多遠，由你決定。",
    "about.body3": "Mistsweeper 是經典益智遊戲《踩地雷》的全新詮釋，靈感來自北歐神話與民間故事。",
    "about.made": "由瑞典斯德哥爾摩的 Great Scott! 製作。",
    "about.version": "版本{version}",
    "accessibility.contact": "如果有什麼讓你無法遊玩，或有什麼能讓遊戲對你來說更容易，請寫信告訴我們。",
    "accessibility.contactTitle": "告訴我們",
    "accessibility.contrast": "世界與選單都以墨水畫在紙上，無論白天或夜晚，對比度都遠高於文字所需。紅色用來標示重要的東西，但從不單獨使用：旗幟有自己的形狀，探險結束後插錯的旗幟會打上叉，探險結束的那一格會加上外框。",
    "accessibility.contrastTitle": "對比與色彩",
    "accessibility.dark": "遊戲會跟隨系統的深色模式：「夜晚」是月光下的世界。你也可以在「設定」的「主題」中選擇「白天」或「夜晚」。",
    "accessibility.darkTitle": "深色與淺色",
    "accessibility.intro": "我們希望讓越多人能玩 Mistsweeper 越好。以下是遊戲目前在網頁版與 iOS App 中支援的功能，以及我們正在努力的方向。",
    "accessibility.keys": "在網頁上，整個遊戲都能用鍵盤來玩：方向鍵或 WASD 鍵移動游標，Enter 鍵或空白鍵探索一格，F 鍵插上或拔起旗幟，Q 和 E 鍵旋轉視角，T 和 G 鍵傾斜視角，加號和減號鍵縮放，H 鍵回到小木屋，Esc 鍵關閉目前開啟的內容。",
    "accessibility.keysTitle": "網頁版的鍵盤操作",
    "accessibility.motion": "開啟系統的「減少動態效果」，或開啟遊戲「設定」中的對應開關後，畫面中不會有任何東西自行移動。霧、風、動物和視角都會靜止，新的土地立即出現，世界的邊緣保持清晰。",
    "accessibility.motionTitle": "減少動態效果",
    "accessibility.sound": "聲音和音樂傳達的一切，你都能在畫面上看到。遊戲沒有語音，也沒有影片。在 iOS App 中，探索和插旗時會有觸覺回饋。音樂、音效和觸覺回饋都可以在「設定」中個別關閉。",
    "accessibility.soundTitle": "聲音",
    "accessibility.title": "輔助使用",
    "accessibility.updated": "更新於2026年10月25日",
    "accessibility.work": "在 iOS App 中，可以用「旁白」與「語音控制」朗讀和遊玩地圖，文字也會跟隨你設定的文字大小。在網頁上，選單與按鈕已經有供螢幕閱讀器使用的標籤，但地圖目前還無法用螢幕閱讀器朗讀或遊玩。我們正在努力。",
    "accessibility.workTitle": "我們正在努力的事",
    "app.tagline": "一場無盡的探險",
    "app.title": "Mistsweeper",
    "apps.appStore": "App Store",
    "apps.colortap": "像素畫著色本，沒有廣告，也沒有追蹤。",
    "apps.intro": "同一間工作室的小遊戲與 App。",
    "apps.krono": "把歷史、流行文化和音樂依序排在時間軸上。",
    "apps.ordna": "安靜的分類解謎。一千關，沒有任何打擾。",
    "apps.tapotron": "在一格格躍躍欲試的按鈕上，玩點擊遊戲、打節拍。",
    "archive.appNoteCloud": "儲存在 iCloud 中，你的所有裝置都能看到。",
    "archive.appNoteDevice": "儲存在這部裝置上。為 Mistsweeper 開啟 iCloud，就能在你的所有裝置上看到。",
    "archive.best": "個人最佳",
    "archive.daily": "每日探險",
    "archive.dayStreak": "連續天數",
    "archive.endlessBest": "最佳",
    "archive.endlessLast": "上次",
    "archive.endlessRuns": "次數",
    "archive.expeditions": "探險次數",
    "archive.gameCenter": "在 Game Center 與朋友比較成績",
    "archive.notPlayed": "未出發",
    "archive.sealed": "未完成，已封存",
    "archive.today": "今天，進行中",
    "archive.todayWord": "今天",
    "archive.webNote": "儲存在此瀏覽器中。iOS App 有自己的探險紀錄，存放在 iCloud。",
    "archive.webNoteShort": "儲存在此瀏覽器中。",
    "banner.1": "三尾",
    "banner.a1": "燕尾",
    "banner.a3": "矛尖",
    "banner.b1": "扇形",
    "banner.b2": "渡鴉旗",
    "banner.b3": "半圓",
    "banner.c2": "T字旗",
    "banner.c3": "路標",
    "banner.c4": "扭轉旗",
    "beta.bugs": "有什麼地方不正常，或看起來不對勁嗎？請告訴我們你做了什麼、發生了什麼，以及使用的裝置。附上截圖會很有幫助。",
    "beta.bugsTitle": "問題",
    "beta.changes": "測試期間遊戲會持續改變。正式推出後，探險會接著現在的編號繼續，不會從 #1 重新開始。",
    "beta.changesTitle": "將會改變的內容",
    "beta.intro": "Mistsweeper 已經可以玩了，但還沒有完成。在正式推出之前，我們需要你的幫忙。",
    "beta.language": "遊戲支援九種語言，但大部分譯文還沒有經過母語人士閱讀。如果有地方讀起來不對或不自然，請告訴我們你在哪裡看到它，以及你會怎麼說。",
    "beta.languageTitle": "文字與語言",
    "beta.more": "了解更多",
    "beta.ticker1": "Mistsweeper 正在測試中",
    "beta.ticker2": "幫我們找出問題",
    "beta.ticker3": "幫我們改進文字",
    "beta.title": "關於測試",
    "button.banner": "旗幟",
    "button.cancel": "取消",
    "button.close": "關閉",
    "button.daily": "今日探險",
    "button.endless": "無盡",
    "button.home": "回到小木屋",
    "button.practice": "練習",
    "button.settings": "設定",
    "button.zoomIn": "放大",
    "button.zoomOut": "縮小",
    "clearing.arrange": "擺放",
    "clearing.cabin": "小木屋留在原地。",
    "clearing.cabinChosen": "你的小木屋：{name}。",
    "clearing.cabinHint": "小木屋可以換成你找到的任何房屋。按住它來選擇。",
    "clearing.cat.creatures": "精怪",
    "clearing.cat.ground": "地形",
    "clearing.cat.houses": "房屋",
    "clearing.cat.plants": "植物",
    "clearing.cat.stones": "岩石",
    "clearing.changeCabin": "更換小木屋",
    "clearing.chooseCabin": "選擇你的小木屋",
    "clearing.clear": "清除",
    "clearing.delete": "刪除",
    "clearing.deleteBody": "擺放在那裡的東西會一起消失。你的發現會保留。",
    "clearing.deleteTitle": "刪除 {name}？",
    "clearing.deleted": "{name} 已刪除。",
    "clearing.discovered": "已發現{n}/{total}",
    "clearing.done": "完成",
    "clearing.edit": "編輯",
    "clearing.editing": "正在編輯：{name}",
    "clearing.family.barley": "大麥",
    "clearing.family.barn": "穀倉",
    "clearing.family.beacon": "烽火堆",
    "clearing.family.beehive": "蜂箱",
    "clearing.family.bergstroll": "山嶺巨怪",
    "clearing.family.birch": "白樺",
    "clearing.family.boat": "小船",
    "clearing.family.boathouse": "船庫",
    "clearing.family.boulder": "巨石",
    "clearing.family.bush": "灌木叢",
    "clearing.family.cairn": "石堆",
    "clearing.family.campfire": "營火",
    "clearing.family.cart": "板車",
    "clearing.family.cave": "洞穴",
    "clearing.family.church": "木板教堂",
    "clearing.family.cottage": "農舍",
    "clearing.family.driftwood": "漂流木",
    "clearing.family.fabod": "夏季牧場",
    "clearing.family.faering": "挪威小艇",
    "clearing.family.fence": "木柵欄",
    "clearing.family.fern": "蕨類",
    "clearing.family.fishhut": "漁屋",
    "clearing.family.flottning": "放木排",
    "clearing.family.fornborg": "古壘",
    "clearing.family.goahti": "草皮屋",
    "clearing.family.gravhog": "墳丘",
    "clearing.family.harbre": "高腳倉",
    "clearing.family.hassja": "曬草架",
    "clearing.family.hides": "獸皮與肉乾",
    "clearing.family.hjell": "曬魚架",
    "clearing.family.house": "小木屋",
    "clearing.family.huldra": "胡爾德拉",
    "clearing.family.huntingtower": "狩獵台",
    "clearing.family.jatte": "巨人",
    "clearing.family.jetty": "棧橋",
    "clearing.family.juniper": "杜松",
    "clearing.family.kastal": "石塔樓",
    "clearing.family.kolmila": "炭窯",
    "clearing.family.kummel": "海岸石標",
    "clearing.family.laundry": "曬衣繩",
    "clearing.family.lavvu": "薩米帳篷",
    "clearing.family.lilypads": "睡蓮",
    "clearing.family.log": "原木",
    "clearing.family.longhouse": "長屋",
    "clearing.family.massif": "群峰",
    "clearing.family.mushroom": "蘑菇",
    "clearing.family.nacken": "內肯",
    "clearing.family.njalla": "單柱倉",
    "clearing.family.oak": "橡樹",
    "clearing.family.oats": "燕麥",
    "clearing.family.outcrop": "裸岩",
    "clearing.family.peak": "山峰",
    "clearing.family.pebbles": "小石子",
    "clearing.family.pine": "松樹",
    "clearing.family.reeds": "蘆葦",
    "clearing.family.rengarde": "馴鹿圍欄",
    "clearing.family.rock": "石頭",
    "clearing.family.rockcarving": "岩畫",
    "clearing.family.rootcellar": "地窖",
    "clearing.family.rowan": "花楸",
    "clearing.family.ruin": "廢墟",
    "clearing.family.runestone": "符文石",
    "clearing.family.rye": "黑麥",
    "clearing.family.sauna": "三溫暖",
    "clearing.family.seamark": "航標",
    "clearing.family.shed": "倉房",
    "clearing.family.shipsetting": "船形石陣",
    "clearing.family.shorestones": "岸邊石",
    "clearing.family.sjotroll": "湖中巨怪",
    "clearing.family.skogstroll": "森林巨怪",
    "clearing.family.smithy": "鐵匠鋪",
    "clearing.family.snag": "枯樹",
    "clearing.family.spruce": "雲杉",
    "clearing.family.stonecircle": "石圈",
    "clearing.family.stones": "立石",
    "clearing.family.stooks": "收割後的田",
    "clearing.family.stormannagard": "首領大廳",
    "clearing.family.stump": "樹樁",
    "clearing.family.tent": "帳篷",
    "clearing.family.tjardal": "焦油窯",
    "clearing.family.tuft": "青草",
    "clearing.family.watermill": "水磨坊",
    "clearing.family.well": "水井",
    "clearing.family.wellsweep": "吊桿井",
    "clearing.family.windmill": "風車",
    "clearing.family.windthrow": "風倒木",
    "clearing.family.woodpile": "柴堆",
    "clearing.fold": "收合",
    "clearing.ground.forest": "森林",
    "clearing.ground.meadow": "草地",
    "clearing.ground.mountain": "山地",
    "clearing.ground.water": "水域",
    "clearing.grown": "霧退去了。",
    "clearing.hint": "在下方選一樣東西，然後點一下格子。再點一下可以旋轉。按住格子可以更改。",
    "clearing.hintVoiceOver": "在下方選一樣東西，然後在格子上點兩下。格子的動作可以編輯、旋轉或清除它。",
    "clearing.large": "大",
    "clearing.locked": "尚未發現。它還在霧中等待。",
    "clearing.lockedName": "{name}，尚未發現",
    "clearing.made": "新的空地：{name}。",
    "clearing.mist": "那裡還在霧中。",
    "clearing.needsLand": "這個需要放在陸地上。",
    "clearing.needsWater": "這個需要放在水上。",
    "clearing.new": "新空地",
    "clearing.photo": "拍照",
    "clearing.photo.back": "返回",
    "clearing.photo.failed": "這裡無法產生照片。",
    "clearing.photo.file": "clearing",
    "clearing.photo.formats": "畫面比例",
    "clearing.photo.notSaved": "無法儲存照片。你可以在「設定」中允許 Mistsweeper 加入照片。",
    "clearing.photo.picture": "你的照片",
    "clearing.photo.save": "儲存",
    "clearing.photo.saved": "已儲存到「照片」。",
    "clearing.photo.share": "分享",
    "clearing.photo.shutter": "拍一張照片",
    "clearing.photo.usage": "Mistsweeper 會在你要求時，把空地的照片儲存到你的照片圖庫。",
    "clearing.rename": "重新命名",
    "clearing.renameSave": "儲存",
    "clearing.renameTitle": "為空地命名",
    "clearing.size": "空地大小",
    "clearing.small": "小",
    "clearing.supporter": "支持者",
    "clearing.turn": "旋轉",
    "clearing.undo": "還原",
    "clearing.yours": "你的空地",
    "controls.banner": "插上旗幟",
    "controls.click": "點擊",
    "controls.drag": "拖曳",
    "controls.pan": "平移",
    "controls.pinch": "兩指開合",
    "controls.qe": "Q 和 E",
    "controls.reveal": "探索",
    "controls.rightClick": "按右鍵",
    "controls.rightDrag": "右鍵拖曳",
    "controls.scroll": "捲動",
    "controls.tg": "T 和 G",
    "controls.tilt": "傾斜視角",
    "controls.title": "操作方式",
    "controls.turn": "旋轉視角",
    "controls.turnTilt": "旋轉和傾斜視角",
    "controls.twist": "兩指旋轉",
    "controls.twoFingers": "兩指上下滑動",
    "controls.voActions": "向上或向下滑動",
    "controls.voFind": "可探索的霧、待解數字、旗幟、南北",
    "controls.voMagicTap": "兩指點兩下",
    "controls.voMove": "在地圖上移動四格",
    "controls.voRotor": "轉動轉輪",
    "controls.voScroll": "三指滑動",
    "controls.voSummary": "你在哪裡，走了多遠",
    "controls.voSwipe": "向左或向右滑動",
    "controls.voTileActions": "格子的動作：旗幟、探索周圍、描述周圍",
    "controls.voTiles": "從北邊起，逐行讀出畫面中的格子",
    "controls.zoom": "縮放",
    "daily.next": "距離下次探險還有{time}",
    "feedback.subject": "Mistsweeper 意見回饋，版本{version}",
    "find.new": "新發現",
    "getApp.beta": "這款 App 目前仍在測試階段，需透過 TestFlight 安裝。TestFlight 是 Apple 的 App，讓你在 App 正式推出前搶先試用。",
    "getApp.haptics": "指尖下的觸覺回饋。",
    "getApp.intro": "同樣的每日探險，再加上幾件只有 App 才做得到的事。",
    "getApp.join": "在 TestFlight 加入測試",
    "getApp.note": "你在此瀏覽器中的探險會留在這裡。App 有自己的紀錄。",
    "getApp.offline": "離線也能玩。",
    "getApp.qr": "用 iPhone 相機對準這裡，加入測試。",
    "getApp.qrLabel": "TestFlight 測試版的 QR Code",
    "getApp.reminder": "每天在你選定的時間提醒你。",
    "getApp.widget": "顯示今日探險和連續天數的小工具。",
    "hint.clearingDesktop": "選一樣東西，擺放到空地上。在格子上按右鍵可以更改。",
    "hint.photoDesktop": "在觀景窗中框好空地，然後拍照。",
    "hint.reveal": "點一下已探索區域旁的霧來探索。",
    "hint.revealDesktop": "點擊已探索區域旁的霧來探索。按右鍵可以插上旗幟。",
    "hint.revealVoiceOver": "滑動到已探索區域旁邊的霧，或用轉輪找到它，然後點兩下來探索。",
    "howto.1": "你從小木屋出發。其餘的一切都是霧。",
    "howto.2": "探索緊鄰已探索區域的一格。你只能從去過的地方往前走，一次一格。",
    "howto.3": "數字代表它周圍八格中藏著幾個精怪。",
    "howto.3example": "以下圖為例，仍在霧中的三格裡，有兩格藏著精怪。",
    "howto.4mouse": "在你認為藏著精怪的地方插上旗幟：在那一格上按右鍵。",
    "howto.4touch": "在你認為藏著精怪的地方插上旗幟：開啟插旗模式，然後點一下那一格。",
    "howto.4voiceOver": "在你認為藏著精怪的地方插上旗幟：在那一格上向上或向下滑動，切換到它的動作，然後選擇「插上旗幟」。",
    "howto.5": "驚醒精怪，探險就會結束。你的成績，就是你離小木屋最遠的距離。",
    "howto.6": "每天都有新的探險：人人踏上同一片土地，只有一次機會。無盡模式留給安靜的時光。",
    "howto.tryLesson": "在世界中試玩",
    "hud.best": "最佳 {distance}",
    "hud.clearing": "空地",
    "hud.menu": "選單",
    "hud.north": "轉回北方朝上",
    "hud.practice": "練習，#{n}",
    "hud.today": "今日",
    "hud.turnLeft": "向左旋轉，Q",
    "hud.turnLeftKey": "Q",
    "hud.turnRight": "向右旋轉，E",
    "hud.turnRightKey": "E",
    "inspect.barley.1": "這是大麥。",
    "inspect.barley.2": "很快就是麵包，或是更好的東西。",
    "inspect.barn.1": "這是一座穀倉。",
    "inspect.barn.2": "裡面全是乾草和貓。",
    "inspect.barn.3": "乾草堆到屋頂。夠撐到春天了。",
    "inspect.beacon.1": "一座烽火堆。望見敵人就點燃。",
    "inspect.beacon.2": "一處點起，再傳下一處，舉國皆知。",
    "inspect.beacon.3": "乾透了，備好了。還沒有人點火。",
    "inspect.beehive.1": "蜂箱。最好別敲。",
    "inspect.beehive.2": "我們在忙。",
    "inspect.birch.1": "這是一棵白樺。",
    "inspect.birch.2": "白樹皮，黑刻痕。有人一直在數。",
    "inspect.birch.3": "白樺皮濕了也點得著。值得記下。",
    "inspect.birch.4": "白樺最先長葉，最先變黃。",
    "inspect.boat.1": "一艘小船。有人會想把它要回去。",
    "inspect.boat.2": "槳收著。船上沒人。",
    "inspect.boathouse.1": "一股焦油和濕繩子的味道。",
    "inspect.boathouse.2": "船出去了。沒人說什麼時候回來。",
    "inspect.boulder.1": "一塊巨石。它搬過一次家，跟著冰河。",
    "inspect.boulder.2": "我跟著冰河來。我不走了。",
    "inspect.boulder.3": "冰河把它留在這裡，自己回家了。",
    "inspect.bush.1": "這是灌木叢。",
    "inspect.bush.2": "灌木叢裡什麼也沒藏。大概。",
    "inspect.bush.3": "有什麼響了一下。只是灌木叢。",
    "inspect.cabin": "你的小木屋。爐子還溫著。",
    "inspect.cairn.1": "這是一座石堆。",
    "inspect.cairn.2": "路過的人，都會添一塊石頭。",
    "inspect.cairn.3": "有人標出了路。或是一座墳。",
    "inspect.campfire.1": "這是一堆營火。",
    "inspect.campfire.2": "一堆火，旁邊沒有人。",
    "inspect.campfire.3": "有人匆匆離開了。",
    "inspect.cart.1": "這是一輛板車。",
    "inspect.cart.2": "馬停在哪，它就留在哪。",
    "inspect.cave.1": "這是一個洞穴。它通往裡面。",
    "inspect.cave.2": "進來。",
    "inspect.cave.3": "裡面有東西在呼吸。也可能是風。",
    "inspect.church.1": "一座木板教堂。塗了幾百年的焦油。",
    "inspect.church.2": "沒用一塊石頭。只有木頭和耐心。",
    "inspect.church.3": "裡面很安靜。一直都是。",
    "inspect.creature.bergstroll": "這裡曾住著一個山嶺巨怪。",
    "inspect.creature.huldra": "這裡曾住著胡爾德拉。",
    "inspect.creature.jatte": "這裡曾住著一個巨人。",
    "inspect.creature.nacken": "這裡曾住著內肯。",
    "inspect.creature.sjotroll": "這裡曾住著一個湖中巨怪。",
    "inspect.creature.skogstroll": "這裡曾住著一個森林巨怪。",
    "inspect.deer.1": "一隻狍鹿。牠已經看見你了。",
    "inspect.deer.2": "牠抬起頭，又繼續吃草。",
    "inspect.driftwood.1": "漂流木。沒有人知道從哪裡來。",
    "inspect.driftwood.2": "它見過的海，比這裡任何人都多。",
    "inspect.duck.1": "一隻綠頭鴨。牠只管自己的事。",
    "inspect.duck.2": "牠對此有意見。",
    "inspect.elk.1": "一頭駝鹿。牠不在乎。",
    "inspect.elk.2": "森林裡最大的東西，也最安靜。",
    "inspect.faering.1": "一艘挪威小艇。四支槳，一面帆。",
    "inspect.faering.2": "和長船是同一種手藝。",
    "inspect.fence.1": "一道木柵欄。連一根釘子也沒用。",
    "inspect.fence.2": "它該圍住的，早就走遠了。",
    "inspect.fern.1": "這是蕨類。",
    "inspect.fern.2": "蕨類比樹先到這裡。",
    "inspect.fern.3": "據說蕨類會在仲夏夜開花。沒有人見過。",
    "inspect.fishhut.1": "漁網、浮標，還有陳年鯡魚。",
    "inspect.fishhut.2": "漁屋。味道先到。",
    "inspect.flottning.1": "原木正往海岸漂去。",
    "inspect.flottning.2": "放木排。河水負責運送。",
    "inspect.fornborg.1": "一座古壘。烽火一點，人們就往這裡跑。",
    "inspect.fornborg.2": "石牆塌了。它擋過的人，也都不在了。",
    "inspect.fornborg.3": "沒有人知道這些石頭是誰堆的。",
    "inspect.goahti.1": "一間草皮屋。外面是草皮，裡面很暖。",
    "inspect.goahti.2": "煙從頂上出去。一直都是這樣。",
    "inspect.gravhog.1": "一座墳丘。葬著某位重要人物。",
    "inspect.gravhog.2": "有人長眠於此。腳步放輕。",
    "inspect.gravhog.3": "一座墳。上面的青草，長了一千年。",
    "inspect.harbre.1": "一座高腳倉。架在柱子上，老鼠搆不著。",
    "inspect.harbre.2": "裡面是去年的穀物。",
    "inspect.hassja.1": "一座曬草架。牧草靠風吹乾。",
    "inspect.hassja.2": "架上晾著牧草。現在可不能下雨。",
    "inspect.hides.1": "馴鹿皮繃在架上。一點也不浪費。",
    "inspect.hides.2": "肉在風中晾乾。過冬的糧食。",
    "inspect.hjell.1": "鱈魚正在晾乾。掌廚的是風。",
    "inspect.hjell.2": "在這裡就聞得到。",
    "inspect.home": "這裡住著 {name}。",
    "inspect.huntingtower.1": "有人坐在上面等著。",
    "inspect.huntingtower.2": "駝鹿都知道。",
    "inspect.jetty.1": "這是一座棧橋。",
    "inspect.jetty.2": "往外走了一小段，就放棄了。",
    "inspect.jetty.3": "適合打赤腳的好地方。",
    "inspect.juniper.1": "這是一株杜松。",
    "inspect.juniper.2": "一株杜松。它會刺回來。",
    "inspect.juniper.3": "一株杜松。遠遠看去，像有人站著不動。",
    "inspect.kastal.1": "厚牆，小窗。",
    "inspect.kastal.2": "有人料到會有客人，不是友善的那種。",
    "inspect.kolmila.1": "這是一座炭窯。",
    "inspect.kolmila.2": "一連悶燒好幾週。總得有人醒著。",
    "inspect.kolmila.3": "木柴進去。木炭出來。",
    "inspect.kummel.1": "一座海岸石標。告訴水手身在何處。",
    "inspect.kummel.2": "從海上看得見。它的用處僅此而已。",
    "inspect.laundry.1": "某人曬的衣服。",
    "inspect.laundry.2": "傍晚就會乾，只要霧別過來。",
    "inspect.laundry.3": "少了一隻襪子。",
    "inspect.lavvu.1": "一頂薩米帳篷。到早上可能就不在了。",
    "inspect.lavvu.2": "木桿和布。別的都不需要。",
    "inspect.lilypads.1": "睡蓮。",
    "inspect.lilypads.2": "睡蓮。別摘。有人很寶貝它們。",
    "inspect.lilypads.3": "睡蓮的長莖，一路伸進黑暗。",
    "inspect.log.1": "這是一根原木。",
    "inspect.log.2": "倒了很久了。苔蘚都搬進來了。",
    "inspect.massif.1": "這是一片群峰。",
    "inspect.massif.2": "山不會注意到訪客。",
    "inspect.massif.3": "岩縫裡有雪，八月也一樣。",
    "inspect.mushroom.1": "蘑菇。最好別碰。",
    "inspect.mushroom.2": "所有蘑菇都能吃。有些只能吃一次。",
    "inspect.mushroom.3": "總有人想把它們裝進籃子。",
    "inspect.njalla.1": "一座單柱倉。一根柱子，熊只能看著。",
    "inspect.njalla.2": "食物放在高處，只有人搆得著。",
    "inspect.oak.1": "這是一棵橡樹。",
    "inspect.oak.2": "一棵橡樹。關於它最老的故事，也沒它老。",
    "inspect.oak.3": "這棵橡樹見過國王來來去去。",
    "inspect.oak.4": "從前，每棵橡樹都歸王室所有。",
    "inspect.oats.1": "這是燕麥。",
    "inspect.oats.2": "燕麥，給馬吃的，也是早餐。",
    "inspect.outcrop.1": "裸岩。大地沒穿外套。",
    "inspect.outcrop.2": "太陽下溫熱，夜裡冰涼。",
    "inspect.outcrop.3": "這是冰河打磨的。",
    "inspect.peak.1": "山峰。終年積雪。",
    "inspect.peak.2": "這上面什麼也不長。",
    "inspect.peak.3": "據說視野很好。霧不這麼認為。",
    "inspect.pebbles.1": "小石子。",
    "inspect.pebbles.2": "每一顆都曾經是一座山。",
    "inspect.pine.1": "這是一棵松樹。",
    "inspect.pine.2": "是松樹先來的。",
    "inspect.pine.3": "松樹偏愛乾燥貧瘠的地方。這棵很知足。",
    "inspect.pine.4": "松樹往哪邊歪，風說了算。",
    "inspect.reeds.1": "蘆葦。",
    "inspect.reeds.2": "蘆葦在低語。只是風。",
    "inspect.reeds.3": "裡面有什麼動了一下。大概是鳥。",
    "inspect.reindeer.1": "這裡的每頭馴鹿都有主人。",
    "inspect.reindeer.2": "牠正在路上。牠知道要去哪裡。",
    "inspect.rengarde.1": "秋天，鹿群會聚到這裡。",
    "inspect.rengarde.2": "現在空著。馴鹿知道自己要去哪裡。",
    "inspect.rock.1": "這是一塊石頭。",
    "inspect.rock.2": "有事？一塊石頭。",
    "inspect.rock.3": "一塊石頭。它沒有意見。",
    "inspect.rock.4": "什麼事也沒發生。畢竟是石頭。",
    "inspect.rockcarving.1": "刻在岩石上，比符文早了很久。",
    "inspect.rockcarving.2": "我們來過。",
    "inspect.rockcarving.3": "沒有人讀得懂。它還是在說些什麼。",
    "inspect.rootcellar.1": "馬鈴薯，在黑暗裡。",
    "inspect.rootcellar.2": "裡面從不結凍。",
    "inspect.rowan.1": "這是一棵花楸。",
    "inspect.rowan.2": "一棵花楸。果子多，雪就多，老人家都這麼說。",
    "inspect.rowan.3": "據說巨怪都繞著花楸走。",
    "inspect.ruin.1": "這是一座廢墟。",
    "inspect.ruin.2": "曾經有人以它為傲。",
    "inspect.ruin.3": "原本立在這裡的已經不在。石頭還在。",
    "inspect.runestone.1": "這是一塊符文石。",
    "inspect.runestone.2": "這是有人為孩子立的。",
    "inspect.runestone.3": "符文石。上面刻著：東行。未歸。",
    "inspect.runestone.4": "符文石。能讀者，讀之。",
    "inspect.rye.1": "這是黑麥。",
    "inspect.rye.2": "黑麥站著過冬，一無所求。",
    "inspect.sauna.1": "這是一間三溫暖。",
    "inspect.sauna.2": "一間三溫暖。還有餘溫。",
    "inspect.sauna.3": "門邊放著白樺枝。有人會回來。",
    "inspect.seamark.1": "一座航標。水手看著它掌舵。",
    "inspect.seamark.2": "這裡。",
    "inspect.shed.1": "一間倉房。工具、繩索，還有焦油味。",
    "inspect.shed.2": "鎖著，鑰匙在別的地方。",
    "inspect.shipsetting.1": "一艘石船，送人走最後一程。",
    "inspect.shipsetting.2": "曾有人乘這艘船遠行。",
    "inspect.shipsetting.3": "船形石陣。鐵器時代以來，它沒動過。",
    "inspect.shorestones.1": "扁石頭最會打水漂。",
    "inspect.shorestones.2": "水在它們身上下了很久的功夫。",
    "inspect.smithy.1": "這是一間鐵匠鋪。",
    "inspect.smithy.2": "一股炭和鐵的味道。",
    "inspect.smithy.3": "據說巨怪不喜歡鐵。",
    "inspect.snag.1": "它死了。照樣站著。",
    "inspect.snag.2": "一棵枯樹。乾透了，生火正好。",
    "inspect.snag.3": "啄木鳥倒是還很有興趣。",
    "inspect.spruce.1": "這是一棵雲杉。",
    "inspect.spruce.2": "雲杉底下，總有幾分黃昏。",
    "inspect.spruce.3": "腳下全是針葉。別的都長不出來。",
    "inspect.spruce.4": "終年墨綠，也不趕時間。",
    "inspect.stonecircle.1": "一座石圈。據說法官曾在此開庭。",
    "inspect.stonecircle.2": "其實是墳墓。法官只是傳說。",
    "inspect.stonecircle.3": "走進去。或者不要。",
    "inspect.stones.1": "靠人力立起來的。沒人記得為什麼。",
    "inspect.stones.2": "立石。它們好像剛才還在說話。",
    "inspect.stones.3": "立石還在等。",
    "inspect.stooks.1": "收割完畢。",
    "inspect.stooks.2": "麥束還在晾乾。有人會回來收。",
    "inspect.stump.1": "這是一截樹樁。",
    "inspect.stump.2": "有人帶著斧頭來過。",
    "inspect.stump.3": "數數年輪，要是還有時間。",
    "inspect.tent.1": "以前某次探險留下的帳篷。",
    "inspect.tent.2": "那支探險隊再也沒有回來拿。",
    "inspect.tent.3": "筆記本的最後一頁是空白的。",
    "inspect.tjardal.1": "一座焦油窯。松木進去，焦油流出來。",
    "inspect.tjardal.2": "從前的船身，塗的就是這個。",
    "inspect.tuft.1": "青草。",
    "inspect.tuft.2": "沒有異狀。青草。",
    "inspect.tuft.3": "青草彎下腰，又站起來。",
    "inspect.tuft.4": "只是青草。",
    "inspect.watermill.1": "這是一座水磨坊。",
    "inspect.watermill.2": "磨粉的是水，日夜不停。",
    "inspect.well.1": "這是一口水井。",
    "inspect.well.2": "丟顆石頭下去，數一數。很深。",
    "inspect.well.3": "冷冽的水，一年到頭。",
    "inspect.wellsweep.1": "一口吊桿井。提水全靠長桿。",
    "inspect.wellsweep.2": "水桶會上來，只要有人拉。",
    "inspect.windmill.1": "這是一座風車。",
    "inspect.windmill.2": "整座風車都會轉身迎風。",
    "inspect.windmill.3": "在這裡，磨麵粉的是風。",
    "inspect.windthrow.1": "這是一棵風倒木。",
    "inspect.windthrow.2": "風做的好事，連根拔起。",
    "inspect.windthrow.3": "風倒木。別問發生過什麼。",
    "inspect.woodpile.1": "下個冬天，已經堆好了。",
    "inspect.woodpile.2": "疊得很用心。別抽最下面那根。",
    "lang.mist": "霧",
    "lang.name": "繁體中文",
    "lesson.cabinText": "你從小木屋出發。點一下已探索區域旁邊的格子，霧就會散去。試試圈起來的那一格。",
    "lesson.cabinTextMouse": "你從小木屋出發。點擊已探索區域旁邊的格子，霧就會散去。試試圈起來的那一格。",
    "lesson.cabinTitle": "小木屋",
    "lesson.done": "完成",
    "lesson.endDistance": "你走到了離小木屋 {distance} 的地方。這就是你的成績。越遠越好。",
    "lesson.endText": "數字周圍的精怪都有了旗幟，這個數字就會消失。驚醒精怪，探險就會結束。",
    "lesson.endTitle": "準備就緒",
    "lesson.invite": "先學會怎麼玩。只要一分鐘，朋友們在等你。",
    "lesson.noCreature": "那裡沒有精怪。",
    "lesson.numberHold": "按住那一格來插上旗幟。",
    "lesson.numberMode": "或者開啟插旗模式，然後點一下那一格。",
    "lesson.numberMouse": "在那一格上按右鍵來插上旗幟。",
    "lesson.numberText": "數字代表它周圍八格中藏著幾個精怪。這個1周圍只剩一格還在霧中，所以那裡睡著一個精怪。",
    "lesson.numberTitle": "數字",
    "lesson.ownText": "你找到的2周圍還有兩格在霧中。在這兩格上都插上旗幟。",
    "lesson.ownTitle": "輪到你了",
    "lesson.safeText": "這個1已經找到了它的精怪。所以它周圍的另一格是安全的。探索那一格。",
    "lesson.safeTitle": "安全地帶",
    "lesson.woke": "那裡睡著一個精怪。再試一次。",
    "list.add": "新增",
    "list.addBody": "所有人都能在 mistsweeper.com 和 App 上看到你的暱稱和探險。之後每天的探險一結束，就會自動加入名單，直到你在「設定」中關閉為止。",
    "list.addTitle": "新增你的暱稱",
    "list.as": "暱稱：{name}",
    "list.countSoFar": "目前共{count}位探險家",
    "list.countSoFarOne": "目前共{count}位探險家",
    "list.empty": "今天的名單上還沒有人。你可以成為第一個。",
    "list.errorAlready": "今天的名單上已經有一次從這裡新增的探險。",
    "list.errorBlocked": "從這裡已無法再新增探險。",
    "list.errorBusy": "這裡的操作過於頻繁。請過幾分鐘再試。",
    "list.errorClosed": "這次探險的名單已截止。",
    "list.errorName": "請使用2到20個中文字、字母、數字或空格。",
    "list.errorOther": "無法連線至名單。請再試一次。",
    "list.errorRefused": "這個暱稱不能使用。請換一個。",
    "list.hiddenName": "暱稱已隱藏",
    "list.loading": "正在尋找今日的頂尖探險家。",
    "list.nameLabel": "你的暱稱",
    "list.notAdded": "不在名單上",
    "list.placeSoFar": "目前第{place}名，共{count}位探險家",
    "list.remove": "移除",
    "list.removeBody": "從這裡新增的探險都會從所有名單中移除。它們仍會保留在「你的探險」中。",
    "list.removeTitle": "移除你的探險？",
    "list.renameBody": "你新增過的每次探險都會改用新暱稱。",
    "list.renameTitle": "你在名單上的暱稱",
    "list.report": "檢舉",
    "list.reportBody": "多位玩家檢舉的暱稱會先隱藏，直到我們查看過為止。",
    "list.reportTitle": "檢舉這個暱稱？",
    "list.tiles": "{tiles}格",
    "list.unreachable": "目前無法連線至名單。請稍後再試。",
    "list.waiting": "等待加入",
    "list.you": "你",
    "list.yours": "你的探險",
    "menu.about": "關於 Mistsweeper",
    "menu.apps": "Great Scott! 的更多作品",
    "menu.appsLine": "Ordna、Krono、Tapotron、Color Tap",
    "menu.back": "返回選單",
    "menu.close": "關閉選單",
    "menu.expeditions": "你的探險",
    "menu.expeditionsLine": "連續{streak}，最佳 {distance}",
    "menu.feedback": "傳送意見回饋",
    "menu.getApp": "取得 iOS App",
    "menu.getAppLine": "提醒與觸覺回饋，測試中",
    "menu.howto": "玩法說明",
    "menu.howtoLine": "規則與操作",
    "menu.list": "頂尖探險家",
    "menu.listLine": "今天誰走得最遠",
    "menu.privacy": "隱私權政策",
    "menu.settingsLine": "{theme}主題，{language}",
    "menu.version": "版本{version} · Great Scott! AB",
    "mode.daily": "探險 #{n}",
    "mode.endless": "無盡",
    "mode.endlessBest": "無盡，最佳 {distance}",
    "note.banner": "已插上旗幟。",
    "note.bannerOff": "插旗模式已關閉。",
    "note.bannerOn": "插旗模式已開啟。",
    "note.cabin": "回到小木屋。",
    "note.clearing": "你的空地。擺放你的發現。",
    "note.copied": "已複製到剪貼簿。",
    "note.endless": "無盡模式。每次都是新的世界。",
    "note.listRemoved": "已從所有名單中移除。",
    "note.listReported": "已檢舉暱稱。",
    "note.north": "北方重新朝上。",
    "note.today": "今日探險。",
    "note.todayPractice": "今日探險，當作練習。",
    "over.bergstroll": "你驚醒了一個山嶺巨怪。",
    "over.bergstrollLine": "山嶺巨怪坐在石頭之間，靜得讓人把它們當成石頭。",
    "over.copied": "已複製到剪貼簿",
    "over.endlessRuns": "無盡探險次數",
    "over.furthestLabel": "最遠距離",
    "over.huldra": "胡爾德拉一直在林間等著。",
    "over.huldraLine": "她看起來像個年輕女子，直到她轉過身去。跟著她走進森林的人，都留在了那裡。",
    "over.jatte": "一個巨人從山中站了起來。",
    "over.jatteLine": "巨人睡在山裡，肩膀露出地面。你剛才就站在其中一個身上。",
    "over.jatteMeadow": "一個巨人從霧中走了出來。",
    "over.jatteMeadowLine": "巨人行走在遠離人煙的曠野上。誰也聽不見它們走近。",
    "over.kickerDaily": "探險 #{n}，{dateShort}",
    "over.kickerEndless": "無盡",
    "over.kickerPractice": "探險 #{n} 的練習",
    "over.kickerTogether": "無盡，一起",
    "over.memberLine": "{tiles}，{distance}",
    "over.nacken": "內肯一直在水邊等著。",
    "over.nackenLine": "內肯在靜水邊拉琴。駐足聆聽的人，不會再往前走了。",
    "over.newWorld": "探索新的世界",
    "over.practiceBoard": "在今日地圖上練習",
    "over.setOutAgain": "再次出發",
    "over.share": "分享",
    "over.shared": "已分享",
    "over.sjotroll": "你驚醒了一個湖中巨怪。",
    "over.sjotrollLine": "那看似小島的東西，長著眼睛。",
    "over.skogstroll": "你驚醒了一個森林巨怪。",
    "over.skogstrollLine": "森林巨怪睡在苔蘚底下，就在雲杉長得最密的地方。它們最恨被人吵醒。",
    "over.streak": "連續天數",
    "over.streakDay": "{days}天",
    "over.streakDays": "{days}天",
    "over.title": "霧中有什麼動了一下。",
    "over.todayResult": "今日成績",
    "over.todayWaiting": "今日探險還在等你",
    "over.togetherBest": "組隊最佳",
    "over.togetherMembers": "探險者",
    "over.yourBest": "個人最佳",
    "party.away": "離開",
    "party.back": "重新會合。",
    "party.cardLine": "{status}，{tiles}，{distance}",
    "party.copied": "已複製連結。",
    "party.fell": "觀看中",
    "party.follow": "跟隨",
    "party.following": "跟隨 {name}",
    "party.full": "那次探險已滿員。",
    "party.guest": "探險者 {n}",
    "party.invite": "邀請朋友",
    "party.inviteBody": "傳送連結或出示 QR Code。對方開啟後會來到你的小木屋旁，加入這次探險。最多 {n} 人。",
    "party.inviteTitle": "一起探險",
    "party.join": "加入",
    "party.joinBody": "一次深入霧中 {distance} 的探險。遇到精怪的人，會在一旁看著隊友繼續前進。",
    "party.joinTitle": "{name} 邀請你",
    "party.joinTitleAnon": "你收到了邀請",
    "party.joined": "{name} 加入了。",
    "party.leave": "離開這次探險",
    "party.lock": "不再接受新探險者",
    "party.locked": "那次探險不再接受新探險者。",
    "party.lockedNote": "已不再接受新探險者。",
    "party.lost": "連線中斷。正在重新尋找隊友。",
    "party.memberFell": "{name} 掉下去了。",
    "party.memberRemoved": "{name} 已不在這次探險中。",
    "party.members": "探險隊員",
    "party.notNow": "以後再說",
    "party.openNote": "已重新接受新探險者。",
    "party.out": "在霧中",
    "party.over": "那次探險已經結束。",
    "party.qrLabel": "這次探險的連結 QR Code",
    "party.remove": "移出這次探險",
    "party.removeAsk": "要把 {name} 移出這次探險嗎？對方將無法再透過連結回來。",
    "party.removed": "你已不在那次探險中。",
    "party.share": "分享連結",
    "party.shareText": "來和我一起在霧中探險。",
    "party.tiles": "{n}格",
    "party.tiles1": "1格",
    "party.unavailable": "無法開始。請稍後再試。",
    "party.unfollow": "停止跟隨",
    "party.unlock": "重新接受新探險者",
    "party.you": "你",
    "party.youFell": "你掉下去了。現在看著隊友。",
    "party.youNamed": "{name}（你）",
    "party.yourName": "你的名字",
    "placeholder.store": "[App Store 連結]",
    "privacy.cloudApp": "當 Mistsweeper 的 iCloud 開啟時，你的設定、探險和空地，以及每個地方的視角，也會儲存在你自己的 iCloud 中，讓你在 iPhone 和 iPad 上都能接著玩。只有你的 Apple 帳號能讀取它們。我們無法讀取。刪除 App 後，它們仍會留在 iCloud 中。你可以在「設定」App 的 iCloud 中刪除它們。",
    "privacy.cloudTitleApp": "在你的 iCloud 中",
    "privacy.contact": "Mistsweeper 由瑞典斯德哥爾摩的 Great Scott! AB 製作。對隱私權有任何疑問，歡迎來信。",
    "privacy.contactTitle": "聯絡我們",
    "privacy.gameCenterApp": "如果你在裝置上登入了 Game Center，App 會把你在每天的探險中到達的距離和無盡模式的最遠成績傳送給 Apple。它們會以你的 Game Center 暱稱顯示在遊戲的 Game Center 排行榜上，你的 Game Center 設定允許的玩家可以看到。遊戲不會讀取你的暱稱或好友，也不保存來自 Game Center 的任何內容。如果你沒有登入，就不會傳送任何內容。你可以在「設定」App 的 Game Center 中登出。",
    "privacy.gameCenterTitleApp": "Game Center",
    "privacy.host": "本網站由 Cloudflare 提供服務。和所有網站代管服務一樣，Cloudflare 需要取得你的 IP 位址才能把網站傳送給你，並可能將其在自己的記錄中短期保存，以維護服務安全。我們自己不保存任何記錄。",
    "privacy.hostTitle": "網站代管",
    "privacy.intro": "Mistsweeper 是拿來玩的，不是用來蒐集資料的。以下就是它保存的所有內容。",
    "privacy.list": "在你用暱稱新增探險或檢舉暱稱之前，不會傳送任何關於你的資訊。你在名單上的名次是在你的裝置上算出的，依據的是所有人收到的同一份回覆。新增之後，我們會保存暱稱、探險及其點按紀錄和成績、新增時間、來自網頁還是 App，以及你的裝置產生的一段代碼經過轉換後的形式。這些內容保存在 Cloudflare，暱稱和探險會在 mistsweeper.com 和 App 中向所有人顯示。此後，每天的探險都會自動新增，直到你在「設定」中關閉。為了讓名單公平友善，我們可以查看新增的內容，隱藏或刪除暱稱或探險，並阻止某部裝置繼續新增。任何人都可以檢舉暱稱，檢舉會保存傳送裝置的代碼，同樣經過轉換。為防止濫用，同一位址的請求會以轉換後的形式計數十分鐘，且絕不寫入紀錄。",
    "privacy.listRemove": "你新增的內容會一直保留，直到你移除。「設定」中的「移除我的探險」會把從那裡新增的內容從所有名單中刪除：瀏覽器和 App 各自移除自己的內容。轉換後的代碼會再保留幾天，以免你的其他裝置自動重新新增這次探險，你做過的檢舉中也會保留。如果你已經沒有那部裝置，請寫信給我們，我們會替你刪除。你隨時可以詢問我們保存了哪些關於你的內容。",
    "privacy.listRemoveTitle": "離開名單",
    "privacy.none": "沒有帳號、沒有廣告、沒有追蹤，也沒有 Cookie。我們不販售也不分享個人資料，除了你新增到「頂尖探險家」的內容和一起探險時傳送的內容，也不蒐集任何個人資料。",
    "privacy.noneTitle": "我們不做的事",
    "privacy.share": "分享成績時，文字要傳到哪裡由你決定。前往 App Store 與電子郵件的連結會在遊戲外開啟。",
    "privacy.shareTitle": "分享與連結",
    "privacy.stored": "你的設定、探險和成績會保存在此瀏覽器的本機儲存空間中，方便你從上次中斷的地方繼續。這些資料會留在你的裝置上，只有在你把探險新增到「頂尖探險家」時才會傳送給我們。在瀏覽器中清除本網站的資料，就會將它們從這裡移除。",
    "privacy.storedApp": "你的設定、探險和成績會儲存在這部裝置上的 App 中，方便你從上次中斷的地方繼續。只有在你把探險新增到「頂尖探險家」時，這些資料才會傳送給我們。刪除 App 就會將它們從這部裝置上移除。",
    "privacy.storedTitle": "在你的瀏覽器中",
    "privacy.storedTitleApp": "在你的裝置上",
    "privacy.title": "隱私權",
    "privacy.together": "當你邀請他人或透過連結加入一次探險時，在你們遊玩期間，這次探險會保存在 Cloudflare：包括它的點按操作、每位隊員選擇的名字和旗幟，以及每個瀏覽器為回到自己位置而保留的一個代碼。每位隊員的鏡頭朝向只會在遊玩時傳給其他隊員，從不保存。為了讓遊戲正常而公平地運作，我們可以查看一起進行的探險、即時觀看正在進行的探險，並重新播放。一次探險的所有內容會在最後一次遊玩一週後刪除。",
    "privacy.togetherTitle": "一起探險",
    "privacy.updated": "更新於2026年11月1日",
    "privacy.updatedApp": "更新於2026年11月1日",
    "privacy.usageApp": "iOS App 透過 TelemetryDeck 統計使用情況。這是一項來自德國、伺服器位於歐盟、重視隱私的分析服務。統計的內容包括：工作階段開始、探險開始或結束、分享成績，以及開啟空地。每筆統計都附有 App 版本、遊戲語言、裝置資訊（如型號、系統、螢幕和設定），以及一個代表此裝置上本 App 的代碼。這個代碼在傳送前會經過不可逆的轉換，無法追溯到你。你的 IP 位址不會被儲存，也不會傳送任何關於你的成績或身分的資訊。",
    "privacy.usageTitleApp": "App 使用統計",
    "privacy.visits": "為了知道有多少人造訪，我們使用 Plausible，這是一項主機位於歐盟、重視隱私的網站分析服務。它不使用 Cookie，也不保存任何個人資料，只記錄總數，例如造訪次數、國家或地區、瀏覽器，以及將你帶到這裡的網站。你的 IP 位址不會被儲存。",
    "privacy.visitsTitle": "造訪統計",
    "punct.comma": "，",
    "punct.join": "{first}{next}",
    "punct.period": "。",
    "reminder.body": "探險 #{n} 正在霧中等你。",
    "sealed.body": "你還在外探索時，下一次探險已經開始了。你的成績已儲存：{distance}。你可以繼續探索，當作練習。",
    "sealed.next": "開始探險 #{n}",
    "sealed.title": "探險 #{n} 已結束。",
    "settings.appPromo": "iOS App 提供提醒與觸覺回饋，目前正在測試中。",
    "settings.debug": "顯示影格時間",
    "settings.developer": "開發者",
    "settings.feel": "體驗",
    "settings.haptics": "觸覺回饋",
    "settings.hapticsLine": "探索一格或插上旗幟時，輕輕震動一下。",
    "settings.language": "語言",
    "settings.languageAuto": "自動",
    "settings.languageAutoLine": "跟隨系統設定：{language}",
    "settings.languageDraft": "草稿",
    "settings.listAuto": "新增我的探險",
    "settings.listAutoLine": "每天的探險一結束，就會自動加入名單。",
    "settings.listName": "名單上的暱稱",
    "settings.listNote": "探險結束時新增你的探險，就能加入今天的名單。",
    "settings.listRemove": "移除我的探險",
    "settings.motion": "減少動態效果",
    "settings.motionLine": "霧靜止不動，新的土地立即出現，世界的邊緣保持清晰。在你更改之前，會跟隨系統設定。",
    "settings.music": "音樂",
    "settings.musicLine": "探索時，森林裡傳來一段安靜的旋律。",
    "settings.remind": "每日提醒",
    "settings.remindDay": "白天",
    "settings.remindDenied": "Mistsweeper 的通知已關閉。點一下即可在「設定」中允許通知。",
    "settings.remindEarlier": "提早{n}分鐘",
    "settings.remindEvening": "晚上",
    "settings.remindLater": "延後{n}分鐘",
    "settings.remindLine": "如果今日探險還在等你，就在{time}提醒。",
    "settings.remindNext": "新探險：{time}",
    "settings.remindNight": "凌晨",
    "settings.remindTime": "提醒時間",
    "settings.reminders": "提醒",
    "settings.sounds": "音效",
    "settings.soundsLine": "每次探索、每面旗幟、每個精怪，都有自己的聲音。",
    "settings.theme": "主題",
    "settings.themeAuto": "自動",
    "settings.themeAutoLine": "跟隨系統設定：淺色模式下為「白天」，深色模式下為「夜晚」",
    "settings.themeSupporter": "在「支持者」中選擇",
    "settings.tilt": "移軸",
    "settings.title": "設定",
    "settings.zoom": "縮放",
    "start.continue": "繼續，{distance}",
    "start.endlessLine": "每次都是新的世界，想玩幾次都可以。",
    "start.setOut": "出發",
    "start.tagDistance": "#{n}，{distance}",
    "start.tagDone": "#{n}，已完成，{distance}",
    "start.tagNew": "#{n}，全新",
    "start.tagNewDate": "#{n}，{dateShort}，全新",
    "start.tagProgress": "#{n}，進行中，{distance}",
    "start.todayDone": "今天已完成。距離下次探險還有{time}。",
    "start.todayDoneShort": "距離下次探險還有{time}。",
    "start.todayInProgress": "進行中。從上次中斷的地方繼續。",
    "start.todayInProgressShort": "從上次中斷的地方繼續。",
    "start.todayNew": "{dateLong}。一次機會，人人踏上同一片土地。",
    "start.todayNewShort": "一次機會，人人踏上同一片土地。",
    "support.devices": "開啟 iCloud 後，App 會把你的探險和空地帶到你的其他裝置上。在瀏覽器中，它們只留在那個瀏覽器裡。",
    "support.devicesTitle": "新裝置",
    "support.intro": "Mistsweeper 由斯德哥爾摩的一間小工作室製作。如果遇到問題，或有任何疑問，請寫信給我們。",
    "support.list": "在{settings}中選擇「{remove}」，就能把你的探險從所有名單上移除。要檢舉某個暱稱，請長按所在的列，在電腦上則按右鍵。",
    "support.listTitle": "你在{list}上的暱稱",
    "support.purchase": "購買紀錄跟著你的 Apple 帳號。在 App 選單中打開{supporter}，然後選擇「{restore}」。",
    "support.purchaseTitle": "購買紀錄不見了",
    "support.title": "支援",
    "supporter.accent": "強調色",
    "supporter.accentLine": "你的旗幟的顏色。",
    "supporter.accentNumber": "顏色 {n}",
    "supporter.banner": "旗幟",
    "supporter.banners": "旗幟",
    "supporter.bannersLine": "每次探險都可以插上另一面旗幟。",
    "supporter.buy": "成為支持者，{price}",
    "supporter.buyLine": "一次購買，不是訂閱。透過「家人共享」，你的家人也能使用。",
    "supporter.buyNoPrice": "成為支持者",
    "supporter.cabin": "你的小木屋",
    "supporter.cabinLine": "讓你找到的一棟房屋立在小木屋的位置，每次探險和每塊空地都是如此。",
    "supporter.chooseCabin": "在空地中選擇",
    "supporter.clearingLocked": "只有支持者才能更改這塊空地。",
    "supporter.clearings": "空地",
    "supporter.clearingsLine": "更大的空地（15×15格），以及想要多少就有多少的空地。",
    "supporter.failed": "購買未能完成。請稍後再試。",
    "supporter.free": "你玩的一切都免費，以後也是。",
    "supporter.icon": "App 圖示",
    "supporter.icons": "App 圖示",
    "supporter.iconsLine": "選擇你主畫面上的圖示。每個圖示都有淺色和深色兩種外觀。",
    "supporter.lead": "成為支持者後，你可以選擇遊戲在你螢幕上的樣子，也能幫助我們繼續製作 Mistsweeper。",
    "supporter.line": "主題、App 圖示、旗幟、小木屋",
    "supporter.nothingToRestore": "在此 Apple 帳號中找不到支持者的購買紀錄。",
    "supporter.pending": "正在等待核准。購買獲得核准後，你就會成為支持者。",
    "supporter.restore": "回復購買",
    "supporter.since": "支持者，自{date}起",
    "supporter.thanks": "感謝你支持 Mistsweeper。你可以在這裡選擇遊戲在你螢幕上的樣子。",
    "supporter.theme": "主題",
    "supporter.themeLine": "「白天」、「夜晚」和「自動」在「設定」中。",
    "supporter.themes": "主題",
    "supporter.themesLine": "用別的顏色玩整個遊戲。有些主題還能選擇旗幟的顏色。",
    "supporter.unreachable": "無法連線至 App Store。請稍後再試。",
    "theme.day": "白天",
    "theme.fjord": "峽灣",
    "theme.mossa": "苔蘚",
    "theme.night": "夜晚",
    "theme.pergament": "羊皮紙",
    "theme.rosa": "粉紅",
    "theme.skymning": "黃昏",
    "time.hoursMinutes": "{h}小時{m}分鐘",
    "time.minutes": "{m}分鐘",
    "webgl.missing": "Mistsweeper 需要 WebGL 2，但這個瀏覽器不支援。",
    "welcome.mistDaily": "每天都有新的探險：人人踏上同一片土地，只有一次機會。無盡模式留給安靜的時光。",
    "welcome.mistNumbers": "數字代表它周圍八格中藏著幾個精怪。在你認為有精怪沉睡的地方插上旗幟，然後繼續前進。",
    "welcome.mistText": "你從林間空地上的一間小木屋出發，其餘的一切都籠罩在霧中。從你已探索的區域開始，一次探索一格。",
    "welcome.mistTitle": "走進霧中",
    "welcome.next": "下一步",
    "welcome.remindNo": "稍後再說",
    "welcome.remindText": "每天都有新的探險。選一個時間，如果當天的探險還在等你，我們會提醒你。你可以在「設定」中更改。",
    "welcome.remindTitle": "每日提醒",
    "welcome.remindYes": "提醒我",
    "welcome.skip": "略過",
    "welcome.starsLater": "過一陣子，我們會問問你的想法。到時花一點時間，就能幫我們很大的忙。",
    "welcome.starsText": "Mistsweeper 由斯德哥爾摩的小工作室 Great Scott! 製作。對一款小遊戲來說，App Store 上的評分是讓更多人發現它的最好方式。",
    "welcome.starsTitle": "出自一間小工作室",
    "welcome.step": "第{n}步，共{total}步",
    "widget.bestDay": "單日最佳 {distance}",
    "widget.clearingDescription": "你的空地，以及已發現的數量和最佳成績。",
    "widget.clearingName": "你的空地",
    "widget.description": "顯示今日探險離開時的樣子，以及連續天數。",
    "widget.next": "下次還有{time}",
    "widget.streak": "連續天數：{days}",
    "widget.waiting": "待出發",
  },
} as const;

export type StringKey = keyof typeof STRINGS.en;

/** A language the interface is written in. */
export type Locale = keyof typeof STRINGS;

export const STRING_KEYS: readonly StringKey[] = [
  "a11y.bannerMode",
  "a11y.board.banner",
  "a11y.board.bannerRemoved",
  "a11y.board.banners1",
  "a11y.board.bannersN",
  "a11y.board.cabin",
  "a11y.board.cellBanner",
  "a11y.board.cellCabin",
  "a11y.board.cellExplored",
  "a11y.board.cellMist",
  "a11y.board.cellWrongBanner",
  "a11y.board.chordWaits",
  "a11y.board.chosen",
  "a11y.board.confirmed",
  "a11y.board.creature",
  "a11y.board.deepMist",
  "a11y.board.describe",
  "a11y.board.dirEast",
  "a11y.board.dirNorth",
  "a11y.board.dirSouth",
  "a11y.board.dirWest",
  "a11y.board.east",
  "a11y.board.explore",
  "a11y.board.explored",
  "a11y.board.exploredOn",
  "a11y.board.frontier0",
  "a11y.board.frontier1",
  "a11y.board.frontierN",
  "a11y.board.furthest",
  "a11y.board.hid",
  "a11y.board.hintExplore",
  "a11y.board.hintPlant",
  "a11y.board.hintReveal",
  "a11y.board.hintTakeAway",
  "a11y.board.inMist",
  "a11y.board.inView",
  "a11y.board.listAnd",
  "a11y.board.mist",
  "a11y.board.nextTo",
  "a11y.board.north",
  "a11y.board.place",
  "a11y.board.plant",
  "a11y.board.revealed1",
  "a11y.board.revealedN",
  "a11y.board.rotorBanners",
  "a11y.board.rotorMist",
  "a11y.board.rotorNorthSouth",
  "a11y.board.rotorNumbers",
  "a11y.board.roundIt",
  "a11y.board.rowHere",
  "a11y.board.rowNorth",
  "a11y.board.rowSouth",
  "a11y.board.south",
  "a11y.board.takeAway",
  "a11y.board.turned",
  "a11y.board.west",
  "a11y.board.woke",
  "a11y.board.wrongBanner",
  "a11y.distance",
  "a11y.find",
  "a11y.findMore",
  "a11y.map",
  "about.body1",
  "about.body2",
  "about.body3",
  "about.made",
  "about.version",
  "accessibility.contact",
  "accessibility.contactTitle",
  "accessibility.contrast",
  "accessibility.contrastTitle",
  "accessibility.dark",
  "accessibility.darkTitle",
  "accessibility.intro",
  "accessibility.keys",
  "accessibility.keysTitle",
  "accessibility.motion",
  "accessibility.motionTitle",
  "accessibility.sound",
  "accessibility.soundTitle",
  "accessibility.title",
  "accessibility.updated",
  "accessibility.work",
  "accessibility.workTitle",
  "app.tagline",
  "app.title",
  "apps.appStore",
  "apps.colortap",
  "apps.intro",
  "apps.krono",
  "apps.ordna",
  "apps.tapotron",
  "archive.appNoteCloud",
  "archive.appNoteDevice",
  "archive.best",
  "archive.daily",
  "archive.dayStreak",
  "archive.endlessBest",
  "archive.endlessLast",
  "archive.endlessRuns",
  "archive.expeditions",
  "archive.gameCenter",
  "archive.notPlayed",
  "archive.sealed",
  "archive.today",
  "archive.todayWord",
  "archive.webNote",
  "archive.webNoteShort",
  "banner.1",
  "banner.a1",
  "banner.a3",
  "banner.b1",
  "banner.b2",
  "banner.b3",
  "banner.c2",
  "banner.c3",
  "banner.c4",
  "beta.bugs",
  "beta.bugsTitle",
  "beta.changes",
  "beta.changesTitle",
  "beta.intro",
  "beta.language",
  "beta.languageTitle",
  "beta.more",
  "beta.ticker1",
  "beta.ticker2",
  "beta.ticker3",
  "beta.title",
  "button.banner",
  "button.cancel",
  "button.close",
  "button.daily",
  "button.endless",
  "button.home",
  "button.practice",
  "button.settings",
  "button.zoomIn",
  "button.zoomOut",
  "clearing.arrange",
  "clearing.cabin",
  "clearing.cabinChosen",
  "clearing.cabinHint",
  "clearing.cat.creatures",
  "clearing.cat.ground",
  "clearing.cat.houses",
  "clearing.cat.plants",
  "clearing.cat.stones",
  "clearing.changeCabin",
  "clearing.chooseCabin",
  "clearing.clear",
  "clearing.delete",
  "clearing.deleteBody",
  "clearing.deleteTitle",
  "clearing.deleted",
  "clearing.discovered",
  "clearing.done",
  "clearing.edit",
  "clearing.editing",
  "clearing.family.barley",
  "clearing.family.barn",
  "clearing.family.beacon",
  "clearing.family.beehive",
  "clearing.family.bergstroll",
  "clearing.family.birch",
  "clearing.family.boat",
  "clearing.family.boathouse",
  "clearing.family.boulder",
  "clearing.family.bush",
  "clearing.family.cairn",
  "clearing.family.campfire",
  "clearing.family.cart",
  "clearing.family.cave",
  "clearing.family.church",
  "clearing.family.cottage",
  "clearing.family.driftwood",
  "clearing.family.fabod",
  "clearing.family.faering",
  "clearing.family.fence",
  "clearing.family.fern",
  "clearing.family.fishhut",
  "clearing.family.flottning",
  "clearing.family.fornborg",
  "clearing.family.goahti",
  "clearing.family.gravhog",
  "clearing.family.harbre",
  "clearing.family.hassja",
  "clearing.family.hides",
  "clearing.family.hjell",
  "clearing.family.house",
  "clearing.family.huldra",
  "clearing.family.huntingtower",
  "clearing.family.jatte",
  "clearing.family.jetty",
  "clearing.family.juniper",
  "clearing.family.kastal",
  "clearing.family.kolmila",
  "clearing.family.kummel",
  "clearing.family.laundry",
  "clearing.family.lavvu",
  "clearing.family.lilypads",
  "clearing.family.log",
  "clearing.family.longhouse",
  "clearing.family.massif",
  "clearing.family.mushroom",
  "clearing.family.nacken",
  "clearing.family.njalla",
  "clearing.family.oak",
  "clearing.family.oats",
  "clearing.family.outcrop",
  "clearing.family.peak",
  "clearing.family.pebbles",
  "clearing.family.pine",
  "clearing.family.reeds",
  "clearing.family.rengarde",
  "clearing.family.rock",
  "clearing.family.rockcarving",
  "clearing.family.rootcellar",
  "clearing.family.rowan",
  "clearing.family.ruin",
  "clearing.family.runestone",
  "clearing.family.rye",
  "clearing.family.sauna",
  "clearing.family.seamark",
  "clearing.family.shed",
  "clearing.family.shipsetting",
  "clearing.family.shorestones",
  "clearing.family.sjotroll",
  "clearing.family.skogstroll",
  "clearing.family.smithy",
  "clearing.family.snag",
  "clearing.family.spruce",
  "clearing.family.stonecircle",
  "clearing.family.stones",
  "clearing.family.stooks",
  "clearing.family.stormannagard",
  "clearing.family.stump",
  "clearing.family.tent",
  "clearing.family.tjardal",
  "clearing.family.tuft",
  "clearing.family.watermill",
  "clearing.family.well",
  "clearing.family.wellsweep",
  "clearing.family.windmill",
  "clearing.family.windthrow",
  "clearing.family.woodpile",
  "clearing.fold",
  "clearing.ground.forest",
  "clearing.ground.meadow",
  "clearing.ground.mountain",
  "clearing.ground.water",
  "clearing.grown",
  "clearing.hint",
  "clearing.hintVoiceOver",
  "clearing.large",
  "clearing.locked",
  "clearing.lockedName",
  "clearing.made",
  "clearing.mist",
  "clearing.needsLand",
  "clearing.needsWater",
  "clearing.new",
  "clearing.photo",
  "clearing.photo.back",
  "clearing.photo.failed",
  "clearing.photo.file",
  "clearing.photo.formats",
  "clearing.photo.notSaved",
  "clearing.photo.picture",
  "clearing.photo.save",
  "clearing.photo.saved",
  "clearing.photo.share",
  "clearing.photo.shutter",
  "clearing.photo.usage",
  "clearing.rename",
  "clearing.renameSave",
  "clearing.renameTitle",
  "clearing.size",
  "clearing.small",
  "clearing.supporter",
  "clearing.turn",
  "clearing.undo",
  "clearing.yours",
  "controls.banner",
  "controls.click",
  "controls.drag",
  "controls.pan",
  "controls.pinch",
  "controls.qe",
  "controls.reveal",
  "controls.rightClick",
  "controls.rightDrag",
  "controls.scroll",
  "controls.tg",
  "controls.tilt",
  "controls.title",
  "controls.turn",
  "controls.turnTilt",
  "controls.twist",
  "controls.twoFingers",
  "controls.voActions",
  "controls.voFind",
  "controls.voMagicTap",
  "controls.voMove",
  "controls.voRotor",
  "controls.voScroll",
  "controls.voSummary",
  "controls.voSwipe",
  "controls.voTileActions",
  "controls.voTiles",
  "controls.zoom",
  "daily.next",
  "feedback.subject",
  "find.new",
  "getApp.beta",
  "getApp.haptics",
  "getApp.intro",
  "getApp.join",
  "getApp.note",
  "getApp.offline",
  "getApp.qr",
  "getApp.qrLabel",
  "getApp.reminder",
  "getApp.widget",
  "hint.clearingDesktop",
  "hint.photoDesktop",
  "hint.reveal",
  "hint.revealDesktop",
  "hint.revealVoiceOver",
  "howto.1",
  "howto.2",
  "howto.3",
  "howto.3example",
  "howto.4mouse",
  "howto.4touch",
  "howto.4voiceOver",
  "howto.5",
  "howto.6",
  "howto.tryLesson",
  "hud.best",
  "hud.clearing",
  "hud.menu",
  "hud.north",
  "hud.practice",
  "hud.today",
  "hud.turnLeft",
  "hud.turnLeftKey",
  "hud.turnRight",
  "hud.turnRightKey",
  "inspect.barley.1",
  "inspect.barley.2",
  "inspect.barn.1",
  "inspect.barn.2",
  "inspect.barn.3",
  "inspect.beacon.1",
  "inspect.beacon.2",
  "inspect.beacon.3",
  "inspect.beehive.1",
  "inspect.beehive.2",
  "inspect.birch.1",
  "inspect.birch.2",
  "inspect.birch.3",
  "inspect.birch.4",
  "inspect.boat.1",
  "inspect.boat.2",
  "inspect.boathouse.1",
  "inspect.boathouse.2",
  "inspect.boulder.1",
  "inspect.boulder.2",
  "inspect.boulder.3",
  "inspect.bush.1",
  "inspect.bush.2",
  "inspect.bush.3",
  "inspect.cabin",
  "inspect.cairn.1",
  "inspect.cairn.2",
  "inspect.cairn.3",
  "inspect.campfire.1",
  "inspect.campfire.2",
  "inspect.campfire.3",
  "inspect.cart.1",
  "inspect.cart.2",
  "inspect.cave.1",
  "inspect.cave.2",
  "inspect.cave.3",
  "inspect.church.1",
  "inspect.church.2",
  "inspect.church.3",
  "inspect.creature.bergstroll",
  "inspect.creature.huldra",
  "inspect.creature.jatte",
  "inspect.creature.nacken",
  "inspect.creature.sjotroll",
  "inspect.creature.skogstroll",
  "inspect.deer.1",
  "inspect.deer.2",
  "inspect.driftwood.1",
  "inspect.driftwood.2",
  "inspect.duck.1",
  "inspect.duck.2",
  "inspect.elk.1",
  "inspect.elk.2",
  "inspect.faering.1",
  "inspect.faering.2",
  "inspect.fence.1",
  "inspect.fence.2",
  "inspect.fern.1",
  "inspect.fern.2",
  "inspect.fern.3",
  "inspect.fishhut.1",
  "inspect.fishhut.2",
  "inspect.flottning.1",
  "inspect.flottning.2",
  "inspect.fornborg.1",
  "inspect.fornborg.2",
  "inspect.fornborg.3",
  "inspect.goahti.1",
  "inspect.goahti.2",
  "inspect.gravhog.1",
  "inspect.gravhog.2",
  "inspect.gravhog.3",
  "inspect.harbre.1",
  "inspect.harbre.2",
  "inspect.hassja.1",
  "inspect.hassja.2",
  "inspect.hides.1",
  "inspect.hides.2",
  "inspect.hjell.1",
  "inspect.hjell.2",
  "inspect.home",
  "inspect.huntingtower.1",
  "inspect.huntingtower.2",
  "inspect.jetty.1",
  "inspect.jetty.2",
  "inspect.jetty.3",
  "inspect.juniper.1",
  "inspect.juniper.2",
  "inspect.juniper.3",
  "inspect.kastal.1",
  "inspect.kastal.2",
  "inspect.kolmila.1",
  "inspect.kolmila.2",
  "inspect.kolmila.3",
  "inspect.kummel.1",
  "inspect.kummel.2",
  "inspect.laundry.1",
  "inspect.laundry.2",
  "inspect.laundry.3",
  "inspect.lavvu.1",
  "inspect.lavvu.2",
  "inspect.lilypads.1",
  "inspect.lilypads.2",
  "inspect.lilypads.3",
  "inspect.log.1",
  "inspect.log.2",
  "inspect.massif.1",
  "inspect.massif.2",
  "inspect.massif.3",
  "inspect.mushroom.1",
  "inspect.mushroom.2",
  "inspect.mushroom.3",
  "inspect.njalla.1",
  "inspect.njalla.2",
  "inspect.oak.1",
  "inspect.oak.2",
  "inspect.oak.3",
  "inspect.oak.4",
  "inspect.oats.1",
  "inspect.oats.2",
  "inspect.outcrop.1",
  "inspect.outcrop.2",
  "inspect.outcrop.3",
  "inspect.peak.1",
  "inspect.peak.2",
  "inspect.peak.3",
  "inspect.pebbles.1",
  "inspect.pebbles.2",
  "inspect.pine.1",
  "inspect.pine.2",
  "inspect.pine.3",
  "inspect.pine.4",
  "inspect.reeds.1",
  "inspect.reeds.2",
  "inspect.reeds.3",
  "inspect.reindeer.1",
  "inspect.reindeer.2",
  "inspect.rengarde.1",
  "inspect.rengarde.2",
  "inspect.rock.1",
  "inspect.rock.2",
  "inspect.rock.3",
  "inspect.rock.4",
  "inspect.rockcarving.1",
  "inspect.rockcarving.2",
  "inspect.rockcarving.3",
  "inspect.rootcellar.1",
  "inspect.rootcellar.2",
  "inspect.rowan.1",
  "inspect.rowan.2",
  "inspect.rowan.3",
  "inspect.ruin.1",
  "inspect.ruin.2",
  "inspect.ruin.3",
  "inspect.runestone.1",
  "inspect.runestone.2",
  "inspect.runestone.3",
  "inspect.runestone.4",
  "inspect.rye.1",
  "inspect.rye.2",
  "inspect.sauna.1",
  "inspect.sauna.2",
  "inspect.sauna.3",
  "inspect.seamark.1",
  "inspect.seamark.2",
  "inspect.shed.1",
  "inspect.shed.2",
  "inspect.shipsetting.1",
  "inspect.shipsetting.2",
  "inspect.shipsetting.3",
  "inspect.shorestones.1",
  "inspect.shorestones.2",
  "inspect.smithy.1",
  "inspect.smithy.2",
  "inspect.smithy.3",
  "inspect.snag.1",
  "inspect.snag.2",
  "inspect.snag.3",
  "inspect.spruce.1",
  "inspect.spruce.2",
  "inspect.spruce.3",
  "inspect.spruce.4",
  "inspect.stonecircle.1",
  "inspect.stonecircle.2",
  "inspect.stonecircle.3",
  "inspect.stones.1",
  "inspect.stones.2",
  "inspect.stones.3",
  "inspect.stooks.1",
  "inspect.stooks.2",
  "inspect.stump.1",
  "inspect.stump.2",
  "inspect.stump.3",
  "inspect.tent.1",
  "inspect.tent.2",
  "inspect.tent.3",
  "inspect.tjardal.1",
  "inspect.tjardal.2",
  "inspect.tuft.1",
  "inspect.tuft.2",
  "inspect.tuft.3",
  "inspect.tuft.4",
  "inspect.watermill.1",
  "inspect.watermill.2",
  "inspect.well.1",
  "inspect.well.2",
  "inspect.well.3",
  "inspect.wellsweep.1",
  "inspect.wellsweep.2",
  "inspect.windmill.1",
  "inspect.windmill.2",
  "inspect.windmill.3",
  "inspect.windthrow.1",
  "inspect.windthrow.2",
  "inspect.windthrow.3",
  "inspect.woodpile.1",
  "inspect.woodpile.2",
  "lang.mist",
  "lang.name",
  "lesson.cabinText",
  "lesson.cabinTextMouse",
  "lesson.cabinTitle",
  "lesson.done",
  "lesson.endDistance",
  "lesson.endText",
  "lesson.endTitle",
  "lesson.invite",
  "lesson.noCreature",
  "lesson.numberHold",
  "lesson.numberMode",
  "lesson.numberMouse",
  "lesson.numberText",
  "lesson.numberTitle",
  "lesson.ownText",
  "lesson.ownTitle",
  "lesson.safeText",
  "lesson.safeTitle",
  "lesson.woke",
  "list.add",
  "list.addBody",
  "list.addTitle",
  "list.as",
  "list.countSoFar",
  "list.countSoFarOne",
  "list.empty",
  "list.errorAlready",
  "list.errorBlocked",
  "list.errorBusy",
  "list.errorClosed",
  "list.errorName",
  "list.errorOther",
  "list.errorRefused",
  "list.hiddenName",
  "list.loading",
  "list.nameLabel",
  "list.notAdded",
  "list.placeSoFar",
  "list.remove",
  "list.removeBody",
  "list.removeTitle",
  "list.renameBody",
  "list.renameTitle",
  "list.report",
  "list.reportBody",
  "list.reportTitle",
  "list.tiles",
  "list.unreachable",
  "list.waiting",
  "list.you",
  "list.yours",
  "menu.about",
  "menu.apps",
  "menu.appsLine",
  "menu.back",
  "menu.close",
  "menu.expeditions",
  "menu.expeditionsLine",
  "menu.feedback",
  "menu.getApp",
  "menu.getAppLine",
  "menu.howto",
  "menu.howtoLine",
  "menu.list",
  "menu.listLine",
  "menu.privacy",
  "menu.settingsLine",
  "menu.version",
  "mode.daily",
  "mode.endless",
  "mode.endlessBest",
  "note.banner",
  "note.bannerOff",
  "note.bannerOn",
  "note.cabin",
  "note.clearing",
  "note.copied",
  "note.endless",
  "note.listRemoved",
  "note.listReported",
  "note.north",
  "note.today",
  "note.todayPractice",
  "over.bergstroll",
  "over.bergstrollLine",
  "over.copied",
  "over.endlessRuns",
  "over.furthestLabel",
  "over.huldra",
  "over.huldraLine",
  "over.jatte",
  "over.jatteLine",
  "over.jatteMeadow",
  "over.jatteMeadowLine",
  "over.kickerDaily",
  "over.kickerEndless",
  "over.kickerPractice",
  "over.kickerTogether",
  "over.memberLine",
  "over.nacken",
  "over.nackenLine",
  "over.newWorld",
  "over.practiceBoard",
  "over.setOutAgain",
  "over.share",
  "over.shared",
  "over.sjotroll",
  "over.sjotrollLine",
  "over.skogstroll",
  "over.skogstrollLine",
  "over.streak",
  "over.streakDay",
  "over.streakDays",
  "over.title",
  "over.todayResult",
  "over.todayWaiting",
  "over.togetherBest",
  "over.togetherMembers",
  "over.yourBest",
  "party.away",
  "party.back",
  "party.cardLine",
  "party.copied",
  "party.fell",
  "party.follow",
  "party.following",
  "party.full",
  "party.guest",
  "party.invite",
  "party.inviteBody",
  "party.inviteTitle",
  "party.join",
  "party.joinBody",
  "party.joinTitle",
  "party.joinTitleAnon",
  "party.joined",
  "party.leave",
  "party.lock",
  "party.locked",
  "party.lockedNote",
  "party.lost",
  "party.memberFell",
  "party.memberRemoved",
  "party.members",
  "party.notNow",
  "party.openNote",
  "party.out",
  "party.over",
  "party.qrLabel",
  "party.remove",
  "party.removeAsk",
  "party.removed",
  "party.share",
  "party.shareText",
  "party.tiles",
  "party.tiles1",
  "party.unavailable",
  "party.unfollow",
  "party.unlock",
  "party.you",
  "party.youFell",
  "party.youNamed",
  "party.yourName",
  "placeholder.store",
  "privacy.cloudApp",
  "privacy.cloudTitleApp",
  "privacy.contact",
  "privacy.contactTitle",
  "privacy.gameCenterApp",
  "privacy.gameCenterTitleApp",
  "privacy.host",
  "privacy.hostTitle",
  "privacy.intro",
  "privacy.list",
  "privacy.listRemove",
  "privacy.listRemoveTitle",
  "privacy.none",
  "privacy.noneTitle",
  "privacy.share",
  "privacy.shareTitle",
  "privacy.stored",
  "privacy.storedApp",
  "privacy.storedTitle",
  "privacy.storedTitleApp",
  "privacy.title",
  "privacy.together",
  "privacy.togetherTitle",
  "privacy.updated",
  "privacy.updatedApp",
  "privacy.usageApp",
  "privacy.usageTitleApp",
  "privacy.visits",
  "privacy.visitsTitle",
  "punct.comma",
  "punct.join",
  "punct.period",
  "reminder.body",
  "sealed.body",
  "sealed.next",
  "sealed.title",
  "settings.appPromo",
  "settings.debug",
  "settings.developer",
  "settings.feel",
  "settings.haptics",
  "settings.hapticsLine",
  "settings.language",
  "settings.languageAuto",
  "settings.languageAutoLine",
  "settings.languageDraft",
  "settings.listAuto",
  "settings.listAutoLine",
  "settings.listName",
  "settings.listNote",
  "settings.listRemove",
  "settings.motion",
  "settings.motionLine",
  "settings.music",
  "settings.musicLine",
  "settings.remind",
  "settings.remindDay",
  "settings.remindDenied",
  "settings.remindEarlier",
  "settings.remindEvening",
  "settings.remindLater",
  "settings.remindLine",
  "settings.remindNext",
  "settings.remindNight",
  "settings.remindTime",
  "settings.reminders",
  "settings.sounds",
  "settings.soundsLine",
  "settings.theme",
  "settings.themeAuto",
  "settings.themeAutoLine",
  "settings.themeSupporter",
  "settings.tilt",
  "settings.title",
  "settings.zoom",
  "start.continue",
  "start.endlessLine",
  "start.setOut",
  "start.tagDistance",
  "start.tagDone",
  "start.tagNew",
  "start.tagNewDate",
  "start.tagProgress",
  "start.todayDone",
  "start.todayDoneShort",
  "start.todayInProgress",
  "start.todayInProgressShort",
  "start.todayNew",
  "start.todayNewShort",
  "support.devices",
  "support.devicesTitle",
  "support.intro",
  "support.list",
  "support.listTitle",
  "support.purchase",
  "support.purchaseTitle",
  "support.title",
  "supporter.accent",
  "supporter.accentLine",
  "supporter.accentNumber",
  "supporter.banner",
  "supporter.banners",
  "supporter.bannersLine",
  "supporter.buy",
  "supporter.buyLine",
  "supporter.buyNoPrice",
  "supporter.cabin",
  "supporter.cabinLine",
  "supporter.chooseCabin",
  "supporter.clearingLocked",
  "supporter.clearings",
  "supporter.clearingsLine",
  "supporter.failed",
  "supporter.free",
  "supporter.icon",
  "supporter.icons",
  "supporter.iconsLine",
  "supporter.lead",
  "supporter.line",
  "supporter.nothingToRestore",
  "supporter.pending",
  "supporter.restore",
  "supporter.since",
  "supporter.thanks",
  "supporter.theme",
  "supporter.themeLine",
  "supporter.themes",
  "supporter.themesLine",
  "supporter.unreachable",
  "theme.day",
  "theme.fjord",
  "theme.mossa",
  "theme.night",
  "theme.pergament",
  "theme.rosa",
  "theme.skymning",
  "time.hoursMinutes",
  "time.minutes",
  "webgl.missing",
  "welcome.mistDaily",
  "welcome.mistNumbers",
  "welcome.mistText",
  "welcome.mistTitle",
  "welcome.next",
  "welcome.remindNo",
  "welcome.remindText",
  "welcome.remindTitle",
  "welcome.remindYes",
  "welcome.skip",
  "welcome.starsLater",
  "welcome.starsText",
  "welcome.starsTitle",
  "welcome.step",
  "widget.bestDay",
  "widget.clearingDescription",
  "widget.clearingName",
  "widget.description",
  "widget.next",
  "widget.streak",
  "widget.waiting",
];

/** The languages in the language list's order (decision 0026). */
export const LANGUAGES: readonly (LanguageDef & { readonly code: Locale })[] = [
  {
    "code": "en",
    "name": "English",
    "mist": "mist",
    "date": "en-GB",
    "released": true
  },
  {
    "code": "sv",
    "name": "Svenska",
    "mist": "dimma",
    "date": "sv-SE",
    "released": true
  },
  {
    "code": "de",
    "name": "Deutsch",
    "mist": "Nebel",
    "date": "de-DE",
    "released": true
  },
  {
    "code": "es",
    "name": "Español",
    "mist": "niebla",
    "date": "es-ES",
    "released": true
  },
  {
    "code": "fr",
    "name": "Français",
    "mist": "brume",
    "date": "fr-FR",
    "released": true
  },
  {
    "code": "ja",
    "name": "日本語",
    "mist": "霧",
    "date": "ja-JP",
    "released": true
  },
  {
    "code": "ko",
    "name": "한국어",
    "mist": "안개",
    "date": "ko-KR",
    "released": true
  },
  {
    "code": "zh-Hans",
    "name": "简体中文",
    "mist": "雾",
    "date": "zh-Hans-CN",
    "released": true
  },
  {
    "code": "zh-Hant",
    "name": "繁體中文",
    "mist": "霧",
    "date": "zh-Hant-TW",
    "released": true
  }
];
